import React from 'react'

export const iconList: {
    [index: string]: {
        viewBox: string
        image: React.ReactNode
    }
} = {
    dashboard: {
        viewBox: '0 0 28 25',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.9532 23.4989V15.9937H17.0401V23.4989C17.0401 24.3245 17.7248 25 18.5618 25H23.127C23.9639 25 24.6487 24.3245 24.6487 23.4989V12.9916H27.2356C27.9356 12.9916 28.2704 12.136 27.7378 11.6857L15.0162 0.382768C14.4379 -0.127589 13.5553 -0.127589 12.9771 0.382768L0.255425 11.6857C-0.261962 12.136 0.0576003 12.9916 0.757595 12.9916H3.34453V23.4989C3.34453 24.3245 4.02931 25 4.86626 25H9.43144C10.2684 25 10.9532 24.3245 10.9532 23.4989Z"
            />
        ),
    },
    dashboard_smartplayer: {
        viewBox: '0 0 28 25',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.9532 23.4989V15.9937H17.0401V23.4989C17.0401 24.3245 17.7248 25 18.5618 25H23.127C23.9639 25 24.6487 24.3245 24.6487 23.4989V12.9916H27.2356C27.9356 12.9916 28.2704 12.136 27.7378 11.6857L15.0162 0.382768C14.4379 -0.127589 13.5553 -0.127589 12.9771 0.382768L0.255425 11.6857C-0.261962 12.136 0.0576003 12.9916 0.757595 12.9916H3.34453V23.4989C3.34453 24.3245 4.02931 25 4.86626 25H9.43144C10.2684 25 10.9532 24.3245 10.9532 23.4989Z"
            />
        ),
    },
    videoChat: {
        viewBox: '0 0 20 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18 0H10C4.38 0 0 4.66 0 10.28C0 15.5 4.49 20 9.72 20C15.39 20 20 15.62 20 10V2C20 0.9 19.1 0 18 0ZM15 13L12 11V13H5V7H12V9L15 7V13Z"
            />
        ),
    },
    phone: {
        viewBox: '0 0 18 18',
        image: (
            <path d="M16.2037 12.25L13.6637 11.96C13.0537 11.89 12.4537 12.1 12.0237 12.53L10.1837 14.37C7.35367 12.93 5.03367 10.62 3.59367 7.78L5.44367 5.93C5.87367 5.5 6.08367 4.9 6.01367 4.29L5.72367 1.77C5.60367 0.76 4.75367 0 3.73367 0H2.00367C0.873674 0 -0.0663265 0.94 0.00367348 2.07C0.533673 10.61 7.36367 17.43 15.8937 17.96C17.0237 18.03 17.9637 17.09 17.9637 15.96V14.23C17.9737 13.22 17.2137 12.37 16.2037 12.25Z" />
        ),
    },
    videoWindow: {
        viewBox: '0 0 22 18',
        image: (
            <path d="M18 9H16V12H13V14H18V9ZM6 6H9V4H4V9H6V6ZM20 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H20C21.1 18 22 17.1 22 16V2C22 0.9 21.1 0 20 0ZM20 16.01H2V1.99H20V16.01Z" />
        ),
    },
    videoClose: {
        viewBox: '0 0 44 44',
        image: (
            <path d="M42.9026 4.26993L32.5751 14.5974L36.1526 18.1749C37.5701 19.5924 36.5576 22.0224 34.5551 22.0224H24.2501C23.0126 22.0224 22.0001 21.0099 22.0001 19.7724V9.42243C22.0001 7.41993 24.4301 6.40743 25.8476 7.82493L29.4251 11.4024L39.7526 1.07493C40.6301 0.197434 42.0476 0.197434 42.9251 1.07493C43.7801 1.97493 43.7801 3.39243 42.9026 4.26993ZM4.27012 42.9024L14.5976 32.5749L18.1751 36.1524C19.5926 37.5699 22.0226 36.5574 22.0226 34.5549V24.2499C22.0226 23.0124 21.0101 21.9999 19.7726 21.9999H9.42262C7.42012 21.9999 6.40762 24.4299 7.82512 25.8474L11.4026 29.4249L1.07512 39.7524C0.197617 40.6299 0.197617 42.0474 1.07512 42.9249C1.97512 43.7799 3.39262 43.7799 4.27012 42.9024Z" />
        ),
    },
    front_layer: {
        viewBox: '0 0 16 16',
        image: (
            <g>
                <path
                    d="M3,12V7c0-2.209,1.791-4,4-4h4c0.346,0,0.681-0.005,1-0.005C11.999,1.341,10.657,0,9.003,0H2.997
		C1.342,0,0,1.342,0,2.997v6.006C0,10.658,1.342,12,2.997,12H3z"
                />
                <path
                    d="M13.003,4H6.997C5.342,4,4,5.342,4,6.997v6.006C4,14.658,5.342,16,6.997,16h6.006
		C14.658,16,16,14.658,16,13.003V6.997C16,5.342,14.658,4,13.003,4z M14,13.003C14,13.547,13.554,14,13.003,14H6.997
		C6.453,14,6,13.554,6,13.003V6.997C6,6.453,6.446,6,6.997,6h6.006C13.547,6,14,6.446,14,6.997V13.003z"
                />
            </g>
        ),
    },
    sortable_handle: {
        viewBox: '0 0 16 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2C16 3.10457 15.1046 4 14 4H2C0.895431 4 0 3.10457 0 2ZM0 8C0 6.89543 0.895431 6 2 6H14C15.1046 6 16 6.89543 16 8C16 9.10457 15.1046 10 14 10H2C0.895431 10 0 9.10457 0 8ZM2 12C0.895431 12 0 12.8954 0 14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14C16 12.8954 15.1046 12 14 12H2Z"
            />
        ),
    },
    back_layer: {
        viewBox: '0 0 16 16',
        image: (
            <g>
                <path
                    d="M3,12V7c0-2.209,1.791-4,4-4h4c0.346,0,0.681-0.005,1-0.005C11.999,1.341,10.657,0,9.003,0H2.997
		C1.342,0,0,1.342,0,2.997v6.006C0,10.658,1.342,12,2.997,12H3z"
                />
                <path
                    d="M13.003,4H6.997C5.342,4,4,5.342,4,6.997v6.006C4,14.658,5.342,16,6.997,16h6.006
		C14.658,16,16,14.658,16,13.003V6.997C16,5.342,14.658,4,13.003,4z"
                />
            </g>
        ),
    },
    identification: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z" />
                <path d="M12 16C11.45 16 11 15.595 11 15.1L11 11.5C11 11.005 11.45 10.6 12 10.6C12.55 10.6 13 11.005 13 11.5L13 15.1C13 15.595 12.55 16 12 16ZM11 7L13 7L13 8.8L11 8.8L11 7Z" />
            </g>
        ),
    },
    office: {
        viewBox: '0 0 16 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M2.99854 0C1.89854 0 1.00854 0.9 1.00854 2L0.998535 18C0.998535 19.1 1.88853 20 2.98853 20H14.9985C16.0985 20 16.9985 19.1 16.9985 18V6.83C16.9985 6.3 16.7885 5.79 16.4085 5.42L11.5785 0.59C11.2085 0.21 10.6985 0 10.1685 0H2.99854ZM9.99854 6V1.5L15.4985 7H10.9985C10.4485 7 9.99854 6.55 9.99854 6Z"
            />
        ),
    },
    smartFolder: {
        viewBox: '0 0 263 215',
        image: (
            <g>
                <path
                    d="M112.958 7.92813C107.962 2.82188 101.255 0 94.2855 0H26.3C11.835 0 0.1315 12.0938 0.1315 26.875L0 188.125C0 202.906 11.835 215 26.3 215H236.7C251.165 215 263 202.906 263 188.125V53.75C263 38.9688 251.165 26.875 236.7 26.875H131.5L112.958 7.92813Z"
                    fill="white"
                />
                <path
                    d="M106.539 180.484C106.539 183.578 105.422 186.016 103.188 187.797C100.969 189.578 97.875 190.469 93.9062 190.469C90.25 190.469 87.0156 189.781 84.2031 188.406V181.656C86.5156 182.688 88.4688 183.414 90.0625 183.836C91.6719 184.258 93.1406 184.469 94.4688 184.469C96.0625 184.469 97.2812 184.164 98.125 183.555C98.9844 182.945 99.4141 182.039 99.4141 180.836C99.4141 180.164 99.2266 179.57 98.8516 179.055C98.4766 178.523 97.9219 178.016 97.1875 177.531C96.4688 177.047 94.9922 176.273 92.7578 175.211C90.6641 174.227 89.0938 173.281 88.0469 172.375C87 171.469 86.1641 170.414 85.5391 169.211C84.9141 168.008 84.6016 166.602 84.6016 164.992C84.6016 161.961 85.625 159.578 87.6719 157.844C89.7344 156.109 92.5781 155.242 96.2031 155.242C97.9844 155.242 99.6797 155.453 101.289 155.875C102.914 156.297 104.609 156.891 106.375 157.656L104.031 163.305C102.203 162.555 100.688 162.031 99.4844 161.734C98.2969 161.438 97.125 161.289 95.9688 161.289C94.5938 161.289 93.5391 161.609 92.8047 162.25C92.0703 162.891 91.7031 163.727 91.7031 164.758C91.7031 165.398 91.8516 165.961 92.1484 166.445C92.4453 166.914 92.9141 167.375 93.5547 167.828C94.2109 168.266 95.75 169.062 98.1719 170.219C101.375 171.75 103.57 173.289 104.758 174.836C105.945 176.367 106.539 178.25 106.539 180.484ZM127.258 190L119.008 163.117H118.797C119.094 168.586 119.242 172.234 119.242 174.062V190H112.75V155.734H122.641L130.75 181.938H130.891L139.492 155.734H149.383V190H142.609V173.781C142.609 173.016 142.617 172.133 142.633 171.133C142.664 170.133 142.773 167.477 142.961 163.164H142.75L133.914 190H127.258ZM179.008 190L176.523 181.844H164.031L161.547 190H153.719L165.812 155.594H174.695L186.836 190H179.008ZM174.789 175.75C172.492 168.359 171.195 164.18 170.898 163.211C170.617 162.242 170.414 161.477 170.289 160.914C169.773 162.914 168.297 167.859 165.859 175.75H174.789ZM198.438 170.945H200.781C203.078 170.945 204.773 170.562 205.867 169.797C206.961 169.031 207.508 167.828 207.508 166.188C207.508 164.562 206.945 163.406 205.82 162.719C204.711 162.031 202.984 161.688 200.641 161.688H198.438V170.945ZM198.438 176.852V190H191.172V155.734H201.156C205.812 155.734 209.258 156.586 211.492 158.289C213.727 159.977 214.844 162.547 214.844 166C214.844 168.016 214.289 169.812 213.18 171.391C212.07 172.953 210.5 174.18 208.469 175.07C213.625 182.773 216.984 187.75 218.547 190H210.484L202.305 176.852H198.438ZM236.078 190H228.812V161.781H219.508V155.734H245.383V161.781H236.078V190Z"
                    fill="#494848"
                />
            </g>
        ),
    },
    smartFolder_smartplayer: {
        viewBox: '0 0 263 215',
        image: (
            <g>
                <path
                    d="M112.958 7.92813C107.962 2.82188 101.255 0 94.2855 0H26.3C11.835 0 0.1315 12.0938 0.1315 26.875L0 188.125C0 202.906 11.835 215 26.3 215H236.7C251.165 215 263 202.906 263 188.125V53.75C263 38.9688 251.165 26.875 236.7 26.875H131.5L112.958 7.92813Z"
                    fill="white"
                />
                <path
                    d="M106.539 180.484C106.539 183.578 105.422 186.016 103.188 187.797C100.969 189.578 97.875 190.469 93.9062 190.469C90.25 190.469 87.0156 189.781 84.2031 188.406V181.656C86.5156 182.688 88.4688 183.414 90.0625 183.836C91.6719 184.258 93.1406 184.469 94.4688 184.469C96.0625 184.469 97.2812 184.164 98.125 183.555C98.9844 182.945 99.4141 182.039 99.4141 180.836C99.4141 180.164 99.2266 179.57 98.8516 179.055C98.4766 178.523 97.9219 178.016 97.1875 177.531C96.4688 177.047 94.9922 176.273 92.7578 175.211C90.6641 174.227 89.0938 173.281 88.0469 172.375C87 171.469 86.1641 170.414 85.5391 169.211C84.9141 168.008 84.6016 166.602 84.6016 164.992C84.6016 161.961 85.625 159.578 87.6719 157.844C89.7344 156.109 92.5781 155.242 96.2031 155.242C97.9844 155.242 99.6797 155.453 101.289 155.875C102.914 156.297 104.609 156.891 106.375 157.656L104.031 163.305C102.203 162.555 100.688 162.031 99.4844 161.734C98.2969 161.438 97.125 161.289 95.9688 161.289C94.5938 161.289 93.5391 161.609 92.8047 162.25C92.0703 162.891 91.7031 163.727 91.7031 164.758C91.7031 165.398 91.8516 165.961 92.1484 166.445C92.4453 166.914 92.9141 167.375 93.5547 167.828C94.2109 168.266 95.75 169.062 98.1719 170.219C101.375 171.75 103.57 173.289 104.758 174.836C105.945 176.367 106.539 178.25 106.539 180.484ZM127.258 190L119.008 163.117H118.797C119.094 168.586 119.242 172.234 119.242 174.062V190H112.75V155.734H122.641L130.75 181.938H130.891L139.492 155.734H149.383V190H142.609V173.781C142.609 173.016 142.617 172.133 142.633 171.133C142.664 170.133 142.773 167.477 142.961 163.164H142.75L133.914 190H127.258ZM179.008 190L176.523 181.844H164.031L161.547 190H153.719L165.812 155.594H174.695L186.836 190H179.008ZM174.789 175.75C172.492 168.359 171.195 164.18 170.898 163.211C170.617 162.242 170.414 161.477 170.289 160.914C169.773 162.914 168.297 167.859 165.859 175.75H174.789ZM198.438 170.945H200.781C203.078 170.945 204.773 170.562 205.867 169.797C206.961 169.031 207.508 167.828 207.508 166.188C207.508 164.562 206.945 163.406 205.82 162.719C204.711 162.031 202.984 161.688 200.641 161.688H198.438V170.945ZM198.438 176.852V190H191.172V155.734H201.156C205.812 155.734 209.258 156.586 211.492 158.289C213.727 159.977 214.844 162.547 214.844 166C214.844 168.016 214.289 169.812 213.18 171.391C212.07 172.953 210.5 174.18 208.469 175.07C213.625 182.773 216.984 187.75 218.547 190H210.484L202.305 176.852H198.438ZM236.078 190H228.812V161.781H219.508V155.734H245.383V161.781H236.078V190Z"
                    fill="#494848"
                />
            </g>
        ),
    },
    fs: {
        viewBox: '0 0 20 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M8.59 0.59C8.21 0.21 7.7 0 7.17 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2H10L8.59 0.59Z"
            />
        ),
    },
    image: {
        viewBox: '0 0 18 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18 16V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16ZM5.9 10.98L8 13.51L11.1 9.52C11.3 9.26 11.7 9.26 11.9 9.53L15.41 14.21C15.66 14.54 15.42 15.01 15.01 15.01H3.02C2.6 15.01 2.37 14.53 2.63 14.2L5.12 11C5.31 10.74 5.69 10.73 5.9 10.98Z"
            />
        ),
    },
    stream: {
        viewBox: '0 0 511.997 511.997',
        image: (
            <g>
                <path
                    d="M212.26,390.24l-60.331,60.331c-25.012,25.012-65.517,25.012-90.508,0.005c-24.996-24.996-24.996-65.505-0.005-90.496
				l120.683-120.683c24.991-24.992,65.5-24.992,90.491,0c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17
				c-41.654-41.654-109.177-41.654-150.831,0L31.247,329.909c-41.654,41.654-41.654,109.177,0,150.831
				c41.649,41.676,109.177,41.676,150.853,0l60.331-60.331c8.331-8.331,8.331-21.839,0-30.17S220.591,381.909,212.26,390.24z"
                />
                <path
                    d="M480.751,31.24c-41.654-41.654-109.199-41.654-150.853,0l-72.384,72.384c-8.331,8.331-8.331,21.839,0,30.17
				c8.331,8.331,21.839,8.331,30.17,0l72.384-72.384c24.991-24.992,65.521-24.992,90.513,0c24.991,24.991,24.991,65.5,0,90.491
				L317.845,284.638c-24.992,24.992-65.5,24.992-90.491,0c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17
				c41.654,41.654,109.177,41.654,150.831,0l132.736-132.736C522.405,140.418,522.405,72.894,480.751,31.24z"
                />
            </g>
        ),
    },
    stream_toolbar: {
        viewBox: '0 0 370 370',
        image: (
            <path d="M185 0C82.88 0 0 82.88 0 185C0 287.12 82.88 370 185 370C287.12 370 370 287.12 370 185C370 82.88 287.12 0 185 0ZM124.875 216.08C122.47 224.035 113.405 227.735 106.005 224.405C99.715 221.445 96.57 214.415 98.605 207.755C100.825 200.17 101.935 192.4 101.75 184.815C101.565 177.23 100.64 170.015 98.605 162.985C96.755 156.325 99.715 149.11 106.005 146.335C113.775 142.82 122.84 147.075 125.245 155.4C128.02 164.835 129.315 174.455 129.5 184.445C129.5 194.805 128.02 205.535 124.875 216.08ZM182.965 245.495C179.82 253.08 170.57 256.04 163.355 251.97C157.25 248.455 154.845 241.055 157.435 234.58C163.54 220.335 166.5 204.425 166.5 187.22C166.5 169.46 163.17 152.255 156.695 135.79C154.105 129.13 157.065 121.73 163.355 118.4C170.57 114.7 179.45 118.03 182.41 125.615C190.18 145.225 194.065 165.945 194.065 187.22C194.435 208.125 190.55 227.735 182.965 245.495ZM240.5 270.1C237.355 277.5 228.66 280.83 221.63 277.315C215.155 274.17 212.01 266.4 214.785 259.74C225.7 234.025 231.25 208.865 231.25 184.63C231.25 160.395 225.7 135.605 214.97 110.445C212.01 103.785 215.155 96.015 221.63 92.87C228.845 89.17 237.355 92.5 240.5 99.9C252.71 128.39 259 156.88 259 184.63C259 212.38 252.71 241.24 240.5 270.1Z" />
        ),
    },
    link: {
        viewBox: '0 0 20 6',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M3.18182 1.94444H1.36364V0.729167C1.36364 0.330556 1.05455 0 0.681818 0C0.309091 0 0 0.330556 0 0.729167V5.10417C0 5.50278 0.309091 5.83333 0.681818 5.83333C1.05455 5.83333 1.36364 5.50278 1.36364 5.10417V3.40278H3.18182V5.10417C3.18182 5.50278 3.49091 5.83333 3.86364 5.83333C4.23636 5.83333 4.54545 5.50278 4.54545 5.10417V0.729167C4.54545 0.330556 4.23636 0 3.86364 0C3.49091 0 3.18182 0.330556 3.18182 0.729167V1.94444ZM6.13636 1.45833H6.81818V5.10417C6.81818 5.50278 7.12727 5.83333 7.5 5.83333C7.87273 5.83333 8.18182 5.50278 8.18182 5.10417V1.45833H8.86364C9.23636 1.45833 9.54545 1.12778 9.54545 0.729167C9.54545 0.330556 9.23636 0 8.86364 0H6.13636C5.76364 0 5.45455 0.330556 5.45455 0.729167C5.45455 1.12778 5.76364 1.45833 6.13636 1.45833ZM11.1364 1.45833H11.8182V5.10417C11.8182 5.50278 12.1273 5.83333 12.5 5.83333C12.8727 5.83333 13.1818 5.50278 13.1818 5.10417V1.45833H13.8636C14.2364 1.45833 14.5455 1.12778 14.5455 0.729167C14.5455 0.330556 14.2364 0 13.8636 0H11.1364C10.7636 0 10.4545 0.330556 10.4545 0.729167C10.4545 1.12778 10.7636 1.45833 11.1364 1.45833ZM18.6364 0H16.3636C15.8636 0 15.4545 0.4375 15.4545 0.972222V5.10417C15.4545 5.50278 15.7636 5.83333 16.1364 5.83333C16.5091 5.83333 16.8182 5.50278 16.8182 5.10417V3.88889H18.6364C19.3909 3.88889 20 3.22778 20 2.43056V1.45833C20 0.661111 19.3909 0 18.6364 0ZM18.6364 2.43056H16.8182V1.45833H18.6364V2.43056Z"
            />
        ),
    },
    audio: {
        viewBox: '0 0 12 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M5.75928 1.99986V10.5493C4.85677 10.0093 3.74303 9.79933 2.56208 10.2293C1.27552 10.7093 0.2866 11.8992 0.0561717 13.2991C-0.385483 16.0389 1.84199 18.3787 4.46312 17.9488C6.34496 17.6388 7.67952 15.8389 7.67952 13.8491V3.99973H9.59976C10.6559 3.99973 11.52 3.09979 11.52 1.99986C11.52 0.899938 10.6559 0 9.59976 0H7.67952C6.62339 0 5.75928 0.899938 5.75928 1.99986Z"
            />
        ),
    },
    playback: {
        viewBox: '0 0 13 19',
        image: (
            <path d="M6.49991 2.20833V11.1146C5.52074 10.5521 4.31241 10.3333 3.03116 10.7812C1.63532 11.2812 0.562407 12.5208 0.312407 13.9792C-0.166759 16.8333 2.24991 19.2708 5.09366 18.8229C7.13532 18.5 8.58324 16.625 8.58324 14.5521V4.29167H10.6666C11.8124 4.29167 12.7499 3.35417 12.7499 2.20833C12.7499 1.0625 11.8124 0.125 10.6666 0.125H8.58324C7.43741 0.125 6.49991 1.0625 6.49991 2.20833Z" />
        ),
    },
    note: {
        viewBox: '0 0 416 416',
        image: (
            <path
                d="M224,0h-32v304.594C175,294.375,152.688,288,128,288c-53,0-96,28.625-96,64s43,64,96,64s96-28.625,96-64V96
		c80-13,128,80,160,128C364,0,224,0,224,0z"
            />
        ),
    },
    text: {
        viewBox: '0 0 14 15',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M0.998535 1.5C0.998535 2.33 1.66854 3 2.49854 3H6.49854V13.5C6.49854 14.33 7.16854 15 7.99854 15C8.82854 15 9.49854 14.33 9.49854 13.5V3H13.4985C14.3285 3 14.9985 2.33 14.9985 1.5C14.9985 0.67 14.3285 0 13.4985 0H2.49854C1.66854 0 0.998535 0.67 0.998535 1.5Z"
            />
        ),
    },
    video: {
        viewBox: '0 0 17 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M14.4375 1V2H12.375V1C12.375 0.45 11.9109 0 11.3438 0H5.15625C4.58906 0 4.125 0.45 4.125 1V2H2.0625V1C2.0625 0.45 1.59844 0 1.03125 0C0.464062 0 0 0.45 0 1V17C0 17.55 0.464062 18 1.03125 18C1.59844 18 2.0625 17.55 2.0625 17V16H4.125V17C4.125 17.55 4.58906 18 5.15625 18H11.3438C11.9109 18 12.375 17.55 12.375 17V16H14.4375V17C14.4375 17.55 14.9016 18 15.4688 18C16.0359 18 16.5 17.55 16.5 17V1C16.5 0.45 16.0359 0 15.4688 0C14.9016 0 14.4375 0.45 14.4375 1ZM4.125 14H2.0625V12H4.125V14ZM4.125 10H2.0625V8H4.125V10ZM4.125 6H2.0625V4H4.125V6ZM14.4375 14H12.375V12H14.4375V14ZM14.4375 10H12.375V8H14.4375V10ZM14.4375 6H12.375V4H14.4375V6Z"
            />
        ),
    },
    group_files_v1: {
        viewBox: '0 0 18 14',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M7.731 0.51625C7.389 0.18375 6.93 0 6.453 0H1.8C0.81 0 0.00899999 0.7875 0.00899999 1.75L0 12.25C0 13.2125 0.81 14 1.8 14H16.2C17.19 14 18 13.2125 18 12.25V3.5C18 2.5375 17.19 1.75 16.2 1.75H9L7.731 0.51625Z"
            />
        ),
    },
    group_files: {
        viewBox: '0 0 19 14',
        image: (
            <path d="M8.1605 0.51625C7.7995 0.18375 7.315 0 6.8115 0H1.9C0.855 0 0.00949999 0.7875 0.00949999 1.75L0 12.25C0 13.2125 0.855 14 1.9 14H17.1C18.145 14 19 13.2125 19 12.25V3.5C19 2.5375 18.145 1.75 17.1 1.75H9.5L8.1605 0.51625Z" />
        ),
    },
    group: {
        viewBox: '0 0 22 15',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M15.95 7.5C17.468 7.5 18.689 6.3 18.689 4.82143C18.689 3.34286 17.468 2.14286 15.95 2.14286C14.432 2.14286 13.2 3.34286 13.2 4.82143C13.2 6.3 14.432 7.5 15.95 7.5ZM7.7 6.42857C9.526 6.42857 10.989 4.99286 10.989 3.21429C10.989 1.43571 9.526 0 7.7 0C5.874 0 4.4 1.43571 4.4 3.21429C4.4 4.99286 5.874 6.42857 7.7 6.42857ZM15.95 9.64286C13.937 9.64286 9.9 10.6286 9.9 12.5893V13.9286C9.9 14.5179 10.395 15 11 15H20.9C21.505 15 22 14.5179 22 13.9286V12.5893C22 10.6286 17.963 9.64286 15.95 9.64286ZM7.7 8.57143C5.137 8.57143 0 9.825 0 12.3214V13.9286C0 14.5179 0.495 15 1.1 15H7.7V12.5893C7.7 11.6786 8.063 10.0821 10.307 8.87143C9.35 8.67857 8.426 8.57143 7.7 8.57143Z"
            />
        ),
    },
    megaphone_smartplayer: {
        viewBox: '0 0 20 13',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M15.5556 4.875V1.08333C15.5556 0.4875 15.0556 0 14.4444 0H1.11111C0.5 0 0 0.4875 0 1.08333V11.9167C0 12.5125 0.5 13 1.11111 13H14.4444C15.0556 13 15.5556 12.5125 15.5556 11.9167V8.125L18.1 10.6058C18.8 11.2883 20 10.8008 20 9.83667V3.1525C20 2.18833 18.8 1.70083 18.1 2.38333L15.5556 4.875Z"
            />
        ),
    },
    megaphone: {
        viewBox: '0 0 22 17',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5555 1.08331V4.875L20.1 2.38336C20.8 1.70081 22 2.18835 22 3.15253V9.83667C22 10.8008 20.8 11.2883 20.1 10.6058L19 9.53333V7.90997C19 6.13373 16.8461 5.22968 15.5829 6.49292L15.5814 6.49445L15 7.07831V6C15 4.89771 14.1023 4 13 4H2V1.08331C2 0.487488 2.5 0 3.11111 0H16.4445C17.0555 0 17.5555 0.487488 17.5555 1.08331ZM13 5C13.55 5 14 5.45001 14 6V8.0827V9.5L15 8.49561L16.29 7.20001C16.92 6.57001 18 7.02002 18 7.90997V8.55835V14.08C18 14.97 16.92 15.42 16.29 14.79L14.5 13L14 12.5V13V16C14 16.55 13.55 17 13 17H1C0.449997 17 0 16.55 0 16V6C0 5.45001 0.449997 5 1 5H2H13Z"
            />
        ),
    },
    gear: {
        viewBox: '0 0 23 23',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M20.2868 12.8807C20.3341 12.5127 20.3696 12.1447 20.3696 11.7537C20.3696 11.3627 20.3341 10.9947 20.2868 10.6267L22.7814 8.72916C23.006 8.55666 23.0651 8.24616 22.9233 7.99316L20.5587 4.01416C20.4169 3.76116 20.0976 3.66916 19.8376 3.76116L16.8937 4.91116C16.2789 4.45116 15.6169 4.07166 14.8957 3.78416L14.4464 0.736662C14.411 0.460662 14.1627 0.253662 13.8671 0.253662H9.13809C8.84252 0.253662 8.59425 0.460662 8.55878 0.736662L8.10952 3.78416C7.38834 4.07166 6.72628 4.46266 6.1115 4.91116L3.16767 3.76116C2.89575 3.65766 2.58836 3.76116 2.44649 4.01416L0.081968 7.99316C-0.0717259 8.24616 -0.000790108 8.55666 0.22384 8.72916L2.71841 10.6267C2.67112 10.9947 2.63565 11.3742 2.63565 11.7537C2.63565 12.1332 2.67112 12.5127 2.71841 12.8807L0.22384 14.7782C-0.000790108 14.9507 -0.0599033 15.2612 0.081968 15.5142L2.44649 19.4932C2.58836 19.7462 2.90757 19.8382 3.16767 19.7462L6.1115 18.5962C6.72628 19.0562 7.38834 19.4357 8.10952 19.7232L8.55878 22.7707C8.59425 23.0467 8.84252 23.2537 9.13809 23.2537H13.8671C14.1627 23.2537 14.411 23.0467 14.4464 22.7707L14.8957 19.7232C15.6169 19.4357 16.2789 19.0447 16.8937 18.5962L19.8376 19.7462C20.1095 19.8497 20.4169 19.7462 20.5587 19.4932L22.9233 15.5142C23.0651 15.2612 23.006 14.9507 22.7814 14.7782L20.2868 12.8807ZM11.5026 15.7787C9.22085 15.7787 7.3647 13.9732 7.3647 11.7537C7.3647 9.53416 9.22085 7.72866 11.5026 7.72866C13.7844 7.72866 15.6405 9.53416 15.6405 11.7537C15.6405 13.9732 13.7844 15.7787 11.5026 15.7787Z"
            />
        ),
    },
    gear_smartplayer: {
        viewBox: '0 0 23 23',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M20.2868 12.8807C20.3341 12.5127 20.3696 12.1447 20.3696 11.7537C20.3696 11.3627 20.3341 10.9947 20.2868 10.6267L22.7814 8.72916C23.006 8.55666 23.0651 8.24616 22.9233 7.99316L20.5587 4.01416C20.4169 3.76116 20.0976 3.66916 19.8376 3.76116L16.8937 4.91116C16.2789 4.45116 15.6169 4.07166 14.8957 3.78416L14.4464 0.736662C14.411 0.460662 14.1627 0.253662 13.8671 0.253662H9.13809C8.84252 0.253662 8.59425 0.460662 8.55878 0.736662L8.10952 3.78416C7.38834 4.07166 6.72628 4.46266 6.1115 4.91116L3.16767 3.76116C2.89575 3.65766 2.58836 3.76116 2.44649 4.01416L0.081968 7.99316C-0.0717259 8.24616 -0.000790108 8.55666 0.22384 8.72916L2.71841 10.6267C2.67112 10.9947 2.63565 11.3742 2.63565 11.7537C2.63565 12.1332 2.67112 12.5127 2.71841 12.8807L0.22384 14.7782C-0.000790108 14.9507 -0.0599033 15.2612 0.081968 15.5142L2.44649 19.4932C2.58836 19.7462 2.90757 19.8382 3.16767 19.7462L6.1115 18.5962C6.72628 19.0562 7.38834 19.4357 8.10952 19.7232L8.55878 22.7707C8.59425 23.0467 8.84252 23.2537 9.13809 23.2537H13.8671C14.1627 23.2537 14.411 23.0467 14.4464 22.7707L14.8957 19.7232C15.6169 19.4357 16.2789 19.0447 16.8937 18.5962L19.8376 19.7462C20.1095 19.8497 20.4169 19.7462 20.5587 19.4932L22.9233 15.5142C23.0651 15.2612 23.006 14.9507 22.7814 14.7782L20.2868 12.8807ZM11.5026 15.7787C9.22085 15.7787 7.3647 13.9732 7.3647 11.7537C7.3647 9.53416 9.22085 7.72866 11.5026 7.72866C13.7844 7.72866 15.6405 9.53416 15.6405 11.7537C15.6405 13.9732 13.7844 15.7787 11.5026 15.7787Z"
            />
        ),
    },
    close: {
        viewBox: '0 0 357 357',
        image: (
            <polygon
                points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3
			214.2,178.5 		"
            />
        ),
    },
    close_tiny: {
        viewBox: '0 0 14 14',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M13.6894 0.321199C13.2753 -0.0929084 12.6064 -0.0929084 12.1923 0.321199L7 5.50284L1.80774 0.31058C1.39363 -0.103527 0.724687 -0.103527 0.31058 0.31058C-0.103527 0.724687 -0.103527 1.39363 0.31058 1.80774L5.50284 7L0.31058 12.1923C-0.103527 12.6064 -0.103527 13.2753 0.31058 13.6894C0.724687 14.1035 1.39363 14.1035 1.80774 13.6894L7 8.49716L12.1923 13.6894C12.6064 14.1035 13.2753 14.1035 13.6894 13.6894C14.1035 13.2753 14.1035 12.6064 13.6894 12.1923L8.49716 7L13.6894 1.80774C14.0929 1.40425 14.0929 0.724687 13.6894 0.321199Z"
            />
        ),
    },
    close_circle: {
        viewBox: '0 0 52 52',
        image: (
            <g>
                <path
                    d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26
		            S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"
                />
                <path
                    d="M35.707,16.293c-0.391-0.391-1.023-0.391-1.414,0L26,24.586l-8.293-8.293c-0.391-0.391-1.023-0.391-1.414,0
                    s-0.391,1.023,0,1.414L24.586,26l-8.293,8.293c-0.391,0.391-0.391,1.023,0,1.414C16.488,35.902,16.744,36,17,36
                    s0.512-0.098,0.707-0.293L26,27.414l8.293,8.293C34.488,35.902,34.744,36,35,36s0.512-0.098,0.707-0.293
                    c0.391-0.391,0.391-1.023,0-1.414L27.414,26l8.293-8.293C36.098,17.316,36.098,16.684,35.707,16.293z"
                />
            </g>
        ),
    },
    error: {
        viewBox: '0 0 76 77',
        image: (
            <g>
                <path d="M38 57.75C35.91 57.75 34.2 56.0175 34.2 53.9L34.2 38.5C34.2 36.3825 35.91 34.65 38 34.65C40.09 34.65 41.8 36.3825 41.8 38.5L41.8 53.9C41.8 56.0175 40.09 57.75 38 57.75ZM38.038 77C59.014 77 76 59.752 76 38.5C76 17.248 59.014 6.14443e-06 38.038 4.31065e-06C17.024 2.47355e-06 -2.40571e-06 17.248 -4.26362e-06 38.5C-6.12153e-06 59.752 17.024 77 38.038 77ZM38 7.7C54.796 7.7 68.4 21.483 68.4 38.5C68.4 55.517 54.796 69.3 38 69.3C21.204 69.3 7.59999 55.517 7.59999 38.5C7.6 21.483 21.204 7.7 38 7.7ZM34.2 19.25L41.8 19.25L41.8 26.95L34.2 26.95L34.2 19.25Z" />
            </g>
        ),
    },
    update: {
        viewBox: '0 0 21 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M16.9415 4.35L14.1515 7.14C13.8315 7.46 14.0515 8 14.5015 8H16.2915C16.2915 11.31 13.6015 14 10.2915 14C9.50153 14 8.73153 13.85 8.04153 13.56C7.68153 13.41 7.27153 13.52 7.00153 13.79C6.49153 14.3 6.67153 15.16 7.34153 15.43C8.25153 15.8 9.25153 16 10.2915 16C14.7115 16 18.2915 12.42 18.2915 8H20.0815C20.5315 8 20.7515 7.46 20.4315 7.15L17.6415 4.36C17.4515 4.16 17.1315 4.16 16.9415 4.35ZM4.29153 8C4.29153 4.69 6.98153 2 10.2915 2C11.0815 2 11.8515 2.15 12.5415 2.44C12.9015 2.59 13.3115 2.48 13.5815 2.21C14.0915 1.7 13.9115 0.84 13.2415 0.57C12.3315 0.2 11.3315 0 10.2915 0C5.87153 0 2.29153 3.58 2.29153 8H0.501534C0.0515344 8 -0.168466 8.54 0.151534 8.85L2.94153 11.64C3.14153 11.84 3.45153 11.84 3.65153 11.64L6.44153 8.85C6.75153 8.54 6.53153 8 6.08153 8H4.29153Z"
            />
        ),
    },
    update_soft: {
        viewBox: '0 0 20 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M11.5515 0.00349014C6.46153 -0.13651 2.29153 3.95349 2.29153 9.00349H0.501534C0.0515344 9.00349 -0.168466 9.54349 0.151534 9.85349L2.94153 12.6535C3.14153 12.8535 3.45153 12.8535 3.65153 12.6535L6.44153 9.85349C6.75153 9.54349 6.53153 9.00349 6.08153 9.00349H4.29153C4.29153 5.10349 7.47153 1.95349 11.3915 2.00349C15.1115 2.05349 18.2415 5.18349 18.2915 8.90349C18.3415 12.8135 15.1915 16.0035 11.2915 16.0035C9.68153 16.0035 8.19153 15.4535 7.01153 14.5235C6.61153 14.2135 6.05153 14.2435 5.69153 14.6035C5.27153 15.0235 5.30153 15.7335 5.77153 16.0935C7.29153 17.2935 9.20153 18.0035 11.2915 18.0035C16.3415 18.0035 20.4315 13.8335 20.2915 8.74349C20.1615 4.05349 16.2415 0.13349 11.5515 0.00349014ZM11.0415 5.00349C10.6315 5.00349 10.2915 5.34349 10.2915 5.75349V9.43349C10.2915 9.78349 10.4815 10.1135 10.7815 10.2935L13.9015 12.1435C14.2615 12.3535 14.7215 12.2335 14.9315 11.8835C15.1415 11.5235 15.0215 11.0635 14.6715 10.8535L11.7915 9.14349V5.74349C11.7915 5.34349 11.4515 5.00349 11.0415 5.00349Z"
            />
        ),
    },
    update_tiny: {
        viewBox: '0 0 21 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M16.9415 4.35L14.1515 7.14C13.8315 7.46 14.0515 8 14.5015 8H16.2915C16.2915 11.31 13.6015 14 10.2915 14C9.50153 14 8.73153 13.85 8.04153 13.56C7.68153 13.41 7.27153 13.52 7.00153 13.79C6.49153 14.3 6.67153 15.16 7.34153 15.43C8.25153 15.8 9.25153 16 10.2915 16C14.7115 16 18.2915 12.42 18.2915 8H20.0815C20.5315 8 20.7515 7.46 20.4315 7.15L17.6415 4.36C17.4515 4.16 17.1315 4.16 16.9415 4.35ZM4.29153 8C4.29153 4.69 6.98153 2 10.2915 2C11.0815 2 11.8515 2.15 12.5415 2.44C12.9015 2.59 13.3115 2.48 13.5815 2.21C14.0915 1.7 13.9115 0.84 13.2415 0.57C12.3315 0.2 11.3315 0 10.2915 0C5.87153 0 2.29153 3.58 2.29153 8H0.501534C0.0515344 8 -0.168466 8.54 0.151534 8.85L2.94153 11.64C3.14153 11.84 3.45153 11.84 3.65153 11.64L6.44153 8.85C6.75153 8.54 6.53153 8 6.08153 8H4.29153Z"
            />
        ),
    },
    power: {
        viewBox: '0 0 18 18',
        image: (
            <g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M9.00359 0C8.45359 0 8.00359 0.45 8.00359 1V9C8.00359 9.55 8.45359 10 9.00359 10C9.55359 10 10.0036 9.55 10.0036 9V1C10.0036 0.45 9.55359 0 9.00359 0ZM14.1436 2.86C13.7536 3.25 13.7636 3.86 14.1336 4.25C15.2636 5.45 15.9636 7.05 16.0036 8.82C16.0936 12.65 12.9236 15.95 9.09359 15.99C5.18359 16.05 2.00359 12.9 2.00359 9C2.00359 7.16 2.71359 5.49 3.87359 4.24C4.24359 3.85 4.24359 3.24 3.86359 2.86C3.46359 2.46 2.81359 2.47 2.43359 2.88C0.983593 4.42 0.0735926 6.47 0.00359261 8.74C-0.136407 13.62 3.83359 17.84 8.71359 17.99C13.8136 18.15 18.0036 14.06 18.0036 8.99C18.0036 6.62 17.0836 4.48 15.5836 2.88C15.2036 2.47 14.5436 2.46 14.1436 2.86Z"
                />
            </g>
        ),
    },
    pencil: {
        viewBox: '0 0 18 18',
        image: (
            <g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M0 14.4625V17.5025C0 17.7825 0.22 18.0025 0.5 18.0025H3.54C3.67 18.0025 3.8 17.9525 3.89 17.8525L14.81 6.9425L11.06 3.1925L0.15 14.1025C0.0500001 14.2025 0 14.3225 0 14.4625ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                />
            </g>
        ),
    },
    delete: {
        viewBox: '0 0 14 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V6C13 4.9 12.1 4 11 4H3C1.9 4 1 4.9 1 6V16ZM4.17 8.17C4.56 7.78 5.19 7.78 5.58 8.17L7 9.59L8.42 8.17C8.81 7.78 9.44 7.78 9.83 8.17C10.22 8.56 10.22 9.19 9.83 9.58L8.41 11L9.83 12.42C10.22 12.81 10.22 13.44 9.83 13.83C9.44 14.22 8.81 14.22 8.42 13.83L7 12.41L5.58 13.83C5.19 14.22 4.56 14.22 4.17 13.83C3.78 13.44 3.78 12.81 4.17 12.42L5.59 11L4.17 9.58C3.78 9.2 3.78 8.56 4.17 8.17ZM10.5 1L9.79 0.29C9.61 0.11 9.35 0 9.09 0H4.91C4.65 0 4.39 0.11 4.21 0.29L3.5 1H1C0.45 1 0 1.45 0 2C0 2.55 0.45 3 1 3H13C13.55 3 14 2.55 14 2C14 1.45 13.55 1 13 1H10.5Z"
            />
        ),
    },
    arrow_up: {
        viewBox: '0 0 284.929 284.929',
        image: (
            <path
                d="M282.082,195.285L149.028,62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665,0.953-6.567,2.856L2.856,195.285
		C0.95,197.191,0,199.378,0,201.853c0,2.474,0.953,4.664,2.856,6.566l14.272,14.271c1.903,1.903,4.093,2.854,6.567,2.854
		c2.474,0,4.664-0.951,6.567-2.854l112.204-112.202l112.208,112.209c1.902,1.903,4.093,2.848,6.563,2.848
		c2.478,0,4.668-0.951,6.57-2.848l14.274-14.277c1.902-1.902,2.847-4.093,2.847-6.566
		C284.929,199.378,283.984,197.188,282.082,195.285z"
            />
        ),
    },
    arrow_up_tiny: {
        viewBox: '0 0 64 64',
        image: (
            <path d="M3.352,48.296l28.56-28.328l28.58,28.347c0.397,0.394,0.917,0.59,1.436,0.59c0.52,0,1.04-0.196,1.436-0.59   c0.793-0.787,0.793-2.062,0-2.849l-29.98-29.735c-0.2-0.2-0.494-0.375-0.757-0.475c-0.75-0.282-1.597-0.107-2.166,0.456   L0.479,45.447c-0.793,0.787-0.793,2.062,0,2.849C1.273,49.082,2.558,49.082,3.352,48.296z" />
        ),
    },
    arrow_down: {
        viewBox: '0 0 12.17 6.59',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M11.7062 0.2925C11.3162 -0.0975 10.6862 -0.0975001 10.2962 0.2925L6.41624 4.1725L2.53624 0.2925C2.14624 -0.0975004 1.51624 -0.0975005 1.12624 0.2925C0.736237 0.6825 0.736237 1.3125 1.12624 1.7025L5.71624 6.2925C6.10624 6.6825 6.73624 6.6825 7.12624 6.2925L11.7162 1.7025C12.0962 1.3225 12.0962 0.6825 11.7062 0.2925Z"
            />
        ),
    },
    arrow_right: {
        viewBox: '0 0 7 11.2',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M0.2925 0.293762C-0.0975 0.683762 -0.0975 1.31376 0.2925 1.70376L4.1725 5.58376L0.2925 9.46376C-0.0975 9.85376 -0.0975 10.4838 0.2925 10.8738C0.6825 11.2638 1.3125 11.2638 1.7025 10.8738L6.2925 6.28376C6.6825 5.89376 6.6825 5.26376 6.2925 4.87376L1.7025 0.283762C1.3225 -0.0962379 0.6825 -0.0962377 0.2925 0.293762Z"
            />
        ),
    },
    arrow_left: {
        viewBox: '0 0 6.59 12.17',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M6.29246 11.7062C6.68246 11.3162 6.68246 10.6862 6.29246 10.2962L2.41246 6.41624L6.29246 2.53624C6.68246 2.14624 6.68246 1.51624 6.29246 1.12624C5.90246 0.736237 5.27246 0.736236 4.88246 1.12624L0.292461 5.71624C-0.0975384 6.10624 -0.0975385 6.73624 0.292461 7.12624L4.88246 11.7162C5.26246 12.0962 5.90246 12.0962 6.29246 11.7062Z"
            />
        ),
    },
    arrow_nobroadcasts: {
        viewBox: '0 0 41.712 41.712',
        image: (
            <path
                d="M31.586,21.8c0.444-0.444,0.444-1.143,0-1.587c-0.429-0.444-1.143-0.444-1.571,0l-8.047,8.032V1.706
        c0-0.619-0.492-1.127-1.111-1.127c-0.619,0-1.127,0.508-1.127,1.127v26.539l-8.031-8.032c-0.444-0.444-1.159-0.444-1.587,0
        c-0.444,0.444-0.444,1.143,0,1.587l9.952,9.952c0.429,0.429,1.143,0.429,1.587,0L31.586,21.8z M39.474,29.086
        c0-0.619,0.492-1.111,1.111-1.111c0.619,0,1.127,0.492,1.127,1.111v10.92c0,0.619-0.508,1.127-1.127,1.127H1.111
        C0.492,41.133,0,40.625,0,40.006v-10.92c0-0.619,0.492-1.111,1.111-1.111s1.127,0.492,1.127,1.111v9.809h37.236V29.086z"
            />
        ),
    },
    arrowhead_up: {
        viewBox: '0 0 292.362 292.361',
        image: (
            <path
                d="M286.935,197.287L159.028,69.381c-3.613-3.617-7.895-5.424-12.847-5.424s-9.233,1.807-12.85,5.424L5.424,197.287
		C1.807,200.904,0,205.186,0,210.134s1.807,9.233,5.424,12.847c3.621,3.617,7.902,5.425,12.85,5.425h255.813
		c4.949,0,9.233-1.808,12.848-5.425c3.613-3.613,5.427-7.898,5.427-12.847S290.548,200.904,286.935,197.287z"
            />
        ),
    },
    arrowhead_down: {
        viewBox: '0 0 292.362 292.362',
        image: (
            <path
                d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424
		C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428
		s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"
            />
        ),
    },
    arrowhead_right: {
        viewBox: '0 0 292.359 292.359',
        image: (
            <path
                d="M222.979,133.331L95.073,5.424C91.456,1.807,87.178,0,82.226,0c-4.952,0-9.233,1.807-12.85,5.424
		c-3.617,3.617-5.424,7.898-5.424,12.847v255.813c0,4.948,1.807,9.232,5.424,12.847c3.621,3.617,7.902,5.428,12.85,5.428
		c4.949,0,9.23-1.811,12.847-5.428l127.906-127.907c3.614-3.613,5.428-7.897,5.428-12.847
		C228.407,141.229,226.594,136.948,222.979,133.331z"
            />
        ),
    },
    arrowhead_left: {
        viewBox: '0 0 292.359 292.359',
        image: (
            <path
                d="M222.979,5.424C219.364,1.807,215.08,0,210.132,0c-4.949,0-9.233,1.807-12.848,5.424L69.378,133.331
		c-3.615,3.617-5.424,7.898-5.424,12.847c0,4.949,1.809,9.233,5.424,12.847l127.906,127.907c3.614,3.617,7.898,5.428,12.848,5.428
		c4.948,0,9.232-1.811,12.847-5.428c3.617-3.614,5.427-7.898,5.427-12.847V18.271C228.405,13.322,226.596,9.042,222.979,5.424z"
            />
        ),
    },
    attention: {
        viewBox: '0 0 508.52 508.52',
        image: (
            <g>
                <path
                    d="M254.26,0C113.845,0,0,113.845,0,254.26s113.845,254.26,254.26,254.26
					s254.26-113.845,254.26-254.26S394.675,0,254.26,0z M254.26,476.737c-122.68,0-222.477-99.829-222.477-222.477
					c0-122.68,99.797-222.477,222.477-222.477c122.649,0,222.477,99.797,222.477,222.477
					C476.737,376.908,376.908,476.737,254.26,476.737z"
                />
                <path
                    d="M254.26,95.347c-17.544,0-31.782,14.239-31.782,31.782v158.912
					c0,17.544,14.239,31.782,31.782,31.782s31.782-14.239,31.782-31.782V127.13C286.042,109.586,271.804,95.347,254.26,95.347z"
                />
                <circle cx="254.26" cy="380.881" r="31.782" />
            </g>
        ),
    },
    broadcast: {
        viewBox: '0 0 32.984 32.984',
        image: (
            <g>
                <g>
                    <path
                        d="M16.492,18.672c-1.202,0-2.18-0.979-2.18-2.181s0.978-2.18,2.18-2.18s2.18,0.978,2.18,2.18S17.693,18.672,16.492,18.672z
			 M16.492,15.312c-0.65,0-1.18,0.529-1.18,1.18c0,0.651,0.529,1.181,1.18,1.181s1.18-0.529,1.18-1.181
			C17.672,15.841,17.142,15.312,16.492,15.312z"
                    />
                    <path
                        d="M11.821,21.662c-0.128,0-0.256-0.049-0.354-0.146c-1.342-1.342-2.081-3.126-2.081-5.023c0-1.898,0.739-3.683,2.081-5.024
			c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707c-1.153,1.153-1.788,2.687-1.788,4.317c0,1.63,0.635,3.163,1.788,4.316
			c0.195,0.195,0.195,0.512,0,0.707C12.077,21.613,11.949,21.662,11.821,21.662z"
                    />
                    <path
                        d="M8.5,24.984c-0.128,0-0.256-0.049-0.354-0.146c-2.229-2.229-3.457-5.192-3.457-8.346c0-3.152,1.228-6.116,3.457-8.346
			c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707c-2.041,2.04-3.164,4.753-3.164,7.639s1.124,5.599,3.164,7.639
			c0.195,0.195,0.195,0.512,0,0.707C8.755,24.935,8.628,24.984,8.5,24.984z"
                    />
                    <path
                        d="M5.178,28.306c-0.128,0-0.256-0.049-0.354-0.146c-6.433-6.434-6.433-16.901,0-23.335c0.195-0.195,0.512-0.195,0.707,0
			s0.195,0.512,0,0.707c-6.043,6.044-6.043,15.877,0,21.921c0.195,0.195,0.195,0.512,0,0.707
			C5.434,28.257,5.306,28.306,5.178,28.306z"
                    />
                </g>
                <g>
                    <path
                        d="M21.163,21.662c-0.128,0-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707c1.153-1.153,1.788-2.687,1.788-4.316
			c0-1.631-0.635-3.164-1.788-4.317c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0c1.342,1.342,2.081,3.126,2.081,5.024
			c0,1.897-0.739,3.682-2.081,5.023C21.419,21.613,21.291,21.662,21.163,21.662z"
                    />
                    <path
                        d="M24.484,24.984c-0.128,0-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707c2.041-2.04,3.164-4.753,3.164-7.639
			s-1.124-5.599-3.164-7.639c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0c2.229,2.229,3.457,5.193,3.457,8.346
			c0,3.153-1.228,6.117-3.457,8.346C24.74,24.935,24.612,24.984,24.484,24.984z"
                    />
                    <path
                        d="M27.806,28.306c-0.128,0-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707c6.042-6.044,6.042-15.877,0-21.921
			c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0c6.433,6.434,6.433,16.901,0,23.335
			C28.062,28.257,27.934,28.306,27.806,28.306z"
                    />
                </g>
            </g>
        ),
    },
    checked: {
        viewBox: '0 0 16.78 12.58',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M5.1925 10.1925L1.6925 6.6925C1.3025 6.3025 0.6825 6.3025 0.2925 6.6925C-0.0975 7.0825 -0.0975 7.7025 0.2925 8.0925L4.4825 12.2825C4.8725 12.6725 5.5025 12.6725 5.8925 12.2825L16.4925 1.6925C16.8825 1.3025 16.8825 0.6825 16.4925 0.2925C16.1025 -0.0975 15.4825 -0.0975 15.0925 0.2925L5.1925 10.1925Z"
            />
        ),
    },
    checkbox: {
        viewBox: '0 0 10 8',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M8.46756 0.272568L3.20582 5.75189L1.52349 4C1.1745 3.63657 0.610738 3.63657 0.261745 4C-0.0872483 4.36342 -0.0872483 4.95049 0.261745 5.31392L2.57942 7.72743C2.92841 8.09086 3.49217 8.09086 3.84116 7.72743L9.73826 1.58649C10.0872 1.22306 10.0872 0.635993 9.73826 0.272568C9.38926 -0.0908561 8.81656 -0.0908561 8.46756 0.272568Z"
            />
        ),
    },
    clock: {
        viewBox: '0 0 51.498 51.498',
        image: (
            <g>
                <path
                    d="M26.456,34.956c-0.195,0.195-0.451,0.293-0.707,0.293s-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414
		l11.986-11.986c-3.114-2.774-7.074-4.307-11.279-4.307c-4.541,0-8.81,1.769-12.021,4.979c-3.211,3.211-4.979,7.479-4.979,12.021
		s1.769,8.81,4.979,12.021c3.21,3.211,7.479,4.979,12.021,4.979s8.81-1.769,12.021-4.979c3.211-3.211,4.979-7.479,4.979-12.021
		c0-4.205-1.533-8.165-4.307-11.279L26.456,34.956z"
                />
                <path d="M25.749,8.249c0.553,0,1-0.447,1-1v-6c0-0.553-0.447-1-1-1s-1,0.447-1,1v6C24.749,7.802,25.196,8.249,25.749,8.249z" />
                <path
                    d="M51.205,10.793c-0.391-0.391-1.023-0.391-1.414,0l-4.243,4.243c-0.391,0.391-0.391,1.023,0,1.414
		c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l4.243-4.243C51.596,11.816,51.596,11.184,51.205,10.793z"
                />
                <path
                    d="M1.707,10.793c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l4.243,4.243c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L1.707,10.793z"
                />
                <path
                    d="M32.996,9.203c0.087,0.023,0.174,0.034,0.26,0.034c0.441,0,0.846-0.295,0.965-0.741L35.773,2.7
		c0.143-0.533-0.174-1.082-0.707-1.225c-0.531-0.142-1.082,0.174-1.225,0.707l-1.553,5.796C32.146,8.512,32.463,9.061,32.996,9.203z
		"
                />
                <path
                    d="M17.277,8.496c0.119,0.447,0.523,0.741,0.965,0.741c0.086,0,0.173-0.011,0.26-0.034c0.533-0.143,0.85-0.691,0.707-1.225
		l-1.553-5.796c-0.143-0.534-0.691-0.85-1.225-0.707s-0.85,0.691-0.707,1.225L17.277,8.496z"
                />
                <path
                    d="M43.749,5.072c-0.478-0.275-1.09-0.111-1.366,0.366l-3,5.196c-0.276,0.479-0.112,1.09,0.366,1.366
		c0.157,0.091,0.329,0.134,0.499,0.134c0.346,0,0.682-0.18,0.867-0.5l3-5.196C44.392,5.96,44.228,5.349,43.749,5.072z"
                />
                <path
                    d="M11.25,12.135c0.17,0,0.342-0.043,0.499-0.134c0.479-0.276,0.643-0.888,0.366-1.366l-3-5.196
		C8.838,4.959,8.225,4.797,7.749,5.072C7.271,5.349,7.106,5.96,7.383,6.438l3,5.196C10.568,11.956,10.904,12.135,11.25,12.135z"
                />
            </g>
        ),
    },
    copy: {
        viewBox: '0 0 496.421 496.421',
        image: (
            <g>
                <g>
                    <path d="M376.964,65.753V0.172H136.5v415.346h306.043V65.753C442.544,65.753,376.964,65.753,376.964,65.753z" />
                    <polygon points="383.505,0 383.505,58.525 442.026,58.525 				" />
                </g>
                <polygon points="126.861,423.523 126.861,81.074 53.878,81.074 53.878,496.421 359.923,496.421 359.923,423.523 			" />
            </g>
        ),
    },
    paste: {
        viewBox: '0 0 24 24',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
            />
        ),
    },
    date: {
        viewBox: '0 0 20 22',
        image: (
            <path d="M17.7778 2.2H16.6667V1.1C16.6667 0.495 16.1667 0 15.5556 0C14.9444 0 14.4444 0.495 14.4444 1.1V2.2H5.55556V1.1C5.55556 0.495 5.05556 0 4.44444 0C3.83333 0 3.33333 0.495 3.33333 1.1V2.2H2.22222C0.988889 2.2 0.0111111 3.19 0.0111111 4.4L0 19.8C0 21.01 0.988889 22 2.22222 22H17.7778C19 22 20 21.01 20 19.8V4.4C20 3.19 19 2.2 17.7778 2.2ZM17.7778 18.7C17.7778 19.305 17.2778 19.8 16.6667 19.8H3.33333C2.72222 19.8 2.22222 19.305 2.22222 18.7V7.7H17.7778V18.7ZM4.44444 9.9H6.66667V12.1H4.44444V9.9ZM8.88889 9.9H11.1111V12.1H8.88889V9.9ZM13.3333 9.9H15.5556V12.1H13.3333V9.9Z" />
        ),
    },
    date_smartplayer: {
        viewBox: '0 0 20 22',
        image: (
            <path d="M17.7778 2.2H16.6667V1.1C16.6667 0.495 16.1667 0 15.5556 0C14.9444 0 14.4444 0.495 14.4444 1.1V2.2H5.55556V1.1C5.55556 0.495 5.05556 0 4.44444 0C3.83333 0 3.33333 0.495 3.33333 1.1V2.2H2.22222C0.988889 2.2 0.0111111 3.19 0.0111111 4.4L0 19.8C0 21.01 0.988889 22 2.22222 22H17.7778C19 22 20 21.01 20 19.8V4.4C20 3.19 19 2.2 17.7778 2.2ZM17.7778 18.7C17.7778 19.305 17.2778 19.8 16.6667 19.8H3.33333C2.72222 19.8 2.22222 19.305 2.22222 18.7V7.7H17.7778V18.7ZM4.44444 9.9H6.66667V12.1H4.44444V9.9ZM8.88889 9.9H11.1111V12.1H8.88889V9.9ZM13.3333 9.9H15.5556V12.1H13.3333V9.9Z" />
        ),
    },
    diskette: {
        viewBox: '0 0 18 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M14.59 0.59C14.21 0.21 13.7 0 13.17 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V4.83C18 4.3 17.79 3.79 17.41 3.42L14.59 0.59ZM9 16C7.34 16 6 14.66 6 13C6 11.34 7.34 10 9 10C10.66 10 12 11.34 12 13C12 14.66 10.66 16 9 16ZM10 6H4C2.9 6 2 5.1 2 4C2 2.9 2.9 2 4 2H10C11.1 2 12 2.9 12 4C12 5.1 11.1 6 10 6Z"
            />
        ),
    },
    display: {
        viewBox: '0 0 22 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M20 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H7V17C7 17.55 7.45 18 8 18H14C14.55 18 15 17.55 15 17V16H20C21.1 16 21.99 15.1 21.99 14L22 2C22 0.9 21.1 0 20 0ZM19 14H3C2.45 14 2 13.55 2 13V3C2 2.45 2.45 2 3 2H19C19.55 2 20 2.45 20 3V13C20 13.55 19.55 14 19 14Z"
            />
        ),
    },
    display_smartplayer: {
        viewBox: '0 0 22 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M20 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H7V17C7 17.55 7.45 18 8 18H14C14.55 18 15 17.55 15 17V16H20C21.1 16 21.99 15.1 21.99 14L22 2C22 0.9 21.1 0 20 0ZM19 14H3C2.45 14 2 13.55 2 13V3C2 2.45 2.45 2 3 2H19C19.55 2 20 2.45 20 3V13C20 13.55 19.55 14 19 14Z"
            />
        ),
    },
    no_display: {
        viewBox: '0 0 520 520',
        image: (
            <g>
                <path
                    d="M505.29,157.622c-9.005-5.568-20.585-6.075-30.037-1.342L397,195.244v-42.185c0-16.862-13.256-30.136-30.118-30.136
		H183.734l-68.365-80.99c-10.883-12.866-30.131-14.591-43.027-3.685C59.476,49.14,57.866,68.36,68.764,81.233l335.867,396.909
		c6.038,7.134,14.641,10.797,23.318,10.797c6.962,0,13.97-2.377,19.71-7.23c12.866-10.891,14.276-30.164,3.378-43.038L397,375.045
		v-19.903l78.136,38.964c4.309,2.154,9.098,3.22,13.764,3.22c5.576,0,11.435-1.528,16.34-4.562
		c8.99-5.561,14.76-15.386,14.76-25.971v-183.2C520,173.007,514.28,163.183,505.29,157.622z"
                />
                <path d="M0,153.059v244.267c0,16.862,14.138,30.597,31,30.597h260.756L29.879,122.647C13.443,123.128,0,136.499,0,153.059z" />
            </g>
        ),
    },
    download: {
        viewBox: '0 0 21 22',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18.6667 12.4759V18.587C18.6667 19.2592 18.1417 19.8092 17.5 19.8092H3.5C2.85833 19.8092 2.33333 19.2592 2.33333 18.587V12.4759C2.33333 11.8037 1.80833 11.2537 1.16667 11.2537C0.525 11.2537 0 11.8037 0 12.4759V19.8092C0 21.1537 1.05 22.2537 2.33333 22.2537H18.6667C19.95 22.2537 21 21.1537 21 19.8092V12.4759C21 11.8037 20.475 11.2537 19.8333 11.2537C19.1917 11.2537 18.6667 11.8037 18.6667 12.4759ZM11.6667 12.0726L13.86 9.77477C14.315 9.29811 15.05 9.29811 15.505 9.77477C15.96 10.2514 15.96 11.0214 15.505 11.4981L11.3167 15.8859C10.8617 16.3626 10.1267 16.3626 9.67167 15.8859L5.48333 11.4981C5.02833 11.0214 5.02833 10.2514 5.48333 9.77477C5.93833 9.29811 6.67333 9.29811 7.12833 9.77477L9.33333 12.0726V1.47588C9.33333 0.803662 9.85833 0.253662 10.5 0.253662C11.1417 0.253662 11.6667 0.803662 11.6667 1.47588V12.0726Z"
            />
        ),
    },
    download_smartplayer: {
        viewBox: '0 0 21 22',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18.6667 12.4759V18.587C18.6667 19.2592 18.1417 19.8092 17.5 19.8092H3.5C2.85833 19.8092 2.33333 19.2592 2.33333 18.587V12.4759C2.33333 11.8037 1.80833 11.2537 1.16667 11.2537C0.525 11.2537 0 11.8037 0 12.4759V19.8092C0 21.1537 1.05 22.2537 2.33333 22.2537H18.6667C19.95 22.2537 21 21.1537 21 19.8092V12.4759C21 11.8037 20.475 11.2537 19.8333 11.2537C19.1917 11.2537 18.6667 11.8037 18.6667 12.4759ZM11.6667 12.0726L13.86 9.77477C14.315 9.29811 15.05 9.29811 15.505 9.77477C15.96 10.2514 15.96 11.0214 15.505 11.4981L11.3167 15.8859C10.8617 16.3626 10.1267 16.3626 9.67167 15.8859L5.48333 11.4981C5.02833 11.0214 5.02833 10.2514 5.48333 9.77477C5.93833 9.29811 6.67333 9.29811 7.12833 9.77477L9.33333 12.0726V1.47588C9.33333 0.803662 9.85833 0.253662 10.5 0.253662C11.1417 0.253662 11.6667 0.803662 11.6667 1.47588V12.0726Z"
            />
        ),
    },
    email: {
        viewBox: '0 0 510 510',
        image: (
            <path
                d="M510,191.25c0-17.85-10.2-33.15-22.95-43.35L255,12.75L22.95,147.9C10.2,158.1,0,173.4,0,191.25v255
			c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V191.25z M255,318.75L43.35,186.15L255,63.75l211.65,122.4L255,318.75z"
            />
        ),
    },
    rss: {
        viewBox: '0 0 124 124',
        image: (
            <g>
                <circle cx="20.3" cy="103.749" r="20" />
                <path
                    d="M67,113.95c0,5.5,4.5,10,10,10s10-4.5,10-10c0-42.4-34.5-77-77-77c-5.5,0-10,4.5-10,10s4.5,10,10,10
		C41.5,56.95,67,82.55,67,113.95z"
                />
                <path
                    d="M114,123.95c5.5,0,10-4.5,10-10c0-62.8-51.1-113.9-113.9-113.9c-5.5,0-10,4.5-10,10s4.5,10,10,10
		c51.8,0,93.9,42.1,93.9,93.9C104,119.45,108.4,123.95,114,123.95z"
                />
            </g>
        ),
    },
    files: {
        viewBox: '0 0 20 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M8.59 0.59C8.21 0.21 7.7 0 7.17 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2H10L8.59 0.59Z"
            />
        ),
    },
    smartFiles: {
        viewBox: '0 0 166 166',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M58.4353 0C62.7555 0 66.9111 1.74587 70.0088 4.90413L81.5 16.625H146.7C155.664 16.625 163 24.1063 163 33.25V116.375C163 125.519 155.664 133 146.7 133H16.3005C7.33558 133 0 125.519 0 116.375L0.081103 16.625C0.081103 7.48125 7.33558 0 16.3005 0H58.4353ZM137.781 113.35C143.291 108.965 146.046 102.965 146.046 95.3497C146.046 89.8493 144.581 85.2146 141.653 81.4456C138.724 77.6379 133.31 73.8496 125.411 70.0799C119.438 67.234 115.642 65.2725 114.023 64.1959C112.444 63.0802 111.288 61.9456 110.555 60.7918C109.823 59.5993 109.458 58.2147 109.458 56.638C109.458 54.0995 110.363 52.0419 112.174 50.4646C113.985 48.8879 116.586 48.0995 119.977 48.0995C122.829 48.0995 125.719 48.465 128.647 49.196C131.614 49.9263 135.352 51.2149 139.86 53.0611L145.642 39.157C141.286 37.2727 137.105 35.8114 133.098 34.7723C129.129 33.7345 124.948 33.215 120.555 33.215C111.616 33.215 104.602 35.3499 99.5157 39.6185C94.468 43.8883 91.9441 49.7536 91.9441 57.2149C91.9441 61.1766 92.714 64.6381 94.2562 67.5995C95.7971 70.5608 97.8586 73.1573 100.441 75.3876C103.023 77.6186 106.895 79.9456 112.059 82.3687C117.569 84.9838 121.21 86.888 122.984 88.0799C124.794 89.2724 126.162 90.5223 127.087 91.8302C127.581 92.5074 127.943 93.2395 128.173 94.0261C128.374 94.7136 128.474 95.4433 128.474 96.2148C128.474 99.1761 127.414 101.407 125.296 102.907C123.214 104.407 120.209 105.157 116.277 105.157C113.003 105.157 109.38 104.638 105.412 103.599C101.48 102.561 96.6638 100.772 90.9612 98.2337V114.849C97.8973 118.234 105.874 119.926 114.89 119.926C124.678 119.926 132.308 117.734 137.781 113.35Z"
            />
        ),
    },
    filter: {
        viewBox: '0 0 512 512',
        image: (
            <path d="m191.8,480.6v-174.3l-177.3-263.5c-7.2-8.3-4.1-31.1 16.9-31.8h449.2c12.2,0 27.7,14.4 16.9,31.8l-177.3,263.5v108.2c0,6.4-3,12.4-8.1,16.3l-87.6,66.1c-5,5.6-30.1,9.3-32.7-16.3zm-122-428.8l159.4,236.9c2.3,3.4 3.5,7.3 3.5,11.4v139.6l46.8-35.3v-104.3c0-4.1 1.2-8 3.5-11.4l159.2-236.9h-372.4z" />
        ),
    },
    fullscreen: {
        viewBox: '0 0 19 19',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.543945 6.10571V2.93896C0.543945 1.77783 1.4939 0.827881 2.65503 0.827881H5.82178C6.40222 0.827881 6.87732 1.30298 6.87732 1.88354C6.87732 2.46411 6.40222 2.93896 5.82178 2.93896H3.71057C3.13 2.93896 2.65503 3.41406 2.65503 3.99463V6.10571C2.65503 6.68628 2.18005 7.16113 1.59949 7.16113C1.01892 7.16113 0.543945 6.68628 0.543945 6.10571ZM0.543945 14.55C0.543945 13.9695 1.01892 13.4946 1.59949 13.4946C2.18005 13.4946 2.65503 13.9695 2.65503 14.55V16.6611C2.65503 17.2417 3.13 17.7168 3.71057 17.7168H5.82178C6.40222 17.7168 6.87732 18.1917 6.87732 18.7722C6.87732 19.3528 6.40222 19.8279 5.82178 19.8279H2.65503C1.4939 19.8279 0.543945 18.8779 0.543945 17.7168V14.55ZM16.3773 17.7168C16.9579 17.7168 17.4329 17.2417 17.4329 16.6611V14.55C17.4329 13.9695 17.9078 13.4946 18.4884 13.4946C19.069 13.4946 19.5439 13.9695 19.5439 14.55V17.7168C19.5439 18.8779 18.594 19.8279 17.4329 19.8279H14.2661C13.6857 19.8279 13.2106 19.3528 13.2106 18.7722C13.2106 18.1917 13.6857 17.7168 14.2661 17.7168H16.3773ZM14.2661 0.827881H17.4329C18.594 0.827881 19.5439 1.77783 19.5439 2.93896V6.10571C19.5439 6.68628 19.069 7.16113 18.4884 7.16113C17.9078 7.16113 17.4329 6.68628 17.4329 6.10571V3.99463C17.4329 3.41406 16.9579 2.93896 16.3773 2.93896H14.2661C13.6857 2.93896 13.2106 2.46411 13.2106 1.88354C13.2106 1.30298 13.6857 0.827881 14.2661 0.827881ZM5.71057 15.3835H14.3773C14.6121 15.3835 14.8215 15.27 14.9537 15.0952C15.0452 14.9741 15.0995 14.8237 15.0995 14.6611V5.99463C15.0995 5.59741 14.7745 5.27222 14.3773 5.27222H5.71057C5.31335 5.27222 4.9884 5.59741 4.9884 5.99463V14.6611C4.9884 15.0583 5.31335 15.3835 5.71057 15.3835ZM4.9884 3.82788H15.0995C15.8939 3.82788 16.5439 4.47778 16.5439 5.27222V15.3835C16.5439 16.178 15.8939 16.8279 15.0995 16.8279H4.9884C4.19397 16.8279 3.54395 16.178 3.54395 15.3835V5.27222C3.54395 4.47778 4.19397 3.82788 4.9884 3.82788Z"
            />
        ),
    },
    fullscreenContent: {
        viewBox: '0 0 22 22',
        image: (
            <g>
                <path d="M4,18h14V4H4V18z M6,6h10v10H6V6z" />
                <polygon points="2,16 0,16 0,22 6,22 6,20 2,20 		" />
                <polygon points="2,2 6,2 6,0 0,0 0,6 2,6 		" />
                <polygon points="20,20 16,20 16,22 22,22 22,16 20,16 		" />
                <polygon points="16,0 16,2 20,2 20,6 22,6 22,0 		" />
            </g>
        ),
    },
    minimize: {
        viewBox: '0 0 357 357',
        image: (
            <path
                d="M0,280.5h76.5V357h51V229.5H0V280.5z M76.5,76.5H0v51h127.5V0h-51V76.5z M229.5,357h51v-76.5H357v-51H229.5V357z
			 M280.5,76.5V0h-51v127.5H357v-51H280.5z"
            />
        ),
    },
    download_arrow: {
        viewBox: '0 0 433.5 433.5',
        image: <path d="M395.25,153h-102V0h-153v153h-102l178.5,178.5L395.25,153z M38.25,382.5v51h357v-51H38.25z" />,
    },
    help: {
        viewBox: '0 0 404.941 404.941',
        image: (
            <path
                d="M391.689,18.283H13.25C5.931,18.283,0,24.218,0,31.535v242.48c0,7.32,5.931,13.252,13.25,13.252h202.674v86.137
		c0,5.359,3.228,10.193,8.18,12.244c1.64,0.68,3.361,1.01,5.068,1.01c3.446,0,6.838-1.348,9.372-3.883l96.171-95.508h56.975
		c7.32,0,13.252-5.932,13.252-13.252V31.534C404.943,24.217,399.01,18.283,391.689,18.283z M122.471,178.627
		c-13.162,0-23.832-10.67-23.832-23.832c0-13.162,10.67-23.832,23.832-23.832s23.832,10.67,23.832,23.832
		C146.303,167.957,135.633,178.627,122.471,178.627z M202.471,178.627c-13.162,0-23.832-10.67-23.832-23.832
		c0-13.162,10.67-23.832,23.832-23.832c13.162,0,23.832,10.67,23.832,23.832C226.303,167.957,215.633,178.627,202.471,178.627z
		 M282.471,178.627c-13.162,0-23.832-10.67-23.832-23.832c0-13.162,10.67-23.832,23.832-23.832s23.832,10.67,23.832,23.832
		C306.303,167.957,295.633,178.627,282.471,178.627z"
            />
        ),
    },
    home: {
        viewBox: '0 0 510 510',
        image: (
            <polygon
                points="204,471.75 204,318.75 306,318.75 306,471.75 433.5,471.75 433.5,267.75 510,267.75 255,38.25 0,267.75
			76.5,267.75 76.5,471.75 		"
            />
        ),
    },
    list: {
        viewBox: '0 0 16 14',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M1 10H15C15.55 10 16 9.55 16 9C16 8.45 15.55 8 15 8H1C0.45 8 0 8.45 0 9C0 9.55 0.45 10 1 10ZM1 14H15C15.55 14 16 13.55 16 13C16 12.45 15.55 12 15 12H1C0.45 12 0 12.45 0 13C0 13.55 0.45 14 1 14ZM1 6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6ZM0 1C0 1.55 0.45 2 1 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0H1C0.45 0 0 0.45 0 1Z"
            />
        ),
    },
    location: {
        viewBox: '0 0 54.757 54.757',
        image: (
            <path
                d="M40.94,5.617C37.318,1.995,32.502,0,27.38,0c-5.123,0-9.938,1.995-13.56,5.617c-6.703,6.702-7.536,19.312-1.804,26.952
        L27.38,54.757L42.721,32.6C48.476,24.929,47.643,12.319,40.94,5.617z M27.557,26c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7
        S31.416,26,27.557,26z"
            />
        ),
    },
    locationActive: {
        viewBox: '0 0 434.174 434.174',
        image: (
            <g>
                <path d="M217.087,119.397c-24.813,0-45,20.187-45,45s20.187,45,45,45s45-20.187,45-45S241.901,119.397,217.087,119.397z" />
                <path
                    d="M217.087,0c-91.874,0-166.62,74.745-166.62,166.619c0,38.93,13.421,74.781,35.878,103.177l130.742,164.378l130.742-164.378
		c22.457-28.396,35.878-64.247,35.878-103.177C383.707,74.745,308.961,0,217.087,0z M217.087,239.397c-41.355,0-75-33.645-75-75
		s33.645-75,75-75s75,33.645,75,75S258.443,239.397,217.087,239.397z"
                />
            </g>
        ),
    },
    logout: {
        viewBox: '0 0 21 21',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.08833 15.7587C9.54333 16.2137 10.2783 16.2137 10.7333 15.7587L14.9217 11.5703C15.3767 11.1153 15.3767 10.3803 14.9217 9.92533L10.7333 5.737C10.2783 5.282 9.54333 5.282 9.08833 5.737C8.63333 6.192 8.63333 6.92699 9.08833 7.38199L11.2817 9.587H1.16667C0.525 9.587 0 10.112 0 10.7537C0 11.3953 0.525 11.9203 1.16667 11.9203H11.2817L9.08833 14.1137C8.63333 14.5687 8.645 15.3153 9.08833 15.7587ZM18.6667 0.253662H2.33333C1.03833 0.253662 0 1.30366 0 2.587V6.087C0 6.72866 0.525 7.25366 1.16667 7.25366C1.80833 7.25366 2.33333 6.72866 2.33333 6.087V3.75366C2.33333 3.112 2.85833 2.587 3.5 2.587H17.5C18.1417 2.587 18.6667 3.112 18.6667 3.75366V17.7537C18.6667 18.3953 18.1417 18.9203 17.5 18.9203H3.5C2.85833 18.9203 2.33333 18.3953 2.33333 17.7537V15.4203C2.33333 14.7787 1.80833 14.2537 1.16667 14.2537C0.525 14.2537 0 14.7787 0 15.4203V18.9203C0 20.2037 1.05 21.2537 2.33333 21.2537H18.6667C19.95 21.2537 21 20.2037 21 18.9203V2.587C21 1.30366 19.95 0.253662 18.6667 0.253662Z"
            />
        ),
    },
    logout_smartplayer: {
        viewBox: '0 0 21 21',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.08833 15.7587C9.54333 16.2137 10.2783 16.2137 10.7333 15.7587L14.9217 11.5703C15.3767 11.1153 15.3767 10.3803 14.9217 9.92533L10.7333 5.737C10.2783 5.282 9.54333 5.282 9.08833 5.737C8.63333 6.192 8.63333 6.92699 9.08833 7.38199L11.2817 9.587H1.16667C0.525 9.587 0 10.112 0 10.7537C0 11.3953 0.525 11.9203 1.16667 11.9203H11.2817L9.08833 14.1137C8.63333 14.5687 8.645 15.3153 9.08833 15.7587ZM18.6667 0.253662H2.33333C1.03833 0.253662 0 1.30366 0 2.587V6.087C0 6.72866 0.525 7.25366 1.16667 7.25366C1.80833 7.25366 2.33333 6.72866 2.33333 6.087V3.75366C2.33333 3.112 2.85833 2.587 3.5 2.587H17.5C18.1417 2.587 18.6667 3.112 18.6667 3.75366V17.7537C18.6667 18.3953 18.1417 18.9203 17.5 18.9203H3.5C2.85833 18.9203 2.33333 18.3953 2.33333 17.7537V15.4203C2.33333 14.7787 1.80833 14.2537 1.16667 14.2537C0.525 14.2537 0 14.7787 0 15.4203V18.9203C0 20.2037 1.05 21.2537 2.33333 21.2537H18.6667C19.95 21.2537 21 20.2037 21 18.9203V2.587C21 1.30366 19.95 0.253662 18.6667 0.253662Z"
            />
        ),
    },
    videoChat_smartplayer: {
        viewBox: '0 0 20 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18 0H10C4.38 0 0 4.66 0 10.28C0 15.5 4.49 20 9.72 20C15.39 20 20 15.62 20 10V2C20 0.9 19.1 0 18 0ZM15 13L12 11V13H5V7H12V9L15 7V13Z"
            />
        ),
    },
    info: {
        viewBox: '0 0 26 26',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M13 19.5C12.285 19.5 11.7 18.915 11.7 18.2L11.7 13C11.7 12.285 12.285 11.7 13 11.7C13.715 11.7 14.3 12.285 14.3 13L14.3 18.2C14.3 18.915 13.715 19.5 13 19.5ZM13.013 26C20.189 26 26 20.176 26 13C26 5.824 20.189 -5.08014e-07 13.013 -1.13536e-06C5.824 -1.76384e-06 -1.43507e-07 5.824 -7.70853e-07 13C-1.3982e-06 20.176 5.824 26 13.013 26ZM13 2.6C18.746 2.6 23.4 7.254 23.4 13C23.4 18.746 18.746 23.4 13 23.4C7.254 23.4 2.6 18.746 2.6 13C2.6 7.254 7.254 2.6 13 2.6ZM11.7 6.5L14.3 6.5L14.3 9.1L11.7 9.1L11.7 6.5Z"
            />
        ),
    },
    monitor_horizontal: {
        viewBox: '0 0 452.388 452.388',
        image: (
            <path
                d="M441.677,43.643H10.687C4.785,43.643,0,48.427,0,54.329v297.425c0,5.898,4.785,10.676,10.687,10.676h162.069v25.631
			c0,0.38,0.074,0.722,0.112,1.089h-23.257c-5.407,0-9.796,4.389-9.796,9.795c0,5.408,4.389,9.801,9.796,9.801h158.506
			c5.406,0,9.795-4.389,9.795-9.801c0-5.406-4.389-9.795-9.795-9.795h-23.256c0.032-0.355,0.115-0.709,0.115-1.089V362.43H441.7
			c5.898,0,10.688-4.782,10.688-10.676V54.329C452.37,48.427,447.589,43.643,441.677,43.643z M422.089,305.133
			c0,5.903-4.784,10.687-10.683,10.687H40.96c-5.898,0-10.684-4.783-10.684-10.687V79.615c0-5.898,4.786-10.684,10.684-10.684
			h370.446c5.898,0,10.683,4.785,10.683,10.684V305.133z"
            />
        ),
    },
    password: {
        viewBox: '0 0 512 512',
        image: (
            <path
                d="M402.286,190.171h-21.943v-65.83C380.343,55.779,324.563,0,256,0S131.659,55.779,131.659,124.341v65.83h-21.944
			c-12.118,0-21.943,9.825-21.943,21.943v277.943c0,12.118,9.825,21.943,21.943,21.943h292.571c12.118,0,21.943-9.825,21.943-21.943
			V212.114C424.229,199.996,414.404,190.171,402.286,190.171z M277.943,373.029c0,12.118-9.825,21.943-21.943,21.943
			s-21.943-9.825-21.943-21.943v-43.886c0-12.118,9.825-21.943,21.943-21.943s21.943,9.825,21.943,21.943V373.029z M336.457,190.171
			H175.544v-65.83c0-44.363,36.093-80.456,80.456-80.456c44.364,0,80.457,36.093,80.457,80.456V190.171z"
            />
        ),
    },
    pause: {
        viewBox: '0 0 365 365',
        image: (
            <g>
                <rect x="74.5" width="73" height="365" />
                <rect x="217.5" width="73" height="365" />
            </g>
        ),
    },
    play: {
        viewBox: '0 0 41.999 41.999',
        image: (
            <path
                d="M36.068,20.176l-29-20C6.761-0.035,6.363-0.057,6.035,0.114C5.706,0.287,5.5,0.627,5.5,0.999v40
        c0,0.372,0.206,0.713,0.535,0.886c0.146,0.076,0.306,0.114,0.465,0.114c0.199,0,0.397-0.06,0.568-0.177l29-20
        c0.271-0.187,0.432-0.494,0.432-0.823S36.338,20.363,36.068,20.176z"
            />
        ),
    },
    play_video: {
        viewBox: '0 0 60 60',
        image: (
            <g>
                <path
                    d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30
		c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15
		C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"
                />
                <path
                    d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
		S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
                />
            </g>
        ),
    },
    search: {
        viewBox: '0 0 17 17',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M12.5006 11.0006H11.7106L11.4306 10.7306C12.6306 9.33063 13.2506 7.42063 12.9106 5.39063C12.4406 2.61063 10.1206 0.390626 7.32063 0.0506256C3.09063 -0.469374 -0.469374 3.09063 0.0506256 7.32063C0.390626 10.1206 2.61063 12.4406 5.39063 12.9106C7.42063 13.2506 9.33063 12.6306 10.7306 11.4306L11.0006 11.7106V12.5006L15.2506 16.7506C15.6606 17.1606 16.3306 17.1606 16.7406 16.7506C17.1506 16.3406 17.1506 15.6706 16.7406 15.2606L12.5006 11.0006ZM6.50063 11.0006C4.01063 11.0006 2.00063 8.99063 2.00063 6.50063C2.00063 4.01063 4.01063 2.00063 6.50063 2.00063C8.99063 2.00063 11.0006 4.01063 11.0006 6.50063C11.0006 8.99063 8.99063 11.0006 6.50063 11.0006Z"
            />
        ),
    },
    gear_black: {
        viewBox: '0 0 21.589 21.589',
        image: (
            <path
                d="M18.622,8.371l-0.545-1.295c0,0,1.268-2.861,1.156-2.971l-1.679-1.639c-0.116-0.113-2.978,1.193-2.978,1.193l-1.32-0.533
		c0,0-1.166-2.9-1.326-2.9H9.561c-0.165,0-1.244,2.906-1.244,2.906L6.999,3.667c0,0-2.922-1.242-3.034-1.131L2.289,4.177
		C2.173,4.29,3.507,7.093,3.507,7.093L2.962,8.386c0,0-2.962,1.141-2.962,1.295v2.322c0,0.162,2.969,1.219,2.969,1.219l0.545,1.291
		c0,0-1.268,2.859-1.157,2.969l1.678,1.643c0.114,0.111,2.977-1.195,2.977-1.195l1.321,0.535c0,0,1.166,2.898,1.327,2.898h2.369
		c0.164,0,1.244-2.906,1.244-2.906l1.322-0.535c0,0,2.916,1.242,3.029,1.133l1.678-1.641c0.117-0.115-1.22-2.916-1.22-2.916
		l0.544-1.293c0,0,2.963-1.143,2.963-1.299v-2.32C21.59,9.425,18.622,8.371,18.622,8.371z M14.256,10.794
		c0,1.867-1.553,3.387-3.461,3.387c-1.906,0-3.461-1.52-3.461-3.387s1.555-3.385,3.461-3.385
		C12.704,7.41,14.256,8.927,14.256,10.794z"
            />
        ),
    },
    page_settings: {
        viewBox: '0 0 17 22',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.59 0.59C10.21 0.21 9.7 0 9.17 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H6.68355L6.17597 19.1459L6.16956 19.1351L6.16341 19.1241C5.8697 18.6003 5.97886 17.9131 6.48826 17.5219L6.49191 17.5191L7.146 17.0216L7.14594 17L7.146 16.9784L6.49191 16.4809L6.48825 16.4781C6.00988 16.1108 5.83602 15.4201 6.1776 14.8514L7.19987 13.1311C7.51952 12.5782 8.18034 12.3801 8.73298 12.5904L8.74113 12.5935L9.54186 12.9064C9.56565 12.8925 9.58963 12.8788 9.6138 12.8653L9.73102 12.0701C9.82198 11.4125 10.393 11 10.9731 11H13.0292C13.6093 11 14.1803 11.4125 14.2713 12.0701L14.3882 12.8634C14.4131 12.8772 14.4379 12.8913 14.4625 12.9056L15.2612 12.5935L15.2763 12.5876L15.2916 12.5822C15.509 12.5053 15.7591 12.4891 16 12.543V6.83C16 6.3 15.79 5.79 15.41 5.42L10.59 0.59ZM9.59318 20L8.37725 20.475C8.26416 20.515 8.12537 20.475 8.06369 20.365L7.84679 20L7.03564 18.635C6.97396 18.525 6.99966 18.39 7.09732 18.315L8.18192 17.49C8.16136 17.33 8.14594 17.165 8.14594 17C8.14594 16.835 8.16136 16.67 8.18192 16.51L7.09732 15.685C6.99966 15.61 6.96881 15.475 7.03564 15.365L8.06369 13.635C8.12537 13.525 8.25902 13.48 8.37725 13.525L9.65717 14.025C9.92447 13.83 10.2123 13.66 10.5259 13.535L10.7212 12.21C10.7366 12.09 10.8446 12 10.9731 12H13.0292C13.1577 12 13.2656 12.09 13.2811 12.21L13.4764 13.535C13.7899 13.66 14.0778 13.825 14.3451 14.025L15.625 13.525C15.7381 13.485 15.8769 13.525 15.9386 13.635L16 13.7384L16.9666 15.365C17.0283 15.475 17.0026 15.61 16.9049 15.685L16 16.3734L15.8204 16.51C15.8409 16.67 15.8563 16.83 15.8563 17C15.8563 17.17 15.8409 17.33 15.8204 17.49L16 17.6266L16.9049 18.315C17.0026 18.39 17.0283 18.525 16.9666 18.635L15.9386 20.365C15.8769 20.475 15.7432 20.52 15.625 20.475L14.3451 19.975C14.0778 20.17 13.7899 20.34 13.4764 20.465L13.2811 21.79C13.2656 21.91 13.1577 22 13.0292 22H10.9731C10.8446 22 10.7366 21.91 10.7212 21.79L10.5259 20.465C10.2255 20.3452 9.94868 20.1888 9.69094 20C9.67966 19.9917 9.66839 19.9834 9.65717 19.975L9.59318 20ZM9 6V1.5L14.5 7H10C9.45 7 9 6.55 9 6ZM10.202 17C10.202 17.965 11.0091 18.75 12.0011 18.75C12.9932 18.75 13.8002 17.965 13.8002 17C13.8002 16.035 12.9932 15.25 12.0011 15.25C11.0091 15.25 10.202 16.035 10.202 17Z"
            />
        ),
    },
    audio_settings: {
        viewBox: '0 0 18 19',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 5.77002V11.77H4L6.63794 14.4082L7.146 14.0215V14V13.9785L6.49194 13.481L6.48828 13.478C6.00989 13.1108 5.83606 12.4199 6.17761 11.8516L7.19983 10.1313C7.51953 9.57812 8.1803 9.37988 8.73303 9.59033L8.74109 9.59375L9 9.69482V0.77002L4 5.77002H0ZM18 8.77002C18 9.70654 17.8568 10.6094 17.5912 11.4585L16.8025 10.1313C16.6042 9.78809 16.2878 9.59668 15.9587 9.53467C15.986 9.2832 16 9.02832 16 8.77002C16 5.6001 13.89 2.91992 11 2.06006V0C15.01 0.910156 18 4.49023 18 8.77002ZM15.9386 10.6348C15.9039 10.5732 15.845 10.5337 15.7799 10.5176C15.7291 10.5054 15.6746 10.5073 15.625 10.5249L14.3451 11.0249C14.0778 10.8252 13.7899 10.6602 13.4764 10.5352L13.3732 9.83496L13.281 9.20996C13.2656 9.08984 13.1577 9 13.0292 9H11H10.973C10.9025 9 10.838 9.02734 10.7917 9.07178C10.7539 9.10791 10.7281 9.15576 10.7212 9.20996L10.5259 10.5352C10.2123 10.6602 9.92444 10.8301 9.65723 11.0249L9 10.7681L8.3772 10.5249C8.31018 10.4995 8.23828 10.5029 8.17725 10.5308C8.13062 10.5518 8.09045 10.5874 8.06372 10.6348L7.03564 12.3652C6.96887 12.4751 6.99963 12.6099 7.09729 12.6851L8.18188 13.5098C8.16138 13.6699 8.146 13.835 8.146 14C8.146 14.165 8.16138 14.3301 8.18188 14.4902L7.35156 15.1216L7.09729 15.3149C6.99963 15.3901 6.974 15.5249 7.03564 15.6348L8.06372 17.3652C8.08533 17.4038 8.11633 17.4336 8.15247 17.4546C8.21936 17.4932 8.30371 17.501 8.3772 17.4751L9.65723 16.9751C9.92444 17.1748 10.2123 17.3398 10.5259 17.4648L10.7212 18.79C10.7366 18.9102 10.8446 19 10.973 19H13.0292C13.1577 19 13.2656 18.9102 13.281 18.79L13.4764 17.4648C13.7899 17.3398 14.0778 17.1699 14.3451 16.9751L15.625 17.4751C15.7433 17.52 15.877 17.4751 15.9386 17.3652L16.9667 15.6348C17.0283 15.5249 17.0026 15.3901 16.9049 15.3149L15.897 14.5483L15.8203 14.4902C15.8409 14.3301 15.8563 14.1699 15.8563 14C15.8563 13.8301 15.8409 13.6699 15.8203 13.5098L16.9049 12.6851C17.0026 12.6099 17.0283 12.4751 16.9667 12.3652L15.9386 10.6348ZM11.0283 15.4717C11.309 15.6475 11.6429 15.75 12.0011 15.75C12.9932 15.75 13.8002 14.9648 13.8002 14C13.8002 13.9951 13.8002 13.9902 13.8002 13.9854C13.7924 13.0269 12.9883 12.25 12.0011 12.25C11.8397 12.25 11.6833 12.2705 11.5344 12.3096C11.3416 12.3599 11.1615 12.4409 11 12.5464C10.519 12.8608 10.202 13.395 10.202 14C10.202 14.6167 10.5315 15.1597 11.0283 15.4717ZM11 4.74023C12.2812 5.38037 13.2177 6.60547 13.4462 8.07129C13.3123 8.02441 13.171 8 13.0292 8H11V4.74023Z"
            />
        ),
    },
    sort: {
        viewBox: '0 0 12.59 17.57',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.2915 13.8025V7.7925C10.2915 7.2425 9.84153 6.7925 9.29153 6.7925C8.74153 6.7925 8.29153 7.2425 8.29153 7.7925V13.8025H6.50153C6.05153 13.8025 5.83153 14.3425 6.15153 14.6525L8.94153 17.4325C9.14153 17.6225 9.45153 17.6225 9.65153 17.4325L12.4415 14.6525C12.7615 14.3425 12.5315 13.8025 12.0915 13.8025H10.2915ZM2.94153 0.1425L0.151534 2.9325C-0.168466 3.2425 0.0515344 3.7825 0.501534 3.7825H2.29153V9.7925C2.29153 10.3425 2.74153 10.7925 3.29153 10.7925C3.84153 10.7925 4.29153 10.3425 4.29153 9.7925V3.7825H6.08153C6.53153 3.7825 6.75153 3.2425 6.43153 2.9325L3.64153 0.1425C3.45153 -0.0475 3.13153 -0.0475 2.94153 0.1425Z"
            />
        ),
    },
    volume_max: {
        viewBox: '0 0 18 17',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M0 6.46102V10.461C0 11.011 0.45 11.461 1 11.461H4L7.29 14.751C7.92 15.381 9 14.931 9 14.041V2.87102C9 1.98102 7.92 1.53102 7.29 2.16102L4 5.46102H1C0.45 5.46102 0 5.91102 0 6.46102ZM13.5 8.46102C13.5 6.69102 12.48 5.17102 11 4.43102V12.481C12.48 11.751 13.5 10.231 13.5 8.46102ZM11 0.911022V1.11102C11 1.49102 11.25 1.82102 11.6 1.96102C14.18 2.99102 16 5.52102 16 8.46102C16 11.401 14.18 13.931 11.6 14.961C11.24 15.101 11 15.431 11 15.811V16.011C11 16.641 11.63 17.081 12.21 16.861C15.6 15.571 18 12.301 18 8.46102C18 4.62102 15.6 1.35102 12.21 0.0610225C11.63 -0.168977 11 0.281022 11 0.911022Z"
            />
        ),
    },
    volume_min: {
        viewBox: '0 0 408 408',
        image: <path d="M89.25,127.5v153h102L318.75,408V0l-127.5,127.5H89.25z" />,
    },
    volume_mute: {
        viewBox: '0 0 18 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M0.63 0.2925C0.24 0.6825 0.24 1.3125 0.63 1.7025L4.29 5.3625L4 5.6625H1C0.45 5.6625 0 6.1125 0 6.6625V10.6625C0 11.2125 0.45 11.6625 1 11.6625H4L7.29 14.9525C7.92 15.5825 9 15.1325 9 14.2425V10.0725L13.18 14.2525C12.69 14.6225 12.16 14.9325 11.58 15.1625C11.22 15.3125 11 15.6925 11 16.0825C11 16.8025 11.73 17.2625 12.39 16.9925C13.19 16.6625 13.94 16.2225 14.61 15.6825L15.95 17.0225C16.34 17.4125 16.97 17.4125 17.36 17.0225C17.75 16.6325 17.75 16.0025 17.36 15.6125L2.05 0.2925C1.66 -0.0975 1.03 -0.0975 0.63 0.2925ZM16 8.6625C16 9.4825 15.85 10.2725 15.59 11.0025L17.12 12.5325C17.68 11.3625 18 10.0525 18 8.6625C18 4.8325 15.6 1.5525 12.22 0.2625C11.63 0.0324998 11 0.4925 11 1.1225V1.3125C11 1.6925 11.25 2.0225 11.61 2.1625C14.18 3.2025 16 5.7225 16 8.6625ZM7.29 2.3725L7.12 2.5425L9 4.4225V3.0725C9 2.1825 7.92 1.7425 7.29 2.3725ZM13.5 8.6625C13.5 6.8925 12.48 5.3725 11 4.6325V6.4225L13.48 8.9025C13.49 8.8225 13.5 8.7425 13.5 8.6625Z"
            />
        ),
    },
    statistics: {
        viewBox: '0 0 333.977 333.977',
        image: (
            <path
                d="M305.188,65.777c-15.874,0-28.789,12.915-28.789,28.789c0,5.521,1.565,10.682,4.271,15.068l-59.435,70.333
        c-3.445-1.46-7.23-2.269-11.201-2.269c-6.512,0-12.522,2.176-17.352,5.835l-50.122-36.198c0.716-2.507,1.106-5.15,1.106-7.884
        c0-15.873-12.915-28.786-28.789-28.786c-15.875,0-28.789,12.914-28.789,28.786c0,5.319,1.456,10.303,3.981,14.583L40.535,213.14
        c-3.591-1.611-7.564-2.516-11.748-2.516C12.914,210.624,0,223.538,0,239.41c0,15.874,12.914,28.789,28.787,28.789
        c15.874,0,28.789-12.914,28.789-28.789c0-5.136-1.358-9.958-3.726-14.137l49.733-59.343c3.47,1.485,7.287,2.31,11.293,2.31
        c6.61,0,12.703-2.246,17.568-6.006l49.982,36.096c-0.766,2.588-1.184,5.323-1.184,8.156c0,15.873,12.915,28.787,28.789,28.787
        c15.873,0,28.787-12.914,28.787-28.787c0-5.355-1.475-10.372-4.032-14.671l59.63-70.562c3.329,1.348,6.963,2.098,10.77,2.098
        c15.874,0,28.789-12.914,28.789-28.786C333.977,78.692,321.061,65.777,305.188,65.777z"
            />
        ),
    },
    statistics_smartplayer: {
        viewBox: '0 0 24 13',
        image: (
            <path d="M24 2.16667C24 3.35833 23.0182 4.33333 21.8182 4.33333C21.6218 4.33333 21.4364 4.31167 21.2618 4.2575L17.3782 8.10333C17.4327 8.27667 17.4545 8.47167 17.4545 8.66667C17.4545 9.85833 16.4727 10.8333 15.2727 10.8333C14.0727 10.8333 13.0909 9.85833 13.0909 8.66667C13.0909 8.47167 13.1127 8.27667 13.1673 8.10333L10.3855 5.34083C10.2109 5.395 10.0145 5.41667 9.81818 5.41667C9.62182 5.41667 9.42545 5.395 9.25091 5.34083L4.28727 10.2808C4.34182 10.4542 4.36364 10.6383 4.36364 10.8333C4.36364 12.025 3.38182 13 2.18182 13C0.981818 13 0 12.025 0 10.8333C0 9.64167 0.981818 8.66667 2.18182 8.66667C2.37818 8.66667 2.56364 8.68833 2.73818 8.7425L7.71273 3.81333C7.65818 3.64 7.63636 3.445 7.63636 3.25C7.63636 2.05833 8.61818 1.08333 9.81818 1.08333C11.0182 1.08333 12 2.05833 12 3.25C12 3.445 11.9782 3.64 11.9236 3.81333L14.7055 6.57583C14.88 6.52167 15.0764 6.5 15.2727 6.5C15.4691 6.5 15.6655 6.52167 15.84 6.57583L19.7127 2.71917C19.6582 2.54583 19.6364 2.36167 19.6364 2.16667C19.6364 0.975 20.6182 0 21.8182 0C23.0182 0 24 0.975 24 2.16667ZM24 2.16667C24 3.35833 23.0182 4.33333 21.8182 4.33333C21.6218 4.33333 21.4364 4.31167 21.2618 4.2575L17.3782 8.10333C17.4327 8.27667 17.4545 8.47167 17.4545 8.66667C17.4545 9.85833 16.4727 10.8333 15.2727 10.8333C14.0727 10.8333 13.0909 9.85833 13.0909 8.66667C13.0909 8.47167 13.1127 8.27667 13.1673 8.10333L10.3855 5.34083C10.2109 5.395 10.0145 5.41667 9.81818 5.41667C9.62182 5.41667 9.42545 5.395 9.25091 5.34083L4.28727 10.2808C4.34182 10.4542 4.36364 10.6383 4.36364 10.8333C4.36364 12.025 3.38182 13 2.18182 13C0.981818 13 0 12.025 0 10.8333C0 9.64167 0.981818 8.66667 2.18182 8.66667C2.37818 8.66667 2.56364 8.68833 2.73818 8.7425L7.71273 3.81333C7.65818 3.64 7.63636 3.445 7.63636 3.25C7.63636 2.05833 8.61818 1.08333 9.81818 1.08333C11.0182 1.08333 12 2.05833 12 3.25C12 3.445 11.9782 3.64 11.9236 3.81333L14.7055 6.57583C14.88 6.52167 15.0764 6.5 15.2727 6.5C15.4691 6.5 15.6655 6.52167 15.84 6.57583L19.7127 2.71917C19.6582 2.54583 19.6364 2.36167 19.6364 2.16667C19.6364 0.975 20.6182 0 21.8182 0C23.0182 0 24 0.975 24 2.16667Z" />
        ),
    },
    tile: {
        viewBox: '0 0 16 16',
        image: (
            <g>
                <path d="M0.941176 4.8H3.76471C4.28235 4.8 4.70588 4.44 4.70588 4V0.8C4.70588 0.36 4.28235 0 3.76471 0H0.941176C0.423529 0 0 0.36 0 0.8V4C0 4.44 0.423529 4.8 0.941176 4.8ZM0.941176 10.4H3.76471C4.28235 10.4 4.70588 10.04 4.70588 9.6V6.4C4.70588 5.96 4.28235 5.6 3.76471 5.6H0.941176C0.423529 5.6 0 5.96 0 6.4V9.6C0 10.04 0.423529 10.4 0.941176 10.4ZM6.58824 10.4H9.41177C9.92941 10.4 10.3529 10.04 10.3529 9.6V6.4C10.3529 5.96 9.92941 5.6 9.41177 5.6H6.58824C6.07059 5.6 5.64706 5.96 5.64706 6.4V9.6C5.64706 10.04 6.07059 10.4 6.58824 10.4ZM12.2353 10.4H15.0588C15.5765 10.4 16 10.04 16 9.6V6.4C16 5.96 15.5765 5.6 15.0588 5.6H12.2353C11.7176 5.6 11.2941 5.96 11.2941 6.4V9.6C11.2941 10.04 11.7176 10.4 12.2353 10.4ZM6.58824 4.8H9.41177C9.92941 4.8 10.3529 4.44 10.3529 4V0.8C10.3529 0.36 9.92941 0 9.41177 0H6.58824C6.07059 0 5.64706 0.36 5.64706 0.8V4C5.64706 4.44 6.07059 4.8 6.58824 4.8ZM11.2941 0.8V4C11.2941 4.44 11.7176 4.8 12.2353 4.8H15.0588C15.5765 4.8 16 4.44 16 4V0.8C16 0.36 15.5765 0 15.0588 0H12.2353C11.7176 0 11.2941 0.36 11.2941 0.8Z" />
                <path d="M0.941176 10.4H3.76471C4.28235 10.4 4.70588 10.04 4.70588 9.6V6.4C4.70588 5.96 4.28235 5.6 3.76471 5.6H0.941176C0.423529 5.6 0 5.96 0 6.4V9.6C0 10.04 0.423529 10.4 0.941176 10.4ZM0.941176 16H3.76471C4.28235 16 4.70588 15.64 4.70588 15.2V12C4.70588 11.56 4.28235 11.2 3.76471 11.2H0.941176C0.423529 11.2 0 11.56 0 12V15.2C0 15.64 0.423529 16 0.941176 16ZM6.58824 16H9.41177C9.92941 16 10.3529 15.64 10.3529 15.2V12C10.3529 11.56 9.92941 11.2 9.41177 11.2H6.58824C6.07059 11.2 5.64706 11.56 5.64706 12V15.2C5.64706 15.64 6.07059 16 6.58824 16ZM12.2353 16H15.0588C15.5765 16 16 15.64 16 15.2V12C16 11.56 15.5765 11.2 15.0588 11.2H12.2353C11.7176 11.2 11.2941 11.56 11.2941 12V15.2C11.2941 15.64 11.7176 16 12.2353 16ZM6.58824 10.4H9.41177C9.92941 10.4 10.3529 10.04 10.3529 9.6V6.4C10.3529 5.96 9.92941 5.6 9.41177 5.6H6.58824C6.07059 5.6 5.64706 5.96 5.64706 6.4V9.6C5.64706 10.04 6.07059 10.4 6.58824 10.4ZM11.2941 6.4V9.6C11.2941 10.04 11.7176 10.4 12.2353 10.4H15.0588C15.5765 10.4 16 10.04 16 9.6V6.4C16 5.96 15.5765 5.6 15.0588 5.6H12.2353C11.7176 5.6 11.2941 5.96 11.2941 6.4Z" />
            </g>
        ),
    },
    view: {
        viewBox: '0 0 18 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9 3.375C5.25 3.375 2.0475 5.7075 0.75 9C2.0475 12.2925 5.25 14.625 9 14.625C12.75 14.625 15.9525 12.2925 17.25 9C15.9525 5.7075 12.75 3.375 9 3.375ZM9 12.75C6.93 12.75 5.25 11.07 5.25 9C5.25 6.93 6.93 5.25 9 5.25C11.07 5.25 12.75 6.93 12.75 9C12.75 11.07 11.07 12.75 9 12.75ZM9 6.75C7.755 6.75 6.75 7.755 6.75 9C6.75 10.245 7.755 11.25 9 11.25C10.245 11.25 11.25 10.245 11.25 9C11.25 7.755 10.245 6.75 9 6.75Z"
            />
        ),
    },
    displayWithGear: {
        viewBox: '0 0 18 16',
        image: (
            <g>
                <path d="M1.6365 0.5H16.3635C17.2635 0.5 18 1.25 18 2.1665L17.9963 6.66705C17.9961 6.94307 17.7722 7.1667 17.4962 7.16664L16.8626 7.16649C16.5865 7.16643 16.3627 6.94259 16.3627 6.66649V2.99975C16.3627 2.5415 15.9945 2.1665 15.5445 2.1665H2.45325C2.00325 2.1665 1.63575 2.5415 1.63575 3.0005V11.333C1.63575 11.792 2.004 12.167 2.454 12.167H8.5C8.77614 12.167 9 12.3909 9 12.667V15C9 15.2761 8.77614 15.5 8.5 15.5H6.54525C6.09525 15.5 5.727 15.125 5.727 14.666V13.8335H1.6365C0.7365 13.8335 0 13.0835 0 12.167V2.1665C0 1.25 0.7365 0.5 1.6365 0.5Z" />
                <path d="M17.0396 11.8483C17.0642 11.6161 17.0724 11.3839 17.0478 11.1597L17.9233 10.479C18.0051 10.4149 18.0215 10.3108 17.9724 10.2227L17.1296 8.78929C17.0805 8.7012 16.9742 8.66917 16.876 8.7012L15.8287 9.1016C15.6405 8.96547 15.4359 8.85335 15.215 8.76527L15.0514 7.67618C15.035 7.57207 14.9532 7.5 14.8468 7.5H13.1532C13.055 7.5 12.965 7.57207 12.9486 7.66817L12.785 8.75726C12.5722 8.84535 12.3677 8.96547 12.1795 9.09359L11.1322 8.69319C11.034 8.65315 10.9276 8.69319 10.8785 8.78128L10.0358 10.2147C9.9867 10.3028 10.0031 10.4069 10.0849 10.471L10.9604 11.1597C10.9358 11.3919 10.9276 11.6241 10.9522 11.8483L10.0767 12.529C9.99489 12.5931 9.97852 12.6972 10.0276 12.7853L10.8704 14.2187C10.9195 14.3068 11.0258 14.3388 11.124 14.3068L12.1631 13.9064C12.3513 14.0425 12.5559 14.1547 12.7768 14.2427L12.9404 15.3318C12.9568 15.4279 13.0386 15.5 13.145 15.5H14.8387C14.9368 15.5 15.0268 15.4279 15.0432 15.3318L15.2069 14.2427C15.4196 14.1547 15.6241 14.0345 15.8123 13.9064L16.8596 14.3068C16.9578 14.3468 17.0642 14.3068 17.1133 14.2187L17.956 12.7853C18.0051 12.6972 17.9887 12.5931 17.9069 12.529L17.0396 11.8483ZM14.0041 12.7052C13.325 12.7052 12.7768 12.1687 12.7768 11.504C12.7768 10.8393 13.325 10.3028 14.0041 10.3028C14.6832 10.3028 15.2314 10.8393 15.2314 11.504C15.2314 12.1687 14.6832 12.7052 14.0041 12.7052Z" />
            </g>
        ),
    },
    viewHide: {
        viewBox: '0 0 932.05 932.05',
        image: (
            <g>
                <path
                    d="M146.375,658.475l121.7-121.699c-7.9-22.101-12.2-45.9-12.2-70.7c0-116.101,94.1-210.1,210.1-210.1
			c24.801,0,48.601,4.3,70.7,12.2l83.101-83.1c-48.5-15.3-100.2-23.5-153.7-23.5c-205.6,0-382.8,121.2-464.2,296.1
			c-2.5,5.3-2.5,11.5,0,16.9C35.375,546.475,85.075,609.375,146.375,658.475z"
                />
                <path
                    d="M785.675,273.675l-121.7,121.7c7.9,22.1,12.2,45.9,12.2,70.7c0,116.1-94.1,210.1-210.1,210.1
			c-24.8,0-48.601-4.3-70.7-12.2l-83.1,83.101c48.5,15.3,100.199,23.5,153.699,23.5c205.601,0,382.801-121.2,464.2-296.101
			c2.5-5.3,2.5-11.5,0-16.899C896.675,385.675,846.975,322.775,785.675,273.675z"
                />
                <path
                    d="M466.075,600.575c74.3,0,134.5-60.2,134.5-134.5c0-2.3-0.101-4.7-0.2-7l-141.3,141.3
			C461.375,600.475,463.675,600.575,466.075,600.575z"
                />
                <path
                    d="M466.075,331.675c-74.3,0-134.5,60.2-134.5,134.5c0,2.3,0.1,4.7,0.2,7l141.3-141.3
			C470.675,331.675,468.375,331.675,466.075,331.675z"
                />
                <path
                    d="M178.875,682.475l-63.2,63.2c-19.5,19.5-19.5,51.2,0,70.7c9.8,9.8,22.6,14.6,35.4,14.6c12.8,0,25.6-4.899,35.4-14.6
			l84.4-84.4l86.2-86.199l56.1-56.101l176.601-176.6l56.1-56.101l107.4-107.399l63.199-63.2c19.5-19.5,19.5-51.2,0-70.7
			c-9.8-9.8-22.6-14.6-35.399-14.6s-25.601,4.9-35.4,14.6l-84.399,84.4l-86.2,86.2l-56.101,56.1l-176.6,176.6l-56.1,56.101
			L178.875,682.475z"
                />
            </g>
        ),
    },
    web_page: {
        viewBox: '0 0 370 370',
        image: (
            <path
                d="M278.751,122.256C266.736,81.844,229.313,52.369,185,52.369s-81.736,29.475-93.751,69.887
	C40.291,125.626,0,168.02,0,219.832c0,54.014,43.787,97.799,97.8,97.799h174.4c54.013,0,97.8-43.785,97.8-97.799
	C370,168.02,329.709,125.626,278.751,122.256z M157.936,220.996c3.325,2.756,3.781,7.688,1.02,11.012
	c-1.545,1.861-3.776,2.822-6.02,2.822c-1.761,0-3.531-0.59-4.99-1.803l-30.131-25.01c-1.789-1.488-2.823-3.689-2.823-6.018
	c0-2.324,1.034-4.527,2.823-6.014l30.131-25.012c3.323-2.758,8.257-2.299,11.01,1.023c2.762,3.324,2.306,8.254-1.02,11.012
	L135.053,202L157.936,220.996z M206.875,154.57l-28.726,99.213c-0.998,3.422-4.115,5.645-7.511,5.645
	c-0.722,0-1.451-0.1-2.179-0.311c-4.147-1.199-6.533-5.533-5.334-9.684l28.724-99.213c1.203-4.146,5.539-6.535,9.688-5.336
	C205.686,146.086,208.072,150.42,206.875,154.57z M252.184,208.018l-30.131,25.01c-1.461,1.213-3.229,1.803-4.99,1.803
	c-2.245,0-4.475-0.961-6.02-2.822c-2.758-3.324-2.306-8.256,1.02-11.012L234.946,202l-22.883-18.99
	c-3.325-2.758-3.777-7.688-1.02-11.012c2.757-3.322,7.689-3.781,11.01-1.023l30.131,25.012c1.79,1.486,2.824,3.689,2.824,6.014
	C255.008,204.328,253.974,206.529,252.184,208.018z"
            />
        ),
    },
    web_app: {
        viewBox: '0 0 18.9 18.9',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.9985 11.8925V17.8925C10.9985 18.4425 11.4485 18.8925 11.9985 18.8925H17.9985C18.5485 18.8925 18.9985 18.4425 18.9985 17.8925V11.8925C18.9985 11.3425 18.5485 10.8925 17.9985 10.8925H11.9985C11.4485 10.8925 10.9985 11.3425 10.9985 11.8925ZM1.99854 18.8925H7.99854C8.54854 18.8925 8.99854 18.4425 8.99854 17.8925V11.8925C8.99854 11.3425 8.54854 10.8925 7.99854 10.8925H1.99854C1.44854 10.8925 0.998535 11.3425 0.998535 11.8925V17.8925C0.998535 18.4425 1.44854 18.8925 1.99854 18.8925ZM0.998535 1.8925V7.8925C0.998535 8.4425 1.44854 8.8925 1.99854 8.8925H7.99854C8.54854 8.8925 8.99854 8.4425 8.99854 7.8925V1.8925C8.99854 1.3425 8.54854 0.8925 7.99854 0.8925H1.99854C1.44854 0.8925 0.998535 1.3425 0.998535 1.8925ZM13.9485 0.2925L9.69853 4.5325C9.30853 4.9225 9.30853 5.5525 9.69853 5.9425L13.9485 10.1925C14.3385 10.5825 14.9685 10.5825 15.3585 10.1925L19.6085 5.9425C19.9985 5.5525 19.9985 4.9225 19.6085 4.5325L15.3685 0.2925C14.9785 -0.0975 14.3385 -0.0975 13.9485 0.2925Z"
            />
        ),
    },
    clean: {
        viewBox: '0 0 303.261 303.261',
        image: (
            <path
                d="M298.012,5.249c-6.996-6.998-18.342-6.998-25.342,0.002l-97.545,97.545l-17.58-17.58c-5.857-5.857-15.355-5.857-21.213,0
        L125.758,95.79c-25.597,6.1-51.193,12.2-76.79,18.303l-40.902,9.751c-3.425,0.816-6.213,3.295-7.424,6.601
        c-1.212,3.306-0.686,6.999,1.4,9.835c45.266,61.527,99.414,115.675,160.94,160.939c1.83,1.346,4.016,2.042,6.224,2.042
        c1.216,0,2.439-0.211,3.612-0.641c3.306-1.212,5.784-4,6.601-7.425l12.213-51.234c5.281-22.153,10.561-44.305,15.839-66.458
        l10.574-10.574c5.857-5.857,5.857-15.355,0-21.213l-17.579-17.579l97.546-97.546C305.012,23.591,305.01,12.245,298.012,5.249z
         M162.708,274.732c-8.537-6.569-16.908-13.333-25.134-20.258l13.832-38.98l-27.336,27.334c-9.842-8.703-19.438-17.669-28.793-26.881
        l13.736-21.701l-21.768,13.668c-8.564-8.699-16.912-17.611-25.036-26.732l27.442-27.441l-39.219,13.916
        c-7.506-8.853-14.812-17.886-21.905-27.103l93.503-22.288l62.964,62.964L162.708,274.732z"
            />
        ),
    },
    zoom_in: {
        viewBox: '0 0 52.966 52.966',
        image: (
            <g>
                <path
                    d="M28.983,20h-6v-6c0-0.552-0.448-1-1-1s-1,0.448-1,1v6h-6c-0.552,0-1,0.448-1,1s0.448,1,1,1h6v6c0,0.552,0.448,1,1,1
		s1-0.448,1-1v-6h6c0.552,0,1-0.448,1-1S29.535,20,28.983,20z"
                />
                <path
                    d="M51.704,51.273L36.845,35.82c3.79-3.801,6.138-9.041,6.138-14.82c0-11.58-9.42-21-21-21s-21,9.42-21,21s9.42,21,21,21
		c5.083,0,9.748-1.817,13.384-4.832l14.895,15.491c0.196,0.205,0.458,0.307,0.721,0.307c0.25,0,0.499-0.093,0.693-0.279
		C52.074,52.304,52.086,51.671,51.704,51.273z M2.983,21c0-10.477,8.523-19,19-19s19,8.523,19,19s-8.523,19-19,19
		S2.983,31.477,2.983,21z"
                />
            </g>
        ),
    },
    zoom_in_bold: {
        viewBox: '0 0 22 22',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1798 15.0155H16.1992L21.6708 20.5096C22.2 21.0384 22.2 21.9027 21.6708 22.4315C21.1417 22.9601 20.2771 22.9601 19.7481 22.4315L14.2636 16.9501V15.9313L13.9152 15.5702C12.1085 17.1178 9.6437 17.9173 7.02407 17.4789C3.43654 16.8727 0.571675 13.8807 0.132954 10.2694C-0.538066 4.81407 4.05593 0.222518 9.51467 0.893172C13.1279 1.33189 16.1218 4.19493 16.7283 7.78038C17.1671 10.3985 16.367 12.8617 14.8185 14.6673L15.1798 15.0155ZM2.64943 9.21178C2.64943 12.4232 5.24318 15.0155 8.45644 15.0155C11.6697 15.0155 14.2636 12.4232 14.2636 9.21178C14.2636 6.00059 11.6697 3.40831 8.45644 3.40831C5.24318 3.40831 2.64943 6.00059 2.64943 9.21178ZM8.27907 5.61925C8.34963 5.57237 8.43435 5.54503 8.52553 5.54503C8.76589 5.54503 8.96828 5.74742 8.96828 5.98765V9.08018H12.0607C12.3074 9.08018 12.5065 9.2794 12.5065 9.52598C12.5065 9.77257 12.3074 9.97179 12.0607 9.97179H8.96828V13.0643C8.96828 13.3109 8.76906 13.5101 8.52236 13.5101C8.27578 13.5101 8.07656 13.3109 8.07656 13.0643V9.97179H4.98415C4.8528 9.97179 4.73488 9.91514 4.65334 9.82506C4.58181 9.7462 4.53823 9.64122 4.53823 9.52598C4.53823 9.2794 4.73745 9.08018 4.98415 9.08018H8.07656L8.07973 5.99083C8.07973 5.83555 8.15883 5.69908 8.27907 5.61925Z"
            />
        ),
    },
    zoom_out: {
        viewBox: '0 0 52.966 52.966',
        image: (
            <g>
                <path d="M28.983,20h-14c-0.552,0-1,0.448-1,1s0.448,1,1,1h14c0.552,0,1-0.448,1-1S29.535,20,28.983,20z" />
                <path
                    d="M51.704,51.273L36.845,35.82c3.79-3.801,6.138-9.041,6.138-14.82c0-11.58-9.42-21-21-21s-21,9.42-21,21s9.42,21,21,21
		c5.083,0,9.748-1.817,13.384-4.832l14.895,15.491c0.196,0.205,0.458,0.307,0.721,0.307c0.25,0,0.499-0.093,0.693-0.279
		C52.074,52.304,52.086,51.671,51.704,51.273z M2.983,21c0-10.477,8.523-19,19-19s19,8.523,19,19s-8.523,19-19,19
		S2.983,31.477,2.983,21z"
                />
            </g>
        ),
    },
    zoom_out_bold: {
        viewBox: '0 0 22 22',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1798 15.0155H16.1992L21.6708 20.5096C22.2 21.0384 22.2 21.9027 21.6708 22.4315C21.1417 22.9601 20.2771 22.9601 19.7481 22.4315L14.2636 16.9501V15.9313L13.9152 15.5702C12.1085 17.1178 9.6437 17.9173 7.02407 17.4789C3.43654 16.8727 0.571675 13.8807 0.132954 10.2694C-0.538066 4.81407 4.05593 0.222518 9.51467 0.893172C13.1279 1.33189 16.1218 4.19493 16.7283 7.78038C17.1671 10.3985 16.367 12.8617 14.8185 14.6673L15.1798 15.0155ZM2.64943 9.21178C2.64943 12.4232 5.24318 15.0155 8.45644 15.0155C11.6697 15.0155 14.2636 12.4232 14.2636 9.21178C14.2636 6.00059 11.6697 3.40831 8.45644 3.40831C5.24318 3.40831 2.64943 6.00059 2.64943 9.21178ZM4.40114 8.85216H8.126H9.19997H12.9248C13.2218 8.85216 13.4618 9.09215 13.4618 9.38927C13.4618 9.68639 13.2218 9.92638 12.9248 9.92638H9.19997H8.126H4.40114C4.10415 9.92638 3.86416 9.68639 3.86416 9.38927C3.86416 9.09215 4.10415 8.85216 4.40114 8.85216Z"
            />
        ),
    },
    plus: {
        viewBox: '0 0 491.86 491.86',
        image: (
            <path
                d="M465.167,211.614H280.245V26.691c0-8.424-11.439-26.69-34.316-26.69s-34.316,18.267-34.316,26.69v184.924H26.69
			C18.267,211.614,0,223.053,0,245.929s18.267,34.316,26.69,34.316h184.924v184.924c0,8.422,11.438,26.69,34.316,26.69
			s34.316-18.268,34.316-26.69V280.245H465.17c8.422,0,26.69-11.438,26.69-34.316S473.59,211.614,465.167,211.614z"
            />
        ),
    },
    usersAD: {
        viewBox: '0 0 30 30',
        image: (
            <g fill="#b3b3b3">
                <path d="M12.33 10.845a1.932 1.932 0 0 1-1.932 1.932 1.932 1.932 0 0 1-1.932-1.932 1.932 1.932 0 0 1 1.932-1.931 1.932 1.932 0 0 1 1.932 1.931zM21.535 10.845a1.932 1.932 0 0 1-1.932 1.932 1.932 1.932 0 0 1-1.932-1.932 1.932 1.932 0 0 1 1.932-1.931 1.932 1.932 0 0 1 1.932 1.931z" />
                <path d="M15 .455C6.967.455.455 6.967.455 15c0 8.035 6.512 14.545 14.545 14.545 8.033 0 14.545-6.51 14.545-14.545C29.545 6.968 23.033.455 15 .455zM8.41 6.683h13.18a4.546 4.546 0 0 1 0 9.09H8.41a4.546 4.546 0 0 1 0-9.09zm2.843 12.07h1.12l2.302 6.322h-.896l-.62-1.762h-2.734l-.62 1.762h-.853l2.301-6.321zm4.381 0h1.58c.616 0 1.106.046 1.469.137.365.088.673.21.925.365.43.269.766.627 1.006 1.074.24.447.36.978.36 1.592 0 .575-.125 1.095-.377 1.562a2.79 2.79 0 0 1-.998 1.087 3.11 3.11 0 0 1-.968.386c-.353.08-.82.119-1.4.119h-1.597v-6.321zm.841.723v4.878h.79c.404 0 .756-.03 1.056-.09.303-.06.581-.17.833-.33.314-.202.549-.467.704-.795.159-.328.238-.738.238-1.23 0-.496-.086-.913-.259-1.253a1.901 1.901 0 0 0-.773-.802 2.58 2.58 0 0 0-.793-.293 5.156 5.156 0 0 0-1.006-.085h-.79zm-4.682.012l-1.113 3.104h2.22l-1.107-3.104z" />
                <path d="M15 30C6.73 30 0 23.27 0 15S6.73 0 15 0s15 6.73 15 15-6.73 15-15 15zM15 .91C7.23.91.91 7.23.91 15S7.23 29.09 15 29.09 29.09 22.77 29.09 15 22.77.91 15 .91zm6.59 15.32H8.41c-2.758 0-5-2.245-5-5 0-2.757 2.242-5 5-5h13.18c2.758 0 5 2.243 5 5 0 2.755-2.242 5-5 5zM8.41 7.137a4.096 4.096 0 0 0-4.092 4.091A4.096 4.096 0 0 0 8.41 15.32h13.182a4.096 4.096 0 0 0 4.09-4.09 4.096 4.096 0 0 0-4.09-4.092z" />
            </g>
        ),
    },
    users: {
        viewBox: '0 0 19 19',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.5 9.75366C12.1244 9.75366 14.25 7.62804 14.25 5.00366C14.25 2.37929 12.1244 0.253662 9.5 0.253662C6.87563 0.253662 4.75 2.37929 4.75 5.00366C4.75 7.62804 6.87563 9.75366 9.5 9.75366ZM9.5 12.1287C6.32937 12.1287 0 13.7199 0 16.8787V18.0662C0 18.7193 0.534375 19.2537 1.1875 19.2537H17.8125C18.4656 19.2537 19 18.7193 19 18.0662V16.8787C19 13.7199 12.6706 12.1287 9.5 12.1287Z"
            />
        ),
    },
    users_smartplayer: {
        viewBox: '0 0 19 19',
        image: (
            <path d="M9.5 9.5C12.1244 9.5 14.25 7.37438 14.25 4.75C14.25 2.12562 12.1244 0 9.5 0C6.87562 0 4.75 2.12562 4.75 4.75C4.75 7.37438 6.87562 9.5 9.5 9.5ZM9.5 11.875C6.32937 11.875 0 13.4662 0 16.625V17.8125C0 18.4656 0.534375 19 1.1875 19H17.8125C18.4656 19 19 18.4656 19 17.8125V16.625C19 13.4662 12.6706 11.875 9.5 11.875Z" />
        ),
    },
    user: {
        viewBox: '0 0 18 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9 9C11.4862 9 13.5 6.98625 13.5 4.5C13.5 2.01375 11.4862 0 9 0C6.51375 0 4.5 2.01375 4.5 4.5C4.5 6.98625 6.51375 9 9 9ZM9 11.25C5.99625 11.25 0 12.7575 0 15.75V16.875C0 17.4937 0.50625 18 1.125 18H16.875C17.4937 18 18 17.4937 18 16.875V15.75C18 12.7575 12.0037 11.25 9 11.25Z"
            />
        ),
    },
    double_arrow_right: {
        viewBox: '0 0 16 17.17',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.78983 16.6671C8.37931 17.111 7.71745 17.111 7.3068 16.6671C6.89628 16.2322 6.89628 15.5075 7.2985 15.0726L13.3732 8.50452L7.3068 1.93647C6.89628 1.49256 6.89628 0.776863 7.3068 0.332954C7.71745 -0.110985 8.37931 -0.110985 8.78983 0.332954L15.7527 7.86131C16.0795 8.21464 16.0795 8.78538 15.7527 9.13871L8.78983 16.6671ZM1.99125 16.8332C1.53507 17.2772 0.799478 17.2772 0.343301 16.8332C-0.112876 16.3984 -0.112876 15.6737 0.334024 15.2388L7.08366 8.67069L0.343301 2.10264C-0.112876 1.65873 -0.112876 0.943031 0.343301 0.499123C0.799478 0.0551834 1.53507 0.0551834 1.99125 0.499123L9.7277 8.02747C10.0909 8.38081 10.0909 8.95155 9.7277 9.30488L1.99125 16.8332Z"
            />
        ),
    },
    double_arrow_left: {
        viewBox: '0 0 16 17.17',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0044 0.332954C15.4605 -0.110985 16.1961 -0.110985 16.6523 0.332954C17.1085 0.767799 17.1085 1.49253 16.6616 1.92741L9.91196 8.49549L16.6523 15.0635C17.1085 15.5075 17.1085 16.2232 16.6523 16.6671C16.1961 17.111 15.4605 17.111 15.0044 16.6671L7.26791 9.13871C6.90475 8.78538 6.90475 8.21464 7.26791 7.86131L15.0044 0.332954ZM8.20578 0.499123C8.6163 0.0551834 9.27817 0.0551834 9.68881 0.499123C10.0993 0.933968 10.0993 1.6587 9.69711 2.09357L3.62241 8.66166L9.68881 15.2297C10.0993 15.6736 10.0993 16.3893 9.68881 16.8332C9.27817 17.2772 8.6163 17.2772 8.20578 16.8332L1.24289 9.30488C0.916107 8.95155 0.916107 8.38081 1.24289 8.02747L8.20578 0.499123Z"
            />
        ),
    },
    not_allow: {
        viewBox: '0 0 400 400',
        image: (
            <path
                d="M199.99,0C89.715,0,0.002,89.72,0.002,200c0,54.818,22.178,104.542,58.02,140.705c0.199,0.229,0.359,0.484,0.576,0.701
		c0.219,0.222,0.475,0.375,0.705,0.576C95.459,377.82,145.18,400,199.99,400c110.289,0,200.008-89.72,200.008-200
		S310.279,0,199.99,0z M199.99,26.231c43.201,0,82.74,15.882,113.172,42.064L68.293,313.165
		C42.115,282.732,26.232,243.197,26.232,200C26.232,104.184,104.182,26.231,199.99,26.231z M199.99,373.77
		c-43.193,0-82.725-15.879-113.15-42.059L331.707,86.838c26.18,30.432,42.061,69.963,42.061,113.162
		C373.768,295.816,295.812,373.77,199.99,373.77z"
            />
        ),
    },
    choice: {
        viewBox: '0 0 16 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM5.832 11.432L2.96 8.56C2.648 8.248 2.648 7.744 2.96 7.432C3.272 7.12 3.776 7.12 4.088 7.432L6.4 9.736L11.904 4.232C12.216 3.92 12.72 3.92 13.032 4.232C13.344 4.544 13.344 5.048 13.032 5.36L6.96 11.432C6.656 11.744 6.144 11.744 5.832 11.432Z"
            />
        ),
    },
    freeRAM: {
        viewBox: '0 0 472.79 472.79',
        image: (
            <g>
                <path
                    d="M353.451,213.05h5.34V39.326h-52.722V0H133.443l0.683,6.926c0,7.608-6.21,13.778-13.745,13.794
				l-6.381-0.423v433.749l5.666-0.301c0.317,0,0.634-0.049,0.675-0.073c7.6,0,13.778,6.17,13.778,13.77v5.349h171.936v-27.401
				h52.722v-185.64h-5.324c-12.876,0-23.345-10.494-23.345-23.353C330.105,223.511,340.575,213.05,353.451,213.05z M261.11,436.082
				H152.74v-47.885h108.37V436.082z M261.11,372.516H152.74v-47.885h108.37V372.516z M261.11,305.862H152.74v-47.91h108.37V305.862z
				 M261.11,217.456H152.74v-47.877h108.37V217.456z M261.11,153.89H152.74v-47.894h108.37V153.89z M261.11,87.22H152.74V39.326
				h108.37V87.22z M348.11,269.991v164.717h-42.041v-31.165h31.01v-10.681h-31.01v-11.803h31.01v-10.665h-31.01v-11.437h31.01
				v-10.681h-31.01v-10.242h31.01v-10.681h-31.01v-11.803h31.01V304.87h-31.01v-11.404h31.01v-10.681h-31.01v-87.382h31.01v-10.681
				h-31.01v-11.811h31.01v-10.673h-31.01v-11.421h31.01v-10.673h-31.01v-10.266h31.01v-10.681h-31.01v-11.795h31.01V96.722h-31.01
				V85.309h31.01V74.628h-31.01V50.023h42.041v152.744c-16.493,2.593-28.702,16.704-28.702,33.636
				C319.408,253.319,331.617,267.414,348.11,269.991z"
                />
            </g>
        ),
    },
    cpuTemperature: {
        viewBox: '0 0 469.656 469.656',
        image: (
            <g>
                <path
                    d="M290.046,311.414V55.215C290.046,24.772,265.274,0,234.825,0c-30.449,0-55.22,24.772-55.22,55.215v256.199
		c-21.121,16.792-33.537,42.271-33.537,69.484c0,48.937,39.814,88.757,88.757,88.757c48.943,0,88.762-39.82,88.762-88.757
		C323.588,353.685,311.17,328.206,290.046,311.414z M234.825,443.397c-34.46,0-62.498-28.034-62.498-62.498
		c0-20.864,10.365-40.281,27.725-51.934l5.812-3.907V55.215c0-15.971,12.991-28.956,28.962-28.956
		c15.971,0,28.961,12.986,28.961,28.956v269.842l5.811,3.907c17.367,11.663,27.732,31.07,27.732,51.934
		C297.329,415.363,269.29,443.397,234.825,443.397z"
                />
                <path
                    d="M261.084,341.66l-12.584-8.445v-98.388v-58.963v-15.562c0-7.543-6.136-13.678-13.673-13.678
		c-7.543,0-13.679,6.135-13.679,13.678v15.562v58.963v98.388l-12.584,8.445c-13.119,8.808-20.957,23.474-20.957,39.235
		c0,26.035,21.184,47.22,47.22,47.22c26.035,0,47.22-21.185,47.22-47.22C282.047,365.135,274.209,350.469,261.084,341.66z"
                />
            </g>
        ),
    },
    startTime: {
        viewBox: '0 0 32.354 32.354',
        image: (
            <g>
                <g>
                    <path
                        d="M22.145,29.01H10.21c-3.873,0-7.024-3.15-7.024-7.023v-8.525c0-1.162,0.945-2.107,2.107-2.107h21.769
			c1.161,0,2.106,0.945,2.106,2.107v8.525C29.168,25.859,26.018,29.01,22.145,29.01z M5.293,12.354c-0.61,0-1.107,0.497-1.107,1.107
			v8.525c0,3.321,2.702,6.023,6.024,6.023h11.935c3.321,0,6.023-2.702,6.023-6.023v-8.525c0-0.61-0.496-1.107-1.106-1.107H5.293z"
                    />
                    <path
                        d="M10.394,12.354c-0.276,0-0.5-0.224-0.5-0.5V2.5c0-0.827-0.673-1.5-1.5-1.5H8.229c-0.827,0-1.5,0.673-1.5,1.5v9.354
			c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5V2.5c0-1.379,1.121-2.5,2.5-2.5h0.164c1.379,0,2.5,1.121,2.5,2.5v9.354
			C10.894,12.13,10.67,12.354,10.394,12.354z"
                    />
                    <path
                        d="M26.124,12.354c-0.276,0-0.5-0.224-0.5-0.5V2.5c0-0.827-0.673-1.5-1.5-1.5H23.96c-0.827,0-1.5,0.673-1.5,1.5v9.354
			c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5V2.5c0-1.379,1.121-2.5,2.5-2.5h0.164c1.379,0,2.5,1.121,2.5,2.5v9.354
			C26.624,12.13,26.4,12.354,26.124,12.354z"
                    />
                    <path
                        d="M19.929,32.354h-7.504c-0.276,0-0.5-0.224-0.5-0.5V28.51c0-0.276,0.224-0.5,0.5-0.5h7.504c0.276,0,0.5,0.224,0.5,0.5
			v3.344C20.429,32.13,20.205,32.354,19.929,32.354z M12.925,31.354h6.504V29.01h-6.504V31.354z"
                    />
                </g>
                <g>
                    <g>
                        <polygon points="14.721,23.418 15.936,20.079 14.402,19.641 17.278,16.223 16.418,19.209 17.952,19.647 			" />
                        <path
                            d="M14.721,23.918c-0.087,0-0.174-0.022-0.252-0.068c-0.209-0.122-0.301-0.375-0.218-0.603l1.031-2.835l-1.018-0.291
				c-0.163-0.046-0.292-0.172-0.342-0.334c-0.049-0.162-0.014-0.339,0.096-0.469l2.877-3.418c0.152-0.181,0.411-0.228,0.618-0.119
				c0.208,0.111,0.311,0.353,0.245,0.58l-0.722,2.504l1.052,0.301c0.164,0.046,0.293,0.173,0.342,0.336
				c0.05,0.164,0.012,0.341-0.099,0.47l-3.231,3.771C15.003,23.857,14.862,23.918,14.721,23.918z M16.225,19.67
				c0.065,0.046,0.119,0.108,0.156,0.181c0.063,0.124,0.072,0.268,0.024,0.398l-0.274,0.755l0.935-1.091l-0.784-0.224
				C16.262,19.685,16.243,19.678,16.225,19.67z M15.281,19.372l0.791,0.226c0.02,0.005,0.038,0.012,0.057,0.02
				c-0.061-0.043-0.111-0.1-0.148-0.166c-0.064-0.116-0.08-0.253-0.043-0.381l0.21-0.728L15.281,19.372z"
                        />
                    </g>
                </g>
            </g>
        ),
    },
    power_circle: {
        viewBox: '0 0 479.219 479.219',
        image: (
            <g>
                <g>
                    <path
                        d="M441.36,353.781c12.156-25.031,19.781-52.625,21.844-81.781h-64.812c-1.75,17.406-6.75,33.781-13.625,49.125
				L441.36,353.781z"
                    />
                    <path
                        d="M369.048,348.969c-9.969,13.97-22.219,26-36.031,36.095l32.438,56.25c23.531-16,43.781-36.375,59.75-59.938
				L369.048,348.969z"
                    />
                    <path
                        d="M305.454,401.312c-15.344,7-31.938,11.375-49.438,13.156v64.75c29.188-2.063,56.781-9.688,81.781-21.875L305.454,401.312
				z"
                    />
                    <path
                        d="M224.016,414.375c-80.625-8.156-144-75.625-144-158.375c0-53.375,26.5-100.375,66.781-129.5l-32.344-56
				C55.078,110.781,16.015,178.813,16.015,256c0,118.313,91.813,214.969,208,223.188v-64.813H224.016z"
                    />
                </g>
                <path d="M399.017,240h64c-2.094-29.156-9.625-56.688-21.814-81.688l-55.688,32.156C392.548,205.844,397.267,222.438,399.017,240z" />
                <path
                    d="M369.423,162.812l55.906-32.25c-16-23.563-36.156-44.063-59.719-60.063l-32.344,56.032
			C347.204,136.594,359.329,148.938,369.423,162.812z"
                />
                <rect x="208.016" width="64" height="192" />
            </g>
        ),
    },
    cpuLoad: {
        viewBox: '0 0 265.523 265.523',
        image: (
            <g>
                <path d="M200.865,212.808H64.882c-12.407,0-22.5-10.093-22.5-22.5V74.917c0-12.407,10.093-22.5,22.5-22.5h135.982c12.407,0,22.5,10.093,22.5,22.5v115.392C223.365,202.715,213.272,212.808,200.865,212.808z M64.882,67.417c-4.135,0-7.5,3.364-7.5,7.5v115.392c0,4.136,3.365,7.5,7.5,7.5h135.982c4.135,0,7.5-3.364,7.5-7.5V74.917c0-4.136-3.365-7.5-7.5-7.5H64.882z" />
                <path d="M76.856,66.571c-4.142,0-7.5-3.358-7.5-7.5V16.912c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C84.356,63.213,80.998,66.571,76.856,66.571z" />
                <path d="M114.201,66.571c-4.142,0-7.5-3.358-7.5-7.5V16.912c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C121.701,63.213,118.343,66.571,114.201,66.571z" />
                <path d="M151.547,66.571c-4.142,0-7.5-3.358-7.5-7.5V16.912c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C159.047,63.213,155.689,66.571,151.547,66.571z" />
                <path d="M188.891,66.571c-4.142,0-7.5-3.358-7.5-7.5V16.912c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C196.391,63.213,193.033,66.571,188.891,66.571z" />
                <path d="M258.023,84.094h-42.158c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h42.158c4.142,0,7.5,3.358,7.5,7.5C265.523,80.736,262.165,84.094,258.023,84.094z" />
                <path d="M258.023,121.44h-42.158c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h42.158c4.142,0,7.5,3.358,7.5,7.5C265.523,118.082,262.165,121.44,258.023,121.44z" />
                <path d="M258.023,158.785h-42.158c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h42.158c4.142,0,7.5,3.358,7.5,7.5C265.523,155.427,262.165,158.785,258.023,158.785z" />
                <path d="M258.023,196.129h-42.158c-4.142,0-7.5-3.358-7.5-7.5s3.358-7.5,7.5-7.5h42.158c4.142,0,7.5,3.358,7.5,7.5S262.165,196.129,258.023,196.129z" />
                <path d="M49.659,84.094H7.5c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h42.159c4.142,0,7.5,3.358,7.5,7.5C57.159,80.736,53.801,84.094,49.659,84.094z" />
                <path d="M49.659,121.44H7.5c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h42.159c4.142,0,7.5,3.358,7.5,7.5C57.159,118.082,53.801,121.44,49.659,121.44z" />
                <path d="M49.659,158.785H7.5c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h42.159c4.142,0,7.5,3.358,7.5,7.5C57.159,155.427,53.801,158.785,49.659,158.785z" />
                <path d="M49.659,196.129H7.5c-4.142,0-7.5-3.358-7.5-7.5s3.358-7.5,7.5-7.5h42.159c4.142,0,7.5,3.358,7.5,7.5S53.801,196.129,49.659,196.129z" />
                <path d="M76.856,256.111c-4.142,0-7.5-3.358-7.5-7.5v-42.159c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C84.356,252.753,80.998,256.111,76.856,256.111z" />
                <path d="M114.201,256.111c-4.142,0-7.5-3.358-7.5-7.5v-42.159c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C121.701,252.753,118.343,256.111,114.201,256.111z" />
                <path d="M151.547,256.111c-4.142,0-7.5-3.358-7.5-7.5v-42.159c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C159.047,252.753,155.689,256.111,151.547,256.111z" />
                <path d="M188.891,256.111c-4.142,0-7.5-3.358-7.5-7.5v-42.159c0-4.142,3.358-7.5,7.5-7.5c4.142,0,7.5,3.358,7.5,7.5v42.159C196.391,252.753,193.033,256.111,188.891,256.111z" />
            </g>
        ),
    },
    notifications: {
        viewBox: '0 0 510 510',
        image: (
            <path
                d="M255,510c28.05,0,51-22.95,51-51H204C204,487.05,226.95,510,255,510z M420.75,357V216.75
			c0-79.05-53.55-142.8-127.5-160.65V38.25C293.25,17.85,275.4,0,255,0c-20.4,0-38.25,17.85-38.25,38.25V56.1
			c-73.95,17.85-127.5,81.6-127.5,160.65V357l-51,51v25.5h433.5V408L420.75,357z"
            />
        ),
    },
    timetable: {
        viewBox: '0 0 18 22',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M18 2H17V1C17 0.45 16.55 0 16 0C15.45 0 15 0.45 15 1V2H5V1C5 0.45 4.55 0 4 0C3.45 0 3 0.45 3 1V2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM17 20H3C2.45 20 2 19.55 2 19V7H18V19C18 19.55 17.55 20 17 20Z"
            />
        ),
    },
    instancesCatalog: {
        viewBox: '0 0 22 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M19.8 2.25H11L9.449 0.66375C9.031 0.23625 8.47 0 7.887 0H2.2C0.99 0 0.011 1.0125 0.011 2.25L0 15.75C0 16.9875 0.99 18 2.2 18H19.8C21.01 18 22 16.9875 22 15.75V4.5C22 3.2625 21.01 2.25 19.8 2.25ZM18.7 15.75H3.3C2.695 15.75 2.2 15.2437 2.2 14.625V5.625C2.2 5.00625 2.695 4.5 3.3 4.5H18.7C19.305 4.5 19.8 5.00625 19.8 5.625V14.625C19.8 15.2437 19.305 15.75 18.7 15.75Z"
            />
        ),
    },
    plus_circle: {
        viewBox: '0 0 52 52',
        image: (
            <path
                d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M38.5,28H28v11c0,1.104-0.896,2-2,2
	s-2-0.896-2-2V28H13.5c-1.104,0-2-0.896-2-2s0.896-2,2-2H24V14c0-1.104,0.896-2,2-2s2,0.896,2,2v10h10.5c1.104,0,2,0.896,2,2
	S39.604,28,38.5,28z"
            />
        ),
    },
    minus_circle: {
        viewBox: '0 0 20 20',
        image: (
            <path
                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14 11H6C5.45 11 5 10.55 5 10C5 9.45 5.45 9 6 9H14C14.55 9 15 9.45 15 10C15 10.55 14.55 11 14 11Z"
                fill="#B3B3B3"
            />
        ),
    },
    folder: {
        viewBox: '0 0 30 24',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M12.885 0.885C12.315 0.315 11.55 0 10.755 0H3C1.35 0 0.015 1.35 0.015 3L0 21C0 22.65 1.35 24 3 24H27C28.65 24 30 22.65 30 21V6C30 4.35 28.65 3 27 3H15L12.885 0.885Z"
            />
        ),
    },
    folder_smartplayer: {
        viewBox: '0 0 30 24',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M12.885 0.885C12.315 0.315 11.55 0 10.755 0H3C1.35 0 0.015 1.35 0.015 3L0 21C0 22.65 1.35 24 3 24H27C28.65 24 30 22.65 30 21V6C30 4.35 28.65 3 27 3H15L12.885 0.885Z"
            />
        ),
    },
    currentDate: {
        viewBox: '0 0 511.634 511.634',
        image: (
            <path
                d="M482.513,83.942c-7.225-7.233-15.797-10.85-25.694-10.85h-36.541v-27.41c0-12.56-4.477-23.315-13.422-32.261
		C397.906,4.475,387.157,0,374.591,0h-18.268c-12.565,0-23.318,4.475-32.264,13.422c-8.949,8.945-13.422,19.701-13.422,32.261v27.41
		h-109.63v-27.41c0-12.56-4.475-23.315-13.422-32.261C178.64,4.475,167.886,0,155.321,0H137.05
		c-12.562,0-23.317,4.475-32.264,13.422c-8.945,8.945-13.421,19.701-13.421,32.261v27.41H54.823c-9.9,0-18.464,3.617-25.697,10.85
		c-7.233,7.232-10.85,15.8-10.85,25.697v365.453c0,9.89,3.617,18.456,10.85,25.693c7.232,7.231,15.796,10.849,25.697,10.849h401.989
		c9.897,0,18.47-3.617,25.694-10.849c7.234-7.234,10.852-15.804,10.852-25.693V109.639
		C493.357,99.739,489.743,91.175,482.513,83.942z M347.187,45.686c0-2.667,0.849-4.858,2.56-6.567
		c1.711-1.711,3.901-2.568,6.57-2.568h18.268c2.67,0,4.853,0.854,6.57,2.568c1.712,1.712,2.567,3.903,2.567,6.567v82.224
		c0,2.666-0.855,4.853-2.567,6.567c-1.718,1.709-3.9,2.568-6.57,2.568h-18.268c-2.669,0-4.859-0.855-6.57-2.568
		c-1.711-1.715-2.56-3.901-2.56-6.567V45.686z M127.915,45.686c0-2.667,0.855-4.858,2.568-6.567
		c1.714-1.711,3.901-2.568,6.567-2.568h18.271c2.667,0,4.858,0.854,6.567,2.568c1.711,1.712,2.57,3.903,2.57,6.567v82.224
		c0,2.666-0.855,4.856-2.57,6.567c-1.713,1.709-3.9,2.568-6.567,2.568H137.05c-2.666,0-4.856-0.855-6.567-2.568
		c-1.709-1.715-2.568-3.901-2.568-6.567V45.686z M456.812,475.088H54.823v-292.36h401.989V475.088z"
            />
        ),
    },
    addArea: {
        viewBox: '0 0 424.502 424.503',
        image: (
            <g>
                <path
                    d="M416.846,362.848l-51.723-51.729l26.206-26.216c3.39-3.389,4.926-8.215,4.104-12.942
			c-0.82-4.726-3.883-8.756-8.217-10.808l-208.589-98.816c-5.636-2.676-12.34-1.497-16.738,2.902
			c-4.407,4.404-5.566,11.107-2.901,16.74l98.821,208.588c2.054,4.331,6.085,7.395,10.816,8.215
			c4.722,0.807,9.552-0.722,12.938-4.104l26.205-26.215l51.736,51.723c2.882,2.882,6.654,4.318,10.427,4.318
			c3.771,0,7.545-1.438,10.426-4.318l36.488-36.487C422.604,377.938,422.604,368.607,416.846,362.848z M369.932,388.912
			l-51.736-51.723c-2.879-2.884-6.653-4.322-10.427-4.322c-3.771,0-7.547,1.438-10.425,4.322l-21.836,21.844l-72.192-152.369
			l152.368,72.183l-21.838,21.845c-5.759,5.762-5.759,15.09,0,20.852l51.722,51.729L369.932,388.912z"
                />
                <path
                    d="M160.464,234.072H32.828V29.488h204.587v146.176c0,8.143,6.601,14.744,14.744,14.744c8.143,0,14.745-6.603,14.745-14.744
			V14.744C266.904,6.6,260.301,0,252.159,0H18.083C9.938,0,3.338,6.601,3.338,14.744v234.074c0,8.144,6.601,14.744,14.744,14.744
			h142.382c8.144,0,14.744-6.602,14.744-14.744C175.208,240.678,168.607,234.072,160.464,234.072z"
                />
            </g>
        ),
    },
    upload_arrow: {
        viewBox: '0 0 14 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M0 1C0 1.55 0.45 2 1 2H13C13.55 2 14 1.55 14 1C14 0.45 13.55 0 13 0H1C0.45 0 0 0.45 0 1ZM2.41 10H4V15C4 15.55 4.45 16 5 16H9C9.55 16 10 15.55 10 15V10H11.59C12.48 10 12.93 8.92 12.3 8.29L7.71 3.7C7.32 3.31 6.69 3.31 6.3 3.7L1.71 8.29C1.08 8.92 1.52 10 2.41 10Z"
            />
        ),
    },
    add_area: {
        viewBox: '0 0 24 24',
        image: (
            <path
                d="M23,7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7H23z M3,3h2v2H3V3z M5,21H3v-2h2V21z M17,19H7v-2H5V7h2V5h10v2h2v10h-2
          	V19z M21,21h-2v-2h2V21z M19,5V3h2v2H19z"
            />
        ),
    },
    options: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <circle cx="256" cy="256" r="64" />
                <circle cx="256" cy="448" r="64" />
                <circle cx="256" cy="64" r="64" />
            </g>
        ),
    },
    table: {
        viewBox: '0 0 20 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M7.99854 7.02H12.9985V18H7.99854V7.02ZM14.9985 18H17.9985C19.0985 18 19.9985 17.1 19.9985 16V7H14.9985V18ZM17.9985 0H2.99854C1.89854 0 0.998535 0.9 0.998535 2V5H19.9985V2C19.9985 0.9 19.0985 0 17.9985 0ZM0.998535 16C0.998535 17.1 1.89854 18 2.99854 18H5.99854V7H0.998535V16Z"
            />
        ),
    },
    input: {
        viewBox: '0 0 512.64 512.64',
        image: (
            <g>
                <path
                    d="M384.32,153.6V12.8c0-7.68-5.12-12.8-12.8-12.8h-230.4c-7.68,0-12.8,5.12-12.8,12.8v140.8h-25.6v307.2
			c0,69.12,307.2,69.12,307.2,0V153.6H384.32z M230.72,102.4h-51.2V51.2h51.2V102.4z M333.12,102.4h-51.2V51.2h51.2V102.4z"
                />
            </g>
        ),
    },
    pc: {
        viewBox: '0 0 485.211 485.211',
        image: (
            <g>
                <path
                    d="M121.304,75.816H30.327C13.564,75.816,0,89.409,0,106.141v333.586c0,16.76,13.564,30.322,30.327,30.322h90.978
			c16.762,0,30.324-13.562,30.324-30.322V106.141C151.628,89.409,138.066,75.816,121.304,75.816z M45.49,379.073
			c-8.382,0-15.163-6.781-15.163-15.168c0-8.377,6.781-15.158,15.163-15.158c8.38,0,15.161,6.781,15.161,15.158
			C60.651,372.292,53.87,379.073,45.49,379.073z M121.304,197.118H30.327v-30.324h90.978V197.118z M121.304,136.467H30.327v-30.326
			h90.978V136.467z"
                />
                <path
                    d="M318.423,409.396v-30.322h-90.98v30.322c-16.759,0-30.327,13.567-30.327,30.331h151.629
			C348.745,422.963,335.183,409.396,318.423,409.396z"
                />
                <path
                    d="M454.889,15.163H90.978c-16.762,0-30.327,13.593-30.327,30.327h30.327h90.978h272.934v242.604H181.955v60.653h272.934
			c16.759,0,30.322-13.562,30.322-30.332V45.489C485.211,28.755,471.647,15.163,454.889,15.163z M272.933,333.584
			c-8.382,0-15.163-6.777-15.163-15.169c0-8.377,6.781-15.158,15.163-15.158c8.383,0,15.164,6.781,15.164,15.158
			C288.097,326.807,281.315,333.584,272.933,333.584z"
                />
            </g>
        ),
    },
    hdmi: {
        viewBox: '0 0 455.273 455.273',
        image: (
            <g>
                <path
                    d="M129.573,0c-3.002,5.319-15.004,9.429-30.014,10.269v69.928h162.238V10.291C246.498,9.535,234.174,5.399,231.129,0
			H129.573z"
                />
                <path
                    d="M370.936,407.729c-1.427,0-2.913,0.144-4.444,0.444c-18.679,3.623-44.33,7.39-69.857,7.39
			c-43.93,0-87.484-11.132-94.473-53.214h24.055v-30.857h8.5c11.061,0,20.321-9.009,22.883-19.757
			c8.592-35.982,33.485-88.253,33.485-88.253c4.385-5.65,7.113-12.669,7.113-20.386v-81.7c0-18.416-14.932-33.35-33.346-33.35
			h-3.054H99.559h-3.124c-18.42,0-33.35,14.934-33.35,33.35v81.708c0,7.724,2.741,14.751,7.145,20.404
			c-0.118,0,24.75,52.257,33.342,88.235c2.565,10.748,11.828,19.765,22.88,19.765h8.612v30.85h25.701
			c6.785,72.702,74.33,92.916,141.126,92.916c26.589,0,53.03-3.202,75.5-7.574C401.769,442.955,393.49,407.729,370.936,407.729z
			 M261.797,162.242h7.009v28.788h-11.433v-28.788H261.797z M132.226,191.021h-11.431v-9.483h-20.741v9.483H88.623v-28.787h10.937
			h0.495l0,0v12.531h20.741v-12.531l0,0h11.431l0,0V191.021z M185.087,187.638c0,1.871-1.513,3.384-3.384,3.384h-5.714h-2.12
			h-22.011h-9.521h-1.908v-16.298h11.429v9.521h22.011v-14.316h-33.44v-7.694l0,0h33.44h0.214h7.62l0,0
			c1.872,0,3.384,1.515,3.384,3.386V187.638z M193.928,162.242L193.928,162.242h3.807h7.624h10.584h11.429h10.586h7.618h0.421l0,0
			c1.871,0,3.382,1.515,3.382,3.384v25.395h-11.421v-20.74h-10.586v20.74h-11.429v-20.74h-10.584v20.74h-11.431V162.242z"
                />
            </g>
        ),
    },
    maximize: {
        viewBox: '0 0 21 21',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3115 8.82404L17.0141 2.12141L15.7413 0.848701C15.4301 0.537422 15.6494 -0.0070117 16.0948 6.8377e-05L20.0334 0.00714846C20.3092 0.0142285 20.5284 0.233467 20.5355 0.509102L20.5425 4.44782C20.5496 4.89338 20.0123 5.11945 19.694 4.80134L18.4283 3.53571L11.72 10.2437L18.4224 16.9461L19.6953 15.6734C20.0063 15.3624 20.5508 15.5816 20.5438 16.0269L20.5367 19.9656C20.5296 20.2413 20.3104 20.4605 20.0346 20.4676L16.096 20.4747C15.6506 20.4818 15.4243 19.9444 15.7425 19.626L17.0082 18.3604L10.3002 11.6524L3.59785 18.3548L4.87067 19.6275C5.18183 19.9388 4.96259 20.4832 4.51716 20.4761L0.57856 20.4691C0.302803 20.462 0.0835645 20.2427 0.0764844 19.9669L0.0694043 16.0284C0.0623242 15.5828 0.599678 15.3568 0.917915 15.6749L2.18366 16.9405L8.89155 10.2325L2.18903 3.5301L0.916206 4.8028C0.605171 5.11384 0.0606152 4.8946 0.0676953 4.44929L0.0747754 0.510566C0.0818555 0.234932 0.301094 0.0156934 0.576851 0.0086133L4.51545 0.00153322C4.96088 -0.00554686 5.1872 0.531807 4.86896 0.850166L3.60322 2.11579L10.3115 8.82404Z"
            />
        ),
    },
    crop: {
        viewBox: '0 0 15 15',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M13.0438 14.1612H3.04382C2.58549 14.1612 2.21049 13.7862 2.21049 13.3279V3.32788C2.21049 2.86955 2.58549 2.49455 3.04382 2.49455H13.0438C13.5022 2.49455 13.8772 2.86955 13.8772 3.32788V13.3279C13.8772 13.7862 13.5022 14.1612 13.0438 14.1612ZM13.8772 0.827881H2.21049C1.29382 0.827881 0.543823 1.57788 0.543823 2.49455V14.1612C0.543823 15.0779 1.29382 15.8279 2.21049 15.8279H13.8772C14.7938 15.8279 15.5438 15.0779 15.5438 14.1612V2.49455C15.5438 1.57788 14.7938 0.827881 13.8772 0.827881Z"
            />
        ),
    },
    fitWidth: {
        viewBox: '0 0 16 16',
        image: (
            <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 3.5v9M14 3.5v9" />
                <path d="M5 8h6M5 8l1.6-1.6M5 8l1.6 1.6M11 8l-1.6-1.6M11 8l-1.6 1.6" />
            </g>
        ),
    },
    fitHeight: {
        viewBox: '0 0 16 16',
        image: (
            <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3.5 2h9M3.5 14h9" />
                <path d="M8 5v6M8 5l-1.6 1.6M8 5l1.6 1.6M8 11l-1.6-1.6M8 11l1.6-1.6" />
            </g>
        ),
    },
    infinity: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M491.841,156.427c-19.471-45.946-51.937-85.013-92.786-112.637C358.217,16.166,308.893-0.007,256,0
			c-35.254-0.002-68.946,7.18-99.571,20.158C110.484,39.63,71.416,72.093,43.791,112.943C16.167,153.78-0.007,203.104,0,256
			c-0.002,35.255,7.181,68.948,20.159,99.573c19.471,45.946,51.937,85.013,92.786,112.637C153.783,495.834,203.107,512.007,256,512
			c35.253,0.002,68.946-7.18,99.571-20.158c45.945-19.471,85.013-51.935,112.638-92.785C495.834,358.22,512.007,308.894,512,256
			C512.002,220.745,504.819,187.052,491.841,156.427z M460.413,342.259c-16.851,39.781-45.045,73.723-80.476,97.676
			c-35.443,23.953-78.02,37.926-123.936,37.933c-30.619-0.002-59.729-6.218-86.255-17.454
			c-39.781-16.851-73.724-45.044-97.677-80.475C48.114,344.495,34.14,301.917,34.133,256c0.002-30.62,6.219-59.731,17.454-86.257
			c16.851-39.781,45.045-73.724,80.476-97.676C167.506,48.113,210.084,34.14,256,34.133c30.619,0.002,59.729,6.218,86.255,17.454
			c39.781,16.85,73.724,45.044,97.677,80.475c23.953,35.443,37.927,78.02,37.934,123.939
			C477.864,286.621,471.648,315.732,460.413,342.259z"
                />
                <path
                    d="M433.11,223.51c-6.359-14.999-16.927-27.712-30.24-36.717c-6.657-4.502-14.011-8.076-21.864-10.524
			c-7.852-2.448-16.206-3.765-24.812-3.764c-12.362-0.011-24.036,2.613-34.69,6.984c-9.338,3.823-17.934,8.94-25.971,14.798
			c-14.059,10.268-26.501,22.793-38.382,35.605c-0.386,0.417-0.764,0.837-1.149,1.256c-0.083-0.091-0.166-0.183-0.249-0.274
			c-6.661-7.219-13.506-14.351-20.697-21.066c-10.79-10.06-22.363-19.233-35.455-26.079c-6.542-3.416-13.469-6.23-20.791-8.185
			c-7.318-1.956-15.027-3.04-23.007-3.038c-11.476-0.002-22.496,2.343-32.491,6.581c-14.999,6.359-27.712,16.927-36.717,30.24
			c-4.502,6.657-8.076,14.011-10.524,21.864c-2.448,7.852-3.765,16.206-3.764,24.812c-0.002,11.476,2.343,22.496,6.581,32.491
			c6.359,14.997,16.928,27.71,30.24,36.715c6.657,4.502,14.011,8.076,21.864,10.524c7.852,2.448,16.206,3.765,24.812,3.764
			c12.362,0.01,24.036-2.613,34.69-6.984c9.338-3.823,17.934-8.94,25.971-14.798c14.059-10.268,26.501-22.793,38.382-35.605
			c0.386-0.417,0.764-0.837,1.149-1.255c0.083,0.091,0.166,0.183,0.249,0.274c6.661,7.219,13.506,14.351,20.697,21.066
			c10.79,10.06,22.363,19.233,35.455,26.079c6.542,3.414,13.469,6.23,20.791,8.185c7.318,1.956,15.027,3.04,23.007,3.038
			c11.476,0.002,22.496-2.344,32.491-6.581c14.999-6.359,27.712-16.927,36.717-30.24c4.502-6.657,8.076-14.011,10.524-21.864
			c2.448-7.852,3.765-16.206,3.764-24.811C439.693,244.525,437.348,233.505,433.11,223.51z M231.208,258.483
			c-6.355,6.889-12.655,13.433-18.941,19.299c-9.426,8.813-18.817,16.044-28.117,20.884c-4.654,2.428-9.28,4.277-13.954,5.525
			c-4.678,1.247-9.406,1.905-14.391,1.907c-6.941-0.002-13.479-1.403-19.462-3.934c-8.968-3.795-16.665-10.183-22.079-18.195
			c-2.708-4.005-4.845-8.406-6.306-13.094c-1.461-4.69-2.251-9.666-2.251-14.873c0.002-6.941,1.403-13.479,3.934-19.461
			c3.795-8.967,10.183-16.665,18.196-22.079c4.004-2.708,8.406-4.845,13.096-6.306c4.69-1.461,9.666-2.251,14.873-2.251
			c7.708,0.01,14.84,1.562,22.044,4.497c6.287,2.569,12.592,6.242,18.941,10.873c11.116,8.086,22.275,19.114,33.553,31.311
			c1.039,1.122,2.085,2.278,3.127,3.418C232.718,256.826,231.961,257.668,231.208,258.483z M402.36,275.464
			c-3.795,8.968-10.183,16.665-18.196,22.079c-4.004,2.708-8.406,4.845-13.096,6.306c-4.69,1.461-9.666,2.251-14.873,2.251
			c-7.708-0.01-14.84-1.562-22.044-4.497c-6.287-2.569-12.592-6.242-18.941-10.873c-11.116-8.086-22.275-19.114-33.553-31.311
			c-1.039-1.122-2.085-2.279-3.127-3.418c0.754-0.825,1.511-1.667,2.263-2.481c6.355-6.889,12.655-13.433,18.941-19.299
			c9.426-8.813,18.817-16.044,28.117-20.884c4.654-2.428,9.28-4.277,13.954-5.525c4.678-1.247,9.406-1.905,14.391-1.907
			c6.941,0.002,13.479,1.403,19.462,3.934c8.968,3.795,16.665,10.183,22.079,18.196c2.708,4.005,4.845,8.406,6.306,13.094
			c1.461,4.69,2.251,9.666,2.251,14.873C406.293,262.942,404.892,269.48,402.36,275.464z"
                />
            </g>
        ),
    },
    progressClock: {
        viewBox: '0 0 485.563 485.562',
        image: (
            <g>
                <path
                    d="M311.409,251.414c5.32-1.537,17.778-5.145,23.569-22.177l11.931-35.086l4.799,1.63c2.197,0.748,4.605-0.438,5.353-2.635
				l6.401-18.824c0.748-2.197-0.438-4.604-2.637-5.351l-154.671-52.592c-2.196-0.747-4.606,0.44-5.353,2.636l-6.401,18.823
				c-0.746,2.196,0.441,4.604,2.636,5.352l4.799,1.632l-12.145,35.725c-5.735,16.865-1.941,22.56,5.255,31.179l31.299,37.48
				l-3.489,10.26c-11.976,2.599-43.272,9.418-47.485,10.635c-5.319,1.539-17.78,5.143-23.572,22.177l-10.271,30.21l-4.8-1.631
				c-2.195-0.747-4.606,0.438-5.354,2.635l-6.398,18.823c-0.748,2.197,0.439,4.604,2.636,5.353l154.672,52.593
				c2.194,0.746,4.604-0.44,5.352-2.638l6.397-18.82c0.749-2.197-0.437-4.606-2.636-5.354l-4.797-1.632l10.486-30.849
				c5.735-16.863,1.944-22.561-5.254-31.176l-31.297-37.481l3.486-10.26C275.897,259.453,307.193,252.635,311.409,251.414z
				 M246.043,278.771l34.035,40.753c2.611,3.127,3.994,4.834,4.369,6.397c0.451,1.877-0.152,5.201-1.838,10.156l-10.488,30.851
				l-116.316-39.55l10.269-30.209c3.243-9.535,9.122-11.237,13.413-12.479c3.356-0.97,32.146-7.282,50.679-11.291
				c2.604-0.563,4.725-2.454,5.583-4.978l6.245-18.365c0.851-2.508,0.337-5.277-1.36-7.31l-33.932-40.631l-0.103-0.125
				c-2.612-3.127-3.995-4.834-4.369-6.398c-0.45-1.877,0.15-5.198,1.837-10.156l12.146-35.725l116.319,39.55L320.6,224.348
				c-3.241,9.537-9.118,11.237-13.41,12.479c-3.354,0.971-32.145,7.285-50.676,11.291c-2.605,0.564-4.728,2.453-5.587,4.979
				l-6.243,18.363C243.831,273.969,244.348,276.736,246.043,278.771z"
                />
                <path
                    d="M337.935,423.581c-3.395,1.924-6.896,3.766-10.399,5.474c-0.567,0.277-1.114,0.58-1.643,0.907
				c-0.562,0.195-1.121,0.422-1.676,0.68c-15.206,7.09-31.062,12.082-47.396,14.977c-0.209,0.03-0.418,0.042-0.629,0.08
				c-3.851,0.681-7.77,1.248-11.646,1.692c-0.042,0.007-0.085,0.017-0.127,0.022c-7.118,0.785-14.316,1.186-21.589,1.186
				c-83.862,0-155.381-53.81-181.88-128.71c-0.399-1.143-0.801-2.283-1.18-3.428c-6.352-19.101-9.802-39.515-9.802-60.722
				c0-21.251,3.465-41.71,9.844-60.846c0.139-0.418,0.273-0.833,0.414-1.252c0.381-1.114,0.775-2.224,1.177-3.331
				c0.187-0.52,0.376-1.037,0.568-1.553c22.02-59.268,72.388-104.863,134.541-120.242c0.039-0.009,0.079-0.012,0.118-0.021
				c0.919-0.228,1.845-0.45,2.772-0.664c0.104-0.023,0.204-0.061,0.304-0.086c13.559-3.108,27.658-4.779,42.126-4.853l0.167,19.829
				c0.051,6.156,3.938,7.934,8.632,3.955l41.886-35.504c4.693-3.979,4.643-10.43-0.123-14.33L249.92,2.045
				c-4.762-3.899-8.616-2.056-8.564,4.099l0.167,19.79c-60.9,0.337-118.103,24.199-161.204,67.298
				c-4.246,4.246-8.298,8.632-12.165,13.141c-0.023,0.026-0.047,0.047-0.071,0.075c-0.143,0.166-0.278,0.339-0.419,0.505
				c-33.925,39.809-53.051,89.425-54.552,142.061c-0.037,0.409-0.081,0.815-0.091,1.233c-0.041,1.756-0.062,3.541-0.062,5.306
				c0,2.894,0.059,5.827,0.168,8.72c0.012,0.339,0.056,0.67,0.089,1.003c1.944,47.958,18.527,93.3,47.621,130.856
				c0.099,0.129,0.178,0.267,0.278,0.396c2.842,3.668,5.847,7.302,8.92,10.798c0.198,0.225,0.415,0.42,0.619,0.634
				c3.111,3.508,6.323,6.944,9.666,10.286c34.123,34.124,77.088,56.187,123.726,64.068c0.142,0.026,0.285,0.054,0.427,0.08
				c0.106,0.016,0.211,0.023,0.315,0.039c12.455,2.062,25.167,3.129,38.042,3.129c33.881,0,66.517-7.209,97.004-21.42
				c0.657-0.306,1.281-0.657,1.882-1.028c0.683-0.235,1.354-0.514,2.016-0.837c4.183-2.042,8.361-4.236,12.412-6.529
				c8.882-5.03,12.008-16.306,6.979-25.188C358.092,421.677,346.815,418.555,337.935,423.581z"
                />
                <path
                    d="M402.976,148.173c3.567,5.309,9.407,8.174,15.354,8.174c3.544,0,7.13-1.017,10.292-3.143
				c8.471-5.693,10.723-17.174,5.03-25.646c-2.599-3.865-5.345-7.698-8.176-11.391c-6.2-8.108-17.798-9.65-25.905-3.45
				c-8.106,6.202-9.65,17.802-3.446,25.907C398.496,141.725,400.801,144.938,402.976,148.173z"
                />
                <path
                    d="M426.446,196.708c1.188,3.711,2.279,7.516,3.247,11.311c2.131,8.36,9.648,13.921,17.896,13.921
				c1.509,0,3.047-0.187,4.577-0.577c9.891-2.52,15.866-12.583,13.345-22.472c-1.15-4.513-2.45-9.04-3.866-13.456
				c-3.11-9.72-13.514-15.079-23.233-11.965C428.69,176.584,423.333,186.988,426.446,196.708z"
                />
                <path
                    d="M414.674,380.14c-7.724-6.675-19.391-5.828-26.067,1.892c-2.556,2.956-5.232,5.869-7.958,8.657
				c-7.134,7.301-6.998,19.001,0.304,26.136c3.595,3.513,8.257,5.263,12.913,5.263c4.803,0,9.602-1.862,13.221-5.566
				c3.246-3.323,6.438-6.792,9.479-10.313C423.239,398.486,422.393,386.815,414.674,380.14z"
                />
                <path
                    d="M454.675,243.736c-10.219-0.307-18.722,7.719-19.024,17.92c-0.115,3.907-0.356,7.859-0.714,11.745
				c-0.933,10.163,6.551,19.16,16.715,20.093c0.574,0.053,1.144,0.078,1.711,0.078c9.44,0,17.503-7.203,18.381-16.792
				c0.426-4.639,0.714-9.354,0.852-14.019C472.897,252.562,464.878,244.041,454.675,243.736z"
                />
                <path
                    d="M446.456,315.401c-9.509-3.723-20.228,0.966-23.949,10.472c-1.423,3.635-2.978,7.28-4.623,10.828
				c-4.29,9.26-0.261,20.244,9,24.535c2.517,1.166,5.157,1.717,7.758,1.717c6.978,0,13.654-3.97,16.78-10.716
				c1.956-4.224,3.81-8.559,5.503-12.889C460.647,329.845,455.959,319.123,446.456,315.401z"
                />
                <path
                    d="M383.518,96.938c6.075-8.204,4.35-19.777-3.854-25.851c-3.735-2.767-7.608-5.454-11.51-7.992
				c-8.557-5.563-20.004-3.139-25.567,5.418c-5.562,8.556-3.139,20.002,5.416,25.567c3.279,2.13,6.529,4.389,9.668,6.713
				c3.306,2.447,7.161,3.629,10.984,3.629C374.311,104.422,379.895,101.833,383.518,96.938z"
                />
            </g>
        ),
    },
    exit: {
        viewBox: '0 0 21 21',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.08833 15.505C9.54333 15.96 10.2783 15.96 10.7333 15.505L14.9217 11.3167C15.3767 10.8617 15.3767 10.1267 14.9217 9.67167L10.7333 5.48333C10.2783 5.02833 9.54333 5.02833 9.08833 5.48333C8.63333 5.93833 8.63333 6.67333 9.08833 7.12833L11.2817 9.33333H1.16667C0.525 9.33333 0 9.85833 0 10.5C0 11.1417 0.525 11.6667 1.16667 11.6667H11.2817L9.08833 13.86C8.63333 14.315 8.645 15.0617 9.08833 15.505ZM18.6667 0H2.33333C1.03833 0 0 1.05 0 2.33333V5.83333C0 6.475 0.525 7 1.16667 7C1.80833 7 2.33333 6.475 2.33333 5.83333V3.5C2.33333 2.85833 2.85833 2.33333 3.5 2.33333H17.5C18.1417 2.33333 18.6667 2.85833 18.6667 3.5V17.5C18.6667 18.1417 18.1417 18.6667 17.5 18.6667H3.5C2.85833 18.6667 2.33333 18.1417 2.33333 17.5V15.1667C2.33333 14.525 1.80833 14 1.16667 14C0.525 14 0 14.525 0 15.1667V18.6667C0 19.95 1.05 21 2.33333 21H18.6667C19.95 21 21 19.95 21 18.6667V2.33333C21 1.05 19.95 0 18.6667 0Z"
            />
        ),
    },
    circle_checked: {
        viewBox: '0 0 511.755 511.755',
        image: (
            <path
                d="M436.891,74.867c-99.819-99.819-262.208-99.819-362.027,0c-99.819,99.797-99.819,262.229,0,362.027
			c49.899,49.92,115.456,74.859,181.013,74.859s131.093-24.939,181.013-74.859C536.709,337.096,536.709,174.664,436.891,74.867z
			 M398.96,185.629L249.627,334.963c-4.16,4.16-9.621,6.251-15.083,6.251c-5.461,0-10.923-2.091-15.083-6.251l-85.333-85.333
			c-8.341-8.341-8.341-21.824,0-30.165c8.341-8.341,21.824-8.341,30.165,0l70.251,70.251l134.251-134.251
			c8.341-8.341,21.824-8.341,30.165,0C407.301,163.805,407.301,177.288,398.96,185.629z"
            />
        ),
    },
    switchArrows: {
        viewBox: '0 0 489.3 489.3',
        image: (
            <g>
                <path
                    d="M119,468.85V50.05l73.6,73.6c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6c4.8-4.8,4.8-12.5,0-17.3l-94.5-94.5
			c-4.6-4.6-12.7-4.6-17.3,0l-94.6,94.5c-4.8,4.8-4.8,12.5,0,17.3c4.8,4.8,12.5,4.8,17.3,0l73.6-73.6v418.8
			c0,6.8,5.5,12.3,12.3,12.3C113.5,481.05,119,475.55,119,468.85z"
                />
                <path
                    d="M373.8,477.45c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l94.5-94.5c4.8-4.8,4.8-12.5,0-17.3s-12.5-4.8-17.3,0l-73.6,73.6
			V20.45c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3v418.8l-73.5-73.6c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3L373.8,477.45z"
                />
            </g>
        ),
    },
    multimedia: {
        viewBox: '0 0 24 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M21.8182 0H2.18182C0.981818 0 0 1 0 2.22222V15.5556C0 16.7778 0.981818 17.7778 2.18182 17.7778H7.63636V18.8889C7.63636 19.5 8.12727 20 8.72727 20H15.2727C15.8727 20 16.3636 19.5 16.3636 18.8889V17.7778H21.8182C23.0182 17.7778 23.9891 16.7778 23.9891 15.5556L24 2.22222C24 0.988889 23.0182 0 21.8182 0ZM20.7273 15.5556H3.27273C2.67273 15.5556 2.18182 15.0556 2.18182 14.4444V3.33333C2.18182 2.72222 2.67273 2.22222 3.27273 2.22222H20.7273C21.3273 2.22222 21.8182 2.72222 21.8182 3.33333V14.4444C21.8182 15.0556 21.3273 15.5556 20.7273 15.5556ZM14.7055 9.85556L10.3636 12.3889C9.63273 12.8111 8.72727 12.2667 8.72727 11.4222V6.35556C8.72727 5.5 9.63273 4.96667 10.3636 5.38889L14.7055 7.92222C15.4364 8.35556 15.4364 9.42222 14.7055 9.85556Z"
            />
        ),
    },
    multimedia_smartplayer: {
        viewBox: '0 0 24 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M21.8182 0H2.18182C0.981818 0 0 1 0 2.22222V15.5556C0 16.7778 0.981818 17.7778 2.18182 17.7778H7.63636V18.8889C7.63636 19.5 8.12727 20 8.72727 20H15.2727C15.8727 20 16.3636 19.5 16.3636 18.8889V17.7778H21.8182C23.0182 17.7778 23.9891 16.7778 23.9891 15.5556L24 2.22222C24 0.988889 23.0182 0 21.8182 0ZM20.7273 15.5556H3.27273C2.67273 15.5556 2.18182 15.0556 2.18182 14.4444V3.33333C2.18182 2.72222 2.67273 2.22222 3.27273 2.22222H20.7273C21.3273 2.22222 21.8182 2.72222 21.8182 3.33333V14.4444C21.8182 15.0556 21.3273 15.5556 20.7273 15.5556ZM14.7055 9.85556L10.3636 12.3889C9.63273 12.8111 8.72727 12.2667 8.72727 11.4222V6.35556C8.72727 5.5 9.63273 4.96667 10.3636 5.38889L14.7055 7.92222C15.4364 8.35556 15.4364 9.42222 14.7055 9.85556Z"
            />
        ),
    },
    layers: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M503.709,130.082l-241-120c-4.219-2.109-9.199-2.109-13.418,0l-241,120C3.208,132.631,0,137.816,0,143.5
			s3.208,10.869,8.291,13.418l241,120c2.109,1.055,4.409,1.582,6.709,1.582s4.6-0.527,6.709-1.582l241-120
			c5.083-2.549,8.291-7.734,8.291-13.418S508.792,132.631,503.709,130.082z"
                />

                <path
                    d="M503.709,355.082l-14.619-7.31L276.127,453.754c-6.211,3.105-13.169,4.746-20.127,4.746s-13.916-1.641-20.127-4.746
			L22.91,347.772l-14.619,7.31C3.208,357.631,0,362.816,0,368.5c0,5.684,3.208,10.869,8.291,13.418l241,120
			c2.109,1.055,4.409,1.582,6.709,1.582s4.6-0.527,6.709-1.582l241-120c5.083-2.549,8.291-7.734,8.291-13.418
			C512,362.816,508.792,357.631,503.709,355.082z"
                />

                <path
                    d="M503.709,280.082l-14.619-7.31L276.127,378.754c-6.211,3.105-13.169,4.746-20.127,4.746s-13.916-1.641-20.127-4.746
			L22.91,272.772l-14.619,7.31C3.208,282.631,0,287.816,0,293.5c0,5.684,3.208,10.869,8.291,13.418l241,120
			c2.109,1.055,4.409,1.582,6.709,1.582s4.6-0.527,6.709-1.582l241-120c5.083-2.549,8.291-7.734,8.291-13.418
			C512,287.816,508.792,282.631,503.709,280.082z"
                />

                <path
                    d="M503.709,205.082l-14.619-7.31L276.127,303.754c-6.211,3.105-13.169,4.746-20.127,4.746s-13.916-1.641-20.127-4.746
			L22.91,197.772l-14.619,7.31C3.208,207.631,0,212.816,0,218.5s3.208,10.869,8.291,13.418l241,120
			c2.109,1.055,4.409,1.582,6.709,1.582s4.6-0.527,6.709-1.582l241-120c5.083-2.549,8.291-7.734,8.291-13.418
			S508.792,207.631,503.709,205.082z"
                />
            </g>
        ),
    },
    notifications_empty: {
        viewBox: '0 0 18 23',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M17.6487 17.6983L16.1183 16.1767V10.2793C16.1183 6.65828 14.1727 3.627 10.7797 2.82494V2.02289C10.7797 1.04392 9.98487 0.253662 9.0002 0.253662C8.01553 0.253662 7.22068 1.04392 7.22068 2.02289V2.82494C3.81586 3.627 1.88211 6.64648 1.88211 10.2793V16.1767L0.351725 17.6983C-0.395674 18.4414 0.126319 19.7152 1.18217 19.7152H16.8064C17.8741 19.7152 18.3961 18.4414 17.6487 17.6983ZM13.7456 17.3562H4.25481V10.2793C4.25481 7.35418 6.0462 4.97161 9.0002 4.97161C11.9542 4.97161 13.7456 7.35418 13.7456 10.2793V17.3562ZM9.0002 23.2537C10.3052 23.2537 11.3729 22.1921 11.3729 20.8947H6.62751C6.62751 22.1921 7.68336 23.2537 9.0002 23.2537Z"
            />
        ),
    },
    notifications_empty_smartplayer: {
        viewBox: '0 0 18 23',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M17.6487 17.6983L16.1183 16.1767V10.2793C16.1183 6.65828 14.1727 3.627 10.7797 2.82494V2.02289C10.7797 1.04392 9.98487 0.253662 9.0002 0.253662C8.01553 0.253662 7.22068 1.04392 7.22068 2.02289V2.82494C3.81586 3.627 1.88211 6.64648 1.88211 10.2793V16.1767L0.351725 17.6983C-0.395674 18.4414 0.126319 19.7152 1.18217 19.7152H16.8064C17.8741 19.7152 18.3961 18.4414 17.6487 17.6983ZM13.7456 17.3562H4.25481V10.2793C4.25481 7.35418 6.0462 4.97161 9.0002 4.97161C11.9542 4.97161 13.7456 7.35418 13.7456 10.2793V17.3562ZM9.0002 23.2537C10.3052 23.2537 11.3729 22.1921 11.3729 20.8947H6.62751C6.62751 22.1921 7.68336 23.2537 9.0002 23.2537Z"
            />
        ),
    },
    DSNotifications: {
        viewBox: '0 0 18 23',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M17.6487 17.6983L16.1183 16.1767V10.2793C16.1183 6.65828 14.1727 3.627 10.7797 2.82494V2.02289C10.7797 1.04392 9.98487 0.253662 9.0002 0.253662C8.01553 0.253662 7.22068 1.04392 7.22068 2.02289V2.82494C3.81586 3.627 1.88211 6.64648 1.88211 10.2793V16.1767L0.351725 17.6983C-0.395674 18.4414 0.126319 19.7152 1.18217 19.7152H16.8064C17.8741 19.7152 18.3961 18.4414 17.6487 17.6983ZM13.7456 17.3562H4.25481V10.2793C4.25481 7.35418 6.0462 4.97161 9.0002 4.97161C11.9542 4.97161 13.7456 7.35418 13.7456 10.2793V17.3562ZM9.0002 23.2537C10.3052 23.2537 11.3729 22.1921 11.3729 20.8947H6.62751C6.62751 22.1921 7.68336 23.2537 9.0002 23.2537Z"
            />
        ),
    },
    DSNotifications_smartplayer: {
        viewBox: '0 0 18 23',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M17.6487 17.6983L16.1183 16.1767V10.2793C16.1183 6.65828 14.1727 3.627 10.7797 2.82494V2.02289C10.7797 1.04392 9.98487 0.253662 9.0002 0.253662C8.01553 0.253662 7.22068 1.04392 7.22068 2.02289V2.82494C3.81586 3.627 1.88211 6.64648 1.88211 10.2793V16.1767L0.351725 17.6983C-0.395674 18.4414 0.126319 19.7152 1.18217 19.7152H16.8064C17.8741 19.7152 18.3961 18.4414 17.6487 17.6983ZM13.7456 17.3562H4.25481V10.2793C4.25481 7.35418 6.0462 4.97161 9.0002 4.97161C11.9542 4.97161 13.7456 7.35418 13.7456 10.2793V17.3562ZM9.0002 23.2537C10.3052 23.2537 11.3729 22.1921 11.3729 20.8947H6.62751C6.62751 22.1921 7.68336 23.2537 9.0002 23.2537Z"
            />
        ),
    },
    playNext: {
        viewBox: '0 0 306 306',
        image: <path d="M0,306l216.75-153L0,0V306z M255,0v306h51V0H255z" />,
    },
    vision: {
        viewBox: '0 0 60 60',
        image: (
            <path
                d="M59,28h-2.18c-0.951-5.666-5.85-10-11.748-10c-5.822,0-10.696,4.119-11.825,9.579c-0.971-0.814-2.079-1.246-3.247-1.246
            c-1.167,0-2.274,0.432-3.245,1.245C25.639,22.118,20.825,18,15.072,18C8.756,18,3.565,22.851,3.051,29H1c-0.553,0-1,0.448-1,1
            s0.447,1,1,1h2.051c0.514,6.149,5.705,11,12.021,11c6.467,0,11.736-5.207,11.911-11.671c0.853-1.285,1.915-1.996,3.017-1.996
            c1.102,0,2.164,0.712,3.017,1.996C33.195,36.793,38.528,42,45.072,42C51.649,42,57,36.617,57,30h2c0.553,0,1-0.448,1-1
            S59.553,28,59,28z M15.072,40C9.519,40,5,35.514,5,30s4.519-10,10.072-10C20.64,20,25,24.393,25,30S20.64,40,15.072,40z M45.072,40
            C39.519,40,35,35.514,35,30s4.519-10,10.072-10C50.64,20,55,24.393,55,30S50.64,40,45.072,40z"
            />
        ),
    },
    inter_connections: {
        viewBox: '0 0 17 13',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M1 6H4C4.55 6 5 5.55 5 5V1C5 0.45 4.55 0 4 0H1C0.45 0 0 0.45 0 1V5C0 5.55 0.45 6 1 6ZM1 13H4C4.55 13 5 12.55 5 12V8C5 7.45 4.55 7 4 7H1C0.45 7 0 7.45 0 8V12C0 12.55 0.45 13 1 13ZM7 13H10C10.55 13 11 12.55 11 12V8C11 7.45 10.55 7 10 7H7C6.45 7 6 7.45 6 8V12C6 12.55 6.45 13 7 13ZM13 13H16C16.55 13 17 12.55 17 12V8C17 7.45 16.55 7 16 7H13C12.45 7 12 7.45 12 8V12C12 12.55 12.45 13 13 13ZM7 6H10C10.55 6 11 5.55 11 5V1C11 0.45 10.55 0 10 0H7C6.45 0 6 0.45 6 1V5C6 5.55 6.45 6 7 6ZM12 1V5C12 5.55 12.45 6 13 6H16C16.55 6 17 5.55 17 5V1C17 0.45 16.55 0 16 0H13C12.45 0 12 0.45 12 1Z"
            />
        ),
    },
    horizontal_pos: {
        viewBox: '0 0 512 512',
        image: (
            <path
                d="M501.333,96H10.667C4.779,96,0,100.779,0,106.667v298.667C0,411.221,4.779,416,10.667,416h490.667
			c5.888,0,10.667-4.779,10.667-10.667V106.667C512,100.779,507.221,96,501.333,96z M490.667,394.667H21.333V117.333h469.333
			V394.667z"
            />
        ),
    },
    file: {
        viewBox: '0 0 31.004 31.004',
        image: (
            <g>
                <path d="M22.398,31.004v-4.512c0-0.938,0.757-1.701,1.697-1.701l3.498-0.1L22.398,31.004z" />
                <path
                    d="M25.896,0H5.105C4.168,0,3.41,0.762,3.41,1.695v27.611c0,0.939,0.758,1.697,1.695,1.697h15.604v-6.02
		c0-0.936,0.764-1.695,1.699-1.695h5.186V1.695C27.594,0.762,26.836,0,25.896,0z M14.295,24.521l-4.328,4.674l-4.219-4.791h2.109
		v-6.779h4.326v6.896H14.295z"
                />
            </g>
        ),
    },
    listCol: {
        viewBox: '0 0 16 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 2C4 3.1 3.1 4 2 4C0.9 4 0 3.1 0 2C0 0.9 0.9 0 2 0C3.1 0 4 0.9 4 2ZM0 8C0 6.9 0.9 6 2 6C3.1 6 4 6.9 4 8C4 9.1 3.1 10 2 10C0.9 10 0 9.1 0 8ZM0 14C0 12.9 0.9 12 2 12C3.1 12 4 12.9 4 14C4 15.1 3.1 16 2 16C0.9 16 0 15.1 0 14ZM7 0C5.89543 0 5 0.895431 5 2C5 3.10457 5.89543 4 7 4H14C15.1046 4 16 3.10457 16 2C16 0.895431 15.1046 0 14 0H7ZM5 8C5 6.89543 5.89543 6 7 6H14C15.1046 6 16 6.89543 16 8C16 9.10457 15.1046 10 14 10H7C5.89543 10 5 9.10457 5 8ZM7 12C5.89543 12 5 12.8954 5 14C5 15.1046 5.89543 16 7 16H14C15.1046 16 16 15.1046 16 14C16 12.8954 15.1046 12 14 12H7Z"
            />
        ),
    },
    listSq: {
        viewBox: '0 0 16 4',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z"
            />
        ),
    },
    shapeRect: {
        viewBox: '0 0 16 16',
        image: (
            <path d="M2.5 3.75C2.5 3.05964 3.05964 2.5 3.75 2.5H12.25C12.9404 2.5 13.5 3.05964 13.5 3.75V12.25C13.5 12.9404 12.9404 13.5 12.25 13.5H3.75C3.05964 13.5 2.5 12.9404 2.5 12.25V3.75Z" />
        ),
    },
    shapeRounded: {
        viewBox: '0 0 16 16',
        image: <rect x="2.5" y="2.5" width="11" height="11" rx="3" ry="3" />,
    },
    shapeEllipse: {
        viewBox: '0 0 16 16',
        image: <ellipse cx="8" cy="8" rx="5.5" ry="4.25" />,
    },
    shapeLine: {
        viewBox: '0 0 16 16',
        image: (
            <path d="M3.2 12.2C2.9 12.5 2.9 13 3.2 13.3C3.5 13.6 4 13.6 4.3 13.3L12.8 4.8C13.1 4.5 13.1 4 12.8 3.7C12.5 3.4 12 3.4 11.7 3.7L3.2 12.2Z" />
        ),
    },
    undo: {
        viewBox: '0 0 16 16',
        image: (
            <path d="M6.2 3.1C6.5 2.8 6.5 2.3 6.2 2C5.9 1.7 5.4 1.7 5.1 2L2.2 4.9C1.9 5.2 1.9 5.7 2.2 6L5.1 8.9C5.4 9.2 5.9 9.2 6.2 8.9C6.5 8.6 6.5 8.1 6.2 7.8L4.7 6.3H9.2C11.3 6.3 13 8 13 10.1C13 12.2 11.3 13.9 9.2 13.9H7.5C7.1 13.9 6.8 14.2 6.8 14.6C6.8 15 7.1 15.3 7.5 15.3H9.2C12.1 15.3 14.4 13 14.4 10.1C14.4 7.2 12.1 4.9 9.2 4.9H4.7L6.2 3.1Z" />
        ),
    },
    redo: {
        viewBox: '0 0 16 16',
        image: (
            <path d="M9.8 3.1C9.5 2.8 9.5 2.3 9.8 2C10.1 1.7 10.6 1.7 10.9 2L13.8 4.9C14.1 5.2 14.1 5.7 13.8 6L10.9 8.9C10.6 9.2 10.1 9.2 9.8 8.9C9.5 8.6 9.5 8.1 9.8 7.8L11.3 6.3H6.8C4.7 6.3 3 8 3 10.1C3 12.2 4.7 13.9 6.8 13.9H8.5C8.9 13.9 9.2 14.2 9.2 14.6C9.2 15 8.9 15.3 8.5 15.3H6.8C3.9 15.3 1.6 13 1.6 10.1C1.6 7.2 3.9 4.9 6.8 4.9H11.3L9.8 3.1Z" />
        ),
    },
    listVertical: {
        viewBox: '0 0 16 16',
        image: (
            <g>
                <circle cx="4" cy="5" r="1.45" />
                <circle cx="4" cy="8" r="1.45" />
                <circle cx="4" cy="11" r="1.45" />
                <rect x="7" y="4.05" width="6" height="1.9" rx="0.95" />
                <rect x="7" y="7.05" width="6" height="1.9" rx="0.95" />
                <rect x="7" y="10.05" width="6" height="1.9" rx="0.95" />
            </g>
        ),
    },
    listHorizontal: {
        viewBox: '0 0 16 16',
        image: (
            <g>
                <circle cx="4" cy="4.2" r="1.45" />
                <rect x="3.05" y="6.4" width="1.9" height="6" rx="0.95" />
                <circle cx="8" cy="4.2" r="1.45" />
                <rect x="7.05" y="6.4" width="1.9" height="6" rx="0.95" />
                <circle cx="12" cy="4.2" r="1.45" />
                <rect x="11.05" y="6.4" width="1.9" height="6" rx="0.95" />
            </g>
        ),
    },
    rotate: {
        viewBox: '0 0 94 94',
        image: (
            <path
                d="M94,47C94,21.043,72.958,0,47,0S0,21.043,0,47s21.042,47,47,47S94,72.957,94,47z M69.273,67.466
		c-5.67,5.67-13.221,8.792-21.26,8.792c-8.038,0-15.587-3.122-21.256-8.792C15.873,56.58,15.001,39.54,24.358,27.66l-8.424-8.424
		h24.397l0.001,24.397l-8.017-8.017c-5.015,7.4-4.192,17.475,2.311,23.979c3.57,3.568,8.324,5.534,13.39,5.534
		c5.063,0,9.818-1.966,13.389-5.537c3.568-3.567,5.535-8.323,5.535-13.389c0-5.062-1.965-9.817-5.535-13.389
		c-1.637-1.634-3.521-2.938-5.604-3.876l-2.33-1.049l4.568-10.15l2.33,1.052c3.316,1.491,6.312,3.564,8.904,6.157
		C80.996,36.672,80.995,55.744,69.273,67.466z"
            />
        ),
    },
    boldLetter: {
        viewBox: '0 0 97.01 97.01',
        image: (
            <path
                d="M71.865,46.842L71.865,46.842c8.133-3.628,12.611-10.272,12.611-18.709C84.477,9.991,73.076,0,52.378,0H11.623
		c-1.104,0-2,0.896-2,2v93.01c0,1.104,0.896,2,2,2h40.756c23.557,0,35.008-9.339,35.008-28.549
		C87.387,62.952,83.593,50.419,71.865,46.842z M52.379,79.963h-24.74V55.02h24.74c8.171,0,16.854,4.435,16.854,12.652
		C69.234,76.162,60.77,79.963,52.379,79.963z M52.379,38.943h-24.74V16.631h24.74c12.938,0,13.941,9.122,13.941,11.918
		C66.32,33.389,64.736,38.943,52.379,38.943z"
            />
        ),
    },
    letters: {
        viewBox: '0 0 573.852 573.852',
        image: (
            <path
                d="M217.667,83.129c-1.632-4.488-4.692-6.732-9.18-6.732H129.54c-4.488,0-7.548,2.244-9.18,6.732
			L0.408,477.257c-0.816,3.672-0.408,6.321,1.224,7.953c1.632,2.448,4.284,3.675,7.956,3.675H80.58c4.896,0,7.956-2.244,9.18-6.732
			l20.196-70.992h118.117l20.196,70.992c1.224,4.488,4.08,6.732,8.568,6.732h71.604h0.609c2.448,0,4.593-0.817,6.429-2.448
			s2.754-3.876,2.754-6.732c0-0.814-0.409-2.446-1.227-4.896L217.667,83.129z M128.316,334.661l40.392-144.432l41.004,144.432
			H128.316z M545.087,220.829c-19.176-17.544-46.103-26.316-80.781-26.316c-21.624,0-41.616,3.57-59.977,10.709
			c-18.361,7.14-34.476,17.646-48.348,31.518c-3.267,3.264-3.876,6.936-1.836,11.016l22.644,39.167
			c1.225,2.447,3.467,4.08,6.732,4.896c2.854,0.817,5.508,0,7.956-2.448c18.768-19.176,39.575-28.764,62.424-28.764
			c29.375,0,44.062,14.077,44.062,42.228v17.748c-17.135-13.464-38.351-20.193-63.646-20.193c-11.424,0-22.746,1.937-33.966,5.812
			c-11.222,3.876-21.219,9.792-29.988,17.748c-8.773,7.956-15.912,18.157-21.42,30.603c-5.508,12.442-8.262,27.027-8.262,43.758
			c0,16.317,2.649,30.6,7.953,42.84c5.307,12.24,12.444,22.542,21.423,30.906c8.975,8.362,18.971,14.688,29.985,18.972
			c11.018,4.284,22.44,6.426,34.272,6.426s23.255-1.836,34.271-5.508c11.019-3.672,20.811-8.975,29.376-15.912v5.508
			c0,2.448,0.918,4.593,2.754,6.429c1.839,1.836,3.979,2.754,6.429,2.754h57.525c2.448,0,4.592-0.918,6.429-2.754
			c1.836-1.836,2.754-3.979,2.754-6.429v-186.05C573.853,263.261,564.265,238.373,545.087,220.829z M497.964,419.116
			c-8.976,13.872-23.256,20.811-42.84,20.811c-11.832,0-21.215-3.774-28.149-11.322c-6.938-7.548-10.404-17.443-10.404-29.685
			c0-12.237,3.467-22.233,10.404-29.985c6.935-7.752,16.317-11.628,28.149-11.628c5.712,0,12.854,1.325,21.42,3.978
			c8.568,2.653,15.708,8.67,21.42,18.054V419.116z"
            />
        ),
    },
    underlineLetter: {
        viewBox: '0 0 93.868 93.868',
        image: (
            <g>
                <path
                    d="M75.915,0H63.367c-1.104,0-2,0.896-2,2v42.117c0,0.514,0.006,1.054,0.014,1.611c0.066,5.981,0.169,15.021-7.857,18.893
			c-1.734,0.854-4.137,1.324-6.764,1.326c-2.593,0-5.141-0.5-6.816-1.336c-7.501-3.745-7.4-11.289-7.326-16.797
			c0.007-0.496,0.013-0.976,0.013-1.432V2c0-1.104-0.896-2-2-2H17.95c-1.104,0-2,0.896-2,2v43.985
			c-0.005,11.042-0.01,20.582,14.223,27.57c4.093,2.053,10.371,3.231,17.226,3.232c6.238,0,12.133-1.005,15.799-2.702
			c13.583-6.539,14.72-17.964,14.72-29.105V2C77.915,0.896,77.021,0,75.915,0z"
                />
                <path
                    d="M75.904,81.407H17.966c-1.104,0-2,0.896-2,2v8.461c0,1.104,0.896,2,2,2h57.938c1.104,0,2-0.896,2-2v-8.461
			C77.904,82.303,77.009,81.407,75.904,81.407z"
                />
            </g>
        ),
    },
    italicLetter: {
        viewBox: '0 0 466.666 466.667',
        image: (
            <path d="M433.333,0v33.333h-66.667L200,433.333h66.667v33.333H33.333v-33.333H100l166.667-400H200V0H433.333z" />
        ),
    },
    centerText: {
        viewBox: '0 0 511.63 511.631',
        image: (
            <path
                d="M511.63,401.994v36.546c0,4.948-1.811,9.232-5.425,12.854c-3.617,3.61-7.905,5.421-12.85,5.421H18.274
		c-4.947,0-9.23-1.811-12.851-5.421C1.809,447.772,0,443.488,0,438.54v-36.546c0-4.948,1.809-9.232,5.424-12.847
		c3.618-3.617,7.898-5.427,12.851-5.427h475.082c4.944,0,9.232,1.81,12.85,5.427C509.82,392.762,511.63,397.046,511.63,401.994z
		 M127.91,274.088c-4.952,0-9.233,1.811-12.85,5.428c-3.618,3.613-5.424,7.901-5.424,12.847v36.545
		c0,4.948,1.807,9.236,5.424,12.847c3.62,3.617,7.901,5.432,12.85,5.432h255.813c4.948,0,9.233-1.814,12.847-5.432
		c3.617-3.61,5.428-7.898,5.428-12.847v-36.545c0-4.945-1.811-9.233-5.428-12.847c-3.613-3.617-7.898-5.428-12.847-5.428H127.91z
		 M54.821,237.548H456.81c4.949,0,9.233-1.812,12.848-5.429c3.613-3.612,5.42-7.898,5.42-12.845v-36.547
		c0-4.952-1.807-9.231-5.42-12.847c-3.614-3.617-7.898-5.424-12.848-5.424H54.821c-4.952,0-9.235,1.807-12.85,5.424
		c-3.617,3.615-5.424,7.898-5.424,12.847v36.547c0,4.947,1.807,9.233,5.424,12.845C45.59,235.736,49.869,237.548,54.821,237.548z
		 M164.457,127.909h182.714c4.948,0,9.236-1.809,12.854-5.424c3.613-3.617,5.424-7.898,5.424-12.847V73.091
		c0-4.948-1.811-9.229-5.417-12.85c-3.62-3.612-7.905-5.424-12.854-5.424H164.457c-4.952,0-9.235,1.812-12.85,5.424
		c-3.617,3.617-5.426,7.902-5.426,12.85v36.547c0,4.948,1.809,9.229,5.426,12.847C155.226,126.1,159.508,127.909,164.457,127.909z"
            />
        ),
    },
    justifyText: {
        viewBox: '0 0 511.63 511.631',
        image: (
            <g>
                <path
                    d="M493.356,274.088H18.274c-4.952,0-9.233,1.811-12.851,5.428C1.809,283.129,0,287.417,0,292.362v36.545
			c0,4.948,1.809,9.236,5.424,12.847c3.621,3.617,7.904,5.432,12.851,5.432h475.082c4.944,0,9.232-1.814,12.85-5.432
			c3.614-3.61,5.425-7.898,5.425-12.847v-36.545c0-4.945-1.811-9.233-5.425-12.847C502.588,275.895,498.3,274.088,493.356,274.088z"
                />
                <path
                    d="M493.356,383.721H18.274c-4.952,0-9.233,1.81-12.851,5.427C1.809,392.762,0,397.046,0,401.994v36.546
			c0,4.948,1.809,9.232,5.424,12.854c3.621,3.61,7.904,5.421,12.851,5.421h475.082c4.944,0,9.232-1.811,12.85-5.421
			c3.614-3.621,5.425-7.905,5.425-12.854v-36.546c0-4.948-1.811-9.232-5.425-12.847C502.588,385.53,498.3,383.721,493.356,383.721z"
                />
                <path
                    d="M506.206,60.241c-3.617-3.612-7.905-5.424-12.85-5.424H18.274c-4.952,0-9.233,1.812-12.851,5.424
			C1.809,63.858,0,68.143,0,73.091v36.547c0,4.948,1.809,9.229,5.424,12.847c3.621,3.616,7.904,5.424,12.851,5.424h475.082
			c4.944,0,9.232-1.809,12.85-5.424c3.614-3.617,5.425-7.898,5.425-12.847V73.091C511.63,68.143,509.82,63.861,506.206,60.241z"
                />
                <path
                    d="M493.356,164.456H18.274c-4.952,0-9.233,1.807-12.851,5.424C1.809,173.495,0,177.778,0,182.727v36.547
			c0,4.947,1.809,9.233,5.424,12.845c3.621,3.617,7.904,5.429,12.851,5.429h475.082c4.944,0,9.232-1.812,12.85-5.429
			c3.614-3.612,5.425-7.898,5.425-12.845v-36.547c0-4.952-1.811-9.231-5.425-12.847C502.588,166.263,498.3,164.456,493.356,164.456z
			"
                />
            </g>
        ),
    },
    leftText: {
        viewBox: '0 0 511.63 511.631',
        image: (
            <g>
                <path
                    d="M18.274,237.548h438.542c4.949,0,9.229-1.812,12.847-5.429c3.614-3.612,5.421-7.898,5.421-12.845v-36.547
			c0-4.952-1.807-9.231-5.421-12.847c-3.617-3.617-7.897-5.424-12.847-5.424H18.274c-4.952,0-9.233,1.807-12.851,5.424
			C1.809,173.495,0,177.778,0,182.727v36.547c0,4.947,1.809,9.233,5.424,12.845C9.044,235.736,13.326,237.548,18.274,237.548z"
                />
                <path
                    d="M18.274,127.909h328.897c4.948,0,9.236-1.809,12.854-5.424c3.613-3.617,5.424-7.898,5.424-12.847V73.091
			c0-4.948-1.811-9.229-5.424-12.85c-3.617-3.612-7.905-5.424-12.854-5.424H18.274c-4.952,0-9.233,1.812-12.851,5.424
			C1.809,63.858,0,68.143,0,73.091v36.547c0,4.948,1.809,9.229,5.424,12.847C9.044,126.1,13.326,127.909,18.274,127.909z"
                />
                <path
                    d="M506.206,389.147c-3.617-3.617-7.905-5.427-12.85-5.427H18.274c-4.952,0-9.233,1.81-12.851,5.427
			C1.809,392.762,0,397.046,0,401.994v36.546c0,4.948,1.809,9.232,5.424,12.854c3.621,3.61,7.904,5.421,12.851,5.421h475.082
			c4.944,0,9.232-1.811,12.85-5.421c3.614-3.621,5.425-7.905,5.425-12.854v-36.546C511.63,397.046,509.82,392.762,506.206,389.147z"
                />
                <path
                    d="M18.274,347.179h365.449c4.948,0,9.233-1.811,12.847-5.428c3.617-3.614,5.428-7.898,5.428-12.847v-36.542
			c0-4.945-1.811-9.233-5.428-12.847c-3.613-3.617-7.898-5.428-12.847-5.428H18.274c-4.952,0-9.233,1.811-12.851,5.428
			C1.809,283.129,0,287.417,0,292.362v36.545c0,4.948,1.809,9.236,5.424,12.847C9.044,345.371,13.326,347.179,18.274,347.179z"
                />
            </g>
        ),
    },
    rightText: {
        viewBox: '0 0 511.63 511.631',
        image: (
            <g>
                <path
                    d="M493.356,383.721H18.274c-4.952,0-9.233,1.81-12.851,5.427C1.809,392.762,0,397.046,0,401.994v36.546
			c0,4.948,1.809,9.232,5.424,12.854c3.621,3.61,7.904,5.421,12.851,5.421h475.082c4.944,0,9.232-1.811,12.85-5.421
			c3.614-3.621,5.425-7.905,5.425-12.854v-36.546c0-4.948-1.811-9.232-5.425-12.847C502.588,385.53,498.3,383.721,493.356,383.721z"
                />
                <path
                    d="M493.356,274.088H127.91c-4.952,0-9.233,1.811-12.85,5.428c-3.618,3.613-5.424,7.901-5.424,12.847v36.545
			c0,4.948,1.807,9.236,5.424,12.847c3.62,3.617,7.901,5.432,12.85,5.432h365.446c4.944,0,9.232-1.814,12.85-5.432
			c3.614-3.61,5.425-7.898,5.425-12.847v-36.545c0-4.945-1.811-9.233-5.425-12.847C502.588,275.895,498.3,274.088,493.356,274.088z"
                />
                <path
                    d="M493.356,164.456H54.821c-4.952,0-9.235,1.807-12.85,5.424c-3.617,3.615-5.424,7.898-5.424,12.847v36.547
			c0,4.947,1.807,9.233,5.424,12.845c3.619,3.617,7.898,5.429,12.85,5.429h438.535c4.944,0,9.232-1.812,12.85-5.429
			c3.614-3.612,5.425-7.898,5.425-12.845v-36.547c0-4.952-1.811-9.231-5.425-12.847C502.588,166.263,498.3,164.456,493.356,164.456z
			"
                />
                <path
                    d="M506.206,60.241c-3.617-3.612-7.905-5.424-12.85-5.424H164.457c-4.952,0-9.235,1.812-12.85,5.424
			c-3.617,3.617-5.426,7.902-5.426,12.85v36.547c0,4.948,1.809,9.229,5.426,12.847c3.619,3.616,7.901,5.424,12.85,5.424h328.899
			c4.944,0,9.232-1.809,12.85-5.424c3.614-3.617,5.425-7.898,5.425-12.847V73.091C511.63,68.143,509.82,63.861,506.206,60.241z"
                />
            </g>
        ),
    },
    goPrev: {
        viewBox: '0 0 20 8',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.5 0.827881C7.85 0.827881 5.45 1.81788 3.6 3.42788L1.71 1.53788C1.08 0.907881 0 1.34788 0 2.23788V7.82788C0 8.37788 0.45 8.82788 1 8.82788H6.59C7.48 8.82788 7.93 7.74788 7.3 7.11788L5.39 5.20788C6.78 4.04788 8.55 3.32788 10.51 3.32788C13.67 3.32788 16.4 5.16788 17.7 7.82788C17.97 8.38788 18.61 8.66788 19.2 8.46788C19.91 8.23788 20.27 7.42788 19.95 6.74788C18.23 3.24788 14.65 0.827881 10.5 0.827881Z"
            />
        ),
    },
    goNext: {
        viewBox: '0 0 20 8',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.60303 0.827881C12.2441 0.827881 14.636 1.81788 16.4798 3.42788L18.3634 1.53788C18.9913 0.907881 20.0676 1.34788 20.0676 2.23788V7.82788C20.0676 8.37788 19.6191 8.82788 19.071 8.82788H13.4998C12.6128 8.82788 12.1644 7.74788 12.7922 7.11788L14.6958 5.20788C13.3105 4.04788 11.5465 3.32788 9.59306 3.32788C6.44372 3.32788 3.72292 5.16788 2.4273 7.82788C2.15821 8.38788 1.52037 8.66788 0.932358 8.46788C0.224752 8.23788 -0.134033 7.42788 0.184887 6.74788C1.89909 3.24788 5.46702 0.827881 9.60303 0.827881Z"
            />
        ),
    },
    animation: {
        viewBox: '0 0 20 20',
        image: <circle xmlns="http://www.w3.org/2000/svg" cx="10.0439" cy="10.3279" r="9.5" />,
    },
    csv: {
        viewBox: '0 0 548.29 548.291',
        image: (
            <path
                d="M486.2,196.121h-13.164V132.59c0-0.399-0.064-0.795-0.116-1.2c-0.021-2.52-0.824-5-2.551-6.96L364.656,3.677
		c-0.031-0.034-0.064-0.044-0.085-0.075c-0.629-0.707-1.364-1.292-2.141-1.796c-0.231-0.157-0.462-0.286-0.704-0.419
		c-0.672-0.365-1.386-0.672-2.121-0.893c-0.199-0.052-0.377-0.134-0.576-0.188C358.229,0.118,357.4,0,356.562,0H96.757
		C84.893,0,75.256,9.649,75.256,21.502v174.613H62.093c-16.972,0-30.733,13.756-30.733,30.73v159.81
		c0,16.966,13.761,30.736,30.733,30.736h13.163V526.79c0,11.854,9.637,21.501,21.501,21.501h354.777
		c11.853,0,21.502-9.647,21.502-21.501V417.392H486.2c16.966,0,30.729-13.764,30.729-30.731v-159.81
		C516.93,209.872,503.166,196.121,486.2,196.121z M96.757,21.502h249.053v110.006c0,5.94,4.818,10.751,10.751,10.751h94.973v53.861
		H96.757V21.502z M258.618,313.18c-26.68-9.291-44.063-24.053-44.063-47.389c0-27.404,22.861-48.368,60.733-48.368
		c18.107,0,31.447,3.811,40.968,8.107l-8.09,29.3c-6.43-3.107-17.862-7.632-33.59-7.632c-15.717,0-23.339,7.149-23.339,15.485
		c0,10.247,9.047,14.769,29.78,22.632c28.341,10.479,41.681,25.239,41.681,47.874c0,26.909-20.721,49.786-64.792,49.786
		c-18.338,0-36.449-4.776-45.497-9.77l7.38-30.016c9.772,5.014,24.775,10.006,40.264,10.006c16.671,0,25.488-6.908,25.488-17.396
		C285.536,325.789,277.909,320.078,258.618,313.18z M69.474,302.692c0-54.781,39.074-85.269,87.654-85.269
		c18.822,0,33.113,3.811,39.549,7.149l-7.392,28.816c-7.38-3.084-17.632-5.939-30.491-5.939c-28.822,0-51.206,17.375-51.206,53.099
		c0,32.158,19.051,52.4,51.456,52.4c10.947,0,23.097-2.378,30.241-5.238l5.483,28.346c-6.672,3.34-21.674,6.919-41.208,6.919
		C98.06,382.976,69.474,348.424,69.474,302.692z M451.534,520.962H96.757v-103.57h354.777V520.962z M427.518,380.583h-42.399
		l-51.45-160.536h39.787l19.526,67.894c5.479,19.046,10.479,37.386,14.299,57.397h0.709c4.048-19.298,9.045-38.352,14.526-56.693
		l20.487-68.598h38.599L427.518,380.583z"
            />
        ),
    },
    time: {
        viewBox: '0 0 20 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z"
            />
        ),
    },
    burger: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M24,3c0-0.6-0.4-1-1-1H1C0.4,2,0,2.4,0,3v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V3z" />
                <path d="M24,11c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V11z" />
                <path d="M24,19c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V19z" />
            </g>
        ),
    },
    toolbar: {
        viewBox: '0 0 336.213 336.213',
        image: (
            <path
                d="M320.344,0H15.869C8.832,0,3.106,5.727,3.106,12.763V323.45c0,7.035,5.726,12.763,12.763,12.763h304.475
            c7.037,0,12.763-5.728,12.763-12.763V12.763C333.106,5.727,327.381,0,320.344,0z M39.267,34.102h38.895v29.172H39.267V34.102z
             M140.151,135.288H39.267V89.404h100.884V135.288z M140.151,63.273h-38.895V34.102h38.895V63.273z M298.466,301.572H171.753V34.641
            h126.712V301.572z"
            />
        ),
    },
    external_link: {
        viewBox: '0 0 511.626 511.627',
        image: (
            <g>
                <path
                    d="M392.857,292.354h-18.274c-2.669,0-4.859,0.855-6.563,2.573c-1.718,1.708-2.573,3.897-2.573,6.563v91.361
			c0,12.563-4.47,23.315-13.415,32.262c-8.945,8.945-19.701,13.414-32.264,13.414H82.224c-12.562,0-23.317-4.469-32.264-13.414
			c-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562,4.471-23.313,13.417-32.259c8.947-8.947,19.702-13.418,32.264-13.418
			h200.994c2.669,0,4.859-0.859,6.57-2.57c1.711-1.713,2.566-3.9,2.566-6.567V82.221c0-2.662-0.855-4.853-2.566-6.563
			c-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648,0-42.016,8.042-58.102,24.125C8.042,113.297,0,132.665,0,155.313v237.542
			c0,22.647,8.042,42.018,24.123,58.095c16.086,16.084,35.454,24.13,58.102,24.13h237.543c22.647,0,42.017-8.046,58.101-24.13
			c16.085-16.077,24.127-35.447,24.127-58.095v-91.358c0-2.669-0.856-4.859-2.574-6.57
			C397.709,293.209,395.519,292.354,392.857,292.354z"
                />
                <path
                    d="M506.199,41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948,0-9.233,1.807-12.847,5.424
			c-3.617,3.615-5.428,7.898-5.428,12.847s1.811,9.233,5.428,12.85l50.247,50.248L198.424,304.067
			c-1.906,1.903-2.856,4.093-2.856,6.563c0,2.479,0.953,4.668,2.856,6.571l32.548,32.544c1.903,1.903,4.093,2.852,6.567,2.852
			s4.665-0.948,6.567-2.852l186.148-186.148l50.251,50.248c3.614,3.617,7.898,5.426,12.847,5.426s9.233-1.809,12.851-5.426
			c3.617-3.616,5.424-7.898,5.424-12.847V54.818C511.626,49.866,509.813,45.586,506.199,41.971z"
                />
            </g>
        ),
    },
    middleAlign: {
        viewBox: '0 0 60 60',
        image: (
            <g>
                <path
                    d="M49.29,58.29C49.11,58.48,49,58.74,49,59c0,0.26,0.11,0.52,0.29,0.71C49.48,59.89,49.74,60,50,60
		c0.26,0,0.52-0.11,0.71-0.29C50.89,59.52,51,59.26,51,59c0-0.26-0.11-0.52-0.29-0.71C50.34,57.92,49.66,57.92,49.29,58.29z"
                />
                <circle cx="38" cy="59" r="1" />
                <circle cx="34" cy="59" r="1" />
                <circle cx="46" cy="59" r="1" />
                <circle cx="42" cy="59" r="1" />
                <circle cx="14" cy="59" r="1" />
                <circle cx="18" cy="59" r="1" />
                <circle cx="30" cy="59" r="1" />
                <circle cx="26" cy="59" r="1" />
                <circle cx="22" cy="59" r="1" />
                <path
                    d="M9.29,58.29C9.11,58.48,9,58.74,9,59c0,0.26,0.11,0.52,0.29,0.71C9.48,59.89,9.74,60,10,60c0.26,0,0.52-0.11,0.71-0.29
		C10.89,59.52,11,59.26,11,59c0-0.26-0.11-0.52-0.29-0.71C10.33,57.92,9.67,57.92,9.29,58.29z"
                />
                <path d="M10,17.47c0.55,0,1-0.45,1-1c0-0.56-0.45-1-1-1c-0.55,0-1,0.44-1,1C9,17.02,9.45,17.47,10,17.47z" />
                <path d="M10,9.73c0.55,0,1-0.44,1-1c0-0.55-0.45-1-1-1c-0.55,0-1,0.45-1,1C9,9.29,9.45,9.73,10,9.73z" />
                <path d="M10,42.53c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C11,42.98,10.55,42.53,10,42.53z" />
                <circle cx="10" cy="12.6" r="1" />
                <circle cx="10" cy="47.4" r="1" />
                <path d="M10,50.27c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C11,50.71,10.55,50.27,10,50.27z" />
                <path d="M10,54.13c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C11,54.58,10.55,54.13,10,54.13z" />
                <path d="M10,5.87c0.55,0,1-0.45,1-1c0-0.56-0.45-1-1-1c-0.55,0-1,0.44-1,1C9,5.42,9.45,5.87,10,5.87z" />
                <path
                    d="M10,2c0.26,0,0.52-0.11,0.71-0.29C10.89,1.52,11,1.26,11,1c0-0.26-0.11-0.52-0.29-0.71c-0.37-0.37-1.05-0.37-1.42,0
		C9.11,0.48,9,0.74,9,1c0,0.26,0.11,0.52,0.29,0.71C9.48,1.89,9.74,2,10,2z"
                />
                <circle cx="26" cy="1" r="1" />
                <circle cx="30" cy="1" r="1" />
                <circle cx="22" cy="1" r="1" />
                <circle cx="18" cy="1" r="1" />
                <circle cx="14" cy="1" r="1" />
                <circle cx="34" cy="1" r="1" />
                <circle cx="42" cy="1" r="1" />
                <circle cx="46" cy="1" r="1" />
                <circle cx="38" cy="1" r="1" />
                <path
                    d="M50,2c0.26,0,0.52-0.11,0.71-0.29C50.89,1.52,51,1.26,51,1c0-0.26-0.11-0.52-0.29-0.71c-0.37-0.37-1.05-0.37-1.42,0
		C49.11,0.48,49,0.74,49,1c0,0.26,0.11,0.52,0.29,0.71C49.48,1.89,49.74,2,50,2z"
                />
                <circle cx="50" cy="47.4" r="1" />
                <path d="M50,42.53c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,42.98,50.55,42.53,50,42.53z" />
                <path d="M50,50.27c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,50.71,50.55,50.27,50,50.27z" />
                <path d="M50,54.13c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,54.58,50.55,54.13,50,54.13z" />
                <path d="M50,3.87c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,4.31,50.55,3.87,50,3.87z" />
                <circle cx="50" cy="12.6" r="1" />
                <path d="M50,7.73c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,8.18,50.55,7.73,50,7.73z" />
                <path d="M50,15.47c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,15.91,50.55,15.47,50,15.47z" />
                <path
                    d="M50,19.33c-0.433,0-0.795,0.283-0.933,0.67H10.933c-0.138-0.387-0.5-0.67-0.933-0.67c-0.433,0-0.795,0.283-0.933,0.67H9v21
		h42V20h-0.067C50.795,19.613,50.433,19.33,50,19.33z M11,22h38v17H11V22z"
                />
            </g>
        ),
    },
    topAlign: {
        viewBox: '0 0 60 60',
        image: (
            <g>
                <path
                    d="M49.29,58.29C49.11,58.48,49,58.74,49,59c0,0.26,0.11,0.52,0.29,0.71C49.48,59.89,49.74,60,50,60
		c0.26,0,0.52-0.11,0.71-0.29C50.89,59.52,51,59.26,51,59c0-0.26-0.11-0.52-0.29-0.71C50.33,57.92,49.67,57.92,49.29,58.29z"
                />
                <circle cx="38" cy="59" r="1" />
                <circle cx="46" cy="59" r="1" />
                <circle cx="42" cy="59" r="1" />
                <circle cx="34" cy="59" r="1" />
                <circle cx="14" cy="59" r="1" />
                <circle cx="22" cy="59" r="1" />
                <circle cx="26" cy="59" r="1" />
                <circle cx="30" cy="59" r="1" />
                <circle cx="18" cy="59" r="1" />
                <path
                    d="M9.29,58.29C9.11,58.48,9,58.74,9,59c0,0.26,0.11,0.52,0.29,0.71C9.48,59.89,9.74,60,10,60c0.26,0,0.52-0.11,0.71-0.29
		C10.89,59.52,11,59.26,11,59c0-0.26-0.11-0.52-0.29-0.71C10.33,57.92,9.67,57.92,9.29,58.29z"
                />
                <circle cx="10" cy="31.93" r="1" />
                <path d="M10,38.67c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C11,39.11,10.55,38.67,10,38.67z" />
                <circle cx="10" cy="35.8" r="1" />
                <path d="M10,27.07c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C11,27.51,10.55,27.07,10,27.07z" />
                <path d="M10,50.27c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C11,50.71,10.55,50.27,10,50.27z" />
                <circle cx="10" cy="24.2" r="1" />
                <circle cx="10" cy="47.4" r="1" />
                <path d="M10,42.53c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C11,42.98,10.55,42.53,10,42.53z" />
                <path d="M10,54.13c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C11,54.58,10.55,54.13,10,54.13z" />
                <circle cx="50" cy="47.4" r="1" />
                <path d="M50,42.53c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,42.98,50.55,42.53,50,42.53z" />
                <path d="M50,38.67c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,39.11,50.55,38.67,50,38.67z" />
                <path d="M50,50.27c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,50.71,50.55,50.27,50,50.27z" />
                <path d="M50,54.13c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,54.58,50.55,54.13,50,54.13z" />
                <circle cx="50" cy="31.93" r="1" />
                <path d="M50,27.07c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,27.51,50.55,27.07,50,27.07z" />
                <circle cx="50" cy="24.2" r="1" />
                <circle cx="50" cy="35.8" r="1" />
                <path
                    d="M9,0v21h0.267C9.45,21.2,9.708,21.33,10,21.33c0.292,0,0.55-0.129,0.733-0.33h38.534c0.183,0.2,0.441,0.33,0.733,0.33
		c0.292,0,0.55-0.129,0.733-0.33H51V0H9z M11,2h38v17H11V2z"
                />
            </g>
        ),
    },
    bottomAlign: {
        viewBox: '0 0 60 60',
        image: (
            <g>
                <path d="M10,29.07c0.55,0,1-0.45,1-1c0-0.56-0.45-1-1-1c-0.55,0-1,0.44-1,1C9,28.62,9.45,29.07,10,29.07z" />
                <circle cx="10" cy="31.93" r="1" />
                <circle cx="10" cy="35.8" r="1" />
                <circle cx="10" cy="24.2" r="1" />
                <path d="M10,5.87c0.55,0,1-0.45,1-1c0-0.56-0.45-1-1-1c-0.55,0-1,0.44-1,1C9,5.42,9.45,5.87,10,5.87z" />
                <circle cx="10" cy="12.6" r="1" />
                <path d="M10,21.33c0.55,0,1-0.44,1-1c0-0.55-0.45-1-1-1c-0.55,0-1,0.45-1,1C9,20.89,9.45,21.33,10,21.33z" />
                <path d="M10,17.47c0.55,0,1-0.45,1-1c0-0.56-0.45-1-1-1c-0.55,0-1,0.44-1,1C9,17.02,9.45,17.47,10,17.47z" />
                <path d="M10,9.73c0.55,0,1-0.44,1-1c0-0.55-0.45-1-1-1c-0.55,0-1,0.45-1,1C9,9.29,9.45,9.73,10,9.73z" />
                <path
                    d="M10,2c0.26,0,0.52-0.11,0.71-0.29C10.89,1.52,11,1.26,11,1c0-0.26-0.11-0.52-0.29-0.71c-0.38-0.37-1.04-0.37-1.42,0
		C9.11,0.48,9,0.74,9,1c0,0.26,0.11,0.52,0.29,0.71C9.48,1.89,9.74,2,10,2z"
                />
                <circle cx="30" cy="1" r="1" />
                <circle cx="34" cy="1" r="1" />
                <circle cx="38" cy="1" r="1" />
                <circle cx="46" cy="1" r="1" />
                <circle cx="18" cy="1" r="1" />
                <circle cx="14" cy="1" r="1" />
                <circle cx="26" cy="1" r="1" />
                <circle cx="22" cy="1" r="1" />
                <circle cx="42" cy="1" r="1" />
                <path
                    d="M50,2c0.26,0,0.52-0.11,0.71-0.29C50.89,1.52,51,1.26,51,1c0-0.26-0.11-0.52-0.29-0.71c-0.38-0.37-1.05-0.37-1.42,0
		C49.11,0.48,49,0.74,49,1c0,0.26,0.11,0.52,0.29,0.71C49.48,1.89,49.74,2,50,2z"
                />
                <path d="M50,7.73c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,8.18,50.55,7.73,50,7.73z" />
                <path d="M50,15.47c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,15.91,50.55,15.47,50,15.47z" />
                <circle cx="50" cy="12.6" r="1" />
                <path d="M50,3.87c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,4.31,50.55,3.87,50,3.87z" />
                <path d="M50,27.07c-0.55,0-1,0.44-1,1c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1C51,27.51,50.55,27.07,50,27.07z" />
                <circle cx="50" cy="35.8" r="1" />
                <path d="M50,19.33c-0.55,0-1,0.45-1,1c0,0.56,0.45,1,1,1c0.55,0,1-0.44,1-1C51,19.78,50.55,19.33,50,19.33z" />
                <circle cx="50" cy="31.93" r="1" />
                <circle cx="50" cy="24.2" r="1" />
                <path
                    d="M50,38.67c-0.293,0-0.55,0.129-0.733,0.33H10.733c-0.183-0.201-0.441-0.33-0.733-0.33c-0.293,0-0.55,0.129-0.733,0.33H9v21
		h42V39h-0.267C50.55,38.799,50.292,38.67,50,38.67z M11,41h38v17H11V41z"
                />
            </g>
        ),
    },
    topBorder: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M59.077,482.462H29.538v-29.538c0-8.157-6.613-14.769-14.769-14.769S0,444.767,0,452.923v44.308
			C0,505.387,6.613,512,14.769,512h44.308c8.157,0,14.769-6.613,14.769-14.769S67.233,482.462,59.077,482.462z"
                />
                <path
                    d="M497.231,438.154c-8.157,0-14.769,6.613-14.769,14.769v29.538h-29.538c-8.157,0-14.769,6.613-14.769,14.769
			S444.767,512,452.923,512h44.308c8.157,0,14.769-6.613,14.769-14.769v-44.308C512,444.767,505.387,438.154,497.231,438.154z"
                />
                <path
                    d="M14.769,103.385C6.613,103.385,0,109.997,0,118.154v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,109.997,22.926,103.385,14.769,103.385z"
                />
                <path
                    d="M14.769,184.471C6.613,184.471,0,191.083,0,199.24v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C29.538,191.083,22.926,184.471,14.769,184.471z"
                />
                <path
                    d="M14.769,265.557C6.613,265.557,0,272.169,0,280.326v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,272.169,22.926,265.557,14.769,265.557z"
                />
                <path
                    d="M14.769,346.643C6.613,346.643,0,353.255,0,361.412v32.434c0,8.157,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,353.255,22.926,346.643,14.769,346.643z"
                />
                <path
                    d="M150.588,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S109.997,512,118.154,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,482.462,150.588,482.462z"
                />
                <path
                    d="M231.674,482.462H199.24c-8.157,0-14.769,6.613-14.769,14.769S191.083,512,199.24,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,482.462,231.674,482.462z"
                />
                <path
                    d="M312.76,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S272.169,512,280.326,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.917,482.462,312.76,482.462z"
                />
                <path
                    d="M393.846,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S353.255,512,361.412,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,482.462,393.846,482.462z"
                />
                <path
                    d="M150.588,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,241.231,150.588,241.231z"
                />
                <path
                    d="M231.674,241.231H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,241.231,231.674,241.231z"
                />
                <path
                    d="M461.611,241.231h-22.588c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.588
			c8.157,0,14.769-6.613,14.769-14.769S469.768,241.231,461.611,241.231z"
                />
                <path
                    d="M72.978,241.231H50.389c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.588
			c8.157,0,14.769-6.613,14.769-14.769S81.134,241.231,72.978,241.231z"
                />
                <path
                    d="M312.76,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.917,241.231,312.76,241.231z"
                />
                <path
                    d="M393.846,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,241.231,393.846,241.231z"
                />
                <path
                    d="M256,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,353.254,264.157,346.643,256,346.643z"
                />
                <path
                    d="M256,275.403c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,282.016,264.157,275.403,256,275.403z"
                />
                <path
                    d="M256,424.254c-8.157,0-14.769,6.613-14.769,14.769v22.587c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.587C270.769,430.867,264.157,424.254,256,424.254z"
                />
                <path
                    d="M256,184.471c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C270.769,191.083,264.157,184.471,256,184.471z"
                />
                <path
                    d="M256,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.158,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,109.997,264.157,103.385,256,103.385z"
                />
                <path
                    d="M497.231,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,158.745,512,150.588v-32.434C512,109.997,505.387,103.385,497.231,103.385z"
                />
                <path
                    d="M497.231,184.471c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,239.831,512,231.674V199.24C512,191.082,505.387,184.471,497.231,184.471z"
                />
                <path
                    d="M497.231,265.557c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769S512,320.917,512,312.76
			v-32.434C512,272.169,505.387,265.557,497.231,265.557z"
                />
                <path
                    d="M497.231,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,402.003,512,393.846v-32.434C512,353.254,505.387,346.643,497.231,346.643z"
                />
                <path
                    d="M497.231,0H14.769C6.613,0,0,6.613,0,14.769v44.308c0,8.157,6.613,14.769,14.769,14.769h482.462
			c8.157,0,14.769-6.613,14.769-14.769V14.769C512,6.613,505.387,0,497.231,0z"
                />
            </g>
        ),
    },
    bottomBorder: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M150.588,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.745,0,150.588,0z"
                />
                <path
                    d="M231.674,0H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,0,231.674,0z"
                />
                <path
                    d="M312.76,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.917,0,312.76,0z"
                />
                <path
                    d="M393.846,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,0,393.846,0z"
                />
                <path
                    d="M497.231,438.154H14.769C6.613,438.154,0,444.767,0,452.923v44.308C0,505.387,6.613,512,14.769,512h482.462
			c8.157,0,14.769-6.613,14.769-14.769v-44.308C512,444.767,505.387,438.154,497.231,438.154z"
                />
                <path
                    d="M59.077,0H14.769C6.613,0,0,6.613,0,14.769v44.308c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769V29.538
			h29.538c8.157,0,14.769-6.613,14.769-14.769S67.233,0,59.077,0z"
                />
                <path
                    d="M497.231,0h-44.308c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h29.538v29.538
			c0,8.157,6.613,14.769,14.769,14.769S512,67.233,512,59.077V14.769C512,6.613,505.387,0,497.231,0z"
                />
                <path
                    d="M14.769,103.385C6.613,103.385,0,109.997,0,118.154v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,109.997,22.926,103.385,14.769,103.385z"
                />
                <path
                    d="M14.769,184.471C6.613,184.471,0,191.083,0,199.24v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C29.538,191.083,22.926,184.471,14.769,184.471z"
                />
                <path
                    d="M14.769,265.557C6.613,265.557,0,272.169,0,280.326v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,272.169,22.926,265.557,14.769,265.557z"
                />
                <path
                    d="M14.769,346.643C6.613,346.643,0,353.255,0,361.412v32.434c0,8.157,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,353.255,22.926,346.643,14.769,346.643z"
                />
                <path
                    d="M150.588,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.745,241.231,150.588,241.231z"
                />
                <path
                    d="M231.674,241.231H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,241.231,231.674,241.231z"
                />
                <path
                    d="M461.61,241.231h-22.588c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.588
			c8.157,0,14.769-6.613,14.769-14.769S469.767,241.231,461.61,241.231z"
                />
                <path
                    d="M72.977,241.231H50.389c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.588
			c8.157,0,14.769-6.613,14.769-14.769S81.133,241.231,72.977,241.231z"
                />
                <path
                    d="M312.76,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.917,241.231,312.76,241.231z"
                />
                <path
                    d="M393.846,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,241.231,393.846,241.231z"
                />
                <path
                    d="M256,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,353.254,264.157,346.643,256,346.643z"
                />
                <path
                    d="M256,275.403c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,282.016,264.157,275.403,256,275.403z"
                />
                <path
                    d="M256,35.62c-8.157,0-14.769,6.613-14.769,14.769v22.587c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V50.39C270.769,42.233,264.157,35.62,256,35.62z"
                />
                <path
                    d="M256,184.471c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C270.769,191.083,264.157,184.471,256,184.471z"
                />
                <path
                    d="M256,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.158,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,109.997,264.157,103.385,256,103.385z"
                />
                <path
                    d="M497.231,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,158.745,512,150.588v-32.434C512,109.997,505.387,103.385,497.231,103.385z"
                />
                <path
                    d="M497.231,184.471c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,239.831,512,231.674V199.24C512,191.082,505.387,184.471,497.231,184.471z"
                />
                <path
                    d="M497.231,265.557c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769S512,320.917,512,312.76
			v-32.434C512,272.169,505.387,265.557,497.231,265.557z"
                />
                <path
                    d="M497.231,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,402.003,512,393.846v-32.434C512,353.254,505.387,346.643,497.231,346.643z"
                />
            </g>
        ),
    },
    rightBorder: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M59.077,0H14.769C6.613,0,0,6.613,0,14.769v44.308c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769V29.538
			h29.538c8.157,0,14.769-6.613,14.769-14.769S67.233,0,59.077,0z"
                />
                <path
                    d="M59.077,482.462H29.538v-29.538c0-8.157-6.613-14.769-14.769-14.769S0,444.767,0,452.923v44.308
			C0,505.387,6.613,512,14.769,512h44.308c8.157,0,14.769-6.613,14.769-14.769S67.233,482.462,59.077,482.462z"
                />
                <path
                    d="M14.769,103.385C6.613,103.385,0,109.997,0,118.154v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,109.997,22.926,103.385,14.769,103.385z"
                />
                <path
                    d="M14.769,184.471C6.613,184.471,0,191.083,0,199.24v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C29.538,191.083,22.926,184.471,14.769,184.471z"
                />
                <path
                    d="M14.769,265.557C6.613,265.557,0,272.169,0,280.326v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,272.169,22.926,265.557,14.769,265.557z"
                />
                <path
                    d="M14.769,346.643C6.613,346.643,0,353.255,0,361.412v32.434c0,8.157,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,353.255,22.926,346.643,14.769,346.643z"
                />
                <path
                    d="M150.588,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S109.997,512,118.154,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,482.462,150.588,482.462z"
                />
                <path
                    d="M231.674,482.462H199.24c-8.157,0-14.769,6.613-14.769,14.769S191.083,512,199.24,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,482.462,231.674,482.462z"
                />
                <path
                    d="M312.76,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S272.169,512,280.326,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,482.462,312.76,482.462z"
                />
                <path
                    d="M393.846,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S353.255,512,361.412,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,482.462,393.846,482.462z"
                />
                <path
                    d="M150.588,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,241.231,150.588,241.231z"
                />
                <path
                    d="M231.674,241.231H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,241.231,231.674,241.231z"
                />
                <path
                    d="M72.977,241.231H50.39c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.587
			c8.157,0,14.769-6.613,14.769-14.769S81.133,241.231,72.977,241.231z"
                />
                <path
                    d="M312.76,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,241.231,312.76,241.231z"
                />
                <path
                    d="M393.846,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,241.231,393.846,241.231z"
                />
                <path
                    d="M256,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,353.254,264.157,346.643,256,346.643z"
                />
                <path
                    d="M256,275.403c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,282.016,264.157,275.403,256,275.403z"
                />
                <path
                    d="M256,35.62c-8.157,0-14.769,6.613-14.769,14.769v22.587c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V50.39C270.769,42.233,264.157,35.62,256,35.62z"
                />
                <path
                    d="M256,424.254c-8.157,0-14.769,6.613-14.769,14.769v22.587c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.587C270.769,430.867,264.157,424.254,256,424.254z"
                />
                <path
                    d="M256,184.471c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C270.769,191.083,264.157,184.471,256,184.471z"
                />
                <path
                    d="M256,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,109.997,264.157,103.385,256,103.385z"
                />
                <path
                    d="M150.588,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,0,150.588,0z"
                />
                <path
                    d="M231.674,0H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,0,231.674,0z"
                />
                <path
                    d="M312.76,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,0,312.76,0z"
                />
                <path
                    d="M393.846,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,0,393.846,0z"
                />
                <path
                    d="M497.231,0h-44.308c-8.157,0-14.769,6.613-14.769,14.769v482.462c0,8.157,6.613,14.769,14.769,14.769h44.308
			c8.157,0,14.769-6.613,14.769-14.769V14.769C512,6.613,505.387,0,497.231,0z"
                />
            </g>
        ),
    },
    leftBorder: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M497.231,0h-44.308c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h29.538v29.538
			c0,8.157,6.613,14.769,14.769,14.769S512,67.233,512,59.077V14.769C512,6.613,505.387,0,497.231,0z"
                />
                <path
                    d="M497.231,438.154c-8.157,0-14.769,6.613-14.769,14.769v29.538h-29.538c-8.157,0-14.769,6.613-14.769,14.769
			S444.767,512,452.923,512h44.308c8.157,0,14.769-6.613,14.769-14.769v-44.308C512,444.767,505.387,438.154,497.231,438.154z"
                />
                <path
                    d="M150.588,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S109.997,512,118.154,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,482.462,150.588,482.462z"
                />
                <path
                    d="M231.674,482.462H199.24c-8.157,0-14.769,6.613-14.769,14.769S191.083,512,199.24,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,482.462,231.674,482.462z"
                />
                <path
                    d="M312.76,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S272.169,512,280.326,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,482.462,312.76,482.462z"
                />
                <path
                    d="M393.846,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S353.255,512,361.412,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,482.462,393.846,482.462z"
                />
                <path
                    d="M150.588,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,241.231,150.588,241.231z"
                />
                <path
                    d="M231.674,241.231H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,241.231,231.674,241.231z"
                />
                <path
                    d="M461.61,241.231h-22.587c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.587
			c8.157,0,14.769-6.613,14.769-14.769S469.767,241.231,461.61,241.231z"
                />
                <path
                    d="M312.76,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,241.231,312.76,241.231z"
                />
                <path
                    d="M393.846,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,241.231,393.846,241.231z"
                />
                <path
                    d="M256,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,353.254,264.157,346.643,256,346.643z"
                />
                <path
                    d="M256,275.403c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,282.016,264.157,275.403,256,275.403z"
                />
                <path
                    d="M256,35.62c-8.157,0-14.769,6.613-14.769,14.769v22.587c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V50.39C270.769,42.233,264.157,35.62,256,35.62z"
                />
                <path
                    d="M256,424.254c-8.157,0-14.769,6.613-14.769,14.769v22.587c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.587C270.769,430.867,264.157,424.254,256,424.254z"
                />
                <path
                    d="M256,184.471c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C270.769,191.083,264.157,184.471,256,184.471z"
                />
                <path
                    d="M256,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,109.997,264.157,103.385,256,103.385z"
                />
                <path
                    d="M150.588,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,0,150.588,0z"
                />
                <path
                    d="M231.674,0H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,0,231.674,0z"
                />
                <path
                    d="M312.76,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,0,312.76,0z"
                />
                <path
                    d="M393.846,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,0,393.846,0z"
                />
                <path
                    d="M497.231,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,158.745,512,150.588v-32.434C512,109.997,505.387,103.385,497.231,103.385z"
                />
                <path
                    d="M497.231,184.471c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,239.831,512,231.674V199.24C512,191.082,505.387,184.471,497.231,184.471z"
                />
                <path
                    d="M497.231,265.557c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769S512,320.917,512,312.76
			v-32.434C512,272.169,505.387,265.557,497.231,265.557z"
                />
                <path
                    d="M497.231,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,402.003,512,393.846v-32.434C512,353.254,505.387,346.643,497.231,346.643z"
                />
                <path
                    d="M59.077,0H14.769C6.613,0,0,6.613,0,14.769v482.462C0,505.387,6.613,512,14.769,512h44.308
			c8.157,0,14.769-6.613,14.769-14.769V14.769C73.846,6.613,67.233,0,59.077,0z"
                />
            </g>
        ),
    },
    fullBorder: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M150.588,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.745,241.231,150.588,241.231z"
                />
                <path
                    d="M231.674,241.231H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,241.231,231.674,241.231z"
                />
                <path
                    d="M312.76,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.917,241.231,312.76,241.231z"
                />
                <path
                    d="M393.846,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,241.231,393.846,241.231z"
                />
                <path
                    d="M256,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,353.254,264.157,346.643,256,346.643z"
                />
                <path
                    d="M256,275.403c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,282.016,264.157,275.403,256,275.403z"
                />
                <path
                    d="M256,184.471c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C270.769,191.083,264.157,184.471,256,184.471z"
                />
                <path
                    d="M256,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.158,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,109.997,264.157,103.385,256,103.385z"
                />
                <path
                    d="M497.231,0H14.769C6.613,0,0,6.613,0,14.769v482.462C0,505.387,6.613,512,14.769,512h482.462
			c8.157,0,14.769-6.613,14.769-14.769V14.769C512,6.613,505.387,0,497.231,0z M438.154,438.154H73.846V73.846h364.308V438.154z"
                />
            </g>
        ),
    },
    noBorder: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path
                    d="M59.077,0H14.769C6.613,0,0,6.613,0,14.769v44.308c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769V29.538
			h29.538c8.157,0,14.769-6.613,14.769-14.769S67.233,0,59.077,0z"
                />
                <path
                    d="M497.231,0h-44.308c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h29.538v29.538
			c0,8.157,6.613,14.769,14.769,14.769S512,67.233,512,59.077V14.769C512,6.613,505.387,0,497.231,0z"
                />
                <path
                    d="M59.077,482.462H29.538v-29.538c0-8.157-6.613-14.769-14.769-14.769S0,444.767,0,452.923v44.308
			C0,505.387,6.613,512,14.769,512h44.308c8.157,0,14.769-6.613,14.769-14.769S67.233,482.462,59.077,482.462z"
                />
                <path
                    d="M497.231,438.154c-8.157,0-14.769,6.613-14.769,14.769v29.538h-29.538c-8.157,0-14.769,6.613-14.769,14.769
			S444.767,512,452.923,512h44.308c8.157,0,14.769-6.613,14.769-14.769v-44.308C512,444.767,505.387,438.154,497.231,438.154z"
                />
                <path
                    d="M14.769,103.385C6.613,103.385,0,109.997,0,118.154v32.434c0,8.158,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,109.997,22.926,103.385,14.769,103.385z"
                />
                <path
                    d="M14.769,184.471C6.613,184.471,0,191.083,0,199.24v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C29.538,191.083,22.926,184.471,14.769,184.471z"
                />
                <path
                    d="M14.769,265.557C6.613,265.557,0,272.169,0,280.326v32.434c0,8.157,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,272.169,22.926,265.557,14.769,265.557z"
                />
                <path
                    d="M14.769,346.643C6.613,346.643,0,353.255,0,361.412v32.434c0,8.157,6.613,14.769,14.769,14.769
			s14.769-6.613,14.769-14.769v-32.434C29.538,353.255,22.926,346.643,14.769,346.643z"
                />
                <path
                    d="M150.588,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S109.997,512,118.154,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,482.462,150.588,482.462z"
                />
                <path
                    d="M231.674,482.462H199.24c-8.157,0-14.769,6.613-14.769,14.769S191.083,512,199.24,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,482.462,231.674,482.462z"
                />
                <path
                    d="M312.76,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S272.169,512,280.326,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,482.462,312.76,482.462z"
                />
                <path
                    d="M393.846,482.462h-32.434c-8.157,0-14.769,6.613-14.769,14.769S353.255,512,361.412,512h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,482.462,393.846,482.462z"
                />
                <path
                    d="M150.588,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,241.231,150.588,241.231z"
                />
                <path
                    d="M231.674,241.231H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,241.231,231.674,241.231z"
                />
                <path
                    d="M461.61,241.231h-22.587c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.587
			c8.157,0,14.769-6.613,14.769-14.769S469.767,241.231,461.61,241.231z"
                />
                <path
                    d="M72.977,241.231H50.39c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h22.587
			c8.157,0,14.769-6.613,14.769-14.769S81.133,241.231,72.977,241.231z"
                />
                <path
                    d="M312.76,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,241.231,312.76,241.231z"
                />
                <path
                    d="M393.846,241.231h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,241.231,393.846,241.231z"
                />
                <path
                    d="M256,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,353.254,264.157,346.643,256,346.643z"
                />
                <path
                    d="M256,275.403c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,282.016,264.157,275.403,256,275.403z"
                />
                <path
                    d="M256,35.619c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V50.389C270.769,42.232,264.157,35.619,256,35.619z"
                />
                <path
                    d="M256,424.254c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-22.588C270.769,430.867,264.157,424.254,256,424.254z"
                />
                <path
                    d="M256,184.471c-8.157,0-14.769,6.613-14.769,14.769v22.588c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			V199.24C270.769,191.083,264.157,184.471,256,184.471z"
                />
                <path
                    d="M256,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769s14.769-6.613,14.769-14.769
			v-32.434C270.769,109.997,264.157,103.385,256,103.385z"
                />
                <path
                    d="M150.588,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S158.746,0,150.588,0z"
                />
                <path
                    d="M231.674,0H199.24c-8.157,0-14.769,6.613-14.769,14.769s6.612,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S239.831,0,231.674,0z"
                />
                <path
                    d="M312.76,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S320.918,0,312.76,0z"
                />
                <path
                    d="M393.846,0h-32.434c-8.157,0-14.769,6.613-14.769,14.769s6.613,14.769,14.769,14.769h32.434
			c8.157,0,14.769-6.613,14.769-14.769S402.003,0,393.846,0z"
                />
                <path
                    d="M497.231,103.385c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,158.745,512,150.588v-32.434C512,109.997,505.387,103.385,497.231,103.385z"
                />
                <path
                    d="M497.231,184.471c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,239.831,512,231.674V199.24C512,191.083,505.387,184.471,497.231,184.471z"
                />
                <path
                    d="M497.231,265.557c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769S512,320.917,512,312.76
			v-32.434C512,272.169,505.387,265.557,497.231,265.557z"
                />
                <path
                    d="M497.231,346.643c-8.157,0-14.769,6.613-14.769,14.769v32.434c0,8.157,6.613,14.769,14.769,14.769
			S512,402.003,512,393.846v-32.434C512,353.254,505.387,346.643,497.231,346.643z"
                />
            </g>
        ),
    },
    timezone: {
        viewBox: '0 0 612.029 612.029',
        image: (
            <g>
                <path
                    d="M470.128,328.236c-78.368,0-141.906,63.538-141.906,141.887c0,78.368,63.538,141.906,141.906,141.906
						c78.349,0,141.887-63.538,141.887-141.906C612.015,391.774,548.477,328.236,470.128,328.236z M479.251,575.03v-12.274
						c0-5.044-4.079-9.142-9.123-9.142c-5.064,0-9.143,4.098-9.143,9.142v12.274c-50.814-4.391-91.394-44.97-95.765-95.765h12.274
						c5.044,0,9.142-4.099,9.142-9.143c0-5.063-4.098-9.123-9.142-9.123h-12.274c4.371-50.814,44.95-91.403,95.765-95.784v12.293
						c0,5.045,4.078,9.143,9.143,9.143c5.044,0,9.123-4.098,9.123-9.143v-12.293c50.814,4.391,91.413,44.97,95.765,95.784h-12.274
						c-5.063,0-9.142,4.06-9.142,9.123c0,5.044,4.078,9.143,9.142,9.143h12.274C570.664,530.07,530.065,570.649,479.251,575.03z"
                />
                <path
                    d="M523.001,456.434h-32.92c-4.371-6.352-11.66-10.527-19.953-10.527c-0.137,0-0.254,0.039-0.4,0.039l-30.003-42.219
						c-4.361-6.157-12.908-7.581-19.084-3.229c-6.157,4.391-7.621,12.947-3.23,19.104l30.013,42.257
						c-0.927,2.596-1.521,5.367-1.521,8.274c0,13.396,10.83,24.227,24.227,24.227c8.293,0,15.602-4.156,19.953-10.527h32.92
						c7.562,0,13.699-6.118,13.699-13.699S530.562,456.434,523.001,456.434z"
                />
                <path
                    d="M419.44,87.726l-23.993-21.534l-28.285-5.523l-0.654,12.938l27.729,27.066l13.562,15.973l-15.279,7.971l-12.431-3.668
						l-18.587-7.786l0.634-14.987l-24.412-10.06l-8.117,35.271l-24.588,5.581l2.439,19.661l32.022,6.176l5.522-31.418l26.48,3.903
						l12.274,7.22h19.777l13.484,27.037l35.848,36.335l-2.635,14.148l-28.881-3.708l-49.868,25.242l-35.965,43.058l-4.653,19.085
						h-12.909l-24.031-11.094l-23.339,11.094l5.834,24.617l10.138-11.708l17.836-0.547l-1.229,22.09l14.801,4.332l14.782,16.606
						l20.051-5.62c30.705-28.93,71.948-46.794,117.357-46.794c50.239,0,95.346,21.846,126.725,56.396
						c3.21-17.582,4.966-35.662,4.966-54.171c0-61.957-18.782-119.592-50.932-167.45l-8.986,2.869l-47.985,4.264l-13.542,21.631
						l-9.797-3.132l-38.159-34.394l-5.562-17.895L419.44,87.726z"
                />
                <path
                    d="M298.667,470.133c0-35.594,10.928-68.689,29.574-96.126l-14.626-4.43l-22.587-22.646l-50.044-11.221l-16.606-34.793
						v20.675h-7.328l-43.136-58.513v-47.985l-31.632-51.4l-50.2,8.957H58.284l-17.036-11.171l21.709-17.221l-21.631,4.986
						c-26.09,44.57-41.311,96.302-41.311,151.663c0,166.182,134.706,300.965,300.897,300.965c12.792,0,25.339-1.093,37.75-2.634
						l-1.864-21.515C313.001,548.268,298.667,510.868,298.667,470.133z"
                />
                <path
                    d="M111.83,96.985l53.469-7.435l24.626-13.513l27.749,7.991l44.278-2.449l15.182-23.856l22.129,3.649l53.742-5.035
						l14.811-16.313l20.88-13.943l29.516,4.459l10.771-1.639C390.081,10.586,346.789,0,300.912,0
						c-93.414,0-176.963,42.57-232.09,109.406h0.156L111.83,96.985z M313.615,29.876l30.773-16.899l19.72,11.386L335.52,46.102
						l-27.241,2.732l-12.294-7.952L313.615,29.876z M222.602,32.345l13.543,5.649l17.758-5.649l9.679,16.762l-40.99,10.752
						l-19.729-11.523C202.863,48.336,222.163,35.945,222.602,32.345z"
                />
            </g>
        ),
    },
    cut: {
        viewBox: '0 0 512 512',
        image: (
            <path
                d="M512,107.275c-23.658-33.787-70.696-42.691-104.489-19.033L233.753,209.907l-63.183-44.246
			c23.526-40.618,12.46-93.179-26.71-120.603c-41.364-28.954-98.355-18.906-127.321,22.45
			c-28.953,41.358-18.913,98.361,22.452,127.327c28.384,19.874,64.137,21.364,93.129,6.982l77.388,54.185l-77.381,54.179
			c-28.992-14.375-64.743-12.885-93.129,6.982c-41.363,28.966-51.404,85.963-22.452,127.32
			c28.966,41.363,85.963,51.411,127.32,22.457c39.165-27.424,50.229-79.985,26.71-120.603l63.183-44.246l173.751,121.658
			c33.793,23.665,80.831,14.755,104.489-19.033l-212.41-148.715L512,107.275z M91.627,167.539
			c-26.173,0-47.392-21.219-47.392-47.392s21.22-47.392,47.392-47.392c26.179,0,47.392,21.219,47.392,47.392
			S117.806,167.539,91.627,167.539z M91.627,439.253c-26.173,0-47.392-21.219-47.392-47.392c0-26.173,21.219-47.392,47.392-47.392
			c26.179,0,47.392,21.219,47.392,47.392C139.019,418.033,117.806,439.253,91.627,439.253z"
            />
        ),
    },
    mp4: {
        viewBox: '0 0 490 490',
        image: (
            <g>
                <path
                    d="M168.266,331.671c-0.994,2.542-2.176,5.996-3.536,10.378l-1.66,5.189l-1.6,5.189h-0.493l-1.712-5.189l-1.66-5.249
		c-1.51-4.531-2.722-8-3.641-10.438l-13.473-34.887h-23.305v75.366h14.303v-41.078c0-3.065-0.112-6.729-0.329-10.991l-0.277-5.518
		l-0.277-5.473h0.441l1.712,5.189l1.712,5.249c1.51,4.636,2.721,8.12,3.641,10.438l16.733,42.184h13.032l16.569-42.513
		c0.845-2.243,2.041-5.727,3.589-10.438l1.652-5.249l1.712-5.249h0.441l-0.277,5.578l-0.277,5.638
		c-0.179,4.157-0.277,7.88-0.277,11.155v41.078h14.303v-75.366h-23.799L168.266,331.671z"
                />
                <path
                    d="M252.686,296.665h-3.753h-30.371v75.366h14.303v-24.344h16.845l3.312-0.06c10.311,0,17.159-1.66,20.539-4.965
		c3.395-3.32,5.084-10.019,5.084-20.113c0-10.154-1.78-17.017-5.323-20.561C269.763,298.429,262.884,296.665,252.686,296.665z
		 M261.494,333.406c-1.75,1.495-5.862,2.243-12.337,2.243h-16.292v-26.946h17.728c6.109,0,9.899,0.763,11.35,2.288
		s2.183,5.473,2.183,11.843C264.126,328.396,263.243,331.91,261.494,333.406z"
                />
                <path
                    d="M339.058,296.665h-22.087l-32.913,43.111v16.075h40.689v16.18h14.311v-16.18h8.658v-11.036h-8.658V296.665z
		 M324.748,344.815h-28.98l28.547-37.339h0.434V344.815z"
                />
                <path
                    d="M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413
		H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z"
                />
            </g>
        ),
    },
    bitrate: {
        viewBox: '0 -72 448 448',
        image: (
            <g>
                <path d="m216 208h32c4.417969 0 8-3.582031 8-8v-32c0-4.417969-3.582031-8-8-8h-32c-4.417969 0-8 3.582031-8 8v32c0 4.417969 3.582031 8 8 8zm0 0" />
                <path d="m224 96h16c4.417969 0 8 3.582031 8 8v32c0 4.417969-3.582031 8-8 8h-16c-4.417969 0-8-3.582031-8-8v-32c0-4.417969 3.582031-8 8-8zm0 0" />
                <path d="m144 116.265625-41.679688 67.734375h41.679688zm0 0" />
                <path d="m304 96h32c4.417969 0 8 3.582031 8 8v96c0 4.417969-3.582031 8-8 8h-32c-4.417969 0-8-3.582031-8-8v-96c0-4.417969 3.582031-8 8-8zm0 0" />
                <path d="m448 0h-448v304h448zm-424 64c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h400c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm336 40v96c0 13.253906-10.746094 24-24 24h-32c-13.253906 0-24-10.746094-24-24v-96c0-13.253906 10.746094-24 24-24h32c13.253906 0 24 10.746094 24 24zm-160 32v-32c0-13.253906 10.746094-24 24-24h16c13.253906 0 24 10.746094 24 24v32c-.023438 4.132812-1.125 8.191406-3.199219 11.769531 6.957031 4.375 11.183594 12.011719 11.199219 20.230469v32c0 13.253906-10.746094 24-24 24h-32c-13.253906 0-24-10.746094-24-24v-32c.015625-8.21875 4.242188-15.855469 11.199219-20.230469-2.074219-3.578125-3.175781-7.636719-3.199219-11.769531zm-112 64c-2.898438 0-5.570312-1.566406-6.984375-4.097656-1.414063-2.527344-1.351563-5.625.167969-8.09375l64-104c1.875-3.050782 5.550781-4.484375 8.996094-3.511719 3.445312.976563 5.820312 4.121094 5.820312 7.703125v96h16c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8h-16v16c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8v-16zm304-184h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm-32 0h16v16h-16zm16 272h-16v-16h16zm-8-40c0-4.417969 3.582031-8 8-8h400c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8h-400c-4.417969 0-8-3.582031-8-8zm40 40h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm32 0h-16v-16h16zm0-256h-16v-16h16zm0 0" />
            </g>
        ),
    },
    planning: {
        viewBox: '0 0 512 512',
        image: (
            <g>
                <path d="m202.210938 241h98.789062v-38.789062l-30-30zm0 0" />
                <path d="m131.605469 140.394531 64.394531 64.394531 64.394531-64.394531c5.859375-5.859375 15.351563-5.859375 21.210938 0l19.394531 19.394531v-68.789062h-210v68.789062l19.394531-19.394531c5.859375-5.859375 15.351563-5.859375 21.210938 0zm64.394531-34.394531c16.539062 0 30 13.460938 30 30s-13.460938 30-30 30-30-13.460938-30-30 13.460938-30 30-30zm0 0" />
                <path d="m174.789062 226-53.789062-53.789062-30 30v38.789062h68.789062zm0 0" />
                <path d="m301 422v81.210938l82.210938-81.210938zm0 0" />
                <path d="m15 512h256v-105c0-8.289062 6.710938-15 15-15h106v-377c0-8.289062-6.710938-15-15-15h-362c-8.289062 0-15 6.710938-15 15v482c0 8.289062 6.710938 15 15 15zm211-60h-90c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h90c8.289062 0 15 6.710938 15 15s-6.710938 15-15 15zm0-60h-90c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h90c8.289062 0 15 6.710938 15 15s-6.710938 15-15 15zm90-60h-180c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h180c8.289062 0 15 6.710938 15 15s-6.710938 15-15 15zm-255-256c0-8.289062 6.710938-15 15-15h240c8.289062 0 15 6.710938 15 15v180c0 8.289062-6.710938 15-15 15h-240c-8.289062 0-15-6.710938-15-15zm15 226c8.285156 0 15 6.714844 15 15s-6.714844 15-15 15-15-6.714844-15-15 6.714844-15 15-15zm0 60c8.285156 0 15 6.714844 15 15s-6.714844 15-15 15-15-6.714844-15-15 6.714844-15 15-15zm0 60c8.285156 0 15 6.714844 15 15s-6.714844 15-15 15-15-6.714844-15-15 6.714844-15 15-15zm0 0" />
                <path d="m497 0h-60c-8.289062 0-15 6.710938-15 15v46h90v-46c0-8.289062-6.710938-15-15-15zm0 0" />
                <path d="m422 407c0 2.328125.542969 4.628906 1.582031 6.710938l28.417969 56.835937v26.453125c0 8.289062 6.710938 15 15 15s15-6.710938 15-15v-26.453125l28.417969-56.835937c1.039062-2.082032 1.582031-4.382813 1.582031-6.710938v-15h-90zm0 0" />
                <path d="m422 91h90v271h-90zm0 0" />
            </g>
        ),
    },
    frames: {
        viewBox: '0 -24 448 448',
        image: (
            <g>
                <path d="m0 400h448v-336h-448zm416-320h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm-400-288h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 32h16v16h-16zm0 0" />
                <path d="m80 0h288v16h-288zm0 0" />
                <path d="m40 32h368v16h-368zm0 0" />
            </g>
        ),
    },
    question: {
        viewBox: '0 0 400 400',
        image: (
            <g>
                <path
                    d="M199.996,0C89.719,0,0,89.72,0,200c0,110.279,89.719,200,199.996,200C310.281,400,400,310.279,400,200
			C400,89.72,310.281,0,199.996,0z M199.996,373.77C104.187,373.77,26.23,295.816,26.23,200
			c0-95.817,77.957-173.769,173.766-173.769c95.816,0,173.772,77.953,173.772,173.769
			C373.769,295.816,295.812,373.77,199.996,373.77z"
                />
                <path
                    d="M199.996,91.382c-35.176,0-63.789,28.616-63.789,63.793c0,7.243,5.871,13.115,13.113,13.115
			c7.246,0,13.117-5.873,13.117-13.115c0-20.71,16.848-37.562,37.559-37.562c20.719,0,37.566,16.852,37.566,37.562
			c0,20.714-16.849,37.566-37.566,37.566c-7.242,0-13.113,5.873-13.113,13.114v45.684c0,7.243,5.871,13.115,13.113,13.115
			s13.117-5.872,13.117-13.115v-33.938c28.905-6.064,50.68-31.746,50.68-62.427C263.793,119.998,235.176,91.382,199.996,91.382z"
                />
                <path
                    d="M200.004,273.738c-9.086,0-16.465,7.371-16.465,16.462s7.379,16.465,16.465,16.465c9.094,0,16.457-7.374,16.457-16.465
			S209.098,273.738,200.004,273.738z"
                />
            </g>
        ),
    },
    cloud_network: {
        viewBox: '0 0 490 490',
        image: (
            <g>
                <rect x="152.931" y="195.391" width="58.917" height="30.625" />
                <rect x="152.931" y="241.957" width="89.542" height="30.625" />
                <rect x="152.931" y="288.508" width="120.167" height="30.625" />
                <path
                    d="M107.187,402.813h275.625c59.097,0,107.188-47.807,107.188-106.574c0-58.768-48.091-106.574-107.188-106.574h-32.793
		c-12.172-40.48-48.27-52.353-72.899-53.22c-21.608-30.595-57.228-49.257-95.015-49.257c-62.431,0-113.513,49.257-116.01,110.731
		C26.647,214.323,0,253.202,0,296.239C0,355.006,48.091,402.813,107.187,402.813z M85.879,223.385l11.754-3.409l-0.838-13.847
		c-0.075-1.166-0.164-2.333-0.164-3.514c0-46.76,38.341-84.802,85.475-84.802c30.087,0,58.319,16.06,73.646,41.915l4.935,8.314
		l9.615-0.867c1.765-0.209,45.713-3.589,52.353,40.106l1.974,13.01h58.185c42.214,0,76.563,34.064,76.563,75.949
		c0,41.885-34.349,75.949-76.563,75.949H107.187c-42.214,0-76.562-34.064-76.562-75.949
		C30.625,262.772,53.339,232.805,85.879,223.385z"
                />
            </g>
        ),
    },
    web_server: {
        viewBox: '0 0 21 16',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M17.5 14C18.4625 14 19.25 13.1 19.25 12V2C19.25 0.9 18.4625 0 17.5 0H3.5C2.5375 0 1.75 0.9 1.75 2V12C1.75 13.1 2.5375 14 3.5 14H0.875C0.39375 14 0 14.45 0 15C0 15.55 0.39375 16 0.875 16H20.125C20.6063 16 21 15.55 21 15C21 14.45 20.6063 14 20.125 14H17.5ZM4.375 2H16.625C17.1063 2 17.5 2.45 17.5 3V11C17.5 11.55 17.1063 12 16.625 12H4.375C3.89375 12 3.5 11.55 3.5 11V3C3.5 2.45 3.89375 2 4.375 2Z"
            />
        ),
    },
    flow_diagram: {
        viewBox: '0 0 60 60',
        image: (
            <polygon points="53,41 53,29 31,29 31,19 38,19 38,3 22,3 22,19 29,19 29,29 7,29 7,41 0,41 0,57 16,57 16,41 9,41 9,31 29,31 29,41 22,41 22,57 38,57 38,41 31,41 31,31 51,31 51,41 44,41 44,57 60,57 60,41 " />
        ),
    },
    direction_arrows: {
        viewBox: '0 0 381.669 381.669',
        image: (
            <g>
                <polygon points="106.615,214.469 0,283.87 106.615,353.271 106.615,313.207 211.979,313.207 211.979,254.534 106.615,254.534" />
                <path d="M302.485,218.295c-36.158,0-65.575,29.417-65.575,65.575s29.417,65.575,65.575,65.575s65.575-29.417,65.575-65.575 S338.643,218.295,302.485,218.295z" />
                <polygon points="275.054,167.2 381.669,97.799 275.054,28.398 275.054,68.462 169.69,68.462 169.69,127.135 275.054,127.135" />
                <path d="M79.184,163.374c36.158,0,65.575-29.417,65.575-65.575s-29.417-65.575-65.575-65.575S13.609,61.641,13.609,97.799 S43.026,163.374,79.184,163.374z" />
            </g>
        ),
    },
    start_page: {
        viewBox: '0 0 489.888 489.888',
        image: (
            <g>
                <path
                    d="M25.383,290.5c-7.2-77.5,25.9-147.7,80.8-192.3c21.4-17.4,53.4-2.5,53.4,25l0,0c0,10.1-4.8,19.4-12.6,25.7
			c-38.9,31.7-62.3,81.7-56.6,136.9c7.4,71.9,65,130.1,136.8,138.1c93.7,10.5,173.3-62.9,173.3-154.5c0-48.6-22.5-92.1-57.6-120.6
			c-7.8-6.3-12.5-15.6-12.5-25.6l0,0c0-27.2,31.5-42.6,52.7-25.6c50.2,40.5,82.4,102.4,82.4,171.8c0,126.9-107.8,229.2-236.7,219.9
			C122.183,481.8,35.283,396.9,25.383,290.5z M244.883,0c-18,0-32.5,14.6-32.5,32.5v149.7c0,18,14.6,32.5,32.5,32.5
			s32.5-14.6,32.5-32.5V32.5C277.383,14.6,262.883,0,244.883,0z"
                />
            </g>
        ),
    },
    looped: {
        viewBox: '0 0 14.155 14.155',
        image: (
            <g>
                <path
                    d="M12.083,1.887c-0.795-0.794-1.73-1.359-2.727-1.697v2.135c0.48,0.239,0.935,0.55,1.334,0.95
		c1.993,1.994,1.993,5.236,0,7.229c-1.993,1.99-5.233,1.99-7.229,0c-1.991-1.995-1.991-5.235,0-7.229
		C3.466,3.269,3.482,3.259,3.489,3.25h0.002l1.181,1.179L4.665,0.685L0.923,0.68l1.176,1.176C2.092,1.868,2.081,1.88,2.072,1.887
		c-2.763,2.762-2.763,7.243,0,10.005c2.767,2.765,7.245,2.765,10.011,0C14.844,9.13,14.847,4.649,12.083,1.887z"
                />
            </g>
        ),
    },
    adBlocks: {
        viewBox: '0 0 24 20',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M21.8182 0H2.18182C0.981818 0 0 1 0 2.22222V15.5556C0 16.7778 0.981818 17.7778 2.18182 17.7778H7.63636V18.8889C7.63636 19.5 8.12727 20 8.72727 20H15.2727C15.8727 20 16.3636 19.5 16.3636 18.8889V17.7778H21.8182C23.0182 17.7778 24 16.7778 24 15.5556V2.22222C24 1 23.0182 0 21.8182 0ZM20.7273 15.5556H3.27273C2.67273 15.5556 2.18182 15.0556 2.18182 14.4444V3.33333C2.18182 2.72222 2.67273 2.22222 3.27273 2.22222H20.7273C21.3273 2.22222 21.8182 2.72222 21.8182 3.33333V14.4444C21.8182 15.0556 21.3273 15.5556 20.7273 15.5556ZM18.5455 5.55556H8.72727C8.12727 5.55556 7.63636 6.05556 7.63636 6.66667C7.63636 7.27778 8.12727 7.77778 8.72727 7.77778H18.5455C19.1455 7.77778 19.6364 7.27778 19.6364 6.66667C19.6364 6.05556 19.1455 5.55556 18.5455 5.55556ZM18.5455 10H8.72727C8.12727 10 7.63636 10.5 7.63636 11.1111C7.63636 11.7222 8.12727 12.2222 8.72727 12.2222H18.5455C19.1455 12.2222 19.6364 11.7222 19.6364 11.1111C19.6364 10.5 19.1455 10 18.5455 10ZM6.54545 5.55556H4.36364V7.77778H6.54545V5.55556ZM6.54545 10H4.36364V12.2222H6.54545V10Z"
            />
        ),
    },
    scoreboard: {
        viewBox: '0 0 18 18',
        image: (
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M17 16H16V2C16 1.45 15.55 1 15 1H11C11 0.45 10.55 0 10 0H3C2.45 0 2 0.45 2 1V16H1C0.45 16 0 16.45 0 17C0 17.55 0.45 18 1 18H10C10.55 18 11 17.55 11 17V3H14V17C14 17.55 14.45 18 15 18H17C17.55 18 18 17.55 18 17C18 16.45 17.55 16 17 16ZM9 10H7V8H9V10Z"
            />
        ),
    },
    volume_plus: {
        viewBox: '0 0 24 24',
        image: <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />,
    },
    volume_minus: {
        viewBox: '0 0 24 24',
        image: <path d="M19 13H5v-2h14v2z" />,
    },
    hash: {
        viewBox: '0 0 34 34',
        image: (
            <path d="M28.0391 14.0429H24.4565L22.9453 19.7666H25.894C26.4147 19.7684 26.9134 19.9678 27.281 20.321C27.6485 20.6741 27.8548 21.1524 27.8548 21.6509V21.9262C27.8548 22.4241 27.6483 22.9016 27.2805 23.2536C26.9128 23.6057 26.414 23.8035 25.894 23.8035H21.8838L20.6232 28.5885C20.5163 28.9932 20.2709 29.3521 19.9263 29.6079C19.5816 29.8637 19.1574 30.0017 18.7213 30H18.5297C18.2313 30.0001 17.9369 29.9349 17.6688 29.8096C17.4007 29.6843 17.1661 29.5021 16.9827 29.2768C16.7993 29.0515 16.672 28.7891 16.6105 28.5096C16.549 28.2301 16.5549 27.9409 16.6278 27.6639L17.6377 23.8035H13.0083L11.7551 28.5814C11.6482 28.9862 11.4028 29.345 11.0581 29.6008C10.7135 29.8566 10.2893 29.9947 9.85323 29.9929H9.61734C9.31864 29.9914 9.02426 29.9246 8.75665 29.7975C8.48905 29.6705 8.2553 29.4866 8.07325 29.2598C7.8912 29.0331 7.76565 28.7696 7.7062 28.4893C7.64674 28.2091 7.65495 27.9195 7.73019 27.6428L8.74011 23.7823H5.96099C5.44474 23.7823 4.94931 23.5874 4.58221 23.24C4.2151 22.8925 4.00595 22.4204 4.00012 21.9262V21.6721C3.9972 21.4234 4.04571 21.1767 4.14286 20.9461C4.24 20.7155 4.38386 20.5056 4.56614 20.3284C4.74841 20.1513 4.96551 20.0105 5.2049 19.914C5.4443 19.8176 5.70127 19.7675 5.96099 19.7666H9.77951L11.2538 14.0429H8.09877C7.57872 14.0429 7.07997 13.8451 6.71223 13.493C6.3445 13.141 6.13791 12.6635 6.13791 12.1656V11.9115C6.1379 11.413 6.34426 10.9347 6.71178 10.5816C7.07931 10.2284 7.57804 10.029 8.09877 10.0272H12.3154L13.5317 5.41152C13.6387 5.00676 13.884 4.64791 14.2287 4.39211C14.5733 4.13632 14.9975 3.99829 15.4336 4.00002H15.6916C15.9891 4.00022 16.2827 4.06524 16.5501 4.19016C16.8175 4.31508 17.0517 4.49663 17.235 4.72105C17.4183 4.94546 17.5458 5.20687 17.6079 5.48545C17.67 5.76404 17.6651 6.05251 17.5935 6.329L16.6204 10.0272H21.2277L22.4735 5.41152C22.5816 5.00737 22.8273 4.64921 23.1717 4.39361C23.5161 4.138 23.9396 3.99952 24.3754 4.00002H24.6261C24.9216 4.00311 25.2125 4.07036 25.477 4.19671C25.7414 4.32305 25.9724 4.50519 26.1527 4.72941C26.333 4.95363 26.4577 5.21408 26.5176 5.49116C26.5775 5.76823 26.571 6.05471 26.4985 6.329L25.518 10.0272H28.0391C28.5599 10.029 29.0586 10.2284 29.4261 10.5816C29.7937 10.9347 30 11.413 30 11.9115V12.1656C30 12.4121 29.9493 12.6562 29.8507 12.884C29.7522 13.1118 29.6078 13.3187 29.4257 13.493C29.2436 13.6674 29.0274 13.8056 28.7895 13.9C28.5516 13.9943 28.2966 14.0429 28.0391 14.0429V14.0429ZM20.7043 13.9794H16.0012L14.4679 19.8089H19.171L20.7043 13.9794Z" />
        ),
    },
    duration_dynamic: {
        viewBox: '0 0 150 110',
        image: (
            <g>
                <path d="M122.727 27.5L95.4545 55H115.909C115.909 77.7562 97.5682 96.25 75 96.25C68.1136 96.25 61.5682 94.5312 55.9091 91.4375L45.9545 101.475C54.3409 106.838 64.2955 110 75 110C105.136 110 129.545 85.3875 129.545 55H150L122.727 27.5ZM34.0909 55C34.0909 32.2438 52.4318 13.75 75 13.75C81.8864 13.75 88.4318 15.4687 94.0909 18.5625L104.045 8.525C95.6591 3.1625 85.7045 0 75 0C44.8636 0 20.4545 24.6125 20.4545 55H0L27.2727 82.5L54.5455 55H34.0909Z" />
                <path d="M77.5 25H70V57.7869L96.25 75L100 68.2787L77.5 53.6885V25Z" />
            </g>
        ),
    },
    dialog_attention: {
        viewBox: '0 0 7 27',
        image: (
            <path d="M0.866234 0.799998H6.19423L5.29423 17.648H1.73023L0.866234 0.799998ZM3.53023 26.252C2.69023 26.252 1.99423 25.988 1.44223 25.46C0.890235 24.908 0.614235 24.236 0.614235 23.444C0.614235 22.652 0.890235 21.992 1.44223 21.464C1.99423 20.936 2.69023 20.672 3.53023 20.672C4.34623 20.672 5.01823 20.936 5.54623 21.464C6.09823 21.992 6.37423 22.652 6.37423 23.444C6.37423 24.236 6.09823 24.908 5.54623 25.46C5.01823 25.988 4.34623 26.252 3.53023 26.252Z" />
        ),
    },
    dialog_success: {
        viewBox: '0 0 33 25',
        image: (
            <path d="M10.2087 20.2634L3.32752 13.3052C2.56077 12.5298 1.34182 12.5298 0.575067 13.3052C-0.191689 14.0805 -0.191689 15.3131 0.575067 16.0885L8.81278 24.4185C9.57954 25.1938 10.8181 25.1938 11.5849 24.4185L32.4249 3.36481C33.1917 2.58946 33.1917 1.35686 32.4249 0.581511C31.6582 -0.193837 30.4392 -0.193837 29.6725 0.581511L10.2087 20.2634Z" />
        ),
    },
    dialog_email: {
        viewBox: '0 0 62 50',
        image: (
            <path d="M55.6665 0.333374H6.33317C2.9415 0.333374 0.197337 3.10837 0.197337 6.50004L0.166504 43.5C0.166504 46.8917 2.9415 49.6667 6.33317 49.6667H55.6665C59.0582 49.6667 61.8332 46.8917 61.8332 43.5V6.50004C61.8332 3.10837 59.0582 0.333374 55.6665 0.333374ZM52.5832 43.5H9.4165C7.72067 43.5 6.33317 42.1125 6.33317 40.4167V12.6667L27.7315 26.0484C29.7357 27.3125 32.264 27.3125 34.2682 26.0484L55.6665 12.6667V40.4167C55.6665 42.1125 54.279 43.5 52.5832 43.5ZM30.9998 21.9167L6.33317 6.50004H55.6665L30.9998 21.9167Z" />
        ),
    },
    drag_image: {
        viewBox: '0 0 22 18',
        image: (
            <path d="M20 12H22V14H20V12ZM20 8H22V10H20V8ZM22 16H20V18C21 18 22 17 22 16ZM12 0H14V2H12V0ZM20 4H22V6H20V4ZM20 0V2H22C22 1 21 0 20 0ZM0 4H2V6H0V4ZM16 0H18V2H16V0ZM16 16H18V18H16V16ZM2 0C1 0 0 1 0 2H2V0ZM8 0H10V2H8V0ZM4 0H6V2H4V0ZM0 8V16C0 17.1 0.9 18 2 18H14V10C14 8.9 13.1 8 12 8H0ZM2.63 15.19L4.12 13.28C4.32 13.03 4.69 13.02 4.9 13.27L6.29 14.94L8.39 12.24C8.59 11.98 8.99 11.98 9.18 12.25L11.4 15.21C11.65 15.54 11.41 16.01 11 16.01H3.02C2.61 16 2.37 15.52 2.63 15.19Z" />
        ),
    },
    drag_area: {
        viewBox: '0 0 22 18',
        image: (
            <path d="M22 12H20V14H22V12ZM22 8H20V10H22V8ZM22 16H20V18C21 18 22 17 22 16ZM14 0H12V2H14V0ZM22 4H20V6H22V4ZM20 0V2H22C22 1 21 0 20 0ZM2 18H10V14C10 12.9 9.1 12 8 12H0V16C0 17.1 0.9 18 2 18ZM2 4H0V6H2V4ZM14 16H12V18H14V16ZM18 0H16V2H18V0ZM18 16H16V18H18V16ZM2 0C1 0 0 1 0 2H2V0ZM2 8H0V10H2V8ZM10 0H8V2H10V0ZM6 0H4V2H6V0Z" />
        ),
    },
    refresh: {
        viewBox: '0 0 17 20',
        image: (
            <g>
                <path d="M13.7912 2.57815L15.4124 0.956954C15.7727 0.596689 15.5138 0 15.0184 0H7.93694C7.62171 0 7.37402 0.247682 7.37402 0.562914V7.64437C7.37402 8.15099 7.98197 8.39868 8.33098 8.03841L9.96343 6.40596C12.1813 8.04967 13.6224 10.6616 13.6224 13.6338C13.6224 14.3768 13.5323 15.1086 13.3522 15.7954C13.2171 16.3583 13.8926 16.7636 14.2979 16.347C15.9641 14.6245 16.9999 12.2828 16.9999 9.69338C16.9999 6.86755 15.7502 4.33444 13.7912 2.57815Z" />
                <path d="M8.66887 12.2152L7.03642 13.8364C4.81854 12.1927 3.37748 9.58076 3.37748 6.60858C3.37748 5.86553 3.46755 5.13374 3.64768 4.44699C3.78278 3.88407 3.10728 3.47878 2.70199 3.89533C1.03576 5.61785 0 7.95957 0 10.549C0 13.3861 1.23841 15.9192 3.19735 17.6755L1.57616 19.2967C1.21589 19.6569 1.47483 20.2536 1.9702 20.2536H9.05166C9.36689 20.2536 9.61457 20.0059 9.61457 19.6907V12.6092C9.62583 12.1139 9.01788 11.8549 8.66887 12.2152Z" />
            </g>
        ),
    },
    downloadLink: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M21.3333 13.3333V20C21.3333 20.7333 20.7333 21.3333 20 21.3333H4C3.26667 21.3333 2.66667 20.7333 2.66667 20V13.3333C2.66667 12.6 2.06667 12 1.33333 12C0.6 12 0 12.6 0 13.3333V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V13.3333C24 12.6 23.4 12 22.6667 12C21.9333 12 21.3333 12.6 21.3333 13.3333ZM13.3333 12.8933L15.84 10.3867C16.36 9.86667 17.2 9.86667 17.72 10.3867C18.24 10.9067 18.24 11.7467 17.72 12.2667L12.9333 17.0533C12.4133 17.5733 11.5733 17.5733 11.0533 17.0533L6.26667 12.2667C5.74667 11.7467 5.74667 10.9067 6.26667 10.3867C6.78667 9.86667 7.62667 9.86667 8.14667 10.3867L10.6667 12.8933V1.33333C10.6667 0.6 11.2667 0 12 0C12.7333 0 13.3333 0.6 13.3333 1.33333V12.8933Z" />
            </g>
        ),
    },
    camera: {
        viewBox: '0 0 20 13',
        image: (
            <g>
                <path d="M15.5556 4.875V1.08333C15.5556 0.4875 15.0556 0 14.4444 0H1.11111C0.5 0 0 0.4875 0 1.08333V11.9167C0 12.5125 0.5 13 1.11111 13H14.4444C15.0556 13 15.5556 12.5125 15.5556 11.9167V8.125L18.1 10.6058C18.8 11.2883 20 10.8008 20 9.83667V3.1525C20 2.18833 18.8 1.70083 18.1 2.38333L15.5556 4.875Z" />
            </g>
        ),
    },
    done: {
        viewBox: '0 0 17 13',
        image: (
            <g>
                <path d="M5.1925 10.1925L1.6925 6.6925C1.3025 6.3025 0.6825 6.3025 0.2925 6.6925C-0.0975 7.0825 -0.0975 7.7025 0.2925 8.0925L4.4825 12.2825C4.8725 12.6725 5.5025 12.6725 5.8925 12.2825L16.4925 1.6925C16.8825 1.3025 16.8825 0.6825 16.4925 0.2925C16.1025 -0.0975 15.4825 -0.0975 15.0925 0.2925L5.1925 10.1925Z" />
            </g>
        ),
    },
    doneMultiply: {
        viewBox: '0 0 23 13',
        image: (
            <g>
                <path d="M16.4725 0.301262C16.0825 -0.088738 15.4525 -0.088738 15.0625 0.301262L9.4225 5.94126L10.8325 7.35126L16.4725 1.70126C16.8525 1.32126 16.8525 0.681262 16.4725 0.301262ZM20.7125 0.291262L10.8325 10.1713L7.3525 6.70126C6.9625 6.31126 6.3325 6.31126 5.9425 6.70126C5.5525 7.09126 5.5525 7.72126 5.9425 8.11126L10.1225 12.2913C10.5125 12.6813 11.1425 12.6813 11.5325 12.2913L22.1225 1.71126C22.5125 1.32126 22.5125 0.691262 22.1225 0.301262H22.1125C21.7325 -0.098738 21.1025 -0.0987382 20.7125 0.291262ZM0.2925 8.12126L4.4725 12.3013C4.8625 12.6913 5.4925 12.6913 5.8825 12.3013L6.5825 11.6013L1.7025 6.70126C1.3125 6.31126 0.6825 6.31126 0.2925 6.70126C-0.0975 7.09126 -0.0975 7.73126 0.2925 8.12126Z" />
            </g>
        ),
    },
    notificationsWarning: {
        viewBox: '0 0 20 25',
        image: (
            <g>
                <path d="M10.0002 25C11.2813 25 12.3178 23.9651 12.3178 22.686H7.68256C7.68256 23.9651 8.71909 25 10.0002 25ZM19.6551 19.5233L18.1527 18.0233V11.0465C18.1527 7.15116 15.4042 3.89535 11.7472 3.10465V1.74419C11.7472 0.77907 10.9669 0 10.0002 0C9.03354 0 8.25323 0.77907 8.25323 1.74419V3.10465C4.59625 3.89535 1.84768 7.15116 1.84768 11.0465V18.0233L0.345291 19.5233C-0.388436 20.2558 0.124008 21.5116 1.16054 21.5116H18.8282C19.8764 21.5116 20.3888 20.2558 19.6551 19.5233ZM11.1648 16.8605H8.83555V14.5349H11.1648V16.8605ZM11.1648 11.0465C11.1648 11.686 10.6408 12.2093 10.0002 12.2093C9.35964 12.2093 8.83555 11.686 8.83555 11.0465V8.72093C8.83555 8.0814 9.35964 7.55814 10.0002 7.55814C10.6408 7.55814 11.1648 8.0814 11.1648 8.72093V11.0465Z" />
            </g>
        ),
    },
    notificationsError: {
        viewBox: '0 0 20 20',
        image: (
            <g>
                <path d="M10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 -3.91654e-07 10 -8.74228e-07C4.48 -1.3568e-06 1.3568e-06 4.48 8.74228e-07 10C3.91654e-07 15.52 4.48 20 10 20ZM10 5C10.55 5 11 5.45 11 6L11 10C11 10.55 10.55 11 10 11C9.45 11 9 10.55 9 10L9 6C9 5.45 9.45 5 10 5ZM9 13L11 13L11 15L9 15L9 13Z" />
            </g>
        ),
    },
    notificationsBuild: {
        viewBox: '0 0 24 24',
        image: (
            <svg>
                <g clip-path="url(#clip0_492_1610)">
                    <path d="M12.09 2.90995C10.08 0.899954 7.07 0.489954 4.65 1.66995L8.28 5.29995C8.67 5.68995 8.67 6.31995 8.28 6.70995L6.69 8.29995C6.3 8.69995 5.67 8.69995 5.28 8.29995L1.65 4.66995C0.480003 7.09995 0.890003 10.09 2.9 12.1C4.76 13.96 7.48 14.45 9.79 13.58L17.75 21.54C18.78 22.57 20.44 22.57 21.46 21.54C22.49 20.51 22.49 18.85 21.46 17.83L13.54 9.89995C14.46 7.55995 13.98 4.79995 12.09 2.90995Z" />
                </g>
                <defs>
                    <clipPath id="clip0_492_1610">
                        <rect width="24" height="24" />
                    </clipPath>
                </defs>
            </svg>
        ),
    },
    unreadCircle: {
        viewBox: '0 0 12 12',
        image: (
            <g>
                <circle cx="6" cy="6" r="5.5" fill="#2582E0" stroke="white" />
            </g>
        ),
    },
    errorWarning: {
        viewBox: '0 0 21 19',
        image: (
            <g>
                <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M2.00137 17.0075H17.0614C18.6014 17.0075 19.5614 15.3375 18.7914 14.0075L11.2614 0.9975C10.4914 -0.3325 8.57137 -0.3325 7.80137 0.9975L0.271371 14.0075C-0.498629 15.3375 0.461371 17.0075 2.00137 17.0075ZM9.53137 10.0075C8.98137 10.0075 8.53137 9.5575 8.53137 9.0075V7.0075C8.53137 6.4575 8.98137 6.0075 9.53137 6.0075C10.0814 6.0075 10.5314 6.4575 10.5314 7.0075V9.0075C10.5314 9.5575 10.0814 10.0075 9.53137 10.0075ZM10.5314 14.0075H8.53137V12.0075H10.5314V14.0075Z"
                />
            </g>
        ),
    },
    openArrow: {
        viewBox: '0 0 11 6',
        image: (
            <g>
                <path d="M0.215426 0.205987C-0.0718107 0.479698 -0.0718107 0.920987 0.215426 1.1947L5.08673 5.83661C5.31535 6.05446 5.68465 6.05446 5.91327 5.83661L10.7846 1.1947C11.0718 0.920987 11.0718 0.479698 10.7846 0.205987C10.4973 -0.067724 10.0342 -0.067724 9.747 0.205987L5.49707 4.25021L1.24714 0.200401C0.96576 -0.067724 0.496801 -0.0677239 0.215426 0.205987Z" />
            </g>
        ),
    },
    monitor: {
        viewBox: '0 0 22 18',
        image: (
            <g>
                <path
                    d="M20 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H7V17C7 17.55 7.45 18 8 18H14C14.55 18 15 17.55 15 17V16H20C21.1 16 21.99 15.1 21.99 14L22 2C22 0.89 21.1 0 20 0ZM19 14H3C2.45 14 2 13.55 2 13V3C2 2.45 2.45 2 3 2H19C19.55 2 20 2.45 20 3V13C20 13.55 19.55 14 19 14Z"
                    //fill="white"
                />
            </g>
        ),
    },
    network: {
        viewBox: '0 0 22 18',
        image: (
            <g>
                <path
                    d="M20 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H7V18H15V16H20C21.1 16 21.99 15.1 21.99 14L22 2C22 0.9 21.1 0 20 0ZM20 14H2V2H20V14ZM3 11V13H5C5 11.89 4.11 11 3 11ZM3 8V9.43C4.97 9.43 6.57 11.03 6.57 13H8C8 10.24 5.76 8 3 8ZM3 5V6.45C6.61 6.45 9.55 9.38 9.55 13H11C11 8.58 7.41 5 3 5Z"
                    //fill="white"
                />
            </g>
        ),
    },
    storage: {
        viewBox: '0 0 13 20',
        image: (
            <g>
                <path
                    d="M12.076 5.4354H10.2463C9.74314 5.4354 9.33146 5.86659 9.33146 6.3936V8.31C9.33146 8.83701 9.74314 9.2682 10.2463 9.2682V11.1846H7.50176V3.519H8.41661C8.7917 3.519 9.01126 3.06864 8.78255 2.75243L6.95285 0.194036C6.76988 -0.0646786 6.40394 -0.0646786 6.22097 0.194036L4.39127 2.75243C4.16256 3.06864 4.38212 3.519 4.75721 3.519H5.67206V11.1846H2.92752V9.20113C3.68684 8.77952 4.19001 7.89798 3.97044 6.8727C3.81492 6.13489 3.26601 5.53122 2.57987 5.33C1.23505 4.93713 0 6.00074 0 7.3518C0 8.16627 0.457424 8.8466 1.09782 9.20113V11.1846C1.09782 12.2386 1.92118 13.101 2.92752 13.101H5.67206V16.0235C4.88529 16.4547 4.40042 17.3842 4.63828 18.4094C4.80296 19.1281 5.36101 19.7318 6.04715 19.9234C7.38283 20.2971 8.60873 19.2527 8.60873 17.892C8.60873 17.0775 8.16045 16.3781 7.51091 16.0235V13.101H10.2555C11.2618 13.101 12.0852 12.2386 12.0852 11.1846V9.2682C12.5883 9.2682 13 8.83701 13 8.31V6.3936C12.9909 5.86659 12.5792 5.4354 12.076 5.4354Z"
                    //fill="white"
                />
            </g>
        ),
    },
    noDeviceArrow: {
        viewBox: '0 0 30 8',
        image: (
            <g>
                <path d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" />
            </g>
        ),
    },
    move: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM14 18V15H10V11H14V8L19 13L14 18Z" />
            </g>
        ),
    },
    controllPlay: {
        viewBox: '0 0 22 27',
        image: (
            <path
                d="M0.333252 2.92417V24.0758C0.333252 25.6888 2.1095 26.6688 3.47742 25.7908L20.0966 15.215C21.3624 14.4188 21.3624 12.5813 20.0966 11.7646L3.47742 1.20917C2.1095 0.331256 0.333252 1.31126 0.333252 2.92417Z"
                fill="white"
            />
        ),
    },
    controllStop: {
        viewBox: '0 0 24 24',
        image: (
            <path
                d="M4 0H20C22.2 0 24 1.8 24 4V20C24 22.2 22.2 24 20 24H4C1.8 24 0 22.2 0 20V4C0 1.8 1.8 0 4 0Z"
                fill="white"
            />
        ),
    },
    logo_smartplayer: {
        viewBox: '0 0 27 27',
        image: (
            <g fill="none">
                <path d="M10.1612 25.9999L1 19.1026L10.322 1L1.01462 8.07283" />
                <path d="M1 19.1011L25.9999 13.6231L10.3579 1" />
                <path d="M1 8.10376L25.9999 13.6746L10.153 25.9999L1 8.10376Z" />
            </g>
        ),
    },
    users_icon_menu: {
        viewBox: '0 0 17 17',
        image: (
            <path d="M8.5 8.5C10.8481 8.5 12.75 6.59812 12.75 4.25C12.75 1.90188 10.8481 0 8.5 0C6.15188 0 4.25 1.90188 4.25 4.25C4.25 6.59812 6.15188 8.5 8.5 8.5ZM8.5 10.625C5.66313 10.625 0 12.0487 0 14.875V15.9375C0 16.5219 0.478125 17 1.0625 17H15.9375C16.5219 17 17 16.5219 17 15.9375V14.875C17 12.0487 11.3369 10.625 8.5 10.625Z" />
        ),
    },
    distributes_icon_menu: {
        viewBox: '0 0 16 18',
        image: (
            <g>
                <path d="M12.25 2.29L13.69 0.85C14.01 0.53 13.78 0 13.34 0H7.05005C6.77005 0 6.55005 0.22 6.55005 0.5V6.79C6.55005 7.24 7.09005 7.46 7.40005 7.14L8.85005 5.69C10.82 7.15 12.1 9.47 12.1 12.11C12.1 12.77 12.02 13.42 11.86 14.03C11.74 14.53 12.34 14.89 12.7 14.52C14.18 12.99 15.1 10.91 15.1 8.61C15.1 6.1 13.99 3.85 12.25 2.29Z" />
                <path d="M7.7 10.85L6.25 12.29C4.28 10.83 3 8.50999 3 5.86999C3 5.20999 3.08 4.55999 3.24 3.94999C3.36 3.44999 2.76 3.08999 2.4 3.45999C0.92 4.98999 0 7.06999 0 9.36999C0 11.89 1.1 14.14 2.84 15.7L1.4 17.14C1.08 17.46 1.31 17.99 1.75 17.99H8.04C8.32 17.99 8.54 17.77 8.54 17.49V11.2C8.55 10.76 8.01 10.53 7.7 10.85Z" />
            </g>
        ),
    },
    history_icon_menu: {
        viewBox: '0 0 15 20',
        image: (
            <path d="M14.7072 15.1692L13.4319 13.8462V8.71795C13.4319 5.56923 11.8106 2.93333 8.9831 2.2359V1.53846C8.9831 0.68718 8.32073 0 7.50017 0C6.67961 0 6.01723 0.68718 6.01723 1.53846V2.2359C3.17988 2.93333 1.56843 5.55897 1.56843 8.71795V13.8462L0.293104 15.1692C-0.329728 15.8154 0.105266 16.9231 0.985141 16.9231H14.0053C14.8951 16.9231 15.3301 15.8154 14.7072 15.1692ZM11.4547 14.8718H3.54568V8.71795C3.54568 6.17436 5.0385 4.10256 7.50017 4.10256C9.96184 4.10256 11.4547 6.17436 11.4547 8.71795V14.8718ZM7.50017 20C8.58765 20 9.47742 19.0769 9.47742 17.9487H5.52292C5.52292 19.0769 6.4028 20 7.50017 20Z" />
        ),
    },
    history_icon: {
        viewBox: '0 0 22 17',
        image: (
            <path d="M16.5 0C14.55 0 12.45 0.4 11 1.5C9.55 0.4 7.45 0 5.5 0C4.05 0 2.51 0.22 1.22 0.79C0.49 1.12 0 1.83 0 2.64V13.92C0 15.22 1.22 16.18 2.48 15.86C3.46 15.61 4.5 15.5 5.5 15.5C7.06 15.5 8.72 15.76 10.06 16.42C10.66 16.72 11.34 16.72 11.93 16.42C13.27 15.75 14.93 15.5 16.49 15.5C17.49 15.5 18.53 15.61 19.51 15.86C20.77 16.19 21.99 15.23 21.99 13.92V2.64C21.99 1.83 21.5 1.12 20.77 0.79C19.49 0.22 17.95 0 16.5 0ZM20 12.73C20 13.36 19.42 13.82 18.8 13.71C18.05 13.57 17.27 13.51 16.5 13.51C14.8 13.51 12.35 14.16 11 15.01V3.5C12.35 2.65 14.8 2 16.5 2C17.42 2 18.33 2.09 19.2 2.28C19.66 2.38 20 2.79 20 3.26V12.73Z" />
        ),
    },
    settings_icon_menu: {
        viewBox: '0 0 18 18',
        image: (
            <path d="M15.8766 9.882C15.9136 9.594 15.9414 9.306 15.9414 9C15.9414 8.694 15.9136 8.406 15.8766 8.118L17.8289 6.633C18.0047 6.498 18.051 6.255 17.9399 6.057L16.0894 2.943C15.9784 2.745 15.7286 2.673 15.525 2.745L13.2212 3.645C12.74 3.285 12.2219 2.988 11.6575 2.763L11.3059 0.378C11.2782 0.162 11.0839 0 10.8525 0H7.15155C6.92024 0 6.72593 0.162 6.69818 0.378L6.34658 2.763C5.78218 2.988 5.26404 3.294 4.78291 3.645L2.47905 2.745C2.26624 2.664 2.02567 2.745 1.91464 2.943L0.0641489 6.057C-0.0561333 6.255 -0.000618345 6.498 0.175179 6.633L2.12745 8.118C2.09044 8.406 2.06268 8.703 2.06268 9C2.06268 9.297 2.09044 9.594 2.12745 9.882L0.175179 11.367C-0.000618345 11.502 -0.0468809 11.745 0.0641489 11.943L1.91464 15.057C2.02567 15.255 2.27549 15.327 2.47905 15.255L4.78291 14.355C5.26404 14.715 5.78218 15.012 6.34658 15.237L6.69818 17.622C6.72593 17.838 6.92024 18 7.15155 18H10.8525C11.0839 18 11.2782 17.838 11.3059 17.622L11.6575 15.237C12.2219 15.012 12.74 14.706 13.2212 14.355L15.525 15.255C15.7378 15.336 15.9784 15.255 16.0894 15.057L17.9399 11.943C18.051 11.745 18.0047 11.502 17.8289 11.367L15.8766 9.882ZM9.00204 12.15C7.21632 12.15 5.76368 10.737 5.76368 9C5.76368 7.263 7.21632 5.85 9.00204 5.85C10.7878 5.85 12.2404 7.263 12.2404 9C12.2404 10.737 10.7878 12.15 9.00204 12.15Z" />
        ),
    },
    downloads_icon_menu: {
        viewBox: '0 0 18 18',
        image: (
            <path d="M16 10V15C16 15.55 15.55 16 15 16H3C2.45 16 2 15.55 2 15V10C2 9.45 1.55 9 1 9C0.45 9 0 9.45 0 10V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V10C18 9.45 17.55 9 17 9C16.45 9 16 9.45 16 10ZM10 9.67L11.88 7.79C12.27 7.4 12.9 7.4 13.29 7.79C13.68 8.18 13.68 8.81 13.29 9.2L9.7 12.79C9.31 13.18 8.68 13.18 8.29 12.79L4.7 9.2C4.31 8.81 4.31 8.18 4.7 7.79C5.09 7.4 5.72 7.4 6.11 7.79L8 9.67V1C8 0.45 8.45 0 9 0C9.55 0 10 0.45 10 1V9.67Z" />
        ),
    },
    exit_icon_menu: {
        viewBox: '0 0 18 18',
        image: (
            <path d="M7.79 13.29C8.18 13.68 8.81 13.68 9.2 13.29L12.79 9.7C13.18 9.31 13.18 8.68 12.79 8.29L9.2 4.7C8.81 4.31 8.18 4.31 7.79 4.7C7.4 5.09 7.4 5.72 7.79 6.11L9.67 8H1C0.45 8 0 8.45 0 9C0 9.55 0.45 10 1 10H9.67L7.79 11.88C7.4 12.27 7.41 12.91 7.79 13.29ZM16 0H2C0.89 0 0 0.9 0 2V5C0 5.55 0.45 6 1 6C1.55 6 2 5.55 2 5V3C2 2.45 2.45 2 3 2H15C15.55 2 16 2.45 16 3V15C16 15.55 15.55 16 15 16H3C2.45 16 2 15.55 2 15V13C2 12.45 1.55 12 1 12C0.45 12 0 12.45 0 13V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z" />
        ),
    },
    left_icon_menu: {
        viewBox: '0 0 7 12',
        image: (
            <path d="M6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.68998 11.69 6.31998 11.69 6.70998 11.3C7.09998 10.91 7.09998 10.28 6.70998 9.88998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.08998 1.08998 6.70998 0.70998Z" />
        ),
    },
    right_icon_menu: {
        viewBox: '0 0 8 12',
        image: (
            <path d="M1.29 0.710022C0.899998 1.10002 0.899998 1.73002 1.29 2.12002L5.17 6.00002L1.29 9.88002C0.899998 10.27 0.899998 10.9 1.29 11.29C1.68 11.68 2.31 11.68 2.7 11.29L7.29 6.70002C7.68 6.31002 7.68 5.68002 7.29 5.29002L2.7 0.700022C2.32 0.320022 1.68 0.320022 1.29 0.710022Z" />
        ),
    },
    new_filter_icon: {
        viewBox: '0 0 18 12',
        image: (
            <path d="M8 12H10C10.55 12 11 11.55 11 11C11 10.45 10.55 10 10 10H8C7.45 10 7 10.45 7 11C7 11.55 7.45 12 8 12ZM0 1C0 1.55 0.45 2 1 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0H1C0.45 0 0 0.45 0 1ZM4 7H14C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5H4C3.45 5 3 5.45 3 6C3 6.55 3.45 7 4 7Z" />
        ),
    },
    internal_storage: {
        viewBox: '0 0 24 24',
        image: (
            <path d="M4 20H20C21.1 20 22 19.1 22 18C22 16.9 21.1 16 20 16H4C2.9 16 2 16.9 2 18C2 19.1 2.9 20 4 20ZM4 17H6V19H4V17ZM2 6C2 7.1 2.9 8 4 8H20C21.1 8 22 7.1 22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6ZM6 7H4V5H6V7ZM4 14H20C21.1 14 22 13.1 22 12C22 10.9 21.1 10 20 10H4C2.9 10 2 10.9 2 12C2 13.1 2.9 14 4 14ZM4 11H6V13H4V11Z" />
        ),
    },
    open_widget_in_modal: {
        viewBox: '0 0 21 22',
        image: (
            <g>
                <path d="M19.3485 15.686C19.3773 15.462 19.3989 15.238 19.3989 15C19.3989 14.762 19.3773 14.538 19.3485 14.314L20.8669 13.159C21.0037 13.054 21.0396 12.865 20.9533 12.711L19.514 10.289C19.4277 10.135 19.2334 10.079 19.075 10.135L17.2831 10.835C16.9089 10.555 16.5059 10.324 16.0669 10.149L15.7935 8.294C15.7719 8.126 15.6208 8 15.4409 8H12.5623C12.3824 8 12.2313 8.126 12.2097 8.294L11.9362 10.149C11.4973 10.324 11.0943 10.562 10.72 10.835L8.92815 10.135C8.76263 10.072 8.57552 10.135 8.48917 10.289L7.04989 12.711C6.95634 12.865 6.99952 13.054 7.13625 13.159L8.65468 14.314C8.6259 14.538 8.60431 14.769 8.60431 15C8.60431 15.231 8.6259 15.462 8.65468 15.686L7.13625 16.841C6.99952 16.946 6.96354 17.135 7.04989 17.289L8.48917 19.711C8.57552 19.865 8.76983 19.921 8.92815 19.865L10.72 19.165C11.0943 19.445 11.4973 19.676 11.9362 19.851L12.2097 21.706C12.2313 21.874 12.3824 22 12.5623 22H15.4409C15.6208 22 15.7719 21.874 15.7935 21.706L16.0669 19.851C16.5059 19.676 16.9089 19.438 17.2831 19.165L19.075 19.865C19.2405 19.928 19.4277 19.865 19.514 19.711L20.9533 17.289C21.0396 17.135 21.0037 16.946 20.8669 16.841L19.3485 15.686V15.686ZM14.0016 17.45C12.6127 17.45 11.4829 16.351 11.4829 15C11.4829 13.649 12.6127 12.55 14.0016 12.55C15.3905 12.55 16.5203 13.649 16.5203 15C16.5203 16.351 15.3905 17.45 14.0016 17.45Z" />
                <path d="M6.83953 18.8925H1C0.45 18.8925 0 18.4425 0 17.8925V11.8925C0 11.3425 0.45 10.8925 1 10.8925H6.9673L6.19198 12.1972C5.8235 12.8099 6.00969 13.5547 6.52719 13.9521L7.60944 14.7754C7.60616 14.8491 7.60431 14.9241 7.60431 15C7.60431 15.0759 7.60616 15.1509 7.60944 15.2246L6.53084 16.0451L6.52719 16.0479C5.97873 16.4691 5.85929 17.2103 6.17767 17.7781L6.18381 17.7891L6.83953 18.8925ZM16.7043 7.84822L18.61 5.9425C19 5.5525 19 4.9225 18.61 4.5325L14.37 0.2925C13.98 -0.0975 13.34 -0.0975 12.95 0.2925L8.7 4.5325C8.31 4.9225 8.31 5.5525 8.7 5.9425L11.18 8.42245L11.2195 8.1545C11.3164 7.44855 11.9308 7 12.5623 7H15.4409C15.9755 7 16.4977 7.32138 16.7043 7.84822ZM0 7.8925V1.8925C0 1.3425 0.45 0.8925 1 0.8925H7C7.55 0.8925 8 1.3425 8 1.8925V7.8925C8 8.4425 7.55 8.8925 7 8.8925H1C0.45 8.8925 0 8.4425 0 7.8925Z" />
            </g>
        ),
    },
    playingVolume: {
        viewBox: '0 0 28 28',
        image: (
            <path
                d="M3.5 11.6666V16.3333C3.5 16.975 4.025 17.5 4.66667 17.5H8.16667L12.005 21.3383C12.74 22.0733 14 21.5483 14 20.51V7.47831C14 6.43998 12.74 5.91498 12.005 6.64998L8.16667 10.5H4.66667C4.025 10.5 3.5 11.025 3.5 11.6666ZM19.25 14C19.25 11.935 18.06 10.1616 16.3333 9.29831V18.69C18.06 17.8383 19.25 16.065 19.25 14ZM16.3333 5.19164V5.42498C16.3333 5.86831 16.625 6.25331 17.0333 6.41664C20.0433 7.61831 22.1667 10.57 22.1667 14C22.1667 17.43 20.0433 20.3816 17.0333 21.5833C16.6133 21.7466 16.3333 22.1316 16.3333 22.575V22.8083C16.3333 23.5433 17.0683 24.0566 17.745 23.8C21.7 22.295 24.5 18.48 24.5 14C24.5 9.51998 21.7 5.70498 17.745 4.19998C17.0683 3.93164 16.3333 4.45664 16.3333 5.19164Z"
                fill="white"
            />
        ),
    },
    editBroadcast: {
        viewBox: '0 0 25 19',
        image: (
            <g>
                <path d="M17.5 5.48438V1.21875C17.5 0.548437 16.9375 0 16.25 0H1.25C0.5625 0 0 0.548437 0 1.21875V13.4062C0 14.0766 0.5625 14.625 1.25 14.625H16.25C16.9375 14.625 17.5 14.0766 17.5 13.4062V9.14062L20.3625 11.9316C21.15 12.6994 22.5 12.1509 22.5 11.0662V3.54656C22.5 2.46187 21.15 1.91344 20.3625 2.68125L17.5 5.48438Z" />
                <path
                    d="M13.1394 8.33806L11.9862 10.2786C11.7735 10.6317 11.8797 11.0616 12.18 11.2922L12.1818 11.2936L13.1778 12.0512C13.1694 12.1564 13.1642 12.2648 13.1642 12.375C13.1642 12.4852 13.1694 12.5936 13.1778 12.6988L12.1818 13.4564L12.1818 13.4564L12.18 13.4578C11.8642 13.7003 11.7936 14.1283 11.979 14.4589L11.9788 14.459L11.9853 14.4698L13.1394 16.4119C13.3457 16.7718 13.7699 16.8694 14.0911 16.7558L14.0988 16.7531L14.1063 16.7501L15.296 16.2854C15.484 16.4102 15.6809 16.5223 15.8874 16.6203L16.0662 17.8332C16.1211 18.2374 16.4743 18.5 16.8447 18.5H19.1578C19.5283 18.5 19.8814 18.2374 19.9364 17.8332L20.1153 16.6195C20.3226 16.5203 20.5186 16.407 20.7044 16.2845L21.8962 16.7501L21.8962 16.7501L21.9003 16.7517C22.2507 16.885 22.6649 16.7577 22.8632 16.4119L24.0173 14.4698L24.0174 14.4699L24.0236 14.4589C24.209 14.1283 24.1383 13.7003 23.8226 13.4578L23.8208 13.4564L22.8249 12.6989C22.8332 12.5952 22.8384 12.4874 22.8384 12.375C22.8384 12.2626 22.8332 12.1548 22.8249 12.0511L23.8208 11.2936L23.8226 11.2922C24.1383 11.0497 24.209 10.6217 24.0236 10.2911L24.0237 10.291L24.0173 10.2802L22.8632 8.33809C22.6568 7.9782 22.2327 7.88062 21.9114 7.99424L21.9038 7.99695L21.8962 7.9999L20.7066 8.46463C20.5185 8.33976 20.3217 8.22768 20.1152 8.12973L19.9364 6.91683C19.8814 6.51261 19.5283 6.25 19.1578 6.25H16.8447C16.4743 6.25 16.1211 6.5126 16.0662 6.91681L15.8873 8.13047C15.68 8.22971 15.4839 8.34301 15.2982 8.46548L14.1063 7.9999L14.1063 7.99988L14.1023 7.99833C13.7519 7.86497 13.3376 7.99233 13.1394 8.33806ZM18.0013 13.8438C17.1482 13.8438 16.4773 13.1715 16.4773 12.375C16.4773 11.5785 17.1482 10.9062 18.0013 10.9062C18.8543 10.9062 19.5253 11.5785 19.5253 12.375C19.5253 13.1715 18.8543 13.8438 18.0013 13.8438Z"
                    stroke="#F0F0F0"
                />
            </g>
        ),
    },
    deleteBasket: {
        viewBox: '0 0 15 18',
        image: (
            <path d="M1.625 16C1.625 17.1 2.525 18 3.625 18H11.625C12.725 18 13.625 17.1 13.625 16V6C13.625 4.9 12.725 4 11.625 4H3.625C2.525 4 1.625 4.9 1.625 6V16ZM13.625 1H11.125L10.415 0.29C10.235 0.11 9.975 0 9.715 0H5.535C5.275 0 5.015 0.11 4.835 0.29L4.125 1H1.625C1.075 1 0.625 1.45 0.625 2C0.625 2.55 1.075 3 1.625 3H13.625C14.175 3 14.625 2.55 14.625 2C14.625 1.45 14.175 1 13.625 1Z" />
        ),
    },
    broadcastDownloadProgress: {
        viewBox: '0 0 81 66',
        image: (
            <g>
                <path d="M63 19.5V4.33333C63 1.95 60.975 0 58.5 0H4.5C2.025 0 0 1.95 0 4.33333V47.6667C0 50.05 2.025 52 4.5 52H58.5C60.975 52 63 50.05 63 47.6667V32.5L73.305 42.4233C76.14 45.1533 81 43.2033 81 39.3467V12.61C81 8.75333 76.14 6.80333 73.305 9.53333L63 19.5Z" />
                <rect y="55" width="11" height="11" rx="2" fill="#494848" />
                <rect x="13" y="55" width="11" height="11" rx="2" fill="#494848" />
                <rect x="26" y="55" width="11" height="11" rx="2" fill="#494848" />
                <rect x="39" y="55" width="11" height="11" rx="2" fill="#B3B3B3" />
                <rect x="52" y="55" width="11" height="11" rx="2" fill="#B3B3B3" />
                <rect x="65" y="55" width="11" height="11" rx="2" fill="#B3B3B3" />
            </g>
        ),
    },
    synchronized: {
        viewBox: '0 0 20 10',
        image: (
            <path
                d="M15 0H12C11.45 0 11 0.45 11 1C11 1.55 11.45 2 12 2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H12C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM6 5C6 5.55 6.45 6 7 6H13C13.55 6 14 5.55 14 5C14 4.45 13.55 4 13 4H7C6.45 4 6 4.45 6 5ZM8 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H8C8.55 2 9 1.55 9 1C9 0.45 8.55 0 8 0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H8C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8Z"
                fill="white"
            />
        ),
    },
    unsynchronized: {
        viewBox: '0 0 20 18',
        image: (
            <path
                d="M19.94 8.23002C19.57 5.76002 17.32 4.00002 14.82 4.00002H11.95C11.43 4.00002 11 4.43002 11 4.95002C11 5.47002 11.43 5.90002 11.95 5.90002H14.85C16.45 5.90002 17.89 7.04002 18.07 8.63002C18.24 10.06 17.43 11.32 16.22 11.85L17.62 13.25C19.25 12.23 20.26 10.34 19.94 8.23002ZM2.12001 0.560017C1.73001 0.170017 1.10001 0.170017 0.710012 0.560017C0.320012 0.950017 0.320012 1.58002 0.710012 1.97002L3.11001 4.37002C1.17001 5.17002 -0.159988 7.14002 0.0200117 9.41002C0.230012 12.05 2.59001 14 5.23001 14H8.05001C8.57001 14 9.00001 13.57 9.00001 13.05C9.00001 12.53 8.57001 12.1 8.05001 12.1H5.16001C3.53001 12.1 2.06001 10.91 1.91001 9.28002C1.76001 7.56002 3.02001 6.11002 4.66001 5.93002L6.76001 8.03002C6.33001 8.12002 6.00001 8.49002 6.00001 8.95002V9.05002C6.00001 9.57002 6.43001 10 6.95001 10H8.73001L11 12.27V14H12.73L16.03 17.3C16.42 17.69 17.05 17.69 17.44 17.3C17.83 16.91 17.83 16.28 17.44 15.89L2.12001 0.560017ZM14 8.95002C14 8.43002 13.57 8.00002 13.05 8.00002H12.39L13.88 9.49002C13.95 9.36002 14 9.21002 14 9.05002V8.95002Z"
                fill="white"
            />
        ),
    },
    syncViewToggleList: {
        viewBox: '0 0 22 20',
        image: (
            <path
                d="M1.66665 14H20.3333C21.0666 14 21.6666 13.4 21.6666 12.6666C21.6666 11.9333 21.0666 11.3333 20.3333 11.3333H1.66665C0.933313 11.3333 0.333313 11.9333 0.333313 12.6666C0.333313 13.4 0.933313 14 1.66665 14ZM1.66665 19.3333H20.3333C21.0666 19.3333 21.6666 18.7333 21.6666 18C21.6666 17.2666 21.0666 16.6666 20.3333 16.6666H1.66665C0.933313 16.6666 0.333313 17.2666 0.333313 18C0.333313 18.7333 0.933313 19.3333 1.66665 19.3333ZM1.66665 8.66663H20.3333C21.0666 8.66663 21.6666 8.06663 21.6666 7.33329C21.6666 6.59996 21.0666 5.99996 20.3333 5.99996H1.66665C0.933313 5.99996 0.333313 6.59996 0.333313 7.33329C0.333313 8.06663 0.933313 8.66663 1.66665 8.66663ZM0.333313 1.99996C0.333313 2.73329 0.933313 3.33329 1.66665 3.33329H20.3333C21.0666 3.33329 21.6666 2.73329 21.6666 1.99996C21.6666 1.26663 21.0666 0.666626 20.3333 0.666626H1.66665C0.933313 0.666626 0.333313 1.26663 0.333313 1.99996Z"
                fill="#323232"
            />
        ),
    },
    syncViewToggleTile: {
        viewBox: '0 0 23 18',
        image: (
            <path d="M1.66659 8.66663H5.66658C6.39992 8.66663 6.99992 8.06663 6.99992 7.33329V1.99996C6.99992 1.26663 6.39992 0.666626 5.66658 0.666626H1.66659C0.933252 0.666626 0.333252 1.26663 0.333252 1.99996V7.33329C0.333252 8.06663 0.933252 8.66663 1.66659 8.66663ZM1.66659 18H5.66658C6.39992 18 6.99992 17.4 6.99992 16.6666V11.3333C6.99992 10.6 6.39992 9.99996 5.66658 9.99996H1.66659C0.933252 9.99996 0.333252 10.6 0.333252 11.3333V16.6666C0.333252 17.4 0.933252 18 1.66659 18ZM9.66658 18H13.6666C14.3999 18 14.9999 17.4 14.9999 16.6666V11.3333C14.9999 10.6 14.3999 9.99996 13.6666 9.99996H9.66658C8.93325 9.99996 8.33325 10.6 8.33325 11.3333V16.6666C8.33325 17.4 8.93325 18 9.66658 18ZM17.6666 18H21.6666C22.3999 18 22.9999 17.4 22.9999 16.6666V11.3333C22.9999 10.6 22.3999 9.99996 21.6666 9.99996H17.6666C16.9333 9.99996 16.3333 10.6 16.3333 11.3333V16.6666C16.3333 17.4 16.9333 18 17.6666 18ZM9.66658 8.66663H13.6666C14.3999 8.66663 14.9999 8.06663 14.9999 7.33329V1.99996C14.9999 1.26663 14.3999 0.666626 13.6666 0.666626H9.66658C8.93325 0.666626 8.33325 1.26663 8.33325 1.99996V7.33329C8.33325 8.06663 8.93325 8.66663 9.66658 8.66663ZM16.3333 1.99996V7.33329C16.3333 8.06663 16.9333 8.66663 17.6666 8.66663H21.6666C22.3999 8.66663 22.9999 8.06663 22.9999 7.33329V1.99996C22.9999 1.26663 22.3999 0.666626 21.6666 0.666626H17.6666C16.9333 0.666626 16.3333 1.26663 16.3333 1.99996Z" />
        ),
    },
    minimize_line: {
        viewBox: '0 0 14 2',
        image: <path d="M13 2H1C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0H13C13.55 0 14 0.45 14 1C14 1.55 13.55 2 13 2Z" />,
    },
    maximize_hollow: {
        viewBox: '0 0 14 14',
        image: (
            <path d="M1 9C0.45 9 0 9.45 0 10V13C0 13.55 0.45 14 1 14H4C4.55 14 5 13.55 5 13C5 12.45 4.55 12 4 12H2V10C2 9.45 1.55 9 1 9ZM1 5C1.55 5 2 4.55 2 4V2H4C4.55 2 5 1.55 5 1C5 0.45 4.55 0 4 0H1C0.45 0 0 0.45 0 1V4C0 4.55 0.45 5 1 5ZM12 12H10C9.45 12 9 12.45 9 13C9 13.55 9.45 14 10 14H13C13.55 14 14 13.55 14 13V10C14 9.45 13.55 9 13 9C12.45 9 12 9.45 12 10V12ZM9 1C9 1.55 9.45 2 10 2H12V4C12 4.55 12.45 5 13 5C13.55 5 14 4.55 14 4V1C14 0.45 13.55 0 13 0H10C9.45 0 9 0.45 9 1Z" />
        ),
    },
    monitoring: {
        viewBox: '0 0 24 20',
        image: (
            <g>
                <path d="M21.8182 0H2.18182C0.981818 0 0 1 0 2.22222V15.5556C0 16.7778 0.981818 17.7778 2.18182 17.7778H7.63636V18.8889C7.63636 19.5 8.12727 20 8.72727 20H15.2727C15.8727 20 16.3636 19.5 16.3636 18.8889V17.7778H21.8182C23.0182 17.7778 23.9891 16.7778 23.9891 15.5556L24 2.22222C24 1 23.0182 0 21.8182 0ZM20.7273 15.5556H3.27273C2.67273 15.5556 2.18182 15.0556 2.18182 14.4444V3.33333C2.18182 2.72222 2.67273 2.22222 3.27273 2.22222H20.7273C21.3273 2.22222 21.8182 2.72222 21.8182 3.33333V14.4444C21.8182 15.0556 21.3273 15.5556 20.7273 15.5556Z" />
                <path d="M10.2559 12.9468H11.6332V11.5923H10.2559V12.9468ZM17.1425 11.5923H15.7652V12.9468H17.1425V11.5923ZM13.0105 12.9468H14.3878V11.5923H13.0105V12.9468ZM5.73423 4.98214C5.4381 5.21919 5.40367 5.64586 5.6447 5.93709L8.19964 8.96447L5.6447 11.9918C5.40367 12.2831 5.44499 12.7097 5.73423 12.9468C6.03035 13.1838 6.46421 13.15 6.70524 12.8587L9.62516 9.39792C9.83865 9.14733 9.83865 8.7816 9.62516 8.53101L6.70524 5.07019C6.46421 4.78574 6.02346 4.7451 5.73423 4.98214Z" />
            </g>
        ),
    },
    auto_scroll: {
        viewBox: '0 0 11 15',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.58252 1C6.58252 1.55 6.13252 2 5.58252 2C5.03252 2 4.58252 1.55 4.58252 1C4.58252 0.45 5.03252 0 5.58252 0C6.13252 0 6.58252 0.45 6.58252 1ZM4.58252 4C4.58252 3.45 5.03252 3 5.58252 3C6.13252 3 6.58252 3.45 6.58252 4V7C6.58252 7.55 6.13252 8 5.58252 8C5.03252 8 4.58252 7.55 4.58252 7V4ZM4.58252 10C4.58252 9.45 5.03252 9 5.58252 9C6.13252 9 6.58252 9.45 6.58252 10C6.58252 10.55 6.13252 11 5.58252 11C5.03252 11 4.58252 10.55 4.58252 10ZM5.5825 13.1725L9.4625 9.2925C9.8525 8.9025 10.4925 8.9125 10.8825 9.2925C11.2725 9.6825 11.2725 10.3125 10.8825 10.7025L6.2925 15.2925C5.9025 15.6825 5.2725 15.6825 4.8825 15.2925L0.2925 10.7025C-0.0975 10.3125 -0.0975 9.6825 0.2925 9.2925C0.6825 8.9025 1.3125 8.9025 1.7025 9.2925L5.5825 13.1725Z"
            />
        ),
    },
    auto_scroll_disable: {
        viewBox: '0 0 16 16',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7926 12.7924L15.4698 16.4697C15.7627 16.7626 16.2376 16.7626 16.5305 16.4697C16.8234 16.1768 16.8234 15.7019 16.5305 15.409L1.59112 0.46967C1.29823 0.176777 0.823354 0.176777 0.530461 0.46967C0.237568 0.762563 0.237568 1.23744 0.530461 1.53033L8.11628 9.11615C7.79953 9.2845 7.58259 9.61824 7.58259 10C7.58259 10.5498 8.03254 11 8.58259 11C8.96448 11 9.29812 10.783 9.46643 10.4663L10.3775 11.3774L8.58259 13.1724L4.70246 9.29248C4.31257 8.90234 3.68269 8.90234 3.29255 9.29248C2.90266 9.68262 2.90266 10.3125 3.29255 10.7026L7.88264 15.2925C8.27253 15.6826 8.90266 15.6826 9.29255 15.2925L11.7926 12.7924ZM13.8826 10.7026L13.7069 10.8784L12.2916 9.46338L12.4625 9.29248C12.8526 8.90234 13.4925 8.9126 13.8826 9.29248C14.2725 9.68262 14.2725 10.3125 13.8826 10.7026ZM9.58259 4V6.75439L7.58259 4.75439V4C7.58259 3.4502 8.03254 3 8.58259 3C9.13264 3 9.58259 3.4502 9.58259 4ZM9.58259 1C9.58259 1.5498 9.13264 2 8.58259 2C8.03254 2 7.58259 1.5498 7.58259 1C7.58259 0.450195 8.03254 0 8.58259 0C9.13264 0 9.58259 0.450195 9.58259 1Z"
            />
        ),
    },
    editorActionToggle: {
        viewBox: '0 0 27 10',
        image: (
            <g>
                <path d="M12.4444 3.75V0.833333C12.4444 0.375 12.0444 0 11.5556 0H0.888889C0.4 0 0 0.375 0 0.833333V9.16667C0 9.625 0.4 10 0.888889 10H11.5556C12.0444 10 12.4444 9.625 12.4444 9.16667V6.25L14.48 8.15833C15.04 8.68333 16 8.30833 16 7.56667V2.425C16 1.68333 15.04 1.30833 14.48 1.83333L12.4444 3.75Z" />
                <path d="M21.2471 4.425L23.4054 6.58333C23.7304 6.90833 24.2554 6.90833 24.5804 6.58333L26.7387 4.425C27.2637 3.9 26.8887 3 26.1471 3H21.8304C21.0887 3 20.7221 3.9 21.2471 4.425Z" />
            </g>
        ),
    },
    editorActionToggleOpened: {
        viewBox: '0 0 27 10',
        image: (
            <g>
                <path d="M12.4444 3.75V0.833333C12.4444 0.375 12.0444 0 11.5556 0H0.888889C0.4 0 0 0.375 0 0.833333V9.16667C0 9.625 0.4 10 0.888889 10H11.5556C12.0444 10 12.4444 9.625 12.4444 9.16667V6.25L14.48 8.15833C15.04 8.68333 16 8.30833 16 7.56667V2.425C16 1.68333 15.04 1.30833 14.48 1.83333L12.4444 3.75Z" />
                <path d="M21.2471 5.40203L23.4054 3.24369C23.7304 2.91869 24.2554 2.91869 24.5804 3.24369L26.7387 5.40203C27.2637 5.92703 26.8887 6.82703 26.1471 6.82703H21.8304C21.0887 6.82703 20.7221 5.92703 21.2471 5.40203Z" />
            </g>
        ),
    },
    pagesView: {
        viewBox: '0 0 33 25',
        image: (
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 5H2C1.44772 5 1 5.44772 1 6V23C1 23.5523 1.44772 24 2 24H24C24.5523 24 25 23.5523 25 23V6C25 5.44772 24.5523 5 24 5ZM2 4C0.895431 4 0 4.89543 0 6V23C0 24.1046 0.89543 25 2 25H24C25.1046 25 26 24.1046 26 23V6C26 4.89543 25.1046 4 24 4H2Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31 1H9C8.44772 1 8 1.44772 8 2V19C8 19.5523 8.44772 20 9 20H31C31.5523 20 32 19.5523 32 19V2C32 1.44772 31.5523 1 31 1ZM9 0C7.89543 0 7 0.89543 7 2V19C7 20.1046 7.89543 21 9 21H31C32.1046 21 33 20.1046 33 19V2C33 0.895431 32.1046 0 31 0H9Z"
                />
            </g>
        ),
    },
    addNewPage: {
        viewBox: '0 0 26 21',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 1H24C24.5523 1 25 1.44772 25 2V19C25 19.5523 24.5523 20 24 20H2C1.44772 20 1 19.5523 1 19V2C1 1.44772 1.44772 1 2 1ZM0 2C0 0.895416 0.895432 0 2 0H24C25.1046 0 26 0.895416 26 2V19C26 20.1046 25.1046 21 24 21H2C0.895432 21 0 20.1046 0 19V2ZM12.254 5H14.381V9.25397H18.6349V11.381H14.381V15.6349H12.254V11.381H8V9.25397H12.254V5Z"
            />
        ),
    },
    deletePage: {
        viewBox: '0 0 26 21',
        image: (
            <g>
                <path d="M16.8287 19.4064C16.8287 20.3281 17.5745 21.0823 18.4861 21.0823H25.1156C26.0272 21.0823 26.773 20.3281 26.773 19.4064V9.35161H16.8287V19.4064ZM27.6017 6.8379H24.7013L23.8726 6H19.7291L18.9004 6.8379H16V8.51371H27.6017V6.8379Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 1H24C24.5523 1 25 1.44772 25 2V5.71783L25.1188 5.8379H26V2C26 0.895431 25.1046 0 24 0H2C0.895431 0 0 0.89543 0 2V19C0 20.1046 0.89543 21 2 21H16.3537C16.1367 20.7062 15.9782 20.3668 15.895 20H2C1.44772 20 1 19.5523 1 19V2C1 1.44772 1.44772 1 2 1ZM16.9367 20C17.1147 20.4714 17.4979 20.8424 17.9743 21H24C25.1046 21 26 20.1046 26 19V9.35161H25V19C25 19.5523 24.5523 20 24 20H16.9367ZM25 8.51371H26V6.8379H25V8.51371Z"
                />
            </g>
        ),
    },
    switchLeft: {
        viewBox: '0 0 25 25',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 12.5C24 18.8513 18.8513 24 12.5 24C6.14873 24 1 18.8513 1 12.5C1 6.14873 6.14873 1 12.5 1C18.8513 1 24 6.14873 24 12.5ZM25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5ZM14 7L15.41 8.41L10.83 13L15.41 17.59L14 19L8 13L14 7Z"
            />
        ),
    },
    switchRight: {
        viewBox: '0 0 25 25',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12.5C1 6.14872 6.14873 0.999998 12.5 0.999999C18.8513 0.999999 24 6.14873 24 12.5C24 18.8513 18.8513 24 12.5 24C6.14873 24 1 18.8513 1 12.5ZM0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5ZM11 19L9.59 17.59L14.17 13L9.59 8.41L11 7L17 13L11 19Z"
            />
        ),
    },
    plusBtn: {
        viewBox: '0 0 30 30',
        image: (
            <path d="M4.31197 4.31199C-1.39055 10.0145 -1.39055 19.2334 4.31197 24.9359C10.0145 30.6385 19.2334 30.6385 24.9359 24.9359C30.6384 19.2334 30.6384 10.0145 24.9359 4.31199C19.2334 -1.39053 10.0145 -1.39053 4.31197 4.31199ZM23.4922 14.624C23.4922 15.4283 22.8426 16.0779 22.0383 16.0779L16.0779 16.078L16.0779 22.0383C16.0779 22.8426 15.4283 23.4923 14.6239 23.4923C13.8196 23.4923 13.17 22.8426 13.17 22.0383L13.17 16.078H7.20964C6.4053 16.078 5.75565 15.4283 5.75565 14.624C5.75565 13.8196 6.4053 13.17 7.20964 13.17H13.17L13.17 7.20965C13.17 6.40532 13.8196 5.75567 14.6239 5.75567C15.4283 5.75567 16.0779 6.40532 16.0779 7.20965L16.0779 13.17L22.0383 13.17C22.822 13.17 23.4819 13.8299 23.4922 14.624Z" />
        ),
    },
    addMedia: {
        viewBox: '0 0 29 29',
        image: (
            <path d="M27.03 4.5H24V1.47C24 0.66 23.34 0 22.53 0H22.485C21.66 0 21 0.66 21 1.47V4.5H17.985C17.175 4.5 16.515 5.16 16.5 5.97V6.015C16.5 6.84 17.16 7.5 17.985 7.5H21V10.515C21 11.325 21.66 12 22.485 11.985H22.53C23.34 11.985 24 11.325 24 10.515V7.5H27.03C27.84 7.5 28.5 6.84 28.5 6.03V5.97C28.5 5.16 27.84 4.5 27.03 4.5ZM19.5 10.515V9H17.985C17.19 9 16.44 8.685 15.87 8.13C15.315 7.56 15 6.81 15 5.97C15 5.43 15.15 4.935 15.405 4.5H3C1.35 4.5 0 5.85 0 7.5V25.5C0 27.15 1.35 28.5 3 28.5H21C22.65 28.5 24 27.15 24 25.5V13.08C23.55 13.335 23.04 13.5 22.47 13.5C20.835 13.485 19.5 12.15 19.5 10.515ZM19.44 25.5H4.5C3.885 25.5 3.525 24.795 3.9 24.3L6.87 20.355C7.185 19.935 7.8 19.965 8.1 20.385L10.5 24L14.415 18.78C14.715 18.39 15.3 18.375 15.6 18.765L20.025 24.285C20.415 24.78 20.07 25.5 19.44 25.5Z" />
        ),
    },
    addSoundTrack: {
        viewBox: '0 0 19 20',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.74411 11.8614V2.2486C6.74411 1.01187 7.75598 0 8.99271 0H11.2413C12.478 0 13.4899 1.01187 13.4899 2.2486C13.4899 3.48533 12.478 4.4972 11.2413 4.4972H8.99271V15.5715C8.99271 17.8089 7.42994 19.8326 5.22631 20.1812C2.15697 20.6646 -0.451401 18.0338 0.065777 14.9532C0.335609 13.3792 1.49364 12.0412 3.0002 11.5016C4.38309 11.0181 5.68727 11.2542 6.74411 11.8614ZM15.7386 6.74577H18.0096C18.6168 6.74577 19.1114 7.24046 19.1114 7.84758V7.89255C19.1114 8.49967 18.6168 8.99437 18.0096 8.99437H15.7386V11.2542C15.7386 11.8613 15.2439 12.356 14.6367 12.356H14.603C13.9846 12.3673 13.49 11.8613 13.49 11.2542V8.99437H11.2301C10.6117 8.99437 10.1171 8.49968 10.1171 7.88131V7.84758C10.1283 7.24046 10.623 6.74577 11.2301 6.74577H13.49V4.47468C13.49 3.86756 13.9846 3.37287 14.603 3.37287H14.6367C15.2439 3.37287 15.7386 3.86756 15.7386 4.47468V6.74577Z"
            />
        ),
    },
    sadSmile: {
        viewBox: '0 0 113 64',
        image: (
            <path
                d="M28.75 0.499994C32.1667 0.499994 34.5625 1.37499 35.9375 3.12499C37.3542 4.91666 38.0625 7.08333 38.0625 9.62499C38.0625 12.1667 37.3542 14.3333 35.9375 16.125C34.5625 17.9583 32.1667 18.875 28.75 18.875C25.4167 18.875 23 17.9583 21.5 16.125C20.0417 14.3333 19.3125 12.1667 19.3125 9.62499C19.3125 7.08333 20.0417 4.91666 21.5 3.12499C23 1.37499 25.4167 0.499994 28.75 0.499994ZM82.25 0.499997C85.7083 0.499997 88.1458 1.375 89.5625 3.125C90.9792 4.91666 91.6875 7.08333 91.6875 9.625C91.6875 12.1667 90.9792 14.3333 89.5625 16.125C88.1458 17.9583 85.7083 18.875 82.25 18.875C78.9583 18.875 76.5625 17.9583 75.0625 16.125C73.6042 14.3333 72.875 12.1667 72.875 9.625C72.875 7.08333 73.6042 4.91666 75.0625 3.125C76.5625 1.375 78.9583 0.499997 82.25 0.499997ZM56.0625 32.375C63.0625 32.375 69.8958 33.0417 76.5625 34.375C83.2292 35.75 89.5833 37.8333 95.625 40.625C101.667 43.4167 107.25 46.9375 112.375 51.1875L112.375 64C104.417 58.0417 95.6042 53.5417 85.9375 50.5C76.2708 47.5 66.3542 46 56.1875 46C49.5625 46 43 46.6667 36.5 48C30 49.3333 23.75 51.3333 17.75 54C11.7083 56.6667 6.04166 59.9583 0.749997 63.875L0.749997 51.1875C5.75 46.9375 11.2083 43.4167 17.125 40.625C23.0417 37.8333 29.2917 35.75 35.875 34.375C42.4583 33.0417 49.1875 32.375 56.0625 32.375Z"
                fill="#E7E7E7"
            />
        ),
    },
    licenseBlocked: {
        viewBox: '0 0 316 61',
        image: (
            <svg width="316" height="61" viewBox="0 0 316 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_1323_689)">
                    <rect x="4" y="12" width="308" height="28" rx="2" fill="#FF8B02" />
                    <mask id="mask0_1323_689" maskUnits="userSpaceOnUse" x="4" y="12" width="308" height="28">
                        <rect x="4" y="12" width="308" height="28" rx="2" fill="#FF8B02" />
                    </mask>
                    <g mask="url(#mask0_1323_689)">
                        <g filter="url(#filter1_d_1323_689)">
                            <circle cx="157.5" cy="26.5" r="26.5" fill="#FF8B02" />
                        </g>
                    </g>
                    <circle cx="157.5" cy="26.5" r="26.5" fill="#FF8B02" />
                    <g clip-path="url(#clip0_1323_689)" filter="url(#filter2_i_1323_689)">
                        <path
                            d="M163 22H162V20C162 17.24 159.76 15 157 15C154.24 15 152 17.24 152 20V22H151C149.9 22 149 22.9 149 24V34C149 35.1 149.9 36 151 36H163C164.1 36 165 35.1 165 34V24C165 22.9 164.1 22 163 22ZM157 31C155.9 31 155 30.1 155 29C155 27.9 155.9 27 157 27C158.1 27 159 27.9 159 29C159 30.1 158.1 31 157 31ZM154 22V20C154 18.34 155.34 17 157 17C158.66 17 160 18.34 160 20V22H154Z"
                            fill="#494848"
                        />
                    </g>
                </g>
                <defs>
                    <filter
                        id="filter0_d_1323_689"
                        x="0"
                        y="0"
                        width="316"
                        height="61"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1323_689" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1323_689" result="shape" />
                    </filter>
                    <filter
                        id="filter1_d_1323_689"
                        x="127"
                        y="-4"
                        width="61"
                        height="61"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1323_689" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1323_689" result="shape" />
                    </filter>
                    <filter
                        id="filter2_i_1323_689"
                        x="145"
                        y="14"
                        width="24"
                        height="28"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1323_689" />
                    </filter>
                    <clipPath id="clip0_1323_689">
                        <rect width="24" height="24" fill="white" transform="translate(145 14)" />
                    </clipPath>
                </defs>
            </svg>
        ),
    },
    licenses: {
        viewBox: '0 0 24 24',
        image: (
            <path d="M20.4699 5.63005C20.8599 6.02005 20.8599 6.64005 20.4699 7.03005L9.12995 18.37C8.73995 18.76 8.11995 18.76 7.72995 18.37L3.52995 14.17C3.13995 13.78 3.13995 13.16 3.52995 12.77C3.91995 12.38 4.53995 12.38 4.92995 12.77L8.42995 16.27L19.07 5.63005C19.46 5.24005 20.0799 5.24005 20.4699 5.63005ZM18.36 3.51005L8.42995 13.44L5.63995 10.65C4.85995 9.87005 3.58995 9.87005 2.80995 10.65L1.40995 12.05C0.629951 12.83 0.629951 14.1 1.40995 14.88L7.00995 20.48C7.78995 21.26 9.05995 21.26 9.83995 20.48L22.59 7.74005C23.37 6.96005 23.37 5.69005 22.59 4.91005L21.19 3.51005C20.4 2.73005 19.14 2.73005 18.36 3.51005V3.51005Z" />
        ),
    },
    triangleUp: {
        viewBox: '0 0 8 5',
        image: (
            <path d="M0.710051 3.28997L3.30005 0.699971C3.69005 0.309971 4.32005 0.309971 4.71005 0.699971L7.30005 3.28997C7.93005 3.91997 7.48005 4.99997 6.59005 4.99997H1.41005C0.520051 4.99997 0.0800515 3.91997 0.710051 3.28997Z" />
        ),
    },
    triangleDown: {
        viewBox: '0 0 8 5',
        image: (
            <path d="M0.710051 2.1175L3.30005 4.7075C3.69005 5.0975 4.32005 5.0975 4.71005 4.7075L7.30005 2.1175C7.93005 1.4875 7.48005 0.4075 6.59005 0.4075H1.41005C0.520051 0.4075 0.0800515 1.4875 0.710051 2.1175Z" />
        ),
    },
    wigetsGallery: {
        viewBox: '0 0 30 22',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7404 17.798L18.8734 17.8337L18.7037 18.4667C18.6104 18.8149 18.8299 19.1791 19.1915 19.276L23.136 20.3329C23.4976 20.4298 23.8698 20.2242 23.9631 19.876L24.1327 19.2429L25.4475 19.5952L25.2779 20.2283C25.1846 20.5764 25.4041 20.9406 25.7657 21.0375C26.1272 21.1344 26.4994 20.9288 26.5927 20.5806L29.3068 10.4515C29.4001 10.1033 29.1806 9.7392 28.819 9.6423C28.4574 9.54543 28.0853 9.75104 27.992 10.0992L27.8223 10.7323L26.5075 10.38L26.6771 9.7469C26.7704 9.39873 26.5509 9.03458 26.1893 8.93768L23.9034 8.32516C23.8721 10.1353 23.1646 12.0128 21.9051 13.9386C21.0918 15.1822 20.0339 16.4684 18.7404 17.798ZM10.568 17.2781C11.1302 17.8808 11.7417 18.4925 12.4017 19.1133C12.2133 19.548 11.7959 19.8679 11.2931 19.906L2.11013 20.6012C1.38861 20.6558 0.75359 20.1102 0.698967 19.3886L0.00376886 10.2057C-0.0508538 9.48416 0.494789 8.84914 1.21631 8.79451L5.9084 8.4393C5.96676 10.2141 6.67069 12.053 7.90228 13.9382C8.29979 14.5466 8.75574 15.1653 9.26904 15.7943L8.18321 14.5539C8.03861 14.3867 7.77624 14.4066 7.65797 14.5871L5.82273 17.3581L4.31965 15.8029C4.16949 15.6494 3.92074 15.6748 3.80902 15.8548L2.33467 18.0774C2.18052 18.3067 2.35521 18.6102 2.6307 18.5893L10.4953 17.9939C10.7642 17.9736 10.8983 17.6534 10.7179 17.4493L10.568 17.2781ZM6.90661 8.36372C6.90517 8.30901 6.90446 8.25439 6.90446 8.2C6.90446 3.8425 9.81383 0.832504 13.3548 0.148087C13.8607 0.0503082 14.3795 0 14.9045 0C18.842 0 22.4279 2.83008 22.8608 7.28723C22.8852 7.53879 22.8996 7.79552 22.9034 8.05722C22.9041 8.10464 22.9045 8.15224 22.9045 8.2C22.9045 10.3631 21.7709 12.7853 19.5068 15.4698C19.2485 15.776 18.9755 16.0856 18.6878 16.3987C18.3542 16.7617 18.0008 17.1293 17.6277 17.5016C17.5942 17.5349 17.5607 17.5683 17.5269 17.6017C17.2074 17.9181 16.8738 18.2378 16.5259 18.5608C16.2166 18.8479 15.8962 19.1376 15.5645 19.43C15.1845 19.76 14.6145 19.76 14.2345 19.43C14.2344 19.43 14.2344 19.4299 14.2343 19.4299C13.6244 18.8912 13.0524 18.3614 12.5184 17.8404C8.85331 14.265 6.97851 11.1083 6.90661 8.36372ZM14.9045 10C16.0045 10 16.9045 9.10001 16.9045 8C16.9045 6.89999 16.0045 6 14.9045 6C13.8045 6 12.9045 6.89999 12.9045 8C12.9045 9.10001 13.8045 10 14.9045 10ZM24.4719 17.9768L25.7868 18.3291L26.126 17.0629L24.8112 16.7106L24.4719 17.9768ZM25.1505 15.4445L26.4653 15.7968L26.8045 14.5307L25.4897 14.1784L25.1505 15.4445ZM25.829 12.9122L27.1438 13.2645L27.4831 11.9984L26.1682 11.6461L25.829 12.9122Z"
            />
        ),
    },
    addNewFolder: {
        viewBox: '0 0 32 16',
        image: (
            <g>
                <path d="M8.59 0.59C8.21 0.21 7.7 0 7.17 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2H10L8.59 0.59Z" />
                <path d="M31.2143 9.28571H27.2857V13.2143C27.2857 13.6464 26.9321 14 26.5 14C26.0679 14 25.7143 13.6464 25.7143 13.2143V9.28571H21.7857C21.3536 9.28571 21 8.93214 21 8.5C21 8.06786 21.3536 7.71429 21.7857 7.71429H25.7143V3.78571C25.7143 3.35357 26.0679 3 26.5 3C26.9321 3 27.2857 3.35357 27.2857 3.78571V7.71429H31.2143C31.6464 7.71429 32 8.06786 32 8.5C32 8.93214 31.6464 9.28571 31.2143 9.28571Z" />
            </g>
        ),
    },
    addNewWidget: {
        viewBox: '0 0 32 19',
        image: (
            <g>
                <path d="M10 11.8925V17.8925C10 18.4425 10.45 18.8925 11 18.8925H17C17.55 18.8925 18 18.4425 18 17.8925V11.8925C18 11.3425 17.55 10.8925 17 10.8925H11C10.45 10.8925 10 11.3425 10 11.8925ZM1 18.8925H7C7.55 18.8925 8 18.4425 8 17.8925V11.8925C8 11.3425 7.55 10.8925 7 10.8925H1C0.45 10.8925 0 11.3425 0 11.8925V17.8925C0 18.4425 0.45 18.8925 1 18.8925ZM0 1.8925V7.8925C0 8.4425 0.45 8.8925 1 8.8925H7C7.55 8.8925 8 8.4425 8 7.8925V1.8925C8 1.3425 7.55 0.8925 7 0.8925H1C0.45 0.8925 0 1.3425 0 1.8925ZM12.95 0.2925L8.7 4.5325C8.31 4.9225 8.31 5.5525 8.7 5.9425L12.95 10.1925C13.34 10.5825 13.97 10.5825 14.36 10.1925L18.61 5.9425C19 5.5525 19 4.9225 18.61 4.5325L14.37 0.2925C13.98 -0.0975 13.34 -0.0975 12.95 0.2925V0.2925Z" />
                <path d="M31.2143 10.2857H27.2857V14.2143C27.2857 14.6464 26.9321 15 26.5 15C26.0679 15 25.7143 14.6464 25.7143 14.2143V10.2857H21.7857C21.3536 10.2857 21 9.93214 21 9.5C21 9.06786 21.3536 8.71429 21.7857 8.71429H25.7143V4.78571C25.7143 4.35357 26.0679 4 26.5 4C26.9321 4 27.2857 4.35357 27.2857 4.78571V8.71429H31.2143C31.6464 8.71429 32 9.06786 32 9.5C32 9.93214 31.6464 10.2857 31.2143 10.2857Z" />
            </g>
        ),
    },
    instruction: {
        viewBox: '0 0 16 20',
        image: (
            <path d="M10.59 0.59C10.21 0.21 9.7 0 9.17 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6.83C16 6.3 15.79 5.79 15.41 5.42L10.59 0.59ZM11 16H5C4.45 16 4 15.55 4 15C4 14.45 4.45 14 5 14H11C11.55 14 12 14.45 12 15C12 15.55 11.55 16 11 16ZM11 12H5C4.45 12 4 11.55 4 11C4 10.45 4.45 10 5 10H11C11.55 10 12 10.45 12 11C12 11.55 11.55 12 11 12ZM9 6V1.5L14.5 7H10C9.45 7 9 6.55 9 6Z" />
        ),
    },
    beta: {
        viewBox: '0 0 35 12',
        image: (
            <g>
                <path d="M4.25781 13.1562C3.7526 13.1562 3.30729 13.0234 2.92188 12.7578C2.54167 12.4922 2.25521 12.1302 2.0625 11.6719H1.98438L1.4375 13H0.460938L3.03906 0.84375H4.35156C4.08594 2.10417 3.88021 3.07031 3.73438 3.74219C3.59375 4.40885 3.39844 5.1901 3.14844 6.08594H3.21875C3.70312 5.47135 4.17969 5.02083 4.64844 4.73438C5.1224 4.44271 5.60938 4.29688 6.10938 4.29688C6.84375 4.29688 7.41667 4.55469 7.82812 5.07031C8.23958 5.58594 8.44531 6.29427 8.44531 7.19531C8.44531 8.28385 8.26562 9.29167 7.90625 10.2188C7.55208 11.1406 7.05469 11.862 6.41406 12.3828C5.77865 12.8984 5.0599 13.1562 4.25781 13.1562ZM5.71094 5.38281C5.21094 5.38281 4.70052 5.63021 4.17969 6.125C3.66406 6.61979 3.2526 7.24219 2.94531 7.99219C2.64323 8.74219 2.49219 9.51042 2.49219 10.2969C2.49219 10.8698 2.63542 11.3099 2.92188 11.6172C3.21354 11.9193 3.63281 12.0703 4.17969 12.0703C4.69531 12.0703 5.17448 11.8594 5.61719 11.4375C6.0651 11.0156 6.42448 10.4167 6.69531 9.64062C6.96615 8.85938 7.10156 8.03125 7.10156 7.15625C7.10156 5.97396 6.63802 5.38281 5.71094 5.38281Z" />
                <path d="M14.6781 13.1562C13.7198 13.1562 12.9672 12.8724 12.4203 12.3047C11.8734 11.737 11.6 10.9505 11.6 9.94531C11.6 8.96615 11.7927 8.02865 12.1781 7.13281C12.5688 6.23177 13.0844 5.53125 13.725 5.03125C14.3656 4.53125 15.0714 4.28125 15.8422 4.28125C16.6391 4.28125 17.238 4.45573 17.6391 4.80469C18.0401 5.14844 18.2406 5.63021 18.2406 6.25C18.2406 7.1875 17.8083 7.92448 16.9438 8.46094C16.0792 8.99219 14.8422 9.25781 13.2328 9.25781H12.975L12.9438 9.88281C12.9438 10.5651 13.1026 11.099 13.4203 11.4844C13.7432 11.8646 14.2406 12.0547 14.9125 12.0547C15.2406 12.0547 15.5766 12.0078 15.9203 11.9141C16.2693 11.8203 16.7016 11.6484 17.2172 11.3984V12.5391C16.7276 12.7682 16.2953 12.9271 15.9203 13.0156C15.5453 13.1094 15.1313 13.1562 14.6781 13.1562ZM15.7641 5.39844C15.2276 5.39844 14.7224 5.64323 14.2484 6.13281C13.7797 6.6224 13.4203 7.30208 13.1703 8.17188H13.2641C14.4516 8.17188 15.3604 8.01823 15.9906 7.71094C16.626 7.39844 16.9438 6.94792 16.9438 6.35938C16.9438 6.08333 16.8474 5.85417 16.6547 5.67188C16.4672 5.48958 16.1703 5.39844 15.7641 5.39844Z" />
                <path d="M23.4109 12.0859C23.6974 12.0859 24.0724 12.0182 24.5359 11.8828V12.8906C24.3589 12.9635 24.1401 13.026 23.8797 13.0781C23.6193 13.1302 23.4109 13.1562 23.2547 13.1562C22.6036 13.1562 22.1036 13.0026 21.7547 12.6953C21.4109 12.3828 21.2391 11.9193 21.2391 11.3047C21.2391 10.9609 21.2859 10.5703 21.3797 10.1328L22.3719 5.42969H21.0281L21.1375 4.85938L22.5828 4.25L23.5594 2.46875H24.325L23.8953 4.4375H26.0359L25.8328 5.42969H23.7L22.6922 10.1484C22.5984 10.6016 22.5516 10.9453 22.5516 11.1797C22.5516 11.4714 22.6271 11.6953 22.7781 11.8516C22.9292 12.0078 23.1401 12.0859 23.4109 12.0859Z" />
                <path d="M32.1047 4.28125C32.5839 4.28125 33.0109 4.41146 33.3859 4.67188C33.7609 4.92708 34.0526 5.29688 34.2609 5.78125H34.3469L34.8703 4.4375H35.8625L34.0422 13H33.0031L33.2062 11.3672H33.1437C32.2115 12.5599 31.2297 13.1562 30.1984 13.1562C29.4745 13.1562 28.9068 12.8984 28.4953 12.3828C28.0839 11.8672 27.8781 11.1615 27.8781 10.2656C27.8781 9.18229 28.063 8.17708 28.4328 7.25C28.8026 6.32292 29.313 5.59635 29.9641 5.07031C30.6151 4.54427 31.3286 4.28125 32.1047 4.28125ZM30.6203 12.0703C31.1255 12.0703 31.6281 11.8307 32.1281 11.3516C32.6281 10.8672 33.0344 10.2396 33.3469 9.46875C33.6594 8.69271 33.8156 7.91667 33.8156 7.14062C33.8156 6.60417 33.6698 6.17708 33.3781 5.85938C33.0865 5.54167 32.7036 5.38281 32.2297 5.38281C31.688 5.38281 31.1828 5.60677 30.7141 6.05469C30.2505 6.5026 29.8859 7.10938 29.6203 7.875C29.3547 8.64062 29.2219 9.44792 29.2219 10.2969C29.2219 10.8906 29.3443 11.3359 29.5891 11.6328C29.8339 11.9245 30.1776 12.0703 30.6203 12.0703Z" />
            </g>
        ),
    },
    displayIcon: {
        viewBox: '0 0 36 26',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36 5C36 2.23858 33.7614 0 31 0H5C2.23857 0 0 2.23858 0 5V21C0 23.7614 2.23857 26 5 26L31 26C33.7614 26 36 23.7614 36 21V5ZM8 7C6.89543 7 6 7.89543 6 9V17C6 18.1046 6.89543 19 8 19H28C29.1046 19 30 18.1046 30 17V9C30 7.89543 29.1046 7 28 7H8Z"
            />
        ),
    },
    infoFill: {
        viewBox: '0 0 16 16',
        image: (
            <path d="M8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.499999C3.86 0.499999 0.500001 3.86 0.500001 8C0.5 12.14 3.86 15.5 8 15.5ZM8 7.25C8.4125 7.25 8.75 7.5875 8.75 8L8.75 11C8.75 11.4125 8.4125 11.75 8 11.75C7.5875 11.75 7.25 11.4125 7.25 11L7.25 8C7.25 7.5875 7.5875 7.25 8 7.25ZM7.25 4.25L8.75 4.25L8.75 5.75L7.25 5.75L7.25 4.25Z" />
        ),
    },
    widgetsGallery: {
        viewBox: '0 0 30 22',
        image: (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7404 17.798L18.8734 17.8337L18.7037 18.4667C18.6104 18.8149 18.8299 19.1791 19.1915 19.276L23.136 20.3329C23.4976 20.4298 23.8698 20.2242 23.9631 19.876L24.1327 19.2429L25.4475 19.5952L25.2779 20.2283C25.1846 20.5764 25.4041 20.9406 25.7657 21.0375C26.1272 21.1344 26.4994 20.9288 26.5927 20.5806L29.3068 10.4515C29.4001 10.1033 29.1806 9.7392 28.819 9.6423C28.4574 9.54543 28.0853 9.75104 27.992 10.0992L27.8223 10.7323L26.5075 10.38L26.6771 9.7469C26.7704 9.39873 26.5509 9.03458 26.1893 8.93768L23.9034 8.32516C23.8721 10.1353 23.1646 12.0128 21.9051 13.9386C21.0918 15.1822 20.0339 16.4684 18.7404 17.798ZM10.568 17.2781C11.1302 17.8808 11.7417 18.4925 12.4017 19.1133C12.2133 19.548 11.7959 19.8679 11.2931 19.906L2.11013 20.6012C1.38861 20.6558 0.75359 20.1102 0.698967 19.3886L0.00376886 10.2057C-0.0508538 9.48416 0.494789 8.84914 1.21631 8.79451L5.9084 8.4393C5.96676 10.2141 6.67069 12.053 7.90228 13.9382C8.29979 14.5466 8.75574 15.1653 9.26904 15.7943L8.18321 14.5539C8.03861 14.3867 7.77624 14.4066 7.65797 14.5871L5.82273 17.3581L4.31965 15.8029C4.16949 15.6494 3.92074 15.6748 3.80902 15.8548L2.33467 18.0774C2.18052 18.3067 2.35521 18.6102 2.6307 18.5893L10.4953 17.9939C10.7642 17.9736 10.8983 17.6534 10.7179 17.4493L10.568 17.2781ZM6.90661 8.36372C6.90517 8.30901 6.90446 8.25439 6.90446 8.2C6.90446 3.8425 9.81383 0.832504 13.3548 0.148087C13.8607 0.0503082 14.3795 0 14.9045 0C18.842 0 22.4279 2.83008 22.8608 7.28723C22.8852 7.53879 22.8996 7.79552 22.9034 8.05722C22.9041 8.10464 22.9045 8.15224 22.9045 8.2C22.9045 10.3631 21.7709 12.7853 19.5068 15.4698C19.2485 15.776 18.9755 16.0856 18.6878 16.3987C18.3542 16.7617 18.0008 17.1293 17.6277 17.5016C17.5942 17.5349 17.5607 17.5683 17.5269 17.6017C17.2074 17.9181 16.8738 18.2378 16.5259 18.5608C16.2166 18.8479 15.8962 19.1376 15.5645 19.43C15.1845 19.76 14.6145 19.76 14.2345 19.43C14.2344 19.43 14.2344 19.4299 14.2343 19.4299C13.6244 18.8912 13.0524 18.3614 12.5184 17.8404C8.85331 14.265 6.97851 11.1083 6.90661 8.36372ZM14.9045 10C16.0045 10 16.9045 9.10001 16.9045 8C16.9045 6.89999 16.0045 6 14.9045 6C13.8045 6 12.9045 6.89999 12.9045 8C12.9045 9.10001 13.8045 10 14.9045 10ZM24.4719 17.9768L25.7868 18.3291L26.126 17.0629L24.8112 16.7106L24.4719 17.9768ZM25.1505 15.4445L26.4653 15.7968L26.8045 14.5307L25.4897 14.1784L25.1505 15.4445ZM25.829 12.9122L27.1438 13.2645L27.4831 11.9984L26.1682 11.6461L25.829 12.9122Z"
            />
        ),
    },
    display_off: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path
                    id="Vector"
                    d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM20 17H4C3.45 17 3 16.55 3 16V6C3 5.45 3.45 5 4 5H20C20.55 5 21 5.45 21 6V16C21 16.55 20.55 17 20 17Z"
                />
                <g id="off">
                    <path d="M10.1988 11.7732C10.1988 12.4738 10.0132 13.0208 9.64192 13.414C9.27315 13.8047 8.75588 14 8.09011 14C7.45157 14 6.94296 13.7996 6.56429 13.3989C6.1881 12.9981 6 12.4562 6 11.7732C6 11.075 6.18439 10.5331 6.55316 10.1474C6.9244 9.75929 7.44414 9.56522 8.11239 9.56522C8.52571 9.56522 8.89076 9.65469 9.20756 9.83365C9.52436 10.0126 9.76814 10.2697 9.93891 10.6049C10.1122 10.9376 10.1988 11.327 10.1988 11.7732ZM7.47384 11.7732C7.47384 12.1411 7.52211 12.4222 7.61863 12.6163C7.71515 12.8078 7.87726 12.9036 8.10496 12.9036C8.33018 12.9036 8.48858 12.8078 8.58016 12.6163C8.6742 12.4222 8.72123 12.1411 8.72123 11.7732C8.72123 11.4077 8.6742 11.1317 8.58016 10.9452C8.48611 10.7587 8.32523 10.6654 8.09754 10.6654C7.87479 10.6654 7.71515 10.7587 7.61863 10.9452C7.52211 11.1292 7.47384 11.4052 7.47384 11.7732Z" />
                    <path d="M13.5994 10.7486H12.7047V13.9244H11.2531V10.7486H10.6963V10.0227L11.2828 9.65974V9.5879C11.2828 9.02331 11.3954 8.61752 11.6207 8.37051C11.8484 8.1235 12.2122 8 12.7121 8C12.9052 8 13.0871 8.01512 13.2578 8.04537C13.4311 8.07561 13.6316 8.12854 13.8593 8.20416L13.5474 9.16068C13.3692 9.11027 13.1947 9.08507 13.024 9.08507C12.9126 9.08507 12.8309 9.12035 12.7789 9.19093C12.7294 9.25898 12.7047 9.37114 12.7047 9.52741V9.64083H13.5994V10.7486ZM16.7401 10.7486H15.8454V13.9244H14.3939V10.7486H13.837V10.0227L14.4236 9.65974V9.5879C14.4236 9.02331 14.5362 8.61752 14.7614 8.37051C14.9891 8.1235 15.3529 8 15.8529 8C16.0459 8 16.2278 8.01512 16.3986 8.04537C16.5718 8.07561 16.7723 8.12854 17 8.20416L16.6882 9.16068C16.51 9.11027 16.3355 9.08507 16.1647 9.08507C16.0533 9.08507 15.9717 9.12035 15.9197 9.19093C15.8702 9.25898 15.8454 9.37114 15.8454 9.52741V9.64083H16.7401V10.7486Z" />
                </g>
            </g>
        ),
    },
    display_on: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path
                    id="Vector"
                    d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM20 17H4C3.45 17 3 16.55 3 16V6C3 5.45 3.45 5 4 5H20C20.55 5 21 5.45 21 6V16C21 16.55 20.55 17 20 17Z"
                />
                <g id="on">
                    <path d="M11.5957 11.4893C11.5957 12.2793 11.3925 12.896 10.9862 13.3393C10.5826 13.7798 10.0164 14 9.28769 14C8.58879 14 8.0321 13.7741 7.61764 13.3223C7.20588 12.8704 7 12.2594 7 11.4893C7 10.7022 7.20181 10.0912 7.60544 9.65644C8.01178 9.21881 8.58066 9 9.31207 9C9.76446 9 10.164 9.10088 10.5108 9.30264C10.8575 9.5044 11.1243 9.79426 11.3113 10.1722C11.5009 10.5473 11.5957 10.9864 11.5957 11.4893ZM8.61317 11.4893C8.61317 11.9042 8.66599 12.2211 8.77164 12.4399C8.87729 12.6559 9.05472 12.7639 9.30394 12.7639C9.55045 12.7639 9.72382 12.6559 9.82406 12.4399C9.92699 12.2211 9.97846 11.9042 9.97846 11.4893C9.97846 11.0773 9.92699 10.7661 9.82406 10.5558C9.72112 10.3456 9.54504 10.2404 9.29581 10.2404C9.05201 10.2404 8.87729 10.3456 8.77164 10.5558C8.66599 10.7633 8.61317 11.0745 8.61317 11.4893Z" />
                    <path d="M15.4112 13.9147V11.2805C15.4112 10.9594 15.3665 10.7178 15.2771 10.5558C15.1904 10.391 15.0496 10.3086 14.8545 10.3086C14.5863 10.3086 14.3927 10.4209 14.2735 10.6454C14.1543 10.8698 14.0947 11.2549 14.0947 11.8005V13.9147H12.5059V9.08525H13.7046L13.9037 9.68201H13.9972C14.1326 9.45467 14.3195 9.28417 14.5579 9.1705C14.799 9.05683 15.0753 9 15.3868 9C15.8961 9 16.2916 9.15487 16.5733 9.46462C16.8578 9.77437 17 10.2106 17 10.7732V13.9147H15.4112Z" />
                </g>
            </g>
        ),
    },
    display_on_off: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M7.75742 7.99361C7.75742 8.4676 7.63551 8.8376 7.39171 9.10358C7.14953 9.36786 6.80983 9.5 6.37261 9.5C5.95327 9.5 5.61926 9.36445 5.37058 9.09335C5.12353 8.82225 5 8.45567 5 7.99361C5 7.52131 5.12109 7.15473 5.36327 6.89386C5.60707 6.63129 5.94839 6.5 6.38724 6.5C6.65868 6.5 6.89842 6.56053 7.10646 6.68159C7.31451 6.80264 7.4746 6.97656 7.58675 7.20332C7.70053 7.42839 7.75742 7.69182 7.75742 7.99361ZM5.9679 7.99361C5.9679 8.24254 5.99959 8.43265 6.06298 8.56394C6.12637 8.69352 6.23283 8.75831 6.38236 8.75831C6.53027 8.75831 6.6343 8.69352 6.69443 8.56394C6.7562 8.43265 6.78708 8.24254 6.78708 7.99361C6.78708 7.74638 6.7562 7.55968 6.69443 7.4335C6.63267 7.30733 6.52702 7.24425 6.37749 7.24425C6.23121 7.24425 6.12637 7.30733 6.06298 7.4335C5.99959 7.55797 5.9679 7.74467 5.9679 7.99361Z" />
                <path d="M10.0467 9.44885V7.86829C10.0467 7.67562 10.0199 7.53069 9.96627 7.4335C9.91426 7.33461 9.82974 7.28517 9.71272 7.28517C9.55181 7.28517 9.4356 7.35251 9.36408 7.48721C9.29256 7.62191 9.25681 7.85294 9.25681 8.18031V9.44885H8.30354V6.55115H9.02276L9.14222 6.90921H9.19829C9.27956 6.7728 9.39171 6.6705 9.53474 6.6023C9.6794 6.5341 9.84519 6.5 10.0321 6.5C10.3377 6.5 10.575 6.59292 10.744 6.77877C10.9147 6.96462 11 7.22634 11 7.56394V9.44885H10.0467Z" />
                <path d="M21.7273 10H10.2727C9.57273 10 9 10.55 9 11.2222V18.5556C9 19.2278 9.57273 19.7778 10.2727 19.7778H13.4545V20.3889C13.4545 20.725 13.7409 21 14.0909 21H17.9091C18.2591 21 18.5455 20.725 18.5455 20.3889V19.7778H21.7273C22.4273 19.7778 22.9936 19.2278 22.9936 18.5556L23 11.2222C23 10.55 22.4273 10 21.7273 10ZM21.0909 18.5556H10.9091C10.5591 18.5556 10.2727 18.2806 10.2727 17.9444V11.8333C10.2727 11.4972 10.5591 11.2222 10.9091 11.2222H21.0909C21.4409 11.2222 21.7273 11.4972 21.7273 11.8333V17.9444C21.7273 18.2806 21.4409 18.5556 21.0909 18.5556Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.27273 3H13.7273C14.4273 3 15 3.55 15 4.22222L14.995 10H13.7273V4.83333C13.7273 4.49722 13.4409 4.22222 13.0909 4.22222H2.90909C2.55909 4.22222 2.27273 4.49722 2.27273 4.83333V10.9444C2.27273 11.2806 2.55909 11.5556 2.90909 11.5556H9V14H6.09091C5.74091 14 5.45455 13.725 5.45455 13.3889V12.7778H2.27273C1.57273 12.7778 1 12.2278 1 11.5556V4.22222C1 3.55 1.57273 3 2.27273 3Z"
                />
                <path d="M15.0537 15.5154C15.0537 15.9826 14.9187 16.3472 14.6487 16.6093C14.3805 16.8698 14.0043 17 13.5201 17C13.0557 17 12.6858 16.8664 12.4104 16.5992C12.1368 16.3321 12 15.9708 12 15.5154C12 15.05 12.1341 14.6887 12.4023 14.4316C12.6723 14.1729 13.0503 14.0435 13.5363 14.0435C13.8369 14.0435 14.1024 14.1031 14.3328 14.2224C14.5632 14.3417 14.7405 14.5131 14.8647 14.7366C14.9907 14.9584 15.0537 15.218 15.0537 15.5154ZM13.0719 15.5154C13.0719 15.7608 13.107 15.9481 13.1772 16.0775C13.2474 16.2052 13.3653 16.2691 13.5309 16.2691C13.6947 16.2691 13.8099 16.2052 13.8765 16.0775C13.9449 15.9481 13.9791 15.7608 13.9791 15.5154C13.9791 15.2718 13.9449 15.0878 13.8765 14.9635C13.8081 14.8391 13.6911 14.7769 13.5255 14.7769C13.3635 14.7769 13.2474 14.8391 13.1772 14.9635C13.107 15.0861 13.0719 15.2701 13.0719 15.5154Z" />
                <path d="M17.5268 14.8324H16.8761V16.9496H15.8205V14.8324H15.4155V14.3485L15.8421 14.1065V14.0586C15.8421 13.6822 15.924 13.4117 16.0877 13.247C16.2533 13.0823 16.5179 13 16.8815 13C17.0219 13 17.1542 13.0101 17.2784 13.0302C17.4044 13.0504 17.5502 13.0857 17.7158 13.1361L17.489 13.7738C17.3594 13.7402 17.2325 13.7234 17.1083 13.7234C17.0273 13.7234 16.9679 13.7469 16.9301 13.794C16.8941 13.8393 16.8761 13.9141 16.8761 14.0183V14.0939H17.5268V14.8324ZM19.811 14.8324H19.1603V16.9496H18.1046V14.8324H17.6996V14.3485L18.1262 14.1065V14.0586C18.1262 13.6822 18.2081 13.4117 18.3719 13.247C18.5375 13.0823 18.8021 13 19.1657 13C19.3061 13 19.4384 13.0101 19.5626 13.0302C19.6886 13.0504 19.8344 13.0857 20 13.1361L19.7732 13.7738C19.6436 13.7402 19.5167 13.7234 19.3925 13.7234C19.3115 13.7234 19.2521 13.7469 19.2143 13.794C19.1783 13.8393 19.1603 13.9141 19.1603 14.0183V14.0939H19.811V14.8324Z" />
            </g>
        ),
    },
    webEngineInfo: {
        viewBox: '0 0 27 27',
        image: (
            <g id="language" clip-path="url(#clip0_3_1057)">
                <path
                    id="Subtract"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.25 13.5C2.25 7.29 7.27875 2.25 13.4887 2.25C18.7632 2.25 23.1886 5.87267 24.4134 10.7597C23.3826 10.2352 22.1534 10 20.7772 10C19.3595 10 18.0755 10.2416 16.9525 10.7591C16.6308 10.9033 16.325 11.067 16.0354 11.25H10.8675C10.7662 11.9812 10.6875 12.735 10.6875 13.5C10.6875 14.265 10.7662 15.0075 10.8675 15.75H16.1325C16.1447 15.6609 16.1565 15.5717 16.1679 15.4825L17.3232 16.2189L17.8764 15.4588C18.0556 15.2125 18.2623 15.0014 18.5019 14.828C18.4755 15.1364 18.4422 15.4432 18.405 15.75H22.0279L22.0249 15.754C21.8439 15.9944 21.5263 16.3254 21.0365 16.7527L21.0345 16.7544C20.5531 17.1766 20.1329 17.5917 19.7823 18H17.9663C17.6063 19.4062 17.0887 20.7562 16.4137 22.005C17.217 21.73 17.9677 21.3449 18.6488 20.868C18.6478 20.9119 18.6473 20.9558 18.6473 21V22H19.8222C19.559 22.1177 19.3133 22.2796 19.0908 22.4885L19.0827 22.4961L19.0748 22.5038C18.7464 22.8262 18.5242 23.2056 18.4064 23.6233C16.9207 24.3451 15.2522 24.75 13.4887 24.75C7.27875 24.75 2.25 19.71 2.25 13.5ZM22.4443 20.3209C22.4443 20.3209 22.4443 20.321 22.4442 20.321C22.5081 20.0964 22.6062 19.8903 22.7384 19.7029C22.875 19.5195 23.0461 19.3218 23.2518 19.1098C23.2518 19.1098 23.2518 19.1099 23.2518 19.1099C23.0461 19.3218 22.875 19.5195 22.7384 19.7029C22.6062 19.8903 22.5082 20.0963 22.4443 20.3209ZM24.6624 12.0907C24.6327 12.0686 24.6025 12.0467 24.5718 12.0251C24.253 11.7928 23.8964 11.6001 23.5021 11.4467C23.8964 11.6001 24.2529 11.7929 24.5717 12.0251C24.6024 12.0467 24.6327 12.0686 24.6625 12.0908C24.6625 12.0908 24.6624 12.0907 24.6624 12.0907ZM18.5617 13.6444C17.9653 13.9127 17.4674 14.3213 17.0678 14.8703L17.0679 14.8703C17.4674 14.3214 17.9654 13.9127 18.5617 13.6444C18.5617 13.6444 18.5617 13.6444 18.5617 13.6444ZM17.9663 9H21.285C20.205 7.14375 18.4837 5.70375 16.4137 4.995C17.0887 6.24375 17.6063 7.59375 17.9663 9ZM15.6488 9C15.165 7.39125 14.4338 5.895 13.5 4.545C12.5662 5.895 11.835 7.39125 11.3512 9H15.6488ZM4.5 13.5C4.5 14.2762 4.6125 15.03 4.7925 15.75H8.595C8.505 15.0075 8.4375 14.265 8.4375 13.5C8.4375 12.735 8.505 11.9925 8.595 11.25H4.7925C4.6125 11.97 4.5 12.7238 4.5 13.5ZM9.03375 18H5.715C6.795 19.8675 8.51625 21.2962 10.5863 22.005C9.91125 20.7562 9.39375 19.4062 9.03375 18ZM5.715 9H9.03375C9.39375 7.59375 9.91125 6.24375 10.5863 4.995C8.51625 5.70375 6.795 7.1325 5.715 9ZM11.3512 18C11.835 19.6087 12.5662 21.105 13.5 22.455C14.4338 21.105 15.165 19.6087 15.6488 18H11.3512Z"
                />
                <path
                    id="?"
                    d="M19.6473 21C19.6473 20.2469 19.8178 19.6262 20.1589 19.1381C20.5142 18.636 21.0258 18.0921 21.6938 17.5063C22.2054 17.06 22.582 16.6764 22.8236 16.3556C23.0795 16.0209 23.2074 15.6444 23.2074 15.2259C23.2074 14.6402 22.9658 14.166 22.4826 13.8033C21.9994 13.4407 21.3527 13.2594 20.5426 13.2594C19.0078 13.2594 17.8495 13.7964 17.0678 14.8703L15 13.5523C15.6111 12.7294 16.3999 12.1018 17.3663 11.6695C18.3327 11.2232 19.4696 11 20.7771 11C22.3689 11 23.6337 11.3417 24.5717 12.0251C25.5239 12.6946 26 13.622 26 14.8075C26 15.3794 25.9005 15.8815 25.7015 16.3138C25.5168 16.7462 25.2894 17.1158 25.0194 17.4226C24.7494 17.7155 24.3941 18.0572 23.9535 18.4477C23.4134 18.9219 23.0084 19.3403 22.7384 19.7029C22.4826 20.0656 22.3547 20.4979 22.3547 21H19.6473ZM21.0116 26C20.5142 26 20.1021 25.8466 19.7752 25.5398C19.4625 25.219 19.3062 24.8285 19.3062 24.3682C19.3062 23.908 19.4625 23.5244 19.7752 23.2176C20.1021 22.9107 20.5142 22.7573 21.0116 22.7573C21.4948 22.7573 21.8928 22.9107 22.2054 23.2176C22.5323 23.5244 22.6957 23.908 22.6957 24.3682C22.6957 24.8285 22.5323 25.219 22.2054 25.5398C21.8928 25.8466 21.4948 26 21.0116 26Z"
                />
            </g>
        ),
    },
    gift: {
        viewBox: '0 0 24 24',
        image: (
            <g clip-path="url(#clip0_1774_2227)">
                <path d="M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.34C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM20 19H4V14V8H9.08L7 10.83L8.62 12L11 8.76L12 7.4L13 8.76L15.38 12L17 10.83L14.92 8H20V19Z" />
                <rect x="11" y="6" width="2" height="13" />
            </g>
        ),
    },
    ipTv: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M21.8182 4.75488H2.18182C0.981818 4.75488 0 5.62091 0 6.67939V18.2265C0 19.2849 0.981818 20.151 2.18182 20.151H9.81818V22.0755H8.72727C8.12727 22.0755 7.63636 22.5085 7.63636 23.0377C7.63636 23.567 8.12727 24 8.72727 24H15.2727C15.8727 24 16.3636 23.567 16.3636 23.0377C16.3636 22.5085 15.8727 22.0755 15.2727 22.0755H14.1818V20.151H21.8182C23.0182 20.151 24 19.2849 24 18.2265V6.67939C24 5.62091 23.0182 4.75488 21.8182 4.75488ZM20.7273 18.2265H3.27273C2.67273 18.2265 2.18182 17.7934 2.18182 17.2642V7.64165C2.18182 7.11241 2.67273 6.67939 3.27273 6.67939H20.7273C21.3273 6.67939 21.8182 7.11241 21.8182 7.64165V17.2642C21.8182 17.7934 21.3273 18.2265 20.7273 18.2265Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0013 0C10.8702 0 9.73904 0.339481 8.81048 1.01276L8.80752 1.01494C8.76464 1.04701 8.72672 1.08385 8.69516 1.12436C8.53292 1.33321 8.55611 1.61874 8.77572 1.80586L8.80865 1.83382C9.02621 2.01957 9.36866 2.03383 9.61 1.87477L9.61293 1.87278C10.3211 1.39163 11.1636 1.13218 12.0013 1.13218C12.8384 1.13218 13.6809 1.3913 14.3961 1.87265C14.6374 2.03825 14.9784 2.01449 15.1963 1.83742L15.2088 1.82729L15.2385 1.7957C15.4832 1.57589 15.4652 1.21652 15.1949 1.01479L15.1922 1.01276C14.2636 0.339481 13.1325 0 12.0013 0ZM12.0013 1.30176C11.2748 1.30176 10.5522 1.52257 9.95949 1.91848L9.95719 1.92004C9.894 1.96326 9.84275 2.01597 9.8048 2.07481C9.67276 2.28003 9.71064 2.54721 9.91014 2.71694L9.93628 2.73938C10.1682 2.93724 10.5023 2.92686 10.7321 2.78425L10.7366 2.78133C11.1046 2.5421 11.548 2.43394 12.0013 2.43394C12.4542 2.43394 12.8981 2.54192 13.2666 2.77622C13.5018 2.92983 13.8456 2.92968 14.0686 2.73193L14.0929 2.71104C14.1972 2.62213 14.2593 2.50743 14.2744 2.38739C14.2965 2.20987 14.2152 2.03002 14.0453 1.91406L14.0416 1.91165C13.4497 1.52247 12.7277 1.30176 12.0013 1.30176ZM12.0013 3.3962C11.5087 3.3962 11.0853 3.74206 11.0853 4.18864V6.11315H12.9174V4.18864C12.9174 3.74206 12.4939 3.3962 12.0013 3.3962Z"
                />
                <path d="M11.8694 15.574C11.6601 15.574 11.4905 15.422 11.4905 15.2344V9.62331C11.4905 9.43574 11.6601 9.28369 11.8694 9.28369H14.1225C14.6617 9.28369 15.1141 9.37379 15.4797 9.55398C15.8475 9.73417 16.1251 9.98194 16.3124 10.2973C16.5021 10.6106 16.5969 10.9668 16.5969 11.3661C16.5969 11.7695 16.5021 12.1279 16.3124 12.4411C16.1228 12.7544 15.8429 13.0012 15.4728 13.1814C15.1027 13.3595 14.6469 13.4486 14.1054 13.4486H12.7399C12.5306 13.4486 12.361 13.2965 12.361 13.109V12.8514C12.361 12.6638 12.5306 12.5118 12.7399 12.5118H13.934C14.2493 12.5118 14.5075 12.4626 14.7085 12.3644C14.9096 12.2661 15.0581 12.1309 15.1541 11.9589C15.2523 11.7869 15.3014 11.5893 15.3014 11.3661C15.3014 11.1429 15.2523 10.9464 15.1541 10.7764C15.0581 10.6065 14.9085 10.4744 14.7051 10.3802C14.5041 10.284 14.2447 10.2358 13.9272 10.2358H13.1409C12.9316 10.2358 12.7619 10.3879 12.7619 10.5755V15.2344C12.7619 15.422 12.5923 15.574 12.383 15.574H11.8694Z" />
                <path d="M9.73456 9.28369C9.94384 9.28369 10.1135 9.43574 10.1135 9.62331V15.2344C10.1135 15.422 9.94384 15.574 9.73456 15.574H9.22099C9.0117 15.574 8.84204 15.422 8.84204 15.2344V9.62331C8.84204 9.43574 9.0117 9.28369 9.22099 9.28369H9.73456Z" />
            </g>
        ),
    },
    complete: {
        viewBox: '0 0 106 106',
        image: (
            <path
                id="Vector"
                d="M39.75 71.4175L24.4242 56.0917C22.7017 54.3692 19.9192 54.3692 18.1967 56.0917C16.4742 57.8142 16.4742 60.5967 18.1967 62.3192L36.6583 80.7808C38.3808 82.5033 41.1633 82.5033 42.8858 80.7808L89.6142 34.0525C91.3367 32.33 91.3367 29.5475 89.6142 27.825C87.8917 26.1025 85.1092 26.1025 83.3867 27.825L39.75 71.4175Z"
            />
        ),
    },
    checkError: {
        viewBox: '0 0 83 83',
        image: (
            <g>
                <path d="M71.6221 27.5975L55.4371 11.4125C54.78 10.7554 53.8808 10.375 52.9817 10.375H30.0183C29.1192 10.375 28.22 10.7554 27.5975 11.3779L11.3779 27.5975C10.7554 28.22 10.375 29.1192 10.375 30.0183V52.9471C10.375 53.8808 10.7554 54.7454 11.3779 55.4025L27.5629 71.5875C28.22 72.2446 29.1192 72.625 30.0183 72.625H52.9471C53.8808 72.625 54.7454 72.2446 55.4025 71.6221L71.5875 55.4371C72.2446 54.78 72.5904 53.9154 72.5904 52.9817V30.0183C72.625 29.1192 72.2446 28.22 71.6221 27.5975ZM65.7083 51.5292L51.5292 65.7083H31.4708L17.2917 51.5292V31.4708L31.4708 17.2917H51.5292L65.7083 31.4708V51.5292Z" />
                <path d="M41.4998 58.7917C43.4098 58.7917 44.9582 57.2433 44.9582 55.3333C44.9582 53.4233 43.4098 51.875 41.4998 51.875C39.5899 51.875 38.0415 53.4233 38.0415 55.3333C38.0415 57.2433 39.5899 58.7917 41.4998 58.7917Z" />
                <path d="M41.4998 24.2083C39.5978 24.2083 38.0415 25.7646 38.0415 27.6667V44.9583C38.0415 46.8604 39.5978 48.4167 41.4998 48.4167C43.4019 48.4167 44.9582 46.8604 44.9582 44.9583V27.6667C44.9582 25.7646 43.4019 24.2083 41.4998 24.2083Z" />
            </g>
        ),
    },
    advertisement: {
        viewBox: '0 0 50 38',
        image: (
            <g>
                <path d="M40 19.0223C40 20.3973 41.125 21.5223 42.5 21.5223H47.5C48.875 21.5223 50 20.3973 50 19.0223C50 17.6473 48.875 16.5223 47.5 16.5223H42.5C41.125 16.5223 40 17.6473 40 19.0223Z" />
                <path d="M36.475 31.0723C35.65 32.1723 35.875 33.6973 36.975 34.4973C38.3 35.4723 39.7 36.5223 41.025 37.5223C42.125 38.3473 43.675 38.1223 44.475 37.0223C44.475 36.9973 44.5 36.9973 44.5 36.9723C45.325 35.8723 45.1 34.3223 44 33.5223C42.675 32.5223 41.275 31.4723 39.975 30.4973C38.875 29.6723 37.325 29.9223 36.5 31.0223C36.5 31.0473 36.475 31.0723 36.475 31.0723Z" />
                <path d="M44.525 1.04733C44.525 1.02233 44.5 1.02233 44.5 0.997328C43.675 -0.102671 42.125 -0.32767 41.05 0.497329C39.725 1.49733 38.3 2.54733 37 3.54732C35.9 4.37232 35.7 5.92232 36.525 6.99732C36.525 7.02232 36.55 7.02232 36.55 7.04732C37.375 8.14732 38.9 8.37232 40 7.54732C41.325 6.57232 42.725 5.49732 44.05 4.49732C45.125 3.69732 45.325 2.14733 44.525 1.04733Z" />
                <path d="M15 11.5223H4.99999C2.25 11.5223 0 13.7723 0 16.5223V21.5223C0 24.2723 2.25 26.5223 4.99999 26.5223H7.49999V34.0223C7.49999 35.3973 8.62499 36.5223 9.99999 36.5223C11.375 36.5223 12.5 35.3973 12.5 34.0223V26.5223H15L27.5 34.0223V4.02234L15 11.5223Z" />
                <path d="M33.7499 19.0223C33.7499 15.6973 32.3 12.6973 30 10.6473V27.3723C32.3 25.3473 33.7499 22.3473 33.7499 19.0223Z" />
            </g>
        ),
    },
    noChannel: {
        viewBox: '0 0 417 375',
        image: (
            <path d="M180.188 282.706L255.31 239.671C267.956 232.499 267.956 214.19 255.31 206.829L180.188 163.794C167.541 156.621 151.875 165.87 151.875 180.215V266.096C151.875 280.63 167.541 289.879 180.188 282.706ZM378.375 72.25H235.114L290.606 16.7575C294.381 12.9825 294.381 7.13127 290.606 3.35627C286.831 -0.418726 280.98 -0.418726 277.205 3.35627L208.5 72.0613L139.795 3.35627C136.02 -0.418726 130.169 -0.418726 126.394 3.35627C122.619 7.13127 122.619 12.9825 126.394 16.7575L181.886 72.25H38.625C17.8625 72.25 0.875 89.0488 0.875 110V336.5C0.875 357.263 17.8625 374.25 38.625 374.25H378.375C399.138 374.25 416.125 357.263 416.125 336.5V110C416.125 89.0488 399.138 72.25 378.375 72.25ZM359.5 336.5H57.5C47.1188 336.5 38.625 328.006 38.625 317.625V128.875C38.625 118.494 47.1188 110 57.5 110H359.5C369.881 110 378.375 118.494 378.375 128.875V317.625C378.375 328.006 369.881 336.5 359.5 336.5Z" />
        ),
    },
    turtle: {
        viewBox: '0 0 25 15',
        image: (
            <g>
                <path d="M14.9103 2.6197C14.9103 2.6197 16.5302 1.94866 16.5602 2.65817C16.744 6.63743 0.702956 12.2195 0.019087 9.74049C-0.147606 9.12928 0.831181 8.57364 0.873923 8.27444C1.64755 -0.214081 8.85809 -2.30415 14.9103 2.6197Z" />
                <path d="M0.762407 11.6681C0.762407 11.6681 9.88778 11.2792 19.7141 3.26509C22.0948 1.32034 25.9673 6.6246 23.1634 8.41548C21.5478 9.44556 19.915 7.87693 19.5688 8.02653C16.6624 9.26177 16.6624 9.89435 16.7051 11.4031C16.7478 12.9119 19.6543 14.8951 17.0898 14.9721C14.5253 15.049 12.8156 12.8863 12.8156 12.8863C12.1488 13.3137 10.3494 14.3951 5.72046 13.8095C5.72046 13.8095 6.259 14.9934 5.29304 14.9721C2.86103 14.9208 1.15991 15.2371 2.37805 13.1769C2.98498 12.1682 0.570069 12.7324 0.762407 11.6681Z" />
            </g>
        ),
    },
    rabbit: {
        viewBox: '0 0 20 20',
        image: (
            <path d="M13.7067 3.42512C17.7757 2.9977 20.477 6.69486 19.3913 8.30196C18.3057 9.90905 16.549 9.34486 16.0746 9.91332C15.6001 10.4818 15.5531 16.752 16.1686 17.3034C16.7841 17.8548 18.7929 17.6752 18.5365 18.4403C18.28 19.2054 16.6558 19.62 15.6942 19.1968C14.8778 18.8335 11.8474 14.9782 11.8474 14.9782C11.8474 14.9782 12.5697 11.3494 7.38087 12.1188C7.38087 12.1188 14.647 11.6401 9.75732 16.846C9.75732 16.846 14.4162 16.3716 13.8947 18.4574C13.3733 20.5432 3.63669 19.7397 3.05113 19.0259C2.46556 18.3121 3.00411 16.5127 3.00411 16.5127C3.00411 16.5127 -2.31724 17.2478 1.20468 13.8926C1.20468 13.8926 0.657585 6.04092 10.6805 6.69486C10.6805 6.69486 4.89757 5.27156 5.22669 2.66859C5.5558 0.0656099 9.68038 3.6602 7.12442 2.19415C4.56846 0.728108 7.20563 -2.37495 13.3263 3.19004C13.5955 3.43366 13.7067 3.42512 13.7067 3.42512Z" />
        ),
    },
    rectangleStar: {
        viewBox: '0 0 18 17',
        image: (
            <path d="M16.65 6.04L11.81 5.62L9.91995 1.17C9.57995 0.36 8.41995 0.36 8.07995 1.17L6.18995 5.63L1.35995 6.04C0.479951 6.11 0.119951 7.21 0.789951 7.79L4.45995 10.97L3.35995 15.69C3.15995 16.55 4.08995 17.23 4.84995 16.77L8.99995 14.27L13.15 16.78C13.91 17.24 14.8399 16.56 14.6399 15.7L13.54 10.97L17.2099 7.79C17.8799 7.21 17.5299 6.11 16.65 6.04ZM8.99995 12.4L5.23995 14.67L6.23995 10.39L2.91995 7.51L7.29995 7.13L8.99995 3.1L10.71 7.14L15.09 7.52L11.77 10.4L12.77 14.68L8.99995 12.4Z" />
        ),
    },
    history: {
        viewBox: '0 0 23 17',
        image: (
            <path d="M17.0454 0C15.0954 0 12.9954 0.4 11.5454 1.5C10.0954 0.4 7.99541 0 6.04541 0C4.59541 0 3.05541 0.22 1.76541 0.79C1.03541 1.12 0.54541 1.83 0.54541 2.64V13.92C0.54541 15.22 1.76541 16.18 3.02541 15.86C4.00541 15.61 5.04541 15.5 6.04541 15.5C7.60541 15.5 9.26541 15.76 10.6054 16.42C11.2054 16.72 11.8854 16.72 12.4754 16.42C13.8154 15.75 15.4754 15.5 17.0354 15.5C18.0354 15.5 19.0754 15.61 20.0554 15.86C21.3154 16.19 22.5354 15.23 22.5354 13.92V2.64C22.5354 1.83 22.0454 1.12 21.3154 0.79C20.0354 0.22 18.4954 0 17.0454 0ZM20.5454 12.73C20.5454 13.36 19.9654 13.82 19.3454 13.71C18.5954 13.57 17.8154 13.51 17.0454 13.51C15.3454 13.51 12.8954 14.16 11.5454 15.01V3.5C12.8954 2.65 15.3454 2 17.0454 2C17.9654 2 18.8754 2.09 19.7454 2.28C20.2054 2.38 20.5454 2.79 20.5454 3.26V12.73Z" />
        ),
    },
    mail: {
        viewBox: '0 0 21 16',
        image: (
            <path d="M18.5454 0H2.54541C1.44541 0 0.55541 0.9 0.55541 2L0.54541 14C0.54541 15.1 1.44541 16 2.54541 16H18.5454C19.6454 16 20.5454 15.1 20.5454 14V2C20.5454 0.9 19.6454 0 18.5454 0ZM18.5454 4L10.5454 9L2.54541 4V2L10.5454 7L18.5454 2V4Z" />
        ),
    },
    cloud: {
        viewBox: '0 0 19 19',
        image: (
            <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_26_238)">
                    <path
                        d="M15.2284 7.905C14.7184 5.3175 12.4459 3.375 9.71594 3.375C7.54844 3.375 5.66594 4.605 4.72844 6.405C2.47094 6.645 0.715942 8.5575 0.715942 10.875C0.715942 13.3575 2.73344 15.375 5.21594 15.375H14.9659C17.0359 15.375 18.7159 13.695 18.7159 11.625C18.7159 9.645 17.1784 8.04 15.2284 7.905Z"
                        fill="#C039FF"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_26_238">
                        <rect width="18" height="18" fill="white" transform="translate(0.715942 0.375)" />
                    </clipPath>
                </defs>
            </svg>
        ),
    },
    dns: {
        viewBox: '0 0 19 19',
        image: (
            <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_26_237)">
                    <path
                        d="M14.4636 10.375H3.96362C3.13862 10.375 2.46362 11.05 2.46362 11.875V14.875C2.46362 15.7 3.13862 16.375 3.96362 16.375H14.4636C15.2886 16.375 15.9636 15.7 15.9636 14.875V11.875C15.9636 11.05 15.2886 10.375 14.4636 10.375ZM5.46362 14.875C4.63862 14.875 3.96362 14.2 3.96362 13.375C3.96362 12.55 4.63862 11.875 5.46362 11.875C6.28862 11.875 6.96362 12.55 6.96362 13.375C6.96362 14.2 6.28862 14.875 5.46362 14.875ZM14.4636 2.875H3.96362C3.13862 2.875 2.46362 3.55 2.46362 4.375V7.375C2.46362 8.2 3.13862 8.875 3.96362 8.875H14.4636C15.2886 8.875 15.9636 8.2 15.9636 7.375V4.375C15.9636 3.55 15.2886 2.875 14.4636 2.875ZM5.46362 7.375C4.63862 7.375 3.96362 6.7 3.96362 5.875C3.96362 5.05 4.63862 4.375 5.46362 4.375C6.28862 4.375 6.96362 5.05 6.96362 5.875C6.96362 6.7 6.28862 7.375 5.46362 7.375Z"
                        fill="#2582E0"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_26_237">
                        <rect width="18" height="18" fill="white" transform="translate(0.213623 0.625)" />
                    </clipPath>
                </defs>
            </svg>
        ),
    },
    change: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0993 8.3567C19.3046 8.14325 19.6623 8.29667 19.6556 8.59016V12.7858C19.6556 12.9726 19.5099 13.1193 19.3245 13.1193H15.1589C14.8675 13.1193 14.7152 12.7658 14.9272 12.5524L15.8808 11.5918C15.7456 11.4697 15.6162 11.3413 15.4932 11.207C14.6815 10.3209 14.1451 9.17873 14.0254 7.9104H16.8269C17.1762 8.45459 17.6217 8.93102 18.1391 9.31723L19.0993 8.3567ZM18.0777 7.9104C18.0862 7.91989 18.0946 7.92935 18.1031 7.93877L18.1315 7.9104H18.0777ZM13.0216 7.9104H3.20863C2.34553 7.9104 1.48242 8.6998 1.48242 9.4892V20.5408C1.48242 21.4091 2.25922 22.1196 3.20863 22.1196H18.7445C19.6076 22.1196 20.4707 21.3302 20.4707 20.5408V13.466C20.2405 13.8562 19.8171 14.1193 19.3245 14.1193H15.1589C13.9812 14.1193 13.3771 12.6943 14.2175 11.8478L14.4897 11.5737C13.6668 10.5585 13.1327 9.2966 13.0216 7.9104ZM4.93484 18.962L7.9557 15.4097L10.1135 17.7858L13.1343 14.2256L17.0183 18.962H4.93484Z"
                />
                <path d="M22.1127 2.6469L23.0664 1.68637C23.2783 1.47291 23.126 1.11938 22.8346 1.11938H18.669C18.4836 1.11938 18.3379 1.26613 18.3379 1.4529V5.64857C18.3379 5.94873 18.6955 6.09548 18.9008 5.88203L19.8611 4.91483C21.1657 5.8887 22.0134 7.43623 22.0134 9.19721C22.0134 9.63745 21.9604 10.071 21.8544 10.4779C21.775 10.8114 22.1723 11.0516 22.4107 10.8048C23.3909 9.7842 24.0001 8.39676 24.0001 6.86258C24.0001 5.18831 23.265 3.68748 22.1127 2.6469Z" />
                <path d="M19.0993 8.35681L18.1391 9.31734C16.8344 8.34347 15.9868 6.79594 15.9868 5.03496C15.9868 4.59472 16.0397 4.16115 16.1457 3.75425C16.2252 3.42073 15.8278 3.1806 15.5894 3.4274C14.6093 4.44797 14 5.83541 14 7.36959C14 9.05053 14.7285 10.5514 15.8808 11.5919L14.9272 12.5525C14.7152 12.7659 14.8675 13.1195 15.1589 13.1195H19.3245C19.5099 13.1195 19.6556 12.9727 19.6556 12.7859V8.59027C19.6623 8.29678 19.3046 8.14336 19.0993 8.35681Z" />
            </g>
        ),
    },
    restart: {
        viewBox: '0 0 18 18',
        image: (
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.00002 0.658264C8.49376 0.658256 8.08335 1.06865 8.08334 1.57492C8.08333 2.08118 8.49373 2.49159 8.99999 2.4916C10.5353 2.49162 12.0211 3.03439 13.1949 4.02398C14.3687 5.01357 15.1549 6.38626 15.4145 7.89944C15.6741 9.41261 15.3904 10.9688 14.6136 12.2931C13.8367 13.6173 12.6168 14.6243 11.1693 15.1361C9.7218 15.6478 8.14 15.6314 6.70346 15.0897C5.26693 14.548 4.06814 13.5158 3.31898 12.1757C2.56983 10.8356 2.31853 9.27385 2.60952 7.76639C2.81497 6.70203 3.28143 5.71315 3.9582 4.88411V6.11248C3.9582 6.61874 4.36861 7.02915 4.87487 7.02915C5.38113 7.02915 5.79154 6.61874 5.79154 6.11248V2.81248C5.79154 2.30622 5.38113 1.89581 4.87487 1.89581H1.57487C1.06861 1.89581 0.658203 2.30622 0.658203 2.81248C0.658203 3.31874 1.06861 3.72915 1.57487 3.72915H2.5344C1.66893 4.79082 1.07238 6.05663 0.809416 7.41892C0.436462 9.35101 0.758542 11.3527 1.71873 13.0703C2.67892 14.7879 4.21539 16.1108 6.05658 16.8051C7.89778 17.4994 9.92515 17.5205 11.7804 16.8646C13.6356 16.2086 15.1992 14.918 16.1949 13.2207C17.1906 11.5235 17.5542 9.52886 17.2214 7.58944C16.8887 5.65001 15.8811 3.89065 14.3766 2.62231C12.8722 1.35396 10.9678 0.658296 9.00002 0.658264Z"
            />
        ),
    },
    settings: {
        viewBox: '0 0 18 18',
        image: (
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.79198 2.23022H17C17.5523 2.23022 18 2.67794 18 3.23022C18 3.78251 17.5523 4.23022 17 4.23022H7.79198C7.4062 5.11318 6.52516 5.73022 5.5 5.73022C4.47484 5.73022 3.5938 5.11318 3.20802 4.23022H1C0.447716 4.23022 0 3.78251 0 3.23022C0 2.67794 0.447715 2.23022 1 2.23022H3.20802C3.5938 1.34727 4.47484 0.730225 5.5 0.730225C6.52516 0.730225 7.4062 1.34727 7.79198 2.23022ZM1 8C0.447715 8 0 8.44772 0 9C0 9.55228 0.447716 10 1 10H10.1208C10.4454 11.0041 11.3879 11.7302 12.5 11.7302C13.6121 11.7302 14.5546 11.0041 14.8792 10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H14.6769C14.2475 7.24186 13.4335 6.73022 12.5 6.73022C11.5665 6.73022 10.7525 7.24186 10.3231 8H1ZM1 13.7693C0.447715 13.7693 0 14.217 0 14.7693C0 15.3216 0.447716 15.7693 1 15.7693H3.20781C3.59348 16.6525 4.47465 17.2698 5.5 17.2698C6.52535 17.2698 7.40652 16.6525 7.79219 15.7693H17C17.5523 15.7693 18 15.3216 18 14.7693C18 14.217 17.5523 13.7693 17 13.7693H7.79176C7.40587 12.8866 6.52497 12.2698 5.5 12.2698C4.47503 12.2698 3.59413 12.8866 3.20824 13.7693H1Z"
                fill="#2582E0"
            />
        ),
    },
    infinityN: {
        viewBox: '0 0 30 31',
        image: (
            <path
                d="M25.2635 8.78605C21.8548 7.7286 18.0899 9.64281 15 13.8687C11.9101 9.64281 8.14516 7.73053 4.73649 8.78605C3.35963 9.24711 2.15987 10.1448 1.30905 11.3505C0.458226 12.5562 0 14.0082 0 15.4983C0 16.9884 0.458226 18.4404 1.30905 19.6461C2.15987 20.8518 3.35963 21.7495 4.73649 22.2106C5.35299 22.4025 5.99359 22.5001 6.63769 22.5C9.50263 22.5 12.4763 20.5974 15 17.1491C17.5237 20.5974 20.4992 22.4981 23.3623 22.4981C24.0063 22.4988 24.6469 22.4019 25.2635 22.2106C26.6404 21.7495 27.8401 20.8518 28.691 19.6461C29.5418 18.4404 30 16.9884 30 15.4983C30 14.0082 29.5418 12.5562 28.691 11.3505C27.8401 10.1448 26.6404 9.24711 25.2635 8.78605ZM5.27648 20.3639C4.28589 20.022 3.42472 19.3684 2.81459 18.4955C2.20446 17.6226 1.87621 16.5745 1.87621 15.4993C1.87621 14.424 2.20446 13.3759 2.81459 12.503C3.42472 11.6301 4.28589 10.9765 5.27648 10.6346C5.71857 10.4977 6.1779 10.4288 6.63957 10.4301C9.03389 10.4301 11.6307 12.2324 13.8657 15.4993C11.1995 19.3971 8.01766 21.211 5.2746 20.362L5.27648 20.3639ZM24.7254 20.3639C21.9767 21.211 18.8005 19.3991 16.1362 15.4993C18.8005 11.6014 21.9748 9.7856 24.7235 10.6346C25.7141 10.9765 26.5753 11.6301 27.1854 12.503C27.7955 13.3759 28.1238 14.424 28.1238 15.4993C28.1238 16.5745 27.7955 17.6226 27.1854 18.4955C26.5753 19.3684 25.7141 20.022 24.7235 20.3639H24.7254Z"
                fill="white"
            />
        ),
    },
    backArrow: {
        viewBox: '0 0 20 20',
        image: (
            <g>
                <g id="Frame" clip-path="url(#clip0_2998_1474)">
                    <path
                        id="Vector"
                        d="M15.0923 18.9525L6.23978 10.0275L15.0982 1.09626C15.2213 0.9722 15.2826 0.8097 15.2826 0.647512C15.2826 0.485012 15.2213 0.322513 15.0982 0.198762C15.04 0.139871 14.9707 0.0931144 14.8943 0.0612045C14.8179 0.0292945 14.7359 0.0128627 14.6531 0.0128627C14.5703 0.0128627 14.4883 0.0292945 14.4119 0.0612045C14.3354 0.0931144 14.2661 0.139871 14.2079 0.198762L4.91572 9.56751C4.85322 9.63001 4.79853 9.72189 4.76728 9.80408C4.72377 9.91871 4.71407 10.0434 4.73933 10.1634C4.76459 10.2834 4.82375 10.3936 4.90978 10.481L14.202 19.8503C14.2602 19.9092 14.3295 19.956 14.4059 19.9879C14.4823 20.0198 14.5643 20.0362 14.6471 20.0362C14.7299 20.0362 14.8119 20.0198 14.8883 19.9879C14.9647 19.956 15.0341 19.9092 15.0923 19.8503C15.2103 19.7307 15.2765 19.5695 15.2765 19.4014C15.2765 19.2334 15.2103 19.0721 15.0923 18.9525Z"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2998_1474">
                        <rect width="20" height="20" fill="white" transform="translate(0 20) rotate(-90)" />
                    </clipPath>
                </defs>
            </g>
        ),
    },
    copyToClipboard: {
        viewBox: '0 0 24 25',
        image: (
            <g>
                <g id="Frame" clip-path="url(#clip0_2998_3226)">
                    <path id="Vector" d="M11.2969 10.3438H16.4527L11.2969 6.4769V10.3438Z" />
                    <path
                        id="Vector_2"
                        d="M3.5625 24.5H16.2188C16.6074 24.5 16.9219 24.1855 16.9219 23.7969V11.75H10.5938C10.2051 11.75 9.89062 11.4355 9.89062 11.0469V6.125H3.5625C3.17386 6.125 2.85938 6.43948 2.85938 6.82812V23.7969C2.85938 24.1855 3.17386 24.5 3.5625 24.5Z"
                    />
                    <path
                        id="Vector_3"
                        d="M21.1406 18.125V6.125H14.8125C14.4239 6.125 14.1094 5.81052 14.1094 5.42188V0.5H7.78125C7.39261 0.5 7.07812 0.814484 7.07812 1.20312V4.71875H10.5938C11.0476 4.71875 11.4974 4.86912 11.8599 5.1417L17.4842 9.35975C18.0123 9.75462 18.3281 10.3857 18.3281 11.0469V18.8281H20.4375C20.8261 18.8281 21.1406 18.5136 21.1406 18.125Z"
                    />
                    <path id="Vector_4" d="M15.5156 4.71876H20.6714L15.5156 0.851898V4.71876Z" />
                </g>
                <defs>
                    <clipPath id="clip0_2998_3226">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                </defs>
            </g>
        ),
    },
    inProgressClock: {
        viewBox: '0 0 22 22',
        image: (
            <path d="M9.99 0.5C4.47 0.5 0 4.98 0 10.5C0 16.02 4.47 20.5 9.99 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 9.99 0.5ZM10 18.5C5.58 18.5 2 14.92 2 10.5C2 6.08 5.58 2.5 10 2.5C14.42 2.5 18 6.08 18 10.5C18 14.92 14.42 18.5 10 18.5ZM9.78 5.5H9.72C9.32 5.5 9 5.82 9 6.22V10.94C9 11.29 9.18 11.62 9.49 11.8L13.64 14.29C13.98 14.49 14.42 14.39 14.62 14.05C14.83 13.71 14.72 13.26 14.37 13.06L10.5 10.76V6.22C10.5 5.82 10.18 5.5 9.78 5.5Z" />
        ),
    },
    securityInfo: {
        viewBox: '0 0 19 18',
        image: (
            <path d="M13.8333 6H13.0833V4.5C13.0833 2.43 11.4033 0.75 9.33331 0.75C7.26331 0.75 5.58331 2.43 5.58331 4.5V6H4.83331C4.00831 6 3.33331 6.675 3.33331 7.5V15C3.33331 15.825 4.00831 16.5 4.83331 16.5H13.8333C14.6583 16.5 15.3333 15.825 15.3333 15V7.5C15.3333 6.675 14.6583 6 13.8333 6ZM7.08331 4.5C7.08331 3.255 8.08831 2.25 9.33331 2.25C10.5783 2.25 11.5833 3.255 11.5833 4.5V6H7.08331V4.5ZM13.0833 15H5.58331C5.17081 15 4.83331 14.6625 4.83331 14.25V8.25C4.83331 7.8375 5.17081 7.5 5.58331 7.5H13.0833C13.4958 7.5 13.8333 7.8375 13.8333 8.25V14.25C13.8333 14.6625 13.4958 15 13.0833 15ZM9.33331 12.75C10.1583 12.75 10.8333 12.075 10.8333 11.25C10.8333 10.425 10.1583 9.75 9.33331 9.75C8.50831 9.75 7.83331 10.425 7.83331 11.25C7.83331 12.075 8.50831 12.75 9.33331 12.75Z" />
        ),
    },
    lock: {
        viewBox: '0 0 20 20',
        image: (
            <path d="M15.0026 6.66671H14.1693V5.00004C14.1693 2.70004 12.3026 0.833374 10.0026 0.833374C7.7026 0.833374 5.83594 2.70004 5.83594 5.00004V6.66671H5.0026C4.08594 6.66671 3.33594 7.41671 3.33594 8.33337V16.6667C3.33594 17.5834 4.08594 18.3334 5.0026 18.3334H15.0026C15.9193 18.3334 16.6693 17.5834 16.6693 16.6667V8.33337C16.6693 7.41671 15.9193 6.66671 15.0026 6.66671ZM10.0026 14.1667C9.08594 14.1667 8.33594 13.4167 8.33594 12.5C8.33594 11.5834 9.08594 10.8334 10.0026 10.8334C10.9193 10.8334 11.6693 11.5834 11.6693 12.5C11.6693 13.4167 10.9193 14.1667 10.0026 14.1667ZM7.5026 6.66671V5.00004C7.5026 3.61671 8.61927 2.50004 10.0026 2.50004C11.3859 2.50004 12.5026 3.61671 12.5026 5.00004V6.66671H7.5026Z" />
        ),
    },
    unlock: {
        viewBox: '0 0 20 20',
        image: (
            <path d="M15.0026 6.66671H14.1693V5.00004C14.1693 2.70004 12.3026 0.833374 10.0026 0.833374C8.58594 0.833374 7.33594 1.55004 6.58594 2.66671L7.96094 3.68337C8.38594 3.04171 9.1526 2.58337 10.0026 2.58337C11.3859 2.58337 12.5026 3.70004 12.5026 5.08337V6.66671H5.0026C4.08594 6.66671 3.33594 7.41671 3.33594 8.33337V16.6667C3.33594 17.5834 4.08594 18.3334 5.0026 18.3334H15.0026C15.9193 18.3334 16.6693 17.5834 16.6693 16.6667V8.33337C16.6693 7.41671 15.9193 6.66671 15.0026 6.66671ZM10.0026 14.1667C9.08594 14.1667 8.33594 13.4167 8.33594 12.5C8.33594 11.5834 9.08594 10.8334 10.0026 10.8334C10.9193 10.8334 11.6693 11.5834 11.6693 12.5C11.6693 13.4167 10.9193 14.1667 10.0026 14.1667Z" />
        ),
    },
    folderGroup: {
        viewBox: '0 0 22 22',
        image: (
            <path d="M17.4166 7.33337H4.58325C4.07909 7.33337 3.66659 6.92087 3.66659 6.41671C3.66659 5.91254 4.07909 5.50004 4.58325 5.50004H17.4166C17.9208 5.50004 18.3333 5.91254 18.3333 6.41671C18.3333 6.92087 17.9208 7.33337 17.4166 7.33337ZM15.5833 1.83337H6.41658C5.91242 1.83337 5.49992 2.24587 5.49992 2.75004C5.49992 3.25421 5.91242 3.66671 6.41658 3.66671H15.5833C16.0874 3.66671 16.4999 3.25421 16.4999 2.75004C16.4999 2.24587 16.0874 1.83337 15.5833 1.83337ZM20.1666 11V18.3334C20.1666 19.3417 19.3416 20.1667 18.3333 20.1667H3.66659C2.65825 20.1667 1.83325 19.3417 1.83325 18.3334V11C1.83325 9.99171 2.65825 9.16671 3.66659 9.16671H18.3333C19.3416 9.16671 20.1666 9.99171 20.1666 11ZM13.9241 14.2634L9.16658 11.6692V17.655L13.9241 15.07C14.2449 14.8959 14.2449 14.4375 13.9241 14.2634Z" />
        ),
    },
    folderWithLines: {
        viewBox: '0 0 20 16',
        image: (
            <path d="M18 2H10L8.59 0.59C8.21 0.21 7.7 0 7.17 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM11 12H5C4.45 12 4 11.55 4 11C4 10.45 4.45 10 5 10H11C11.55 10 12 10.45 12 11C12 11.55 11.55 12 11 12ZM15 8H5C4.45 8 4 7.55 4 7C4 6.45 4.45 6 5 6H15C15.55 6 16 6.45 16 7C16 7.55 15.55 8 15 8Z" />
        ),
    },
    directoryUp: {
        viewBox: '0 0 24 24',
        image: (
            <path d="M12.5925 18.5825V7.4125L17.4725 12.2925C17.8625 12.6825 18.5025 12.6825 18.8925 12.2925C19.2825 11.9025 19.2825 11.2725 18.8925 10.8825L12.3025 4.2925C11.9125 3.9025 11.2825 3.9025 10.8925 4.2925L4.2925 10.8725C3.9025 11.2625 3.9025 11.8925 4.2925 12.2825C4.6825 12.6725 5.3125 12.6725 5.7025 12.2825L10.5925 7.4125V18.5825C10.5925 19.1325 11.0425 19.5825 11.5925 19.5825C12.1425 19.5825 12.5925 19.1325 12.5925 18.5825Z" />
        ),
    },
    directoryRefresh: {
        viewBox: '0 0 24 24',
        image: (
            <path d="M12.0049 5.29153V2.50153C12.0049 2.05153 12.5449 1.83153 12.8549 2.15153L16.6549 5.94153C16.8549 6.14153 16.8549 6.45153 16.6549 6.65153L12.8649 10.4415C12.5449 10.7515 12.0049 10.5315 12.0049 10.0815V7.29153C8.27485 7.29153 5.32485 10.7115 6.14485 14.5815C6.61485 16.8515 8.45485 18.6815 10.7149 19.1515C14.2849 19.9015 17.4649 17.4515 17.9449 14.1415C18.0149 13.6615 18.4349 13.2915 18.9249 13.2915C19.5249 13.2915 20.0049 13.8215 19.9249 14.4215C19.3049 18.8115 15.1249 22.0615 10.3949 21.1415C7.27486 20.5315 4.76485 18.0215 4.15485 14.9015C3.16485 9.77153 7.06485 5.29153 12.0049 5.29153Z" />
        ),
    },
    treeDots: {
        viewBox: '0 0 16 4',
        image: (
            <path d="M2 0.5C0.9 0.5 0 1.4 0 2.5C0 3.6 0.9 4.5 2 4.5C3.1 4.5 4 3.6 4 2.5C4 1.4 3.1 0.5 2 0.5ZM14 0.5C12.9 0.5 12 1.4 12 2.5C12 3.6 12.9 4.5 14 4.5C15.1 4.5 16 3.6 16 2.5C16 1.4 15.1 0.5 14 0.5ZM8 0.5C6.9 0.5 6 1.4 6 2.5C6 3.6 6.9 4.5 8 4.5C9.1 4.5 10 3.6 10 2.5C10 1.4 9.1 0.5 8 0.5Z" />
        ),
    },
    fileItem: {
        viewBox: '0 0 16 20',
        image: (
            <path d="M2 0C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6.83C16 6.3 15.79 5.79 15.41 5.42L10.58 0.59C10.21 0.21 9.7 0 9.17 0H2ZM9 6V1.5L14.5 7H10C9.45 7 9 6.55 9 6Z" />
        ),
    },
    sendFile: {
        viewBox: '0 0 16 20',
        image: (
            <path d="M9.16992 0C9.6999 0 10.2101 0.20987 10.5801 0.589844L15.4102 5.41992C15.7901 5.78992 16 6.3001 16 6.83008V18C16 19.1 15.1 20 14 20H1.99023C0.890234 20 0 19.1 0 18L0.00976562 2C0.00976562 0.9 0.9 0 2 0H9.16992ZM10.7363 10.1338C10.4939 9.84711 10.0781 10.0519 10.0781 10.457V11.1807H3.38477C3.17323 11.1807 3.00015 11.3855 3 11.6357V14.3672C3 14.6175 3.17314 14.8222 3.38477 14.8223H10.0781V15.5459C10.0781 15.951 10.4939 16.1518 10.7363 15.8652L12.8877 13.3203C13.0376 13.1428 13.0375 12.8562 12.8877 12.6787L10.7363 10.1338Z" />
        ),
    },
    keyboard: {
        viewBox: '0 0 20 20',
        image: (
            <path d="M18 0.103516H2C0.9 0.103516 0.00999999 1.00352 0.00999999 2.10352L0 12.1035C0 13.2035 0.9 14.1035 2 14.1035H18C19.1 14.1035 20 13.2035 20 12.1035V2.10352C20 1.00352 19.1 0.103516 18 0.103516ZM9 3.10352H11V5.10352H9V3.10352ZM9 6.10352H11V8.10352H9V6.10352ZM6 3.10352H8V5.10352H6V3.10352ZM6 6.10352H8V8.10352H6V6.10352ZM5 8.10352H3V6.10352H5V8.10352ZM5 5.10352H3V3.10352H5V5.10352ZM13 12.1035H7C6.45 12.1035 6 11.6535 6 11.1035C6 10.5535 6.45 10.1035 7 10.1035H13C13.55 10.1035 14 10.5535 14 11.1035C14 11.6535 13.55 12.1035 13 12.1035ZM14 8.10352H12V6.10352H14V8.10352ZM14 5.10352H12V3.10352H14V5.10352ZM17 8.10352H15V6.10352H17V8.10352ZM17 5.10352H15V3.10352H17V5.10352ZM10.35 19.7535L13.14 16.9635C13.45 16.6535 13.23 16.1135 12.79 16.1135H7.21C6.76 16.1135 6.54 16.6535 6.86 16.9635L9.65 19.7535C9.84 19.9435 10.16 19.9435 10.35 19.7535Z" />
        ),
    },
    terminal: {
        viewBox: '0 0 20 20',
        image: (
            <path d="M17.7773 0C18.9996 0 20 1.00043 20 2.22266V17.7773C20 18.9996 18.9996 20 17.7773 20H2.22266C1.00043 20 0 18.9996 0 17.7773V2.22266C0 1.00043 1.00043 0 2.22266 0H17.7773ZM5.22461 4.43848C4.79128 4.00514 4.09056 4.00514 3.65723 4.43848C3.23514 4.87177 3.22408 5.58328 3.65723 6.0166L7.96875 10.3271L3.65723 14.6387C3.2242 15.0719 3.22432 15.7718 3.65723 16.2051C4.09056 16.6384 4.79128 16.6384 5.22461 16.2051L10.3242 11.1055C10.7575 10.6722 10.7574 9.97241 10.3242 9.53906L5.22461 4.43848ZM10 13.8887C9.38889 13.8887 8.88867 14.3889 8.88867 15C8.88867 15.6111 9.38889 16.1113 10 16.1113H15.5557C16.1667 16.1113 16.667 15.6111 16.667 15C16.667 14.3889 16.1667 13.8887 15.5557 13.8887H10Z" />
        ),
    },
    windowMode: {
        viewBox: '0 0 22 18',
        image: (
            <path d="M12 4.00445H5C4.45 4.00445 4 4.45495 4 5.00556V10.01C4 10.5606 4.45 11.0111 5 11.0111H12C12.55 11.0111 13 10.5606 13 10.01V5.00556C13 4.45495 12.55 4.00445 12 4.00445ZM20 0H2C0.9 0 0 0.901001 0 2.00222V16.0178C0 17.119 0.9 18 2 18H20C21.1 18 22 17.119 22 16.0178V2.00222C22 0.901001 21.1 0 20 0ZM19 16.0278H3C2.45 16.0278 2 15.5773 2 15.0267V2.98331C2 2.4327 2.45 1.9822 3 1.9822H19C19.55 1.9822 20 2.4327 20 2.98331V15.0267C20 15.5773 19.55 16.0278 19 16.0278Z" />
        ),
    },
    createFolder: {
        viewBox: '0 0 24 24',
        image: (
            <path d="M20 6H12L10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM18 14H16V16C16 16.55 15.55 17 15 17C14.45 17 14 16.55 14 16V14H12C11.45 14 11 13.55 11 13C11 12.45 11.45 12 12 12H14V10C14 9.45 14.45 9 15 9C15.55 9 16 9.45 16 10V12H18C18.55 12 19 12.45 19 13C19 13.55 18.55 14 18 14Z" />
        ),
    },
    rejectedModeration: {
        viewBox: '0 0 27 26',
        image: (
            <>
                <rect x="0.5" y="0" width="26" height="26" rx="5" fill="#D61750" />
                <path
                    d="M18.0833 10.2917H17.3274V8.77976C17.3274 6.69333 15.634 5 13.5476 5C11.4612 5 9.76786 6.69333 9.76786 8.77976V10.2917H9.0119C8.18036 10.2917 7.5 10.972 7.5 11.8036V19.3631C7.5 20.1946 8.18036 20.875 9.0119 20.875H18.0833C18.9149 20.875 19.5952 20.1946 19.5952 19.3631V11.8036C19.5952 10.972 18.9149 10.2917 18.0833 10.2917ZM13.5476 17.0952C12.7161 17.0952 12.0357 16.4149 12.0357 15.5833C12.0357 14.7518 12.7161 14.0714 13.5476 14.0714C14.3792 14.0714 15.0595 14.7518 15.0595 15.5833C15.0595 16.4149 14.3792 17.0952 13.5476 17.0952ZM11.2798 10.2917V8.77976C11.2798 7.52488 12.2927 6.5119 13.5476 6.5119C14.8025 6.5119 15.8155 7.52488 15.8155 8.77976V10.2917H11.2798Z"
                    fill="white"
                />
            </>
        ),
    },
    pendingModeration: {
        viewBox: '0 0 27 26',
        image: (
            <>
                <rect x="0.5" y="0" width="26" height="26" rx="5" fill="#EDB91B" />
                <path
                    d="M14.7453 5.0031C10.2308 4.87868 6.5324 8.51353 6.5324 13.0016H4.94482C4.54571 13.0016 4.35059 13.4815 4.6344 13.757L7.1089 16.2454C7.28628 16.4231 7.56122 16.4231 7.73861 16.2454L10.2131 13.757C10.488 13.4815 10.2929 13.0016 9.89382 13.0016H8.30623C8.30623 9.53556 11.1266 6.7361 14.6033 6.78053C17.9027 6.82497 20.6787 9.60665 20.7231 12.9127C20.7674 16.3876 17.9736 19.2226 14.5147 19.2226C13.0867 19.2226 11.7652 18.7338 10.7186 17.9073C10.3639 17.6318 9.86721 17.6584 9.54792 17.9784C9.17541 18.3516 9.20202 18.9826 9.61887 19.3026C10.967 20.369 12.661 21 14.5147 21C18.9936 21 22.6211 17.2941 22.4969 12.7705C22.3816 8.6024 18.9049 5.11863 14.7453 5.0031ZM14.2929 9.44668C13.9293 9.44668 13.6277 9.74885 13.6277 10.1132V13.3837C13.6277 13.6948 13.7962 13.988 14.0623 14.148L16.8295 15.7921C17.1488 15.9788 17.5568 15.8721 17.743 15.5611C17.9293 15.2411 17.8229 14.8323 17.5124 14.6457L14.9581 13.126V10.1043C14.9581 9.74885 14.6566 9.44668 14.2929 9.44668Z"
                    fill="white"
                />
            </>
        ),
    },
    pendingContentModeration: {
        viewBox: '0 0 18 16',
        image: (
            <path
                d="M10.2453 0.00310175C5.73084 -0.121319 2.0324 3.51353 2.0324 8.00155H0.444819C0.0457067 8.00155 -0.149415 8.48146 0.134398 8.75696L2.6089 11.2454C2.78628 11.4231 3.06122 11.4231 3.23861 11.2454L5.71311 8.75696C5.98805 8.48146 5.79293 8.00155 5.39382 8.00155H3.80623C3.80623 4.53556 6.62663 1.7361 10.1033 1.78053C13.4027 1.82497 16.1787 4.60665 16.2231 7.91268C16.2674 11.3876 13.4736 14.2226 10.0147 14.2226C8.58672 14.2226 7.26521 13.7338 6.21865 12.9073C5.86388 12.6318 5.36721 12.6584 5.04792 12.9784C4.67541 13.3516 4.70202 13.9826 5.11887 14.3026C6.46698 15.369 8.161 16 10.0147 16C14.4936 16 18.1211 12.2941 17.9969 7.77048C17.8816 3.6024 14.4049 0.118635 10.2453 0.00310175ZM9.79292 4.44668C9.42929 4.44668 9.12774 4.74885 9.12774 5.11322V8.3837C9.12774 8.69475 9.29625 8.98803 9.56232 9.148L12.3295 10.7921C12.6488 10.9788 13.0568 10.8721 13.243 10.5611C13.4293 10.2411 13.3229 9.83231 13.0124 9.64568L10.4581 8.12597V5.10433C10.4581 4.74885 10.1566 4.44668 9.79292 4.44668Z"
                fill="#EDB91B"
            />
        ),
    },
    rejectedContentModeration: {
        viewBox: '0 0 12 17',
        image: (
            <path
                d="M10.5 5.83333H9.75V4.30952C9.75 2.20667 8.07 0.5 6 0.5C3.93 0.5 2.25 2.20667 2.25 4.30952V5.83333H1.5C0.675 5.83333 0 6.51905 0 7.35714V14.9762C0 15.8143 0.675 16.5 1.5 16.5H10.5C11.325 16.5 12 15.8143 12 14.9762V7.35714C12 6.51905 11.325 5.83333 10.5 5.83333ZM6 12.6905C5.175 12.6905 4.5 12.0048 4.5 11.1667C4.5 10.3286 5.175 9.64286 6 9.64286C6.825 9.64286 7.5 10.3286 7.5 11.1667C7.5 12.0048 6.825 12.6905 6 12.6905ZM3.75 5.83333V4.30952C3.75 3.04476 4.755 2.02381 6 2.02381C7.245 2.02381 8.25 3.04476 8.25 4.30952V5.83333H3.75Z"
                fill="#D61750"
            />
        ),
    },
    approvedContentModeration: {
        viewBox: '0 0 16 16',
        image: (
            <path
                d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM5.832 11.432L2.96 8.56C2.648 8.248 2.648 7.744 2.96 7.432C3.272 7.12 3.776 7.12 4.088 7.432L6.4 9.736L11.904 4.232C12.216 3.92 12.72 3.92 13.032 4.232C13.344 4.544 13.344 5.048 13.032 5.36L6.96 11.432C6.656 11.744 6.144 11.744 5.832 11.432Z"
                fill="#19C061"
            />
        ),
    },
    book: {
        viewBox: '0 0 18 18',
        image: (
            <g>
                <path d="M16.3636 2.40909C15.4555 2.12273 14.4573 2 13.5 2C11.9045 2 10.1864 2.32727 9 3.22727C7.81364 2.32727 6.09545 2 4.5 2C2.90455 2 1.18636 2.32727 0 3.22727V15.2136C0 15.4182 0.204545 15.6227 0.409091 15.6227C0.490909 15.6227 0.531818 15.5818 0.613636 15.5818C1.71818 15.05 3.31364 14.6818 4.5 14.6818C6.09545 14.6818 7.81364 15.0091 9 15.9091C10.1045 15.2136 12.1091 14.6818 13.5 14.6818C14.85 14.6818 16.2409 14.9273 17.3864 15.5409C17.4682 15.5818 17.5091 15.5818 17.5909 15.5818C17.7955 15.5818 18 15.3773 18 15.1727V3.22727C17.5091 2.85909 16.9773 2.61364 16.3636 2.40909ZM16.3636 13.4545C15.4636 13.1682 14.4818 13.0455 13.5 13.0455C12.1091 13.0455 10.1045 13.5773 9 14.2727V4.86364C10.1045 4.16818 12.1091 3.63636 13.5 3.63636C14.4818 3.63636 15.4636 3.75909 16.3636 4.04545V13.4545Z" />
                <path d="M13.5002 6.9091C14.2202 6.9091 14.9156 6.98273 15.5456 7.12182V5.87819C14.8993 5.75546 14.2038 5.68182 13.5002 5.68182C12.1093 5.68182 10.8493 5.9191 9.81836 6.36091V7.7191C10.7429 7.19546 12.0275 6.9091 13.5002 6.9091Z" />
                <path d="M9.81836 8.53728V9.89546C10.7429 9.37182 12.0275 9.08546 13.5002 9.08546C14.2202 9.08546 14.9156 9.15909 15.5456 9.29819V8.05455C14.8993 7.93182 14.2038 7.85818 13.5002 7.85818C12.1093 7.85818 10.8493 8.10364 9.81836 8.53728Z" />
                <path d="M13.5002 10.0427C12.1093 10.0427 10.8493 10.28 9.81836 10.7218V12.08C10.7429 11.5564 12.0275 11.27 13.5002 11.27C14.2202 11.27 14.9156 11.3436 15.5456 11.4827V10.2391C14.8993 10.1082 14.2038 10.0427 13.5002 10.0427Z" />
            </g>
        ),
    },
    vSortableHandle: {
        viewBox: '0 0 14 14',
        image: (
            <path d="M6.70703 0.591797C6.86644 0.440357 7.11403 0.440357 7.27344 0.591797L9.49707 2.80762C9.75209 3.05471 9.57644 3.48535 9.21777 3.48535H7.79102V5.64941C8.49745 5.95578 8.99206 6.65894 8.99219 7.47754C8.99219 8.29619 8.49741 8.99921 7.79102 9.30566V11.4717H9.22656C9.57698 11.472 9.75972 11.9014 9.50488 12.1484L7.28125 14.3643C7.12184 14.5157 6.87523 14.5157 6.71582 14.3643L4.49219 12.1484C4.23717 11.9014 4.41195 11.4718 4.77051 11.4717H6.19727V9.30078C5.49688 8.99176 5.00684 8.29182 5.00684 7.47754C5.00696 6.6633 5.49685 5.96323 6.19727 5.6543V3.48535H4.77051C4.41195 3.48522 4.23717 3.05466 4.49219 2.80762L6.70703 0.591797Z" />
        ),
    },
    noBroadcast: {
        viewBox: '0 0 142 142',
        image: (
            <path d="M141.75 126V15.75C141.75 7.0875 134.663 0 126 0H15.75C7.0875 0 0 7.0875 0 15.75V126C0 134.663 7.0875 141.75 15.75 141.75H126C134.663 141.75 141.75 134.663 141.75 126ZM46.4625 86.4675L63 106.391L87.4125 74.97C88.9875 72.9225 92.1375 72.9225 93.7125 75.0487L121.354 111.904C123.323 114.502 121.433 118.204 118.204 118.204H23.7825C20.475 118.204 18.6638 114.424 20.7113 111.825L40.32 86.625C41.8162 84.5775 44.8087 84.4987 46.4625 86.4675Z" />
        ),
    },
    attached: {
        viewBox: '0 0 16 19',
        image: (
            <path d="M14.1867 1.65586C11.9789 -0.551953 8.38362 -0.551953 6.17815 1.65586L0.0609593 7.76836C0.0211156 7.8082 2.16677e-05 7.86211 2.16677e-05 7.91836C2.16677e-05 7.97461 0.0211156 8.02852 0.0609593 8.06836L0.925803 8.9332C0.965334 8.97256 1.01885 8.99466 1.07463 8.99466C1.13042 8.99466 1.18393 8.97256 1.22346 8.9332L7.34065 2.8207C8.10002 2.06133 9.11018 1.64414 10.1836 1.64414C11.2571 1.64414 12.2672 2.06133 13.0242 2.8207C13.7836 3.58008 14.2008 4.59023 14.2008 5.66133C14.2008 6.73477 13.7836 7.74258 13.0242 8.50195L6.78987 14.734L5.77971 15.7441C4.83518 16.6887 3.30002 16.6887 2.35549 15.7441C1.89846 15.2871 1.64768 14.6801 1.64768 14.0332C1.64768 13.3863 1.89846 12.7793 2.35549 12.3223L8.54065 6.13945C8.69768 5.98477 8.90393 5.89805 9.12424 5.89805H9.12659C9.3469 5.89805 9.5508 5.98477 9.70549 6.13945C9.86252 6.29648 9.9469 6.50273 9.9469 6.72305C9.9469 6.94102 9.86018 7.14727 9.70549 7.30195L4.65002 12.3527C4.61018 12.3926 4.58908 12.4465 4.58908 12.5027C4.58908 12.559 4.61018 12.6129 4.65002 12.6527L5.51487 13.5176C5.5544 13.5569 5.60791 13.579 5.66369 13.579C5.71948 13.579 5.77299 13.5569 5.81252 13.5176L10.8656 8.46445C11.3321 7.99805 11.5875 7.3793 11.5875 6.7207C11.5875 6.06211 11.3297 5.44102 10.8656 4.97695C9.90236 4.01367 8.33674 4.01602 7.37346 4.97695L6.77346 5.5793L1.19065 11.1598C0.811734 11.5365 0.511378 11.9846 0.306995 12.4783C0.102612 12.9719 -0.00172892 13.5013 2.16677e-05 14.0355C2.16677e-05 15.1207 0.42424 16.1402 1.19065 16.9066C1.98518 17.6988 3.0258 18.0949 4.06643 18.0949C5.10705 18.0949 6.14768 17.6988 6.93987 16.9066L14.1867 9.66445C15.2531 8.5957 15.8438 7.17305 15.8438 5.66133C15.8461 4.14727 15.2555 2.72461 14.1867 1.65586Z" />
        ),
    },
    downloaded: {
        viewBox: '0 0 16 17',
        image: (
            <path d="M4.88798 11.9758L1.59386 8.6817C1.50772 8.59451 1.40513 8.52529 1.29204 8.47804C1.17895 8.43079 1.0576 8.40646 0.935037 8.40646C0.812472 8.40646 0.691127 8.43079 0.578034 8.47804C0.464942 8.52529 0.362353 8.59451 0.276214 8.6817C0.189023 8.76784 0.119798 8.87043 0.0725517 8.98352C0.025305 9.09661 0.000976562 9.21796 0.000976562 9.34052C0.000976562 9.46309 0.025305 9.58443 0.0725517 9.69753C0.119798 9.81062 0.189023 9.91321 0.276214 9.99935L4.21974 13.9429C4.5868 14.3099 5.17974 14.3099 5.5468 13.9429L15.5233 3.97582C15.6105 3.88968 15.6797 3.78709 15.7269 3.674C15.7742 3.56091 15.7985 3.43956 15.7985 3.317C15.7985 3.19443 15.7742 3.07308 15.7269 2.95999C15.6797 2.8469 15.6105 2.74431 15.5233 2.65817C15.4371 2.57098 15.3345 2.50176 15.2215 2.45451C15.1084 2.40726 14.987 2.38293 14.8644 2.38293C14.7419 2.38293 14.6205 2.40726 14.5074 2.45451C14.3944 2.50176 14.2918 2.57098 14.2056 2.65817L4.88798 11.9758Z" />
        ),
    },
    paperClip: {
        viewBox: '0 0 20 20',
        image: (
            <path
                d="M13.7487 5.62496V14.4416C13.7487 16.1833 12.4737 17.7333 10.7404 17.9C8.7487 18.0916 7.08203 16.5333 7.08203 14.5833V4.28329C7.08203 3.19163 7.86536 2.19996 8.9487 2.09163C10.1987 1.96663 11.2487 2.94163 11.2487 4.16663V12.9166C11.2487 13.375 10.8737 13.75 10.4154 13.75C9.95703 13.75 9.58203 13.375 9.58203 12.9166V5.62496C9.58203 5.28329 9.2987 4.99996 8.95703 4.99996C8.61536 4.99996 8.33203 5.28329 8.33203 5.62496V12.8C8.33203 13.8916 9.11536 14.8833 10.1987 14.9916C11.4487 15.1166 12.4987 14.1416 12.4987 12.9166V4.30829C12.4987 2.56663 11.2237 1.01663 9.49037 0.849959C7.50703 0.658292 5.83203 2.21663 5.83203 4.16663V14.3916C5.83203 16.7833 7.58203 18.925 9.96536 19.15C12.707 19.4 14.9987 17.2666 14.9987 14.5833V5.62496C14.9987 5.28329 14.7154 4.99996 14.3737 4.99996C14.032 4.99996 13.7487 5.28329 13.7487 5.62496Z"
                fill="#B3B3B3"
            />
        ),
    },
    linked: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M10.633 16.1955L8.74761 18.0808C7.96598 18.8624 6.70019 18.8624 5.91921 18.081C5.13808 17.2998 5.13808 16.0339 5.91906 15.253L9.69042 11.4816C10.4714 10.7006 11.7373 10.7006 12.5183 11.4816C12.7786 11.7419 13.2008 11.7419 13.4611 11.4816C13.7214 11.2212 13.7214 10.7991 13.4611 10.5388C12.1594 9.23708 10.0493 9.23708 8.74761 10.5388L4.97627 14.3101C3.67458 15.6118 3.67458 17.7219 4.97627 19.0236C6.27781 20.326 8.38807 20.326 9.69046 19.0236L11.5758 17.1382C11.8362 16.8779 11.8362 16.4558 11.5758 16.1954C11.3155 15.9351 10.8933 15.9351 10.633 16.1955Z" />
                <path d="M19.0216 4.97627C17.7199 3.67458 15.6091 3.67458 14.3074 4.97627L12.0454 7.23828C11.7851 7.49863 11.7851 7.92076 12.0454 8.1811C12.3058 8.44145 12.7279 8.44145 12.9882 8.1811L15.2503 5.91909C16.0312 5.13808 17.2978 5.13808 18.0788 5.91909C18.8598 6.70006 18.8598 7.96598 18.0788 8.74695L13.9308 12.895C13.1498 13.676 11.8839 13.676 11.1029 12.895C10.8426 12.6347 10.4204 12.6347 10.1601 12.895C9.89976 13.1553 9.89976 13.5775 10.1601 13.8378C11.4618 15.1395 13.5719 15.1395 14.8736 13.8378L19.0216 9.6898C20.3233 8.3881 20.3233 6.27797 19.0216 4.97627Z" />
            </g>
        ),
    },
    selectRight: {
        viewBox: '0 0 32 32',
        image: (
            <path d="M19.0527 7.61339C18.5327 8.13339 18.5327 8.97339 19.0527 9.49339L24.226 14.6667H3.99935C3.26602 14.6667 2.66602 15.2667 2.66602 16.0001C2.66602 16.7334 3.26602 17.3334 3.99935 17.3334H24.2393L19.066 22.5067C18.546 23.0267 18.546 23.8667 19.066 24.3867C19.586 24.9067 20.426 24.9067 20.946 24.3867L28.3993 16.9334C28.9193 16.4134 28.9193 15.5734 28.3993 15.0534L20.9327 7.61339C20.426 7.09339 19.5727 7.09339 19.0527 7.61339Z" />
        ),
    },
    selectLeft: {
        viewBox: '0 0 32 32',
        image: (
            <path d="M12.9343 24.4001C13.4543 23.8801 13.4543 23.0401 12.9343 22.5201L7.77427 17.3334H28.0009C28.7343 17.3334 29.3343 16.7334 29.3343 16.0001C29.3343 15.2667 28.7343 14.6667 28.0009 14.6667H7.77427L12.9476 9.49339C13.4676 8.97339 13.4676 8.13339 12.9476 7.61339C12.4276 7.09339 11.5876 7.09339 11.0676 7.61339L3.60094 15.0667C3.08094 15.5867 3.08094 16.4267 3.60094 16.9467L11.0543 24.4001C11.5743 24.9067 12.4276 24.9067 12.9343 24.4001Z" />
        ),
    },
    advertisementItem: {
        viewBox: '0 0 32 32',
        image: (
            <path d="M1.6 6.4C0.72 6.4 0 7.12 0 8V28.8C0 30.56 1.44 32 3.2 32H24C24.88 32 25.6 31.28 25.6 30.4C25.6 29.52 24.88 28.8 24 28.8H4.8C3.92 28.8 3.2 28.08 3.2 27.2V8C3.2 7.12 2.48 6.4 1.6 6.4ZM28.8 0H9.6C7.84 0 6.4 1.44 6.4 3.2V22.4C6.4 24.16 7.84 25.6 9.6 25.6H28.8C30.56 25.6 32 24.16 32 22.4V3.2C32 1.44 30.56 0 28.8 0ZM16 20V5.6L24.752 12.16C25.184 12.48 25.184 13.12 24.752 13.44L16 20Z" />
        ),
    },
    iptvIconButton: {
        viewBox: '0 0 24 24',
        image: (
            <g>
                <path d="M20.1818 5.9624H3.81818C2.81818 5.9624 2 6.68409 2 7.56616V17.1888C2 18.0708 2.81818 18.7925 3.81818 18.7925H10.1818V20.3963H9.27273C8.77273 20.3963 8.36363 20.7571 8.36363 21.1981C8.36363 21.6392 8.77273 22 9.27273 22H14.7273C15.2273 22 15.6363 21.6392 15.6363 21.1981C15.6363 20.7571 15.2273 20.3963 14.7273 20.3963H13.8182V18.7925H20.1818C21.1818 18.7925 22 18.0708 22 17.1888V7.56616C22 6.68409 21.1818 5.9624 20.1818 5.9624ZM19.2728 17.1888H4.72728C4.22728 17.1888 3.81818 16.8278 3.81818 16.3868V8.36804C3.81818 7.92701 4.22728 7.56616 4.72728 7.56616H19.2728C19.7728 7.56616 20.1818 7.92701 20.1818 8.36804V16.3868C20.1818 16.8278 19.7728 17.1888 19.2728 17.1888Z" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9993 2C11.0567 2 10.1141 2.2829 9.34032 2.84397L9.33785 2.84578C9.30212 2.87251 9.27052 2.90321 9.24422 2.93697C9.10902 3.11101 9.12834 3.34895 9.31135 3.50488L9.33879 3.52818C9.52009 3.68297 9.80547 3.69486 10.0066 3.56231L10.009 3.56065C10.5992 3.15969 11.3012 2.94348 11.9993 2.94348C12.6969 2.94348 13.399 3.15942 13.995 3.56054C14.1961 3.69854 14.4802 3.67874 14.6618 3.53118L14.6723 3.52274L14.697 3.49642C14.9009 3.31324 14.8859 3.01377 14.6607 2.84566L14.6584 2.84397C13.8846 2.2829 12.942 2 11.9993 2ZM11.9993 3.0848C11.3939 3.0848 10.7917 3.26881 10.2978 3.59873L10.2959 3.60003C10.2432 3.63605 10.2005 3.67998 10.1689 3.72901C10.0589 3.90003 10.0905 4.12267 10.2567 4.26412L10.2785 4.28282C10.4718 4.4477 10.7502 4.43905 10.9417 4.32021L10.9454 4.31778C11.2521 4.11842 11.6216 4.02828 11.9993 4.02828C12.3767 4.02828 12.7467 4.11827 13.0537 4.31352C13.2497 4.44152 13.5362 4.4414 13.7221 4.27661L13.7423 4.2592C13.8292 4.18511 13.881 4.08952 13.8936 3.98949C13.912 3.84156 13.8442 3.69168 13.7027 3.59505L13.6996 3.59304C13.2063 3.26872 12.6047 3.0848 11.9993 3.0848ZM11.9993 4.83017C11.5888 4.83017 11.236 5.11838 11.236 5.49053V7.09429H12.7628V5.49053C12.7628 5.11838 12.4098 4.83017 11.9993 4.83017Z"
                />
                <path d="M11.89 14.9783C11.7156 14.9783 11.5742 14.8516 11.5742 14.6953V10.0193C11.5742 9.86304 11.7156 9.73633 11.89 9.73633H13.7676C14.2169 9.73633 14.5939 9.81141 14.8986 9.96157C15.2051 10.1117 15.4364 10.3182 15.5925 10.581C15.7506 10.8421 15.8296 11.1389 15.8296 11.4717C15.8296 11.8078 15.7506 12.1065 15.5925 12.3675C15.4345 12.6286 15.2012 12.8343 14.8928 12.9844C14.5844 13.1328 14.2046 13.2071 13.7533 13.2071H12.6154C12.441 13.2071 12.2996 13.0803 12.2996 12.9241V12.7094C12.2996 12.5531 12.441 12.4264 12.6154 12.4264H13.6105C13.8732 12.4264 14.0884 12.3854 14.2559 12.3036C14.4235 12.2217 14.5472 12.109 14.6272 11.9657C14.7091 11.8223 14.75 11.6577 14.75 11.4717C14.75 11.2857 14.7091 11.1219 14.6272 10.9803C14.5472 10.8387 14.4226 10.7286 14.2531 10.6501C14.0856 10.5699 13.8694 10.5298 13.6048 10.5298H12.9496C12.7751 10.5298 12.6337 10.6565 12.6337 10.8128V14.6953C12.6337 14.8516 12.4924 14.9783 12.318 14.9783H11.89Z" />
                <path d="M10.111 9.73633C10.2854 9.73633 10.4267 9.86304 10.4267 10.0193V14.6953C10.4267 14.8516 10.2854 14.9783 10.111 14.9783H9.68298C9.50857 14.9783 9.36719 14.8516 9.36719 14.6953V10.0193C9.36719 9.86304 9.50857 9.73633 9.68298 9.73633H10.111Z" />
            </g>
        ),
    },
    treeExpand: {
        viewBox: '0 -2 6 24',
        image: (
            <path
                d="M0.5 -1.5V17.0002C0.5 19.2094 2.29086 21.0002 4.5 21.0002H5"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
            />
        ),
    },
    externalAdvertisement: {
        viewBox: '0 0 24 24',
        image: (
            <path d="M11.7979 4.52832C15.4535 4.52851 18.0706 7.01629 18.5039 10.0801C19.8628 10.2282 20.9477 10.7222 21.7363 11.4727C22.6839 12.3745 23.12 13.5677 23.1475 14.7295C23.2003 16.9752 21.6599 19.4717 18.874 19.4717H6.65234C4.8161 19.4716 3.37354 18.8384 2.37891 17.8027C1.39844 16.7815 0.917893 15.4372 0.855469 14.1123C0.733886 11.5236 2.24708 8.59459 5.36914 8.18555C5.49089 8.1696 5.55378 8.11096 5.57324 8.0791C6.45336 6.63854 7.43103 5.72112 8.52832 5.18164C9.61629 4.64679 10.7327 4.52833 11.7979 4.52832ZM11.7979 6.42871C10.8658 6.42873 10.0823 6.53526 9.36719 6.88672C8.66141 7.23369 7.93049 7.86533 7.19434 9.07031C6.83219 9.66287 6.22012 9.99022 5.61621 10.0693C3.78114 10.3097 2.66245 12.0781 2.75391 14.0234C2.79832 14.9653 3.13693 15.8488 3.75 16.4873C4.34951 17.1113 5.27787 17.5712 6.65234 17.5713H18.874C20.2779 17.5713 21.2839 16.298 21.248 14.7744C21.2309 14.0519 20.964 13.36 20.4268 12.8486C19.8946 12.3424 19.0119 11.9326 17.6182 11.9326H16.6689V10.9824C16.6686 8.58501 14.7733 6.42892 11.7979 6.42871Z" />
        ),
    },
}
